(function () {
  /**
   *  @name : Le module angular représentant l'application
   */
  angular
    .module('app', [
      'ngCookies',
      'ngMaterial',
      'ngMessages',
      'ngSanitize',
      'ui.mask',
      'ui.router',
      'angularSpinner',
      'pascalprecht.translate',
      'ui.tinymce',
      'ng-clamp'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('EditFavorisController', EditFavorisController);

  /** @ngInject */
  function EditFavorisController($mdDialog, ErrorService, FavorisService, LoadingService, ParametresService, services) {
    var vm = this;

    vm.services = services;

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
      var favoris = _.filter(angular.copy(vm.services), {
        isFavori: true
      });

      var max = ParametresService.get('NB_FAVORIS_MAX', 5);
      if (favoris.length > max) {
        ErrorService.alert(undefined, {
          message: 'Vous pouvez sélectionner au maximum ' + max + ' fonctionnalités.'
        });
      } else {
        LoadingService.show();

        FavorisService.saveFavoris(favoris).then(function () {
          $mdDialog.hide();
        }, function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('FavorisService', FavorisService);

  /* @ngInject */
  function FavorisService($http, $mdDialog, $q, LoadingService, BACKEND) {
    var service = {
      getFavoris: getFavoris,
      editFavoris: editFavoris,
      saveFavoris: saveFavoris
    };
    return service;

    function getFavoris() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/favoris').then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function getServices(favoris) {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/services/favoris/BOV').then(function (response) {
          var codesFavoris = _.map(favoris, function (favori) {
            return favori.code;
          });

          var services = response.data;
          angular.forEach(services, function (service) {
            service.isFavori = (codesFavoris.indexOf(service.code) !== -1);
          });

          resolve(services);
        }, reject);
      });
    }

    function editFavoris(favoris) {
      return $q(function (resolve, reject) {
        LoadingService.show();

        $mdDialog.show({
          controller: 'EditFavorisController',
          controllerAs: 'ctrl',
          bindToController: true,
          templateUrl: 'app/eleveur/bovin/_common/directives/favoris/services/editFavoris/editFavoris.html',
          resolve: {
            services: function () {
              return getServices(favoris);
            }
          },
          onShowing: function () {
            LoadingService.hide();
          }
        }).then(resolve, function (error) {
          if (angular.isDefined(error)) {
            LoadingService.hide();

            reject(error);
          }
        });
      });
    }

    function saveFavoris(favoris) {
      return $q(function (resolve, reject) {
        $http.put(BACKEND.url + '/favoris', _.map(favoris, function (service) {
          return _.pick(service, 'code');
        })).then(resolve, reject);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advFavoris', AdvFavoris);

  AdvFavoris.$inject = [];

  /* @ngInject */
  function AdvFavoris() {
    var directive = {
      restrict: 'E',
      replace: true,
      controller: AdvFavorisController,
      controllerAs: 'favorisCtrl',
      bindToController: true,
      templateUrl: 'app/eleveur/bovin/_common/directives/favoris/favoris.html'
    };

    AdvFavorisController.$inject = ['ErrorService', 'FavorisService', 'FonctionnaliteService', 'LoadingService'];

    /* @inject */
    function AdvFavorisController(ErrorService, FavorisService, FonctionnaliteService, LoadingService) {
      var vm = this;

      vm.favoris = undefined;

      vm.loading = false;
      vm.error = false;

      vm.load = function () {
        vm.favoris = undefined;
        vm.loading = true;
        vm.error = false;

        FavorisService.getFavoris().then(function (favoris) {
          vm.favoris = favoris;
        }, function (error) {
          vm.error = true;

          ErrorService.log(error);
        }).finally(function () {
          vm.loading = false;
        });
      };

      vm.load();

      vm.goToFavori = function (favori) {
        LoadingService.show();

        FonctionnaliteService.goToFonctionnalite(favori,
          {
            newPage: true
          }).catch(function (error) {
            ErrorService.alert(error);
          }).finally(function () {
            LoadingService.hide();
          });
      };

      vm.editFavoris = function () {
        FavorisService.editFavoris(vm.favoris).then(function () {
          vm.load();
        });
      };
    }

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('DossierAnimalService', DossierAnimalService);

  /* @ngInject */
  function DossierAnimalService($http, $q, BACKEND) {
    var service = {
      getInventaire: getInventaire
    };
    return service;

    function getInventaire(sortis) {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/animaux?sortis=' + sortis).then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advDossierAnimal', AdvDossierAnimal);

  /* @ngInject */
  function AdvDossierAnimal() {
    var directive = {
      restrict: 'E',
      replace: true,
      controller: AdvDossierAnimalController,
      controllerAs: 'dossierAnimalCtrl',
      bindToController: true,
      templateUrl: 'app/eleveur/bovin/_common/directives/dossierAnimal/dossierAnimal.html'
    };

    AdvDossierAnimalController.$inject = ['$scope', '$window', 'DossierAnimalService', 'ErrorService', 'FonctionnaliteService', 'LoadingService'];

    /* @inject */
    function AdvDossierAnimalController($scope, $window, DossierAnimalService, ErrorService, FonctionnaliteService, LoadingService) {
      var vm = this;

      // Fonctionnalite
      vm.fonctionnalite = undefined;

      vm.loadingFonctionnalite = false;
      vm.errorFonctionnalite = false;

      vm.loadFonctionnalite = function () {
        vm.fonctionnalite = undefined;
        vm.loadingFonctionnalite = true;
        vm.errorFonctionnalite = false;

        FonctionnaliteService.completeAcces('DOSSIER_ANIMAL', {
          numeroNational: 'FR999999999'
        }).then(function (fonctionnalite) {
          vm.fonctionnalite = fonctionnalite;
          vm.getInventaire();
        }, function (error) {
          vm.errorFonctionnalite = true;

          ErrorService.log(error);
        }).finally(function () {
          vm.loadingFonctionnalite = false;
        });
      };

      vm.loadFonctionnalite();

      // Recherche
      vm.searchText = '';
      vm.sortis = false;

      vm.animal = undefined;

      var inventaire;
      vm.searching = false;
      vm.errorSearching = false;

      $scope.$watch(function () {
        return vm.sortis;
      }, function () {
        vm.getInventaire();
      });

      vm.getInventaire = function () {
        if (angular.isDefined(vm.fonctionnalite)) {
          inventaire = [];
          vm.searching = true;
          vm.errorSearching = false;

          DossierAnimalService.getInventaire(vm.sortis).then(function (inv) {
            inventaire = inv;
          }, function (error) {
            vm.errorSearching = true;

            ErrorService.log(error);
          }).finally(function () {
            vm.searching = false;
          });
        }
      };

      vm.searchAnimal = function (search) {
        var searchLowerCase = search.toLowerCase();

        var result;
        if (angular.isDefined(inventaire)) {
          result = _.filter(inventaire, function (animal) {
            if (searchLowerCase === '') {
              return true;
            }

            if (angular.isDefined(animal.identifiantFavori) && (animal.identifiantFavori.toLowerCase().indexOf(searchLowerCase) !== -1)) {
              return true;
            }

            if (angular.isDefined(animal.numeroNational) && (animal.numeroNational.toLowerCase().indexOf(searchLowerCase) !== -1)) {
              return true;
            }

            return false;
          });
        } else {
          result = [];
        }

        return result;
      };

      vm.onSubmit = function () {
        if (vm.searchAnimalForm.$valid) {
          LoadingService.show();
          FonctionnaliteService.goToFonctionnalite(vm.fonctionnalite, {
            numeroNational: vm.animal.numeroNational,
            newPage: true
          }).catch(function (error) {
            ErrorService.alert(error);
          }).finally(function () {
            LoadingService.hide();
          });
        }
      };
    }

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('SelectionExploitationController', SelectionExploitationController);

  /** @ngInject */
  function SelectionExploitationController($mdDialog, $state, AuthentService, ExploitationService, ErrorService, LoadingService,
    SessionService, UserService, HttpInterceptor, exploitations, FonctionnaliteService, ModalService, StatutRecouvrementService) {
    var vm = this;

    vm.exploitations = exploitations;
    vm.openFormAuth = false;
    vm.estKeyCloak = UserService.getEstKeyCloak();
    if (exploitations.length === 1 && !vm.estKeyCloak) {
      vm.openFormAuth = true;
      vm.exploitation = exploitations[0];
    }

    vm.toggleForm = function (exploitation) {
      vm.exploitation = exploitation;
      vm.openFormAuth = !vm.openFormAuth;
    };

    vm.close = function () {
      $mdDialog.cancel();
    };

    vm.cancel = function () {
      if (exploitations.length === 1 || vm.estKeyCloak) {
        vm.close();
      } else {
        vm.toggleForm();
      }
    };

    function onFinishAuthent(token, profil) {

      SessionService.setCredentials({
        token: token
      });

      var login = vm.exploitation.login;

      UserService.getListTypeAbonnement(login).then(function (response) {
        var estBovin = _.find(response.listeTypeAbonnement, function (typeAbonnement) {
          return typeAbonnement === "BOV";
        });
        if (profil.profil === 'ADMIN') {
          $state.go('app.admin.home');
        } else if (estBovin) {
          $state.go('app.eleveur.bovin');
        } else {
          $state.go('app.eleveur.woc');
        }
        $mdDialog.hide(token);
      });
    }
    function goToOdoo() {
      FonctionnaliteService.getFonctionnalite('ODOO').then(function (fonctionnalite) {
        FonctionnaliteService.goToFonctionnalite(fonctionnalite, {
          menu: false,
          newPage: true
        }).catch(function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });
      });
    }

    vm.selectionCheptel = function (cheptel) {
      StatutRecouvrementService.getEstSuspendus(cheptel.numExploitation).then(function (suspensionDto) {
        if (suspensionDto.suspendu) {
          if (suspensionDto.estResponsable) {
            ModalService.popupSuspensionAccesResponsable(UserService.isMultiExploitation()).then(function () {
              goToOdoo();
            });
          } else {
            ModalService.popupSuspensionAccesAutre(suspensionDto.emailResponsable, UserService.isMultiExploitation()).then(function () {

            });
          }

        } else {
          LoadingService.show();
          AuthentService.setExploitation(cheptel).then(function (token) {
            SessionService.setCredentials({
              token: token
            });
            LoadingService.show();
            UserService.loadProfil().then(function () {
              LoadingService.show();
              // $state.reload();
              redirectionByTypeAbo(token);
            }, function (error) {
              ErrorService.alert(error);
            }).finally(function () {
              // LoadingService.hide();
              $mdDialog.hide(token);
            });
          }, function (error) {
            if (angular.isDefined(_.get(error, 'data.cause'))) {
              ErrorService.alert(error, {message: _.get(error, 'data.cause')});
            } else {
              ErrorService.alert(error);
            }
          }).finally(function () {
            LoadingService.hide();
          });
        }
      });
    };
    function redirectionByTypeAbo(token) {
      UserService.getListTypeAbonnement(UserService.get('login')).then(function (response) {
        var estBovin = _.find(response.listeTypeAbonnement, function (typeAbonnement) {
          return typeAbonnement === "BOV";
        });
        if (estBovin) {
          $state.go('app.eleveur.bovin', {}, {reload: true});
        } else {
          $state.go('app.eleveur.woc', {}, {reload: true});
        }
      }, function (error) {
        LoadingService.hide();
        ErrorService.alert(error);
      }).finally(function () {
        $mdDialog.hide(token);
      });
    }
    vm.onSubmitAuthent = function () {
      vm.authentError = undefined;

      if (vm.authentForm.$valid) {

        LoadingService.show();
        HttpInterceptor.deactivate();
        AuthentService.login(vm.exploitation.login, vm.exploitation.password).then(function (token) {
          UserService.getProfil(token).then(function (profil) {
            LoadingService.hide();

            if ((profil.profil !== 'ADMIN') && (profil.multiExploitation === true)) {
              ExploitationService.goToSelectionExploitation(token).then(function (token) {
                onFinishAuthent(token, profil);
              }, function (error) {
                ErrorService.alert(error);
              });
            } else {
              onFinishAuthent(token, profil);
            }
          }, function (error) {
            LoadingService.hide();
            ErrorService.alert(error);
          });
        }, function (error) {
          LoadingService.hide();
          if (_.get(error, 'data.code')) {
            vm.authentError = error.data.message;
          } else {
            ErrorService.alert(error);
          }

        }).finally(function () {
          HttpInterceptor.activate();
        });
      }
    };
  }
})();

(function () {
  'use-strict';

  angular
    .module('app')
    .controller('AnnulationCommandeAutoController', AnnulationCommandeAutoController);

  /* @ngInject */
  function AnnulationCommandeAutoController($mdDialog, UserService, commandeAuto) {
    var vm = this;

    vm.commandeAuto = commandeAuto;
    vm.numeroExploitation = UserService.getNumeroExploitation();

    vm.remarques = undefined;

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.onSubmit = function () {
      $mdDialog.hide(vm.remarques);
    };
  }
})();

(function () {
  /**
   * Service métier gestion des infos perso
   * @constructor
   */

  angular
    .module('app').factory('CompteService', CompteService);

  /* @ngInject */
  function CompteService($http, $q, UserService, BACKEND) {

    var service = {
      getInfosContact: getInfosContact,
      modifieMailContact: modifieMailContact,
      modifieTelPortableContact: modifieTelPortableContact,
      modifieTelFixeContact: modifieTelFixeContact,
      getAbonnements: getAbonnements,
      getNiveaux: getNiveaux,
      modifieRaisonSociale: modifieRaisonSociale,
      modifieAdresse: modifieAdresse,
      updateAbonnement: updateAbonnement,
      ajoutAbonnement: ajoutAbonnement,
      ajoutAbonnementFlore: ajoutAbonnementFlore,
      resiliationAbonnement: resiliationAbonnement,
      clotureCompte: clotureCompte,
      annulerClotureDifferee: annulerClotureDifferee,
      getAlertNotification: getAlertNotification,
      saveAlertNotification: saveAlertNotification
    };

    return service;

    function getInfosContact(login, numExploitation) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/utilisateurs/' + login + '/info',
          method: "GET",
          params: {
            numExploitation: numExploitation
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function modifieMailContact(login, mail) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/utilisateurs/' + login + '/mail',
          method: "PATCH",
          data: {
            mail: mail
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function modifieTelPortableContact(login, telMobile) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/utilisateurs/' + login + '/tel-mobile',
          method: "PATCH",
          data: {
            telMobile: telMobile
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function modifieTelFixeContact(login, telFixe) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/utilisateurs/' + login + '/tel-fixe',
          method: "PATCH",
          data: {
            telFixe: telFixe
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function getAbonnements(identifiant) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/eleveurs/' + identifiant + '/abonnements-exploitations',
          method: "GET"
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function getNiveaux(numExploitation) {
      if (angular.isUndefined(numExploitation)) {
        numExploitation = UserService.get('exploitationActive.numExploitation');
      }
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/exploitations/' + numExploitation + '/tarif-abonnements',
          method: "GET"
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function modifieRaisonSociale(exploitation) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/exploitations/' + exploitation.numExploitation + '/raisonSociale',
          method: "PATCH",
          data: {
            adresse: exploitation.adresse,
            numDetenteur: exploitation.numDetenteur,
            numExploitation: exploitation.numExploitation,
            raisonSociale: exploitation.raisonSociale
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function modifieAdresse(exploitation) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/exploitations/' + exploitation.numExploitation + '/adresse',
          method: "PATCH",
          data: {
            adresse: exploitation.adresse,
            numDetenteur: exploitation.numDetenteur,
            numExploitation: exploitation.numExploitation,
            raisonSociale: exploitation.raisonSociale
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function updateAbonnement(identifiant, idEleveurOrganismeAbonnement, idTarifAbonnementOrganisme) {

      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/eleveurs/' + identifiant + '/abonnements/' + idEleveurOrganismeAbonnement,
          method: "PUT",
          data: {
            idOrganismeAbonnement: idTarifAbonnementOrganisme
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function ajoutAbonnement(identifiant, idAbonnement) {

      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/eleveurs/' + identifiant + '/abonnements/' + idAbonnement,
          method: "POST",
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function ajoutAbonnementFlore(identifiant, idAbonnement, numeroMobile) {

      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/eleveurs/' + identifiant + '/abonnementsFlore/' + idAbonnement + "/telephoneFlore/" + numeroMobile,
          method: "POST",
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function resiliationAbonnement(identifiant, idAbonnement, raisonChoix) {

      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/eleveurs/' + identifiant + '/abonnements-exploitations/' + idAbonnement,
          method: "DELETE",
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            raisonCloture: raisonChoix
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function clotureCompte(identifiant, raisonChoix) {

      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/eleveurs/' + identifiant,
          method: "DELETE",
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            raisonCloture: raisonChoix
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function annulerClotureDifferee(identifiant, abonnement) {

      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/eleveurs/' + identifiant + '/clotureDifferee',
          method: "DELETE",
          headers: {
            'Content-Type': 'application/json'
          },
          data: abonnement
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function getAlertNotification(numExploitation) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + "/eleveurs/" + numExploitation + '/alerte/',
          method: "GET"
        })
          .then(function (response) {
            resolve(response.data);
          }, function (error) {
            reject(error);
          });
      });
    }

    function saveAlertNotification(numExploitation, value) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + "/eleveurs/" + numExploitation + '/alerte/',
          method: "PATCH",
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            alerte: value
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, function (error) {
            reject(error);
          });
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('ChangeMdpService', ChangeMdpService);

  /* @ngInject */
  function ChangeMdpService($http, $q, BACKEND) {

    var service = {
      getInfosUtilisateur: getInfosUtilisateur,
      changePassword: changePassword
    };

    return service;

    function getInfosUtilisateur(infosUtilisateur) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/exploitations-identifiants/' + infosUtilisateur.identifiant,
          method: "GET",
          params: {
            mdpActuel: infosUtilisateur.mdpActuel,
            mdpNouveau: infosUtilisateur.mdpNouveau
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function changePassword(infosUtilisateur) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/utilisateurs/' + infosUtilisateur.login + '/changePassword',
          method: "POST",
          data: {
            ancienPassword: infosUtilisateur.mdpActuel,
            nouveauPassword: infosUtilisateur.mdpNouveau,
            numExploitation: infosUtilisateur.numExploitation
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('ExploitationService', ExploitationService);

  /* @ngInject */
  function ExploitationService($http, $mdDialog, $q, LoadingService, BACKEND) {
    var service = {
      goToSelectionExploitation: goToSelectionExploitation,
      hasSortiePresumee: hasSortiePresumee
    };

    return service;

    function goToSelectionExploitation(token) {
      return $q(function (resolve, reject) {
        LoadingService.show();

        $mdDialog.show({
          controller: 'SelectionExploitationController',
          controllerAs: 'ctrl',
          bindToController: true,
          templateUrl: 'app/eleveur/_common/services/exploitation/selectionExploitation/selectionExploitation.html',
          locals: {
            token: token
          },
          resolve: {
            exploitations: ['UserService', function (UserService) {
              return UserService.getExploitations();
            }]
          },
          onShowing: function () {
            LoadingService.hide();
          }
        }).then(resolve, reject);
      });
    }

    function hasSortiePresumee(numExploitation) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/sortiesPresumees/' + numExploitation,
          method: "GET"
        })
          .then(function (response) {
            resolve(response.data);
          }, function (error) {
            reject(error);
          });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('CommandeAutoService', CommandeAutoService);

  /* @ngInject */
  function CommandeAutoService($filter, $http, $mdDialog, $q, ErrorService, LoadingService, ModalService, UserService, BACKEND) {
    var service = {
      checkCommandeAuto: checkCommandeAuto
    };
    return service;

    function checkCommandeAuto() {
      return $q(function (resolve) {
        getCommandeAuto().then(function (commandeAuto) {
          showCommandeAutoModal(commandeAuto).then(resolve);
        }, resolve);
      });
    }

    function getCommandeAuto() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/exploitations/' + UserService.getNumeroExploitation() + '/commandesAuto').then(function (response) {
          if (response.data === '') {
            reject();
          } else {
            resolve(response.data);
          }
        }, reject);
      });
    }

    function showCommandeAutoModal(commandeAuto) {
      ModalService.popupCommandeAuto(commandeAuto);
     /*
      return $q(function (resolve) {
        ModalService.confirm({
          title: 'Commande automatique',
          template: 'Nous vous proposons de vous recommander ' + commandeAuto.quantite + ' boucles(' + commandeAuto.typeAdhesionBoucleCommandeAuto + ').',
          cancelText: 'Valider',
          okText: 'Annuler / Modifier'
        }).then(function () {
          showAnnulationCommandeAutoModal(commandeAuto).then(resolve);
        }, function () {
          LoadingService.show();
          accepteCommandeAuto(commandeAuto).then(resolve, function (error) {
            ErrorService.alert(error).then(resolve);
          }).finally(function () {
            LoadingService.hide();
          });
        });
      });
      */
    }

    /* function showAnnulationCommandeAutoModal(commandeAuto) {
      return $q(function (resolve) {
        $mdDialog.show({
          templateUrl: 'app/eleveur/_common/services/commandeAuto/annulationCommande/annulationCommande.html',
          controller: 'AnnulationCommandeAutoController',
          controllerAs: 'ctrl',
          locals: {
            commandeAuto: commandeAuto
          }
        }).then(function (remarques) {
          LoadingService.show();
          confirmeAnnulation(commandeAuto, remarques).then(function () {
            ModalService.alert({
              title: 'Confirmation',
              template: 'Votre demande a bien été prise en compte.'
            }).then(resolve);
          }, function (error) {
            ErrorService.alert(error).then(resolve);
          }).finally(function () {
            LoadingService.hide();
          });
        }, resolve);
      });
    } */

    /* function confirmeAnnulation(commandeAuto, remarques) {
      commandeAuto.estAccepte = false;
      commandeAuto.remarques = remarques;

      return $q(function (resolve, reject) {
        $http.post(BACKEND.url + '/exploitations/' + UserService.getNumeroExploitation() + '/commandesAuto', commandeAuto).then(function (response) {
          resolve(response.data);
        }, reject);
      });
    } */

    /* function accepteCommandeAuto(commandeAuto) {
      commandeAuto.estAccepte = true;

      return $q(function (resolve, reject) {
        $http.post(BACKEND.url + '/exploitations/' + UserService.getNumeroExploitation() + '/commandesAuto', commandeAuto).then(function (response) {
          resolve(response.data);
        }, reject);
      });
    } */
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advMenu', AdvMenu);

  /* @ngInject */
  function AdvMenu() {
    var directive = {
      require: 'ngModel',
      restrict: 'E',
      replace: true,
      controller: AdvMenuController,
      controllerAs: 'ctrl',
      bindToController: true,
      templateUrl: 'app/eleveur/_common/directives/menu/menu.html',
      scope: {
        menu: '=',
        orientation: '=',
        type: '='
      }
    };

    AdvMenuController.$inject = ['$document', '$filter', '$scope', '$state', 'ErrorService', 'ModalService', 'FonctionnaliteService', 'LoadingService'];

    /* @inject */
    function AdvMenuController($document, $filter, $scope, $state, ErrorService, ModalService, FonctionnaliteService, LoadingService) {
      var vm = this;
      var nbLinksPerCol = 4;

      vm.selectedItem = undefined;

      vm.selectItem = function (item) {
        if (angular.isDefined(vm.selectedItem) && (item.code === vm.selectedItem.code)) {
          vm.selectedItem = undefined;
        } else {
          vm.selectedItem = item;
        }
      };

      vm.selectItemWoc = function (item) {
        if (item.items[0].code.includes('OVCAP_')) {
          vm.goToFonctionnalite(item.items[0]);
        } else {
          vm.selectItem(item);
        }
      };
      vm.closeSubMenu = function () {
        vm.selectedItem = undefined;
      };

      vm.generateColArray = function (items) {
        if (angular.isUndefined(_.get(items, 'length'))) {
          return [];
        }
        return new Array(Math.ceil(items.length / nbLinksPerCol));
      };

      vm.getLinksInCol = function (items, nbCol) {
        var orderedItems = $filter('orderBy')(items, 'ordre');
        return orderedItems.slice(nbCol * nbLinksPerCol, nbCol * nbLinksPerCol + nbLinksPerCol);
      };

      vm.goToFonctionnalite = function (fonctionnalite) {
        vm.closeSubMenu();
        LoadingService.show();

        FonctionnaliteService.goToFonctionnalite(fonctionnalite, {
          newPage: true
        }).catch(function (error) {
          if (angular.isDefined(_.get(error, 'data.cause'))) {
            ErrorService.alert(error, {message: _.get(error, 'data.cause')});
          } else {
            ErrorService.alert(error);
          }
        }).finally(function () {
          LoadingService.hide();
        });
      };

      $document.on('click', function (event) {
        var div = $document[0].getElementById('divMenu');
        if (div !== null) {
          if ($document[0].getElementById('divMenu').contains(event.target)) {
          } else {
            vm.closeSubMenu();
          }
        }
      });
    }
    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('AlerteService', AlerteService);

  /* @ngInject */
  function AlerteService($http, $q, UserService, BACKEND) {
    var service = {
      getAlerte: getAlerte
    };
    return service;

    function getAlerte() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/departements/' + UserService.get('exploitationActive.codeDepartement') + '/communication').then(function (response) {
          resolve(response.data);
        }, function (error) {
          if (_.get(error, 'status') === 404) {
            resolve(null);
          } else {
            reject(error);
          }
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advAlerte', AdvAlerte);

  /* @ngInject */
  function AdvAlerte() {
    var directive = {
      restrict: 'E',
      replace: true,
      controller: AdvAlerteController,
      controllerAs: 'alerteCtrl',
      bindToController: true,
      templateUrl: 'app/eleveur/_common/directives/alerte/alerte.html',
      scope: {
        alerte: '=?'
      }
    };

    AdvAlerteController.$inject = ['$sce', 'AlerteService', 'ErrorService'];

    /* @inject */
    function AdvAlerteController($sce, AlerteService, ErrorService) {
      var vm = this;

      vm.loading = false;
      vm.error = false;

      vm.load = function () {
        vm.loading = true;
        vm.error = false;

        AlerteService.getAlerte().then(function (alerte) {
          vm.alerte = alerte;
        }, function (error) {
          vm.error = true;

          ErrorService.log(error);
        }).finally(function () {
          vm.loading = false;
        });
      };

      if (angular.isUndefined(vm.alerte)) {
        vm.load();
      }

      vm.trustAsHtml = function (html) {
        return $sce.trustAsHtml(html);
      };
    }

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('ActualitesService', ActualitesService);

  /* @ngInject */
  function ActualitesService($http, $q, UserService, BACKEND) {
    var service = {
      getActualites: getActualites
    };
    return service;

    function getActualites() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/departements/' + UserService.get('exploitationActive.codeDepartement') + '/actualites').then(function (response) {
          // resolve(response.data.slice(0, 2));
          resolve(response.data);

        }, reject);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advActualites', AdvActualites);

  /* @ngInject */
  function AdvActualites() {
    var directive = {
      restrict: 'E',
      replace: true,
      controller: AdvActualitesController,
      controllerAs: 'actualitesCtrl',
      bindToController: true,
      templateUrl: 'app/eleveur/_common/directives/actualites/actualites.html'
    };

    AdvActualitesController.$inject = ['$window', 'ActualitesService', 'ErrorService'];

    /* @inject */
    function AdvActualitesController($window, ActualitesService, ErrorService) {
      var vm = this;

      vm.actualites = undefined;

      vm.loading = false;
      vm.error = false;

      vm.load = function () {
        vm.loading = true;
        vm.error = false;

        ActualitesService.getActualites().then(function (actualites) {
          vm.actualites = actualites;
        }, function (error) {
          vm.error = true;

          ErrorService.log(error);
        }).finally(function () {
          vm.loading = false;
        });
      };

      vm.load();

      vm.showActualite = function (actualite) {
        $window.open(actualite.lien, '_blank');
      };
    }

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminSelectionExploitationController', AdminSelectionExploitationController);

  /** @ngInject */
  function AdminSelectionExploitationController($mdDialog, AdminClotureAbonnementService, ErrorService, LoadingService, MulticheptelService, idExploitationOrigine) {

    var vm = this;
    vm.afficheInfosExploitation = false;

    vm.exploitation = {};
    vm.idExploitationOrigine = idExploitationOrigine;

    vm.exploitationInconnue = false;

    vm.openListAbonnements = function () {
      var exploit = {};
      exploit.numExploitation = vm.numExploitation;
      exploit.identifiant = vm.identifiant;
      if (vm.authentForm.$valid) {
        vm.exploitationInconnue = false;
        AdminClotureAbonnementService.getListAbonnements(exploit)
          .then(function (result) {
            if (result.length > 0) {
              vm.exploitation.infoIdentifiant = result[0].identifiant;
              vm.exploitation.infoNumExploitation = result[0].numExploitation;
              vm.afficheInfosExploitation = true;
            } else {
              vm.exploitation = {};
              vm.exploitationInconnue = true;
            }
            if (result.length > 0) {
              AdminClotureAbonnementService.getListAbonnementsByEleveur(vm.exploitation.infoIdentifiant)
                .then(function (result) {
                  vm.exploitation.numSiren = result.eleveurOrganismeAbonnements[0].eleveurAbonnementExploitations[0].exploitation.numSiren;
                  vm.exploitation.numAgrin = result.eleveurOrganismeAbonnements[0].eleveurAbonnementExploitations[0].exploitation.numAgrin;
                  vm.exploitation.profil = result.profil;
                  vm.exploitation.numDetenteur = result.eleveurOrganismeAbonnements[0].eleveurAbonnementExploitations[0].exploitation.numDetenteur;
                  vm.exploitation.raisonSociale = result.eleveurOrganismeAbonnements[0].eleveurAbonnementExploitations[0].exploitation.raisonSociale;
                });
            }
          });

      }
    };

    vm.rapprocherCheptel = function () {
      LoadingService.show();
      MulticheptelService.rapprocherCheptels(vm.idExploitationOrigine, {
        login: vm.exploitation.infoIdentifiant,
        numExploitation: vm.exploitation.infoNumExploitation,
        raisonsociale: vm.exploitation.raisonSociale
      }).then(function () {
        $mdDialog.hide();
      }, function (error) {
        ErrorService.alert(error);
      }).finally(function () {
        LoadingService.hide();
      });
    };

    vm.cancel = function () {
      vm.afficheInfosExploitation = !vm.afficheInfosExploitation;
    };

    vm.close = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('AdminGestionModalesService', AdminGestionModalesService);

  /* @ngInject */
  function AdminGestionModalesService($state, $q, HabilitationsService) {
    var service = {
      checkAccess: checkAccess
    };
    return service;

    function checkAccess() {
      return HabilitationsService.hasGestionModaleHabilitation().then(function (authorized) {
        if (!authorized) {
          // Redirection si l'utilisateur n'est pas autorisé
          $state.go('app.admin.home');
          return $q.reject('Access denied');
        }
        return authorized;
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('AdminGestionAbonnementService', AdminGestionAbonnementService);

  /* @ngInject */
  function AdminGestionAbonnementService($http, $q, BACKEND, DownloadFileService, ErrorService, LoadingService) {

    var filter;
    var order;
    var abonnementSelectionne;
    var service = {
      getListAbonnements: getListAbonnements,
      getExportListAbonnements: getExportListAbonnements,
      getListAbonnementsByEleveur: getListAbonnementsByEleveur,
      getExportListAbonnementsByEleveur: getExportListAbonnementsByEleveur,
      getExportListAutorisations: getExportListAutorisations,
      getInformationExploitation: getInformationExploitation,
      getFilter: getFilter,
      setFilter: setFilter,
      getOrder: getOrder,
      setOrder: setOrder,
      getAbonnementSelectionne: getAbonnementSelectionne,
      setAbonnementSelectionne: setAbonnementSelectionne,
      getExportSelonChoix: getExportSelonChoix
    };

    return service;

    function getListAbonnements() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/eleveurs-abonnements-exploitations').then(function (response) {
          resolve(response.data);
        }, function (error) {
          reject(error);
        });
      });
    }

    function getExportSelonChoix(choix) {
      LoadingService.show();
      if (choix === "Abonnements") {
        getExportListAbonnements().then(function (file) {
          DownloadFileService.downloadFromFile(file);
        }, function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });
      } else if (choix === "Autorisations d'accès et connexions SSO") {
        getExportListAutorisations().then(function (file) {
          DownloadFileService.downloadFromFile(file);
        }, function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });
      }
    }

    function getExportListAbonnements() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/eleveurs-abonnements-exploitations/excel').then(function (response) {
          resolve(response.data);
        }, function (error) {
          reject(error);
        });
      });
    }

    function getExportListAutorisations() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/eleveurs-abonnements-exploitations/autorisations-acces/excel').then(function (response) {
          resolve(response.data);
        }, function (error) {
          reject(error);
        });
      });
    }

    function getListAbonnementsByEleveur(identifiant) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/eleveurs/' + identifiant,
          method: "GET"
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function getInformationExploitation(numeroExploitation) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/exploitations/' + numeroExploitation,
          method: "GET"
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function getExportListAbonnementsByEleveur(identifiant) {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/eleveurs/' + identifiant + '/services/excel').then(function (response) {
          resolve(response.data);
        }, function (error) {
          reject(error);
        });
      });
    }

    // redmine 32680 : Ajout du filtre de la page selection des abonnement pour pouvoir le restituer lors du retour depuis le détail
    function setFilter(param) {
      filter = param;
    }

    function getFilter() {
      return filter;
    }

    // redmine 32680 : Ajout du critère de trie de la page selection des abonnement pour pouvoir le restituer lors du retour depuis le détail
    function setOrder(param) {
      order = param;
    }

    function getOrder() {
      return order;
    }

    // redmine 32680 : Ajout de l'abonnement selectionné pour gérer le mise en première position
    function setAbonnementSelectionne(param) {
      abonnementSelectionne = param;
    }

    function getAbonnementSelectionne() {
      return abonnementSelectionne;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('AdminCommunicationService', AdminCommunicationService);

  /* @ngInject */
  function AdminCommunicationService($http, $q, BACKEND) {
    var service = {
      get: get,
      save: save
    };
    return service;

    function get() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/communications').then(function (response) {
          resolve(response.data);
        }, function (error) {
          if (_.get(error, 'status') === 404) {
            resolve(undefined);
          } else {
            reject(error);
          }
        });
      });
    }

    function save(communication) {
      return $q(function (resolve, reject) {
        $http.put(BACKEND.url + '/communications', communication).then(resolve, reject);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('AdminClotureAbonnementService', AdminClotureAbonnementService);

  /* @ngInject */
  function AdminClotureAbonnementService($http, $q, $timeout, BACKEND) {

    var service = {
      cloturerAbonnement: cloturerAbonnement,
      resilierAbonnement: resilierAbonnement,
      getListAbonnements: getListAbonnements,
      getListAbonnementsByEleveur: getListAbonnementsByEleveur
    };

    return service;

    function cloturerAbonnement(identifiant, numExploitation, raisonChoix, dateCloture) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/eleveurs-organismes-abonnements/compte/' + identifiant + '/' + numExploitation,
          method: "DELETE",
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            raisonCloture: raisonChoix,
            dateCloture: dateCloture
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function resilierAbonnement(idEleveurOrganismeAbonnement, raisonChoix, dateCloture) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/eleveurs-organismes-abonnements/abonnement/' + idEleveurOrganismeAbonnement,
          method: "DELETE",
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            raisonCloture: raisonChoix,
            dateCloture: dateCloture
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function getListAbonnements(saisie) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/eleveurs-abonnements-exploitations',
          method: "GET",
          params: {
            active: true,
            numExploitation: saisie.numExploitation,
            identifiant: saisie.identifiant
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function getListAbonnementsByEleveur(identifiant) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/eleveurs/' + identifiant,
          method: "GET"
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ResiliationController', ResiliationController)
    .config(function ($mdDateLocaleProvider) {

      // Example of a French localization.
      $mdDateLocaleProvider.months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
      $mdDateLocaleProvider.shortDays = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];
      $mdDateLocaleProvider.firstDayOfWeek = 1;
    });

  /** @ngInject */
  function ResiliationController($filter, $mdDialog, $scope, $state, AdminClotureAbonnementService, ErrorService, LoadingService, ModalService, ReferentielService, abonnement, abonnements, identifiant, numExploitation, nbAbonnements, DELAICLOTURE) {
    var vm = this;

    vm.abonnement = abonnement;
    vm.dernierAbonnement = false;
    vm.dateCloture = new Date();
    vm.raisonsResiliations = ReferentielService.getRaisonsResiliations();
    vm.commentaireLibre = '';

    var dateFinAbonnement;
    var dateClotureAbonnement;
    var delaiClotureAuthorise = _.subtract(_.now(), new Date(moment().subtract(DELAICLOTURE, 'month').calendar()).getTime());

    $scope.$watch(function () {
      vm.dateCloture.setHours(0, 0, 0, 0);
      var delaiCloture = _.subtract(_.now(), vm.dateCloture);
      vm.error = undefined;
      if (vm.dateCloture.getTime() > _.now()) {
        vm.error = "La date de clôture ne doit pas être supérieure à la date du jour.";
      } else if (delaiClotureAuthorise < delaiCloture) {
        vm.error = "La date de clôture ne doit pas être plus de " + DELAICLOTURE + " mois dans le passé.";
      } else {
        vm.dateCloture.setHours(23, 59, 59, 999);
        if (angular.isDefined(abonnement) && new Date(abonnement.dateOuverture).getTime() > vm.dateCloture.getTime() || angular.isDefined(abonnements) && new Date(abonnements[0].dateOuverture).getTime() > vm.dateCloture.getTime()) {
          vm.error = "La date de clôture ne doit pas être inférieure à la date de début de l'abonnement";
        }
      }
    }, true);

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.confirm = function () {
      if (nbAbonnements === 1 && angular.isDefined(abonnement)) {
        vm.dernierAbonnement = true;
      } else {
        resiliationAbonnement();
      }

    };

    vm.confirmCloture = function () {
      resiliationAbonnement();
    };

    function resiliationAbonnement() {
      dateFinAbonnement = vm.dateCloture.getTime();
      dateClotureAbonnement = $filter('date')(dateFinAbonnement, 'yyyy-MM-dd');
      if (vm.raisonChoix === 'AUTRE') {
        vm.raisonChoix = vm.commentaireLibre;
      }
      if (angular.isDefined(abonnement)) {
        var dateFinEngagement = _.add(new Date(abonnement.dateOuverture).getTime(), abonnement.finEngagement * 1000 * 3600 * 24 * 30.5);
        if (dateFinAbonnement < dateFinEngagement) {
          ModalService.confirm({
            template: "Cet abonnement à l’offre Pilot’Elevage comporte un engagement à l’année civile. Souhaitez-vous vraiment le résilier tout de même en date du " + $filter('date')(vm.dateCloture, 'dd/MM/yyyy') + " ?"
          }).then(function () {
            $mdDialog.hide();
            LoadingService.show();
            AdminClotureAbonnementService.resilierAbonnement(abonnement.idEleveurAbonnementExploitation, vm.raisonChoix, dateClotureAbonnement).then(function () {
              LoadingService.hide();
              ModalService.alert({
                template: "La résiliation de l'abonnement a bien été prise en compte."
              }).then(function () {
                $mdDialog.hide();
                $state.reload();
              });

            }, function (error) {
              LoadingService.hide();
              if (_.get(error, 'data.code')) {
                dialog(error.data.message);
              } else {
                ErrorService.alert(error);
              }
            });
          });
        } else {
          ModalService.confirm({
            template: "Cet abonnement à l'offre Pilot'Elevage va être résilié. Souhaitez-vous continuer ?"
          }).then(function () {
            $mdDialog.hide();
            LoadingService.show();
            if (nbAbonnements === 1) {
              AdminClotureAbonnementService.resilierAbonnement(abonnement.idEleveurAbonnementExploitation, vm.raisonChoix, dateClotureAbonnement).then(function () {

                LoadingService.hide();
                ModalService.alert({
                  template: "La clôture du compte a bien été enregistrée."
                }).then(function () {
                  $mdDialog.hide();
                  $state.reload();
                });

              }, function (error) {
                LoadingService.hide();
                if (_.get(error, 'data.code')) {
                  dialog(error.data.message);
                } else {
                  ErrorService.alert(error);
                }
              });
            } else {
              AdminClotureAbonnementService.resilierAbonnement(abonnement.idEleveurAbonnementExploitation, vm.raisonChoix, dateClotureAbonnement).then(function () {
                LoadingService.hide();
                ModalService.alert({
                  template: "La résiliation de l'abonnement a bien été prise en compte."
                }).then(function () {
                  $mdDialog.hide();
                  $state.reload();
                });

              }, function (error) {
                LoadingService.hide();
                if (_.get(error, 'data.code')) {
                  dialog(error.data.message);
                } else {
                  ErrorService.alert(error);
                }
              });
            }
          });
        }
      } else {
        ModalService.confirm({
          template: "En confirmant, vous allez résilier tous les abonnements et clôturer le compte. Souhaitez-vous continuer ?"
        }).then(function () {
          $mdDialog.hide();
          LoadingService.show();
          AdminClotureAbonnementService.cloturerAbonnement(identifiant, numExploitation, vm.raisonChoix, dateClotureAbonnement).then(function () {
            LoadingService.hide();
            ModalService.alert({
              template: "La clôture du compte a bien été enregistrée."
            }).then(function () {
              $mdDialog.hide();
              $state.reload();
            });

          }, function (error) {
            LoadingService.hide();
            if (_.get(error, 'data.code')) {
              dialog(error.data.message);
            } else {
              ErrorService.alert(error);
            }
          });
        });
      }
    }

    function dialog(text) {
      ModalService.alert({
        template: text
      });
      LoadingService.hide();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('PerteMdpService', PerteMdpService);

  /* @ngInject */
  function PerteMdpService($http, $q, BACKEND) {

    var service = {
      getInfosUtilisateur: getInfosUtilisateur,
      resetPassword: resetPassword
    };

    return service;

    function getInfosUtilisateur(infosUtilisateur) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/exploitations-identifiants/' + infosUtilisateur.numExploitation,
          method: "GET",
          params: {
            numagrin: infosUtilisateur.numagrin,
            siren: infosUtilisateur.numSiren,
            numExploitation: infosUtilisateur.numExploitation
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function resetPassword(infosUtilisateur) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/utilisateurs/' + infosUtilisateur.identifiant + '/resetPassword',
          method: "POST",
          data: {
            numeroExploitation: infosUtilisateur.numExploitation,
            numeroSiren: infosUtilisateur.numSiren,
            numeroNumagrin: infosUtilisateur.numagrin
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('DejaAbonneController', DejaAbonneController);

  /** @ngInject */
  function DejaAbonneController($mdDialog, $state, login) {
    var vm = this;

    vm.login = login;

    vm.close = function () {
      $mdDialog.hide();
      $state.go('auth');
    };

    vm.goToPerteMdp = function () {
      $mdDialog.hide();
      $state.go('pertemdp');
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('NouvelAbonnementService', NouvelAbonnementService);

  /* @ngInject */
  function NouvelAbonnementService($http, $q, BACKEND) {
    var service = {
      ajoutNouvelAbonnement: ajoutNouvelAbonnement,
      getInfosExploitation: getInfosExploitation
    };

    return service;

    function ajoutNouvelAbonnement(infosAbonnement) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/exploitations/' + infosAbonnement.infosExploitation.numExploitation + '/abonnements',
          method: "POST",
          data: {
            abonneFloreInfos: infosAbonnement.abonneFloreInfos,
            email: infosAbonnement.infosAbonne.email,
            listIdTarifAbonnementOrganisme: infosAbonnement.activeAbonnement,
            numExploitation: infosAbonnement.infosAbonne.numExploitation,
            numNumagrin: infosAbonnement.infosExploitation.numagrin,
            numSiren: infosAbonnement.infosExploitation.siren,
            numTelephone: infosAbonnement.infosAbonne.telephone,
            typeMobile: infosAbonnement.typeMobile,
            listAutorisationsAcces: infosAbonnement.listAutorisationsAcces,
            options: infosAbonnement.options,
            contactFacturation: infosAbonnement.contactFacturation,
            iban: infosAbonnement.iban,
            codeVerification: infosAbonnement.codeVerification,
            raisonSocial: infosAbonnement.infosExploitation.raisonSociale,
            pdfPrelevementDownloaded: infosAbonnement.pdfPrelevementDownloaded
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function getInfosExploitation(infosExploitation) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/exploitations-identifiants/' + infosExploitation.numExploitation,
          method: "GET",
          params: {
            numagrin: infosExploitation.numagrin,
            siren: infosExploitation.numSiren
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('EleveurWocMainController', EleveurWocMainController);

  /** @ngInject */
  function EleveurWocMainController($state, profil, showAlerteSaisieAutotisations, ModalService, AlerteSaisieAutorisationsService, LoadingService, InformationService, AuthentService, MenuService) {

    var vm = this;

    MenuService.getMegaMenu('OVCAP').then(function (megaMenu) {
      vm.menu = megaMenu;
      $state.go('app.eleveur.woc.home');
    });
    vm.showAlerteSaisieAutotisations = showAlerteSaisieAutotisations;

    if (AuthentService.hasModaleAccueil() === 'true') {
      AuthentService.setModaleAccueil('false');
      if (profil.profil !== 'TECHNICIEN') {
        if (angular.isDefined(vm.showAlerteSaisieAutotisations) && vm.showAlerteSaisieAutotisations.showAlerte) {
          ModalService.changementSystemeAuthentification().then(function () {
            $state.go('app.eleveur.compte.compte', {
              onglet: 'autorisations d\'accès'
            });
          }, function () {
          }).finally(function () {
            AlerteSaisieAutorisationsService.saveAffichageAlerteSaisieAutorisation();
            LoadingService.hide();
          });
        }
      }
      InformationService.displayNextModaleInformation();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('EleveurWocHomeController', EleveurWocHomeController);

  /** @ngInject */
  function EleveurWocHomeController() {
  }
})();

(function () {
  angular
    .module('app')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('app.eleveur.woc', {
        url: '/woc',
        controller: 'EleveurWocMainController',
        templateUrl: 'app/eleveur/woc/main/main.html',
        controllerAs: 'ctrl',
        resolve: {
          showAlerteSaisieAutotisations: ['AlerteSaisieAutorisationsService', function (AlerteSaisieAutorisationsService) {
            return AlerteSaisieAutorisationsService.getShowAlerteSaisieAutorisations();
          }]
        }
      }).state('app.eleveur.woc.home', {
        url: '/home',
        templateUrl: 'app/eleveur/woc/home/home.html',
        controller: 'EleveurWocHomeController',
        controllerAs: 'ctrl'
      }).state('app.eleveur.woc.fonctionnalite', {
        url: '/fonctionnalite/:code',
        templateUrl: 'app/eleveur/fonctionnalite/fonctionnalite.html',
        controller: 'EleveurFonctionnaliteController',
        controllerAs: 'ctrl',
        resolve: {
          fonctionnalite: ['$stateParams', 'FonctionnaliteService', function ($stateParams, FonctionnaliteService) {
            return FonctionnaliteService.completeAcces($stateParams.code);
          }]
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('FonctionnaliteService', FonctionnaliteService);

  /* @ngInject */
  function FonctionnaliteService($http, $q, $state, $window, $document, ErrorService, BACKEND) {
    var service = {
      goToFonctionnalite: goToFonctionnalite,
      completeAcces: completeAcces,
      getFonctionnalite: getFonctionnalite
    };
    return service;

    function goToFonctionnalite(fonctionnalite, options) {
      return $q(function (resolve, reject) {
        if (fonctionnalite === null) {
          reject({
            userMessage: 'Fonctionnalité non disponible'
          });
        } else {
          switch (fonctionnalite.acces.application) {
            case 'IPG':
              resolve();

              $state.go('app.eleveur.bovin.fonctionnalite', {
                code: fonctionnalite.code.toLowerCase()
              });
              break;
            case 'BGTA':
              if (options.menu === false) {
                // reroutage vers portail bgta
                var urlBgta = '/redirection/' + fonctionnalite.code + '/';
                $window.open(urlBgta);
              } else {
                // menu
                resolve();
                $state.go('app.eleveur.bovin.lien_bgta');
              }
              break;
            case 'MENU_IA':
                // menu
                resolve();
                $state.go('app.eleveur.bovin.lien_commandes_ia');
              break;
            default:
              if (options.newPage === true) {
                var url = '/redirection/' + fonctionnalite.code + '/';
                delete options.newPage;
                if (angular.isDefined(options) && !_.isEmpty(options)) {
                  url += angular.toJson(options);
                }
                $window.open(url);
                resolve();
              } else {
                delete options.newPage;
                var params = {fonctionnalite: fonctionnalite.code};
                if (angular.isDefined(options) && !_.isEmpty(options)) {
                  params.options = angular.toJson(options);
                }
                $state.go('redirection', params);
              }
          }
        }
      });
    }

    function completeAcces(code, options) {
      return $q(function (resolve, reject) {
        var url = BACKEND.url + '/services/' + code.toUpperCase();
        if (angular.isObject(options)) {
          url += '?' + _.map(options, function (value, key) {
            return key + '=' + value;
          }).join('&');
        }

        $http.get(url).then(function (response) {
          resolve(response.data);
        }, reject);

      });
    }

    function getFonctionnalite(code) {
      return $q(function (resolve) {
        completeAcces(code).then(function (fonctionnalite) {
          resolve(fonctionnalite);
        }, function (error) {
          ErrorService.log(error);

          resolve(null);
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('CompteMainController', CompteMainController);

  /** @ngInject */
  function CompteMainController($state) {

    $state.go('app.eleveur.compte.compte');

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('CompteController', CompteController);

  /** @ngInject */
  function CompteController($log, $filter, $mdDialog, $scope, $state, $stateParams, $location, $anchorScroll, $timeout, CompteService,
    FloreService, ErrorService, LoadingService, ModalService, UserService, ParametresService, ReferentielService, niveaux,
    profil, saisie, NOMABONNEMENT, REDUCTION, AdminService, AbonnementOptionService, options, StatutRecouvrementService, AuthentService, AutorisationAccesService) {

    // Ajoute un verrou pour les petits malins suspendus qui iraient directement sur le site par url ou favori
    if (!UserService.get('profilAssistance')) {
      StatutRecouvrementService.getEstSuspendus(profil.exploitationActive.numExploitation).then(function (suspensionDto) {
        if (suspensionDto.suspendu) {
          AuthentService.logout();
        }
      });
    }

    var vm = this;
    var contact = {};
    var abonnementSelectionne;
    var abonnements;
    var aboBovinActif;
    var aboOvinActif;
    var abonnementFloreActif;
    var compteId;
    vm.aboFloreActif = {};
    vm.monCompte = true;
    vm.options = options;
    CompteService.aucunResponsable = false;
    ParametresService.load().then(function (result) {
      vm.parametres = result;
    });
    // accès à mon compte restreint aux responsables (empêcher accès direct sauf pour compte assistance)
    if (!UserService.get('profilAssistance')) {
      AutorisationAccesService.getCurrentAutorisationAcces().then(function (result) {
        if (angular.equals(result.profil.libelle, 'Responsable/associé Facturation') === false && angular.equals(result.profil.libelle, 'Responsable/associé') === false) {
          AuthentService.logout();
        }
      });
    }

    vm.origineAboFloreActif = {};
    vm.origineShowNotification = undefined;
    // pour précocher à oui le bloc flore, on regarde si on vient de la popup d'information de la page d'accueil (sur selection du oui on redirige sur mon compte)
    if (UserService.get('profil') === 'TECHNICIEN') {
      vm.showNotification = false;
    } else if (angular.isDefined($stateParams.showNotification) && $stateParams.showNotification === true) {
      vm.showNotification = $stateParams.showNotification;
    } else {
      // cas spécifique aux elevages sans abonnement bovin qui n'auront pas eu la popup d'information, on ne précoche pas de choix dans le bloc flore
      CompteService.getAlertNotification(profil.login).then(function (alertNotification) {
        if (angular.isUndefined(alertNotification.alerte)) {
          vm.showNotification = undefined;
        } else {
          vm.showNotification = false;
          vm.origineShowNotification = vm.showNotification;
        }
      });
    }

    vm.login = UserService.get('login');
    vm.exploitationActive = UserService.get('exploitationActive');

    // RECUPERATION DE L'ABONNEMENT FLORE
    vm.abonnementFlore = _.get(niveaux, 'FLORE');

    vm.onglet = $stateParams.onglet;

    vm.onglets = [
      {
        libelle: 'services'
      },
      {
        libelle: 'informations'
      },
      {
        libelle: 'autorisations d\'accès'
      }
    ];

    var reduc = _.find(REDUCTION, {departement: vm.exploitationActive.codeDepartement});
    vm.reduction = angular.isDefined(reduc);
    vm.reductionTxt = vm.reduction ? reduc.texte : '';

    // modifications différées
    vm.modificationsEnCours = [];

    init();

    vm.changeOnglet = function (onglet) {
      if (_.isEqual(vm.contact, vm.origineContact) && _.isEqual(vm.aboFloreActif, vm.origineAboFloreActif) &&
        (!AdminService.hasChanges() && !CompteService.aucunResponsable)) {
        vm.onglet = onglet;
      } else if (CompteService.aucunResponsable) {
        ModalService.alert({
          template: "Il faut saisir au moins un responsable/associé Facturation pour cette exploitation"
        });
      } else {
        var template = "";
        if (AdminService.hasChanges()) {
          template = "Vos modifications n’ont pas été enregistrées, souhaitez-vous continuer et donc perdre vos saisies ?";
        } else {
          template = "Les modifications effectuées n’ont pas été enregistrées. Voulez-vous continuer ?";
        }
        ModalService.confirm({
          template: template,
          cancelText: 'Non',
          okText: 'Oui'
        }).then(function () {
          vm.contact = angular.copy(vm.origineContact);
          vm.aboFloreActif = angular.copy(vm.origineAboFloreActif);
          vm.modifNiveau = false;
          vm.showNotification = vm.origineShowNotification;
          vm.onglet = onglet;

          AdminService.setHasChanges(false);
        }, function () { });
      }
      getOptionsEnabled();
      // mise à jour url selon l'onglet courant... sans recharger le controller.
      $state.transitionTo('app.eleveur.compte.compte', {
        onglet: vm.onglet
      }, {notify: false});
    };

    function getOptionsEnabled() {
      var isPerformance = false;
      var isEssentiel = false;
      var isOvin = false;
      if (angular.isDefined(vm.aboBovActif)) {
        var niveauBovActuel = _.find(vm.abonnementsBovin, {
          disponible: false
        });
        if (niveauBovActuel.niveauAbonnement.libelle === 'Performance') {
          isPerformance = true;
        } else {
          isEssentiel = true;
        }
      }
      if (angular.isDefined(vm.aboOvActif)) {
        isOvin = true;
      }

      angular.forEach(vm.options, function (option) {
        if (angular.isUndefined(option.dependances) || (angular.isDefined(option.dependances) && option.dependances.length === 0)) {
          option.allowed = true;
          vm.anyOptionEnabled = true;
        } else {
          option.allowed = false;
        }

        angular.forEach(option.dependances, function (dependance) {
          if (option.allowed === false) {
            if (_.isEqual(dependance, 'Performance')) {
              if (isPerformance) {
                option.allowed = true;
                vm.anyOptionEnabled = true;
              }
            } else if (_.isEqual(dependance, 'Essentiel')) {
              if (isEssentiel) {
                option.allowed = true;
                vm.anyOptionEnabled = true;
              }
            } else if (_.isEqual(dependance, 'Ovin/Caprin')) {
              if (isOvin) {
                option.allowed = true;
                vm.anyOptionEnabled = true;
              }
            }
          }
        });
      });
    }

    $scope.$watch(function () {
      vm.testValiditeFormDataHub();
      if (vm.contact && vm.origineContact) {
        vm.isEqual = _.isEqual(vm.origineContact, vm.contact);
      }
      if (angular.isDefined(vm.aboFloreActif.preference) && (angular.isDefined(vm.notificationForm && vm.notificationForm.$valid))) {
        if (!_.isEqual(vm.aboFloreActif, vm.origineAboFloreActif) && (vm.aboFloreActif.preference === 'sms' || (vm.aboFloreActif.preference === 'skype' && vm.parametres.FLORE_SKYPE_OPTION === 'enabled') || (vm.aboFloreActif.preference === 'facebook' && vm.parametres.FLORE_FACEBOOK_OPTION === 'enabled'))) {
          vm.disableEnregistrerFlore = false;
        } else {
          vm.disableEnregistrerFlore = true;
        }
      } else {
        vm.disableEnregistrerFlore = true;
      }
    }, true);

    /* GESTION DE L'ONGLET INFORMATIONS */
    vm.validerModificationInformations = function () {
      if (vm.contactForm.$valid) {
        var appels = [];
        if (vm.contact.mail !== vm.confirmMail && angular.isDefined(vm.confirmMail)) {
          ModalService.alert({
            template: "La confirmation de l’e-mail ne correspond pas à l’e-mail initialement saisi."
          });
        } else {
          if (vm.contact.mail !== vm.origineContact.mail) {
            appels.push(CompteService.modifieMailContact(vm.login, vm.contact.mail));
          }

          if (vm.contact.telMobile !== vm.origineContact.telMobile) {
            appels.push(CompteService.modifieTelPortableContact(vm.login, vm.contact.telMobile));
          }

          if (vm.contact.telFixe !== vm.origineContact.telFixe) {
            appels.push(CompteService.modifieTelFixeContact(vm.login, vm.contact.telFixe));
          }

          LoadingService.show();
          Promise.all(appels).then(function () {
            LoadingService.hide();
            if (angular.equals(vm.contact, vm.origineContact)) {
              $state.go('app.eleveur.bovin.home');
            } else {
              ModalService.alert({
                template: "Vos informations ont bien été modifiées."
              }).then(function () {
                init();
                $state.go('app.eleveur.bovin.home');
              });
            }
          }, function (error) {
            LoadingService.hide();
            if (angular.isDefined(_.get(error, 'status')) && _.get(error, 'status') === 403) {
              dialog(_.get(error, 'data.message'));
            } else {
              ErrorService.alert(error);
            }
          });
        }
      }
    };

    vm.annuleModificationsInformations = function () {
      vm.contact = vm.origineContact;
      init();
      if (_.isEqual($stateParams.bov, true)) {
        $state.go('app.eleveur.bovin.home');
      } else {
        $state.go('app.eleveur.woc.home');
      }
    };

    /* GESTION DE L'ONGLET SERVICE */
    var hasClotureCompteDifferee = false;
    var hasModificationBovinDifferee = false;
    var hasModificationOvcapDifferee = false;

    // RECUPERATION DES ABONNEMENTS ACTIFS
    CompteService.getAbonnements(UserService.get('login')).then(function (result) {
      // pas d'abonnement en cours, compte fermé, déconnexion
      if (!angular.isArray(result) || result.length === 0) {
        AuthentService.logout();
      }
      angular.forEach(result, function (abonnement) {
        abonnements = result;
        if (_.isEqual(abonnement.typeAbonnement.code, 'BOV')) {
          vm.aboBovActif = abonnement;
          aboBovinActif = abonnement;
        }
        if (_.isEqual(abonnement.typeAbonnement.code, 'OVCAP')) {
          vm.aboOvActif = abonnement;
          aboOvinActif = abonnement;
        }
        if (_.isEqual(abonnement.typeAbonnement.code, 'FLORE')) {
          abonnementFloreActif = abonnement;
          vm.showNotification = true;
          vm.origineShowNotification = vm.showNotification;
          FloreService.getAbonneFlore(UserService.get('login')).then(function (result) {
            vm.aboFloreActif = result;
            vm.origineAboFloreActif = angular.copy(result);
          });
        }
        // en attendant de monter un service propre pour les infos du compte...
        compteId = abonnement.compteId;
        // INIT DEMANDES DIFFEREES
        // mise en place des libellés adéquats d'après le type de modification en cours
        if (angular.isDefined(abonnement.dateDemandeDifferee)) {
          var description;
          switch (abonnement.typeModificationDifferee) {
            case 'RESILIATION_ABONNEMENT_BOVIN':
              description = 'Résiliation de l\'abonnement à la formule bovin';
              hasModificationBovinDifferee = true;
              break;
            case 'CHANGEMENT_PERF_VERS_ESS':
              description = 'Modification de l\'abonnement Perfomance Bovin en Essentiel Bovin';
              hasModificationBovinDifferee = true;
              break;
            case 'RESILIATION_ABONNEMENT_OVCAP':
              description = 'Résiliation de l\'abonnement à la formule ovin/caprin';
              hasModificationOvcapDifferee = true;
              break;
            case 'CLOTURE_COMPTE':
              description = 'Clôture de compte';
              hasClotureCompteDifferee = true;
              break;
            default:
              description = '';
          }

          var idAbonnement;
          var typeModificationDifferee;
          // une seule ligne à conserver en cas de clôture de compte
          if (hasClotureCompteDifferee) {
            vm.modificationsEnCours = [];
            description = 'Clôture de compte';
            typeModificationDifferee = 'CLOTURE_COMPTE';
          } else {
            idAbonnement = abonnement.idEleveurOrganismeAbonnement;
            typeModificationDifferee = abonnement.typeModificationDifferee;
          }
          // note: si clôture, pas d'idEleveurOrganismeAbonnement
          vm.modificationsEnCours.push({
            idAbonnement: idAbonnement,
            description: description,
            dateEffective: abonnement.dateClotureEffective,
            typeModificationDifferee: typeModificationDifferee
          });

        }
      });
      getOptionsEnabled();
      if ((angular.isDefined(vm.options) && vm.options.length > 0 && angular.isDefined(vm.anyOptionEnabled) && vm.anyOptionEnabled === true) || (angular.isDefined(vm.abonnementFlore) && angular.isDefined(vm.aboBovActif))) {
        vm.onglets.splice(1, 0, {
          libelle: 'options'
        });
      }
      if (angular.isDefined(vm.aboBovActif)) {
        vm.onglets.splice(4, 0, {
          libelle: 'facturation'
        });
      }
    }, function (error) {
      ErrorService.alert(error);
    });

    // RECUPERATION DES ABONNEMENTS BOVIN
    vm.abonnementsBovin = _.get(niveaux, 'BOV');

    // RECUPERATION DES ABONNEMENTS OVIN
    vm.abonnementsOvCap = _.get(niveaux, 'OVCAP');

    // RECUPERATION DES INFOS LIEES AU TYPE D'ABONNEMENT BOVIN ACTUEL
    var niveauBovActuel = _.find(vm.abonnementsBovin, {
      disponible: false
    });

    // RECUPERATION DES INFOS LIEES AU TYPE D'ABONNEMENT OVIN ACTUEL
    var niveauWocActuel = _.find(vm.abonnementsOvCap, {
      disponible: false
    });

    if (angular.isDefined(niveauBovActuel)) {
      vm.bovin = niveauBovActuel;
    } else {
      vm.bovin = 0;
    }

    vm.bovinSelected = !_.isEqual(vm.bovin, 0);
    if (angular.isDefined(niveauWocActuel)) {
      vm.ovin = niveauWocActuel;
    } else {
      vm.ovin = 0;
    }

    // gestion classique pendant période rétractation
    // idem si ESS -> PERF
    // hors période rétractation, si PERF -> ESS : gestion différée (<=> maintenir les services PERF jusqu'à terme)
    vm.modificationBovin = function (abonnementBovinSelectionne) {
      if (angular.isDefined(aboBovinActif)) {
        var timeDiff = _.subtract(_.now(), new Date(aboBovinActif.dateDebutGestion).getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        var estModificationImpossible = (niveauBovActuel.nomAbonnement === NOMABONNEMENT.PERFORMANCE) && (diffDays > niveauBovActuel.retractationMaxJours);
        // si demande de modification différée en cours, blocage
        if (hasModificationBovinDifferee || hasClotureCompteDifferee) {
          saisie.changeAbonnement = false;
          ModalService.alert({
            template: "Une demande de modification est actuellement en cours pour cet abonnement. Veuillez annuler la demande en cours pour effectuer cette opération."
          }).then(function () {
            vm.bovin = niveauBovActuel;
          });
        } else if (estModificationImpossible) {
          // si augmentation niveau et durée engagement minimum non atteint
          saisie.changeAbonnement = false;
          changeNiveauAbonnementDiffereeDialog(aboBovinActif.idEleveurOrganismeAbonnement, abonnementBovinSelectionne.idTarifAbonnementOrganisme);
          vm.bovin = niveauBovActuel;
        } else {
          // si augmentation niveau et durée engagement minimum atteint
          ModalService.confirm({
            template: "Votre abonnement à l’offre " + niveauBovActuel.libelleAbonnement + " va être modifié prochainement. Souhaitez-vous continuer ?"
          }).then(function () {
            updateAbonnement(aboBovinActif.idEleveurOrganismeAbonnement, vm.bovin.idTarifAbonnementOrganisme);
          }, function () {
            vm.bovin = niveauBovActuel;
          });
        }
      } else {
        abonnementSelectionne = abonnementBovinSelectionne;
        ajoutAbonnementDialog("Votre abonnement à Pilot'Elevage va être modifié. Souhaitez-vous continuer ?");
      }
    };

    vm.resiliationBovin = function () {
      var msg;
      abonnementSelectionne = aboBovinActif;
      var timeDiff = _.subtract(_.now(), new Date(aboBovinActif.dateDebutGestion).getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      var estSuppressionImpossible = (diffDays > niveauBovActuel.retractationMaxJours);
      if (hasModificationBovinDifferee || hasClotureCompteDifferee) {
        ModalService.alert({
          template: "Une demande de modification est actuellement en cours pour cet abonnement. Veuillez annuler la demande en cours pour effectuer cette opération."
        }).then(function () {
          saisie.changeAbonnement = false;
          vm.bovin = niveauBovActuel;
        });
      } else if (estSuppressionImpossible) {
        saisie.changeAbonnement = false;
        vm.bovin = niveauBovActuel;
        resiliationDiffereeDialog();
      } else if (abonnements.length > 1) {
        msg = '<p>Vous souhaitez résilier votre abonnement à l’offre ' + niveauBovActuel.libelleAbonnement + '.</p>';
        msg += '<p>Information : En cas de résiliation durant la période de rétractation, les services ne seront pas facturés. Souhaitez-vous continuer ?</p>';
        resiliationAbonnementDialog(msg);
      } else {
        msg = '<p>Vous souhaitez résilier votre abonnement à l’offre ' + niveauBovActuel.libelleAbonnement + '.</p>';
        msg += '<p class="bold">Cela a pour conséquence de clôturer votre compte.</p>';
        msg += '<p>Information : En cas de résiliation durant la période de rétractation, les services ne seront pas facturés. Souhaitez-vous continuer ?</p>';
        resiliationAbonnementDialog(msg);
      }
    };

    vm.modificationOvin = function (abonnementOvinSelectionne) {
      if (hasModificationOvcapDifferee || hasClotureCompteDifferee) {
        ModalService.alert({
          template: "Une demande de modification est actuellement en cours pour cet abonnement. Veuillez annuler la demande en cours pour effectuer cette opération."
        }).then(function () {
          vm.ovin = niveauWocActuel;
        });
      } else if (!_.isEqual(abonnementOvinSelectionne, niveauWocActuel)) {
        if (angular.isDefined(aboOvinActif)) {
          ModalService.confirm({
            template: "Votre abonnement à l’offre " + niveauWocActuel.libelleAbonnement + " va être modifié prochainement. Souhaitez-vous continuer ?"
          }).then(function () {
            updateAbonnement(aboOvinActif.idEleveurOrganismeAbonnement, vm.bovin.idTarifAbonnementOrganisme);
          }, function () {
            vm.ovin = niveauWocActuel;
          });
        } else {
          abonnementSelectionne = abonnementOvinSelectionne;
          ajoutAbonnementDialog("Votre abonnement à Pilot'Elevage va être modifié. Souhaitez-vous continuer ?");
        }
      }
    };
    vm.notificationOuiButton = function () {
      if (vm.showNotification === false || angular.isUndefined(vm.showNotification)) {
        vm.showNotification = true;
        if (angular.isUndefined(vm.aboFloreActif.telephoneSms)) {
          vm.aboFloreActif.telephoneSms = vm.contact.telMobile;
        }
        $location.hash('div-bottom');
        $anchorScroll();
      }
    };

    vm.datahubButton = function (option, value) {
      option.isSelected = value;
      $timeout(function () {
        $location.hash('bottom-' + option.idAbonnement);
        $anchorScroll();
      });
    };

    vm.notificationNonButton = function () {
      if (vm.showNotification === true || angular.isUndefined(vm.showNotification)) {
        if (angular.isDefined(abonnementFloreActif)) {
          ModalService.confirm({
            template: "Votre abonnement à Pilot'Elevage va être modifié. Souhaitez-vous continuer ?"
          }).then(function () {
            LoadingService.show();
            CompteService.resiliationAbonnement(UserService.get('login'), abonnementFloreActif.idEleveurAbonnementExploitation, vm.raisonChoix).then(function () {
              LoadingService.hide();
              vm.showNotification = false;
              vm.origineShowNotification = vm.showNotification;
              ModalService.alert({
                title: "Confirmation",
                template: '<p>Vous avez choisi de vous désabonner au service de notification des sorties présumées. ' +
                  '<b>Sachez que ce service reste disponible à tout moment sans surcoût d\'abonnement.</b></p>' +
                  '<p>Nous vous informons que votre modification a bien été prise en compte.</p>'
              }).then(function () {
                $mdDialog.hide();
                $stateParams.onglet = 'options';
                $state.transitionTo($state.current, $stateParams, {
                  reload: true
                });
              });
            }, function (error) {
              LoadingService.hide();
              if (_.get(error, 'data.code')) {
                dialog(error.data.message);
              } else {
                ErrorService.alert(error);
              }
            });
          }, function () {
            vm.showNotification = true;
            vm.origineShowNotification = vm.showNotification;
          });
        } else {
          // Mise à jour du status de l'alerte
          CompteService.getAlertNotification(profil.login).then(function (alertNotification) {
            if (angular.isUndefined(alertNotification.alerte)) {
              CompteService.saveAlertNotification(profil.login, false);
            }
          });
          vm.showNotification = false;
          vm.origineShowNotification = vm.showNotification;
        }
      }
    };
    function updateFloreInformations() {
      FloreService.updateAbonneFlore(UserService.get('exploitationActive.numExploitation'), vm.aboFloreActif).then(function () {
        LoadingService.hide();
        ModalService.alert({
          template: "Votre modification a bien été prise en compte."
        }).then(function () {
          if ($stateParams.showNotification) {
            CompteService.saveAlertNotification(profil.login, true);
          }
          $mdDialog.hide();
          $stateParams.onglet = 'options';
          $state.transitionTo($state.current, $stateParams, {
            reload: true
          });
        });
      }, function (error) {
        LoadingService.hide();
        if (_.get(error, 'data.code')) {
          dialog(error.data.message);
        } else {
          ErrorService.alert(error);
        }
      });
    }
    vm.enregistrerNotif = function () {
      if (!vm.notificationForm.$invalid && angular.isDefined(vm.aboFloreActif.preference)) {
        /* ModalService.confirm({
          template: "Votre abonnement à Pilot'Elevage va être modifié. Souhaitez-vous continuer ?"
        }).then(function () { */
        LoadingService.show();
        if (angular.isDefined(abonnementFloreActif)) {
          updateFloreInformations();
        } else {
          CompteService.ajoutAbonnementFlore(UserService.get('login'), vm.abonnementFlore[0].idTarifAbonnementOrganisme, vm.aboFloreActif.telephoneSms).then(function () {
            updateFloreInformations();
          }, function (error) {
            LoadingService.hide();
            if (_.get(error, 'data.code')) {
              dialog(error.data.message);
            } else {
              ErrorService.alert(error);
            }
          });
        }
        /* LoadingService.show();
      }, function () {
        vm.aboFloreActif = angular.copy(vm.origineAboFloreActif);
        vm.showNotification = vm.origineShowNotification;
      }); */
      }
    };

    vm.resiliationOvin = function () {
      var msg;
      abonnementSelectionne = aboOvinActif;
      var timeDiff = _.subtract(_.now(), new Date(aboOvinActif.dateDebutGestion).getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      var estSuppressionImpossible = (diffDays > niveauWocActuel.retractationMaxJours);
      if (hasModificationOvcapDifferee || hasClotureCompteDifferee) {
        saisie.changeAbonnement = false;
        ModalService.alert({
          template: "Une demande de modification est actuellement en cours pour cet abonnement. Veuillez annuler la demande en cours pour effectuer cette opération."
        }).then(function () {
          vm.ovin = niveauWocActuel;
        });
      } else if (estSuppressionImpossible) {
        saisie.changeAbonnement = false;
        vm.ovin = niveauWocActuel;
        resiliationDiffereeDialog();
      } else if (abonnements.length > 1) {
        msg = '<p>Vous souhaitez résilier votre abonnement à l’offre Pilot\'Elevage Ovin/Caprin.</p>';
        msg += '<p>Information : En cas de résiliation durant la période de rétractation, les services ne seront pas facturés. Souhaitez-vous continuer ?</p>';
        resiliationAbonnementDialog(msg);
      } else {
        msg = '<p>Vous souhaitez résilier votre abonnement à l’offre Pilot\'Elevage Ovin/Caprin.</p>';
        msg += '<p class="bold">Cela a pour conséquence de clôturer votre compte.</p>';
        msg += '<p>Information : En cas de résiliation durant la période de rétractation, les services ne seront pas facturés. Souhaitez-vous continuer ?</p>';
        resiliationAbonnementDialog(msg);
      }

    };

    vm.showHelp = function () {
      ModalService.floreInfos();
    };

    vm.clotureCompte = function () {
      var timeDiffOv;
      var diffDaysOv;
      var estSuppressionImpossibleOv;
      if (angular.isDefined(aboOvinActif)) {
        timeDiffOv = _.subtract(_.now(), new Date(aboOvinActif.dateDebutGestion).getTime());
        diffDaysOv = Math.ceil(timeDiffOv / (1000 * 3600 * 24));
        estSuppressionImpossibleOv = (diffDaysOv > niveauWocActuel.retractationMaxJours);
      }
      var timeDiffBov;
      var diffDaysBov;
      var estSuppressionImpossibleBov;
      if (angular.isDefined(aboBovinActif)) {
        timeDiffBov = _.subtract(_.now(), new Date(aboBovinActif.dateDebutGestion).getTime());
        diffDaysBov = Math.ceil(timeDiffBov / (1000 * 3600 * 24));
        estSuppressionImpossibleBov = (diffDaysBov > niveauBovActuel.retractationMaxJours);
      }
      // si modif différée en cours -> impossible
      // si tous abonnements en période de rétraction, clôture compte directe possible
      // sinon (passé période de rétractation) clôture de compte différée
      if (hasModificationBovinDifferee || hasModificationOvcapDifferee || hasClotureCompteDifferee) {
        // modale d'information : modification différée en cours, nécessite annulation des modifications
        saisie.changeAbonnement = false;
        ModalService.alert({
          template: "Une demande de modification est actuellement en cours pour cet abonnement. Veuillez annuler la demande en cours pour effectuer cette opération."
        });
      } else if (!estSuppressionImpossibleBov && !estSuppressionImpossibleOv) {
        // tout en période de rétractation, prise en compte immédiate
        clotureCompteDialog("Vos abonnements à Pilot'Elevage vont être résiliés, cela a pour conséquence de clôturer votre compte. Souhaitez-vous continuer ?");
      } else {
        // ovin et/ou bovin a passé la période de rétractation : clôture de compte différée
        // modale modification différée / clôture de compte
        clotureCompteDiffereeDialog();
      }
    };

    // gestion différée - résiliation
    function resiliationDiffereeDialog() {
      // exclure changement niveau, changement détention et cessation activités
      var raisons = ReferentielService.getRaisonsResiliations();
      vm.raisonsResiliations = _.filter(raisons, function (raison) {
        if (raison.code === '1' || raison.code === '4' || raison.code === '5') {
          return false;
        }
        return true;
      });
      vm.commentaireLibre = '';
      $mdDialog.show({
        controller: DialogResiliationDiffereeController,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: "app/eleveur/compte/compte/templates/demandeModificationAbonnement.html",
        locals: {
          raisonChoix: vm.raisonChoix,
          raisonsResiliations: vm.raisonsResiliations,
          commentaireLibre: vm.commentaireLibre
        }
      });
    }

    // controller demande de modification différée - résiliation
    function DialogResiliationDiffereeController() {
      var vm = this;

      vm.annulerDemande = function () {
        $mdDialog.hide();
        restore();
      };

      // confirmer la demande résiliation différée
      vm.confirmerDemande = function () {
        LoadingService.show();
        if (vm.raisonChoix === 'AUTRE') {
          vm.raisonChoix = vm.commentaireLibre;
        }
        CompteService.resiliationAbonnement(UserService.get('login'), abonnementSelectionne.idEleveurAbonnementExploitation, vm.raisonChoix).then(function () {
          LoadingService.hide();
          $mdDialog.hide();
          $state.reload('app');
        }, function (error) {
          LoadingService.hide();
          $mdDialog.hide();
          if (_.get(error, 'data.code')) {
            dialog(error.data.message);
          } else {
            ErrorService.alert(error);
          }
        });
      };
    }

    // rafraîchir la vue principale avec les niveaux d'abonnements actuels
    function restore() {
      if (angular.isDefined(niveauBovActuel)) {
        vm.bovin = niveauBovActuel;
      } else {
        vm.bovin = 0;
      }
      if (angular.isDefined(niveauWocActuel)) {
        vm.ovin = niveauWocActuel;
      } else {
        vm.ovin = 0;
      }
    }

    // résiliation durant période rétractation
    function resiliationAbonnementDialog(message) {
      vm.raisonsResiliations = ReferentielService.getRaisonsResiliations();
      vm.commentaireLibre = '';
      ModalService.confirm({
        template: message
      }).then(function () {
        $mdDialog.show({
          controller: DialogResiliationAbonnementController,
          controllerAs: 'ctrl',
          bindToController: true,
          templateUrl: "app/eleveur/compte/compte/templates/confirmClotureAbonnement.html",
          locals: {
            raisonChoix: vm.raisonChoix,
            raisonsResiliations: vm.raisonsResiliations,
            commentaireLibre: vm.commentaireLibre
          }
        });
      }, function () {
        if (angular.isDefined(niveauBovActuel)) {
          vm.bovin = niveauBovActuel;
        } else {
          vm.bovin = 0;
        }
        if (angular.isDefined(niveauWocActuel)) {
          vm.ovin = niveauWocActuel;
        } else {
          vm.ovin = 0;
        }
      });
    }

    function DialogResiliationAbonnementController() {
      var vm = this;
      var message;

      if (abonnements.length > 1) {
        message = "Votre modification a bien été prise en compte. Elle sera effective prochainement.";
      } else {
        message = "Votre compte est maintenant clôturé, vous allez être déconnecté.";
      }
      vm.close = function () {
        LoadingService.show();
        if (vm.raisonChoix === 'AUTRE') {
          vm.raisonChoix = vm.commentaireLibre;
        }
        CompteService.resiliationAbonnement(UserService.get('login'), abonnementSelectionne.idEleveurAbonnementExploitation, vm.raisonChoix).then(function () {
          LoadingService.hide();
          ModalService.alert({
            template: message
          }).then(function () {
            $mdDialog.hide();
            if (abonnements.length > 1) {
              $state.reload('app');
            } else {
              $state.go('auth');
            }
          });

        }, function (error) {
          LoadingService.hide();
          if (_.get(error, 'data.code')) {
            dialog(error.data.message);
          } else {
            ErrorService.alert(error);
          }
        });
      };
    }

    function ajoutAbonnementDialog(message) {
      ModalService.confirm({
        template: message
      }).then(function () {
        $mdDialog.show({
          controller: DialogAjoutAbonnementController,
          controllerAs: 'ctrl',
          bindToController: true
        });
      }, function () {
        if (angular.isDefined(niveauBovActuel)) {
          vm.bovin = niveauBovActuel;
        } else {
          vm.bovin = 0;
        }
        if (angular.isDefined(niveauWocActuel)) {
          vm.ovin = niveauWocActuel;
        } else {
          vm.ovin = 0;
        }
      });
    }

    function clotureCompteDialog(message) {
      vm.raisonsResiliations = ReferentielService.getRaisonsResiliations();
      vm.commentaireLibre = '';
      ModalService.confirm({
        template: message
      }).then(function () {
        $mdDialog.show({
          controller: DialogClotureCompteController,
          controllerAs: 'ctrl',
          bindToController: true,
          templateUrl: "app/eleveur/compte/compte/templates/confirmClotureAbonnement.html",
          locals: {
            raisonChoix: vm.raisonChoix,
            raisonsResiliations: vm.raisonsResiliations,
            commentaireLibre: vm.commentaireLibre
          }
        });
      }, function () {
        if (angular.isDefined(niveauBovActuel)) {
          vm.bovin = niveauBovActuel;
        } else {
          vm.bovin = 0;
        }
        if (angular.isDefined(niveauWocActuel)) {
          vm.ovin = niveauWocActuel;
        } else {
          vm.ovin = 0;
        }
      });
    }

    function DialogClotureCompteController() {
      var vm = this;
      vm.close = function () {
        LoadingService.show();
        if (vm.raisonChoix === 'AUTRE') {
          vm.raisonChoix = vm.commentaireLibre;
        }
        CompteService.clotureCompte(UserService.get('login'), vm.raisonChoix).then(function () {
          LoadingService.hide();
          ModalService.alert({
            template: "Votre compte est maintenant clôturé, vous allez être déconnecté."
          }).then(function () {
            $mdDialog.hide();
            $state.go('auth');
          });

        }, function (error) {
          LoadingService.hide();
          if (_.get(error, 'data.code')) {
            dialog(error.data.message);
          } else {
            ErrorService.alert(error);
          }
        });
      };
    }

    // Gestion différée de la clôture de compte
    function clotureCompteDiffereeDialog() {
      // exclure changement niveau, changement détention et cessation activités
      var raisons = ReferentielService.getRaisonsResiliations();
      vm.raisonsResiliations = _.filter(raisons, function (raison) {
        if (raison.code === '1' || raison.code === '4' || raison.code === '5') {
          return false;
        }
        return true;
      });
      vm.commentaireLibre = '';
      $mdDialog.show({
        controller: DialogClotureCompteDiffereeController,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: "app/eleveur/compte/compte/templates/demandeModificationAbonnement.html",
        locals: {
          raisonChoix: vm.raisonChoix,
          raisonsResiliations: vm.raisonsResiliations,
          commentaireLibre: vm.commentaireLibre
        }
      });
    }

    function DialogClotureCompteDiffereeController() {
      var vm = this;

      vm.annulerDemande = function () {
        $mdDialog.hide();
        restore();
      };

      vm.confirmerDemande = function () {
        LoadingService.show();
        if (vm.raisonChoix === 'AUTRE') {
          vm.raisonChoix = vm.commentaireLibre;
        }
        CompteService.clotureCompte(UserService.get('login'), vm.raisonChoix).then(function () {
          LoadingService.hide();
          $mdDialog.hide();
          $state.reload('app');
        }, function (error) {
          LoadingService.hide();
          if (_.get(error, 'data.code')) {
            dialog(error.data.message);
          } else {
            ErrorService.alert(error);
          }
        });
      };
    }

    // changement de niveau différée
    function changeNiveauAbonnementDiffereeDialog(idEleveurOrganismeAbonnementCourant, idTarifAbonnementOrganismeCible) {
      // exclure changement détention et cessation activités
/*      var raisons = ReferentielService.getRaisonsResiliations();
      vm.raisonsResiliations = _.filter(raisons, function (raison) {
        if (raison.code === '1' || raison.code === '4') {
          return false;
        }
        return true;
      });
      vm.commentaireLibre = '';*/
      $mdDialog.show({
        controller: DialogChangementNiveauDiffereeController,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: "app/eleveur/compte/compte/templates/demandeModificationAbonnement.html",
        locals: {
          // raisonChoix: vm.raisonChoix,
          // raisonsResiliations: vm.raisonsResiliations,
          // commentaireLibre: vm.commentaireLibre,
          idEleveurOrganismeAbonnement: idEleveurOrganismeAbonnementCourant,
          idTarifAbonnementOrganisme: idTarifAbonnementOrganismeCible
        }
      });
    }

    function DialogChangementNiveauDiffereeController() {
      var vm = this;

      vm.annulerDemande = function () {
        $mdDialog.hide();
        restore();
      };

      vm.confirmerDemande = function () {
        LoadingService.show();
/*        if (vm.raisonChoix === 'AUTRE') {
          vm.raisonChoix = vm.commentaireLibre;
        }*/
          LoadingService.show();
          CompteService.updateAbonnement(UserService.get('login'), vm.idEleveurOrganismeAbonnement, vm.idTarifAbonnementOrganisme).then(function () {
          LoadingService.hide();
          $mdDialog.hide();
          $state.reload('app');
        }, function (error) {
          LoadingService.hide();
          if (_.get(error, 'data.code')) {
            dialog(error.data.message);
          } else {
            ErrorService.alert(error);
          }
        });
      };
    }

    function DialogAjoutAbonnementController() {
      LoadingService.show();
      CompteService.ajoutAbonnement(UserService.get('login'), abonnementSelectionne.idTarifAbonnementOrganisme).then(function () {
        LoadingService.hide();
        ModalService.alert({
          template: "Votre modification a bien été prise en compte. Elle sera effective prochainement."
        }).then(function () {
          $mdDialog.hide();
          $state.reload('app');
        });

      }, function (error) {
        LoadingService.hide();
        if (_.get(error, 'data.code')) {
          dialog(error.data.message);
        } else {
          ErrorService.alert(error);
        }
      });
    }

    vm.annuleModificationsService = function () {
      if (_.isEqual($stateParams.bov, true)) {
        $state.go('app.eleveur.bovin.home');
      } else {
        $state.go('app.eleveur.woc.home');
      }
    };

    function init() {
      CompteService.getInfosContact(vm.login, UserService.getNumeroExploitation())
        .then(function (profil) {
          contact = {
            mail: profil.mail,
            telMobile: profil.telMobile,
            telFixe: profil.telFixe
          };
          vm.contact = contact;
          vm.origineContact = angular.copy(contact);
          saisie.contact = contact;
          saisie.origineContact = vm.origineContact;
          if ($stateParams.showNotification) {
            vm.aboFloreActif.telephoneSms = vm.contact.telMobile;
          }
        }, function (error) {
          ErrorService.alert(error);
        });
      vm.disableAbonnement = UserService.get('profil') === 'TECHNICIEN';
      if ($stateParams.showNotification) {
        $location.hash('div-bottom');
        $anchorScroll();
      }
    }

    function updateAbonnement(idEleveurOrganismeAbonnement, idTarifAbonnementOrganisme) {
      LoadingService.show();
      CompteService.updateAbonnement(UserService.get('login'), idEleveurOrganismeAbonnement, idTarifAbonnementOrganisme).then(function () {
        LoadingService.hide();
        vm.modifNiveau = false;
        ModalService.alert({
          template: "Votre modification a bien été prise en compte. Elle sera effective prochainement."
        }).then(function () {
          $mdDialog.hide();
          $state.reload('app');
        });

      }, function (error) {
        LoadingService.hide();
        if (_.get(error, 'data.code')) {
          dialog(error.data.message);
        } else {
          ErrorService.alert(error);
        }
      });
    }

    function dialog(text) {
      ModalService.alert({
        template: text
      });
      LoadingService.hide();
    }

    vm.optionDataHubNonButtonClic = function (option) {
      option.isSelected = false;
      if (option.idEleveurAbonnementExploitation) {
        LoadingService.show();
        AbonnementOptionService.deleteOption(UserService.get('login'), option).then(function () {
          LoadingService.hide();
          AbonnementOptionService.saveSaisie(UserService.getNumeroExploitation(), option).then(function () {
          }, function (error) {
            if (_.get(error, 'data.code')) {
              dialog(error.data.message);
            } else {
              ErrorService.alert(error);
            }
          });
          $mdDialog.hide();
          $stateParams.onglet = 'options';
          $state.transitionTo($state.current, $stateParams, {
            reload: true
          });
        }, function (error) {
          LoadingService.hide();
          if (_.get(error, 'data.code')) {
            dialog(error.data.message);
          } else {
            ErrorService.alert(error);
          }
        });
      } else {
        option.estSaisie = true;
      }
    };

    vm.optionNonButtonClic = function (option) {
      option.isSelected = false;
      if (option.idEleveurAbonnementExploitation) {
        ModalService.confirm({
          template: "Votre abonnement à Pilot'Elevage va être modifié. Souhaitez-vous continuer ?"
        }).then(function () {
          LoadingService.show();
          AbonnementOptionService.deleteOption(UserService.get('login'), option).then(function () {
            LoadingService.hide();
            AbonnementOptionService.saveSaisie(UserService.getNumeroExploitation(), option).then(function () {
            }, function (error) {
              if (_.get(error, 'data.code')) {
                dialog(error.data.message);
              } else {
                ErrorService.alert(error);
              }
            });
            ModalService.alert({
              title: "Confirmation",
              template: '<p>Votre modification a bien été prise en compte.</p>'
            }).then(function () {
              $mdDialog.hide();
              $stateParams.onglet = 'options';
              $state.transitionTo($state.current, $stateParams, {
                reload: true
              });
            });
          }, function (error) {
            LoadingService.hide();
            if (_.get(error, 'data.code')) {
              dialog(error.data.message);
            } else {
              ErrorService.alert(error);
            }
          });

        }, function () {
          option.isSelected = true;
        });

      } else {
        LoadingService.show();
        AbonnementOptionService.saveSaisie(UserService.getNumeroExploitation(), option).then(function () {
          LoadingService.hide();
          option.estSaisie = true;
        }, function (error) {
          if (_.get(error, 'data.code')) {
            dialog(error.data.message);
          } else {
            ErrorService.alert(error);
          }
        });
      }
      $location.hash('bottom-' + option.idAbonnement);
      $anchorScroll();
    };

    vm.optionOuiButtonClic = function (option) {
      option.isSelected = true;
      $location.hash('bottom-' + option.idAbonnement);
      $anchorScroll();
      if (!option.templateHtml && !option.idEleveurAbonnementExploitation) {
        LoadingService.show();
        AbonnementOptionService.addOption(UserService.get('login'), option).then(function () {
          LoadingService.hide();
          ModalService.alert({
            template: "Votre modification a bien été prise en compte."
          }).then(function () {
            $mdDialog.hide();
            $stateParams.onglet = 'options';
            $state.transitionTo($state.current, $stateParams, {
              reload: true
            });
          });
        }, function (error) {
          LoadingService.hide();
          if (_.get(error, 'data.code')) {
            dialog(error.data.message);
          } else {
            ErrorService.alert(error);
          }
        });
      }
    };

    vm.showOptionHelp = function (option) {
      ModalService.optionInfos({
        title: option.titrePopup,
        nom: option.nom,
        body: option.contenuPopup
      });
    };

    vm.enregistrerOptionDatahub = function (option) {
      LoadingService.show();
      AbonnementOptionService.addOption(UserService.get('login'), option).then(function () {
        LoadingService.hide();
        ModalService.alert({
          template: "Votre demande a bien été prise en compte."
        }).then(function () {
          $mdDialog.hide();
          $stateParams.onglet = 'options';
          $state.transitionTo($state.current, $stateParams, {
            reload: true
          });
        });
      }, function (error) {
        LoadingService.hide();
        if (_.get(error, 'data.code')) {
          dialog(error.data.message);
        } else {
          ErrorService.alert(error);
        }
      });
    };

    vm.testValiditeFormDataHub = function () {
      angular.forEach(vm.options, function (option) {
        if (_.isEqual(option.nom, 'dataHUB')) {
          var telephone = _.find(option.optionDonneesComplementaires, function (donnee) {
            return donnee.libelle === "N° de téléphone à contacter";
          });
          var marque = _.find(option.optionDonneesComplementaires, function (donnee) {
            return donnee.libelle === "Marque";
          });
          var typeMobile = _.find(option.optionDonneesComplementaires, function (donnee) {
            return donnee.libelle === "Type de matériel";
          });
          var retour = angular.isDefined(telephone.valeur) && angular.isDefined(marque.valeur) && angular.isDefined(typeMobile.valeur);
          vm.formDataHubValid = retour;
        }
      });
    };

    // annuler les modifications liées à la clôture différée
    // (annule toutes les modifications en cours)
    vm.annulerModificationsEnCours = function () {
      // récupération des abonnements à annuler
      // soit depuis les modifs en cours, soit depuis les abonnements connus en cas de clôture de compte
      var abonnementDataIds = [];
      // depuis les modifs en cours
      angular.forEach(vm.modificationsEnCours, function (modification) {
        if (modification.typeModificationDifferee !== 'CLOTURE_COMPTE' && angular.isDefined(modification.idAbonnement)) {
          abonnementDataIds.push(modification.idAbonnement);
        }
      });
      // depuis les abonnements courants (cas de clôture)
      if (abonnementDataIds.length === 0) {
        if (angular.isDefined(aboBovinActif)) {
          abonnementDataIds.push(aboBovinActif.idEleveurOrganismeAbonnement);
        }
        if (angular.isDefined(aboOvinActif)) {
          abonnementDataIds.push(aboOvinActif.idEleveurOrganismeAbonnement);
        }
      }

      var abonnements = {
        compte: {
          compteId: compteId,
          numExploitation: profil.exploitationActive.numExploitation,
          numDetenteur: profil.exploitationActive.numDetenteur
        },
        abonnementDataIds: abonnementDataIds
      };

      CompteService.annulerClotureDifferee(UserService.get('login'), abonnements).then(function () {
        LoadingService.hide();
        $state.reload('app');
      }, function (error) {
        LoadingService.hide();
        if (_.get(error, 'data.code')) {
          dialog(error.data.message);
        } else {
          ErrorService.alert(error);
        }
      });
    };

  }
})();

(function () {
  angular
    .module('app')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('app.eleveur.compte', {
        url: '/compte',
        templateUrl: 'app/eleveur/compte/main/main.html',
        controller: 'CompteMainController',
        controllerAs: 'ctrl',
        params: {
          bov: true
        },
        resolve: {
          saisie: [function () {
            return {};
          }]
        }
      }).state('app.eleveur.compte.compte', {
        url: '/services?onglet',
        templateUrl: 'app/eleveur/compte/compte/compte.html',
        controller: 'CompteController',
        controllerAs: 'ctrl',
        params: {
          showNotification: false,
          onglet: 'services'
        },
        resolve: {
          // eslint-disable-next-line
          niveaux: ['CompteService', 'profil', function (CompteService, profil) {
            return CompteService.getNiveaux();
          }],
          // eslint-disable-next-line
          options: ['AbonnementOptionService', 'profil', function (AbonnementOptionService, profil) {
            return AbonnementOptionService.getOptions();
          }]
        }
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('EleveurBovinMainController', EleveurBovinMainController);

  /** @ngInject */
  function EleveurBovinMainController($state, $stateParams, profil, showAlerteSaisieAutotisations, sortiePresumeeFonctionnalite, CommandeAutoService, ExploitationService,
    CompteService, ErrorService, FonctionnaliteService, LoadingService, ModalService, AlerteSaisieAutorisationsService, InformationService, AuthentService, MenuService) {

    var vm = this;
    MenuService.getMegaMenu('BOV').then(function (megaMenu) {
      vm.menu = megaMenu;
      $state.go('app.eleveur.bovin.home');
    });
    vm.showAlerteSaisieAutotisations = showAlerteSaisieAutotisations;

    vm.getOrientation = function () {
      if (_.isEqual($state.current.name, 'app.eleveur.bovin.home')) {
        return 'horizontal';
      }
      return 'vertical';
    };

    if (AuthentService.hasModaleAccueil() === 'true') {
      AuthentService.setModaleAccueil('false');
      if (showAlerteSaisieAutotisations.forceShowAlerte) {
        showAlerteSaisieAutorisation();
      } else {
        InformationService.displayNextModaleInformation().then(function () {
          CommandeAutoService.checkCommandeAuto().then(function () {
            ExploitationService.hasSortiePresumee(profil.exploitationActive.numExploitation).then(function (hasSortiePresumee) {
              if (hasSortiePresumee === true) {
                ModalService.confirm({
                  template: "Vous avez des sorties présumées, voulez-vous les saisir maintenant ?"
                }).then(function () {
                  goToFonctionnalite(sortiePresumeeFonctionnalite);
                });
              } else if (profil.profil !== 'TECHNICIEN') {
                showPopupFlore();
              }
            }, function () {
              if (profil.profil !== 'TECHNICIEN') {
                showPopupFlore();
              }
            });
          });
        });
      }
    }
    function showAlerteSaisieAutorisation() {
      if (profil.profil !== 'TECHNICIEN') {
        ModalService.changementSystemeAuthentification().then(function () {
          $state.go('app.eleveur.compte.compte', {
            onglet: 'autorisations d\'accès'
          });
        }, function () {

        }).finally(function () {
          AlerteSaisieAutorisationsService.saveAffichageAlerteSaisieAutorisation();
          LoadingService.hide();
        });
      }
    }
    function showPopupFlore() {
      CompteService.getNiveaux(profil.exploitationActive.numExploitation).then(function (list) {
        vm.abonnementFlore = _.get(list, 'FLORE');
        if (angular.isDefined(vm.abonnementFlore)) {
          CompteService.getAbonnements(profil.login).then(function (result) {
            var abonnementBov = _.find(result, ['typeAbonnement.code', 'BOV']);
            if (angular.isDefined(abonnementBov)) {
              CompteService.getAlertNotification(profil.login).then(function (alertNotification) {
                if (angular.isUndefined(alertNotification.alerte)) {
                  ModalService.floreAlerte().then(function () {
                    $state.go('app.eleveur.compte.compte', {
                      showNotification: true,
                      onglet: 'options'
                    });
                  }, function () {
                    CompteService.saveAlertNotification(profil.login, false);
                  });
                } else if (angular.isDefined(vm.showAlerteSaisieAutotisations) && vm.showAlerteSaisieAutotisations.showAlerte) {
                  showAlerteSaisieAutorisation();
                }
              });
            }
          }, function (error) {
            ErrorService.alert(error);
          });
        } else if (angular.isDefined(vm.showAlerteSaisieAutotisations) && vm.showAlerteSaisieAutotisations.showAlerte) {
          showAlerteSaisieAutorisation();
        }
      }, function (error) {
        ErrorService.alert(error);
      });
    }

    function goToFonctionnalite(fonctionnalite) {
      LoadingService.show();

      FonctionnaliteService.goToFonctionnalite(fonctionnalite, {
        newPage: true
      }).catch(function (error) {
        ErrorService.alert(error);
      }).finally(function () {
        LoadingService.hide();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('EleveurBovinHomeController', EleveurBovinHomeController);

  /** @ngInject */
  function EleveurBovinHomeController($state) {
    var vm = this;

    vm.goToMonCompte = function () {
      $state.go('app.eleveur.compte.compte', {
        promo: 'true'
      });
    };
  }
})();

(function () {
  angular
    .module('app')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('app.eleveur.bovin', {
        url: '/bovin',
        controller: 'EleveurBovinMainController',
        templateUrl: 'app/eleveur/bovin/main/main.html',
        controllerAs: 'ctrl',
        resolve: {
          sortiePresumeeFonctionnalite: ['FonctionnaliteService', function (FonctionnaliteService) {
            return FonctionnaliteService.getFonctionnalite('SORTIE_PRESUMEE');
          }],
          showAlerteSaisieAutotisations: ['AlerteSaisieAutorisationsService', function (AlerteSaisieAutorisationsService) {
            return AlerteSaisieAutorisationsService.getShowAlerteSaisieAutorisations();
          }]
        }
      }).state('app.eleveur.bovin.home', {
        url: '/home',
        templateUrl: 'app/eleveur/bovin/home/home.html',
        controller: 'EleveurBovinHomeController',
        controllerAs: 'ctrl'
      }).state('app.eleveur.bovin.fonctionnalite', {
        url: '/fonctionnalite/:code',
        templateUrl: 'app/eleveur/fonctionnalite/fonctionnalite.html',
        controller: 'EleveurFonctionnaliteController',
        controllerAs: 'ctrl',
        resolve: {
          fonctionnalite: ['$stateParams', 'FonctionnaliteService', function ($stateParams, FonctionnaliteService) {
            return FonctionnaliteService.completeAcces($stateParams.code);
          }]
        }
      })
      .state('app.eleveur.bovin.lien_bgta', {
        url: '/lien_bgta',
        templateUrl: 'app/eleveur/lienBgta/lienBgta.html',
        controller: 'EleveurLienBgtaController',
        controllerAs: 'ctrl',
        resolve: {
          menu: ['MenuService', function (MenuService) {
            return MenuService.getMegaMenu('BOV');
          }],
          fonctionnalite: ['FonctionnaliteService', function (FonctionnaliteService) {
            return FonctionnaliteService.getFonctionnalite('LIEN_BGTA');
          }]
        }
      })
      .state('app.eleveur.bovin.lien_commandes_ia', {
        url: '/lien_commandes_ia',
        templateUrl: 'app/eleveur/lienCommandesIA/lienCommandesIA.html',
        controller: 'EleveurLienCommandesIAController',
        controllerAs: 'ctrl',
        resolve: {
          menu: ['MenuService', function (MenuService) {
            return MenuService.getMegaMenu('PARTENAIRES');
          }],
          fonctionnalite: ['FonctionnaliteService', function (FonctionnaliteService) {
            return FonctionnaliteService.getFonctionnalite('LIEN_COMMANDES_IA');
          }]
        }
      })
      .state('app.eleveur.lienApplication', {
        url: '/lienApplication',
        templateUrl: 'app/eleveur/lienApplication/lienApplication.html',
        controller: 'LienApplicationController',
        controllerAs: 'ctrl',
        resolve: {
          departements: ['ContactService', function (ContactService) {
            return ContactService.getDepartements();
          }]
        }
      })
      ;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('MenuService', MenuService);

  /* @ngInject */
  function MenuService($http, $q, BACKEND) {
    var service = {
      getMegaMenu: getMegaMenu
    };
    return service;

    function getMegaMenu(code) {
      return $q(function (resolve, reject) {
        $http.post(BACKEND.url + '/menus/mega', {
          code: code,
          libelle: ""
        }).then(function (response) {
          resolve(response.data);
        }, function (error) {
          error.fatal = true;

          reject(error);
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('PopupLoginSynelController', PopupLoginSynelController);

  /** @ngInject */
  function PopupLoginSynelController($mdDialog) {
    var vm = this;

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.confirm = function (loginSynel) {
      $mdDialog.hide(loginSynel);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminTechniciensGestionController', AdminTechniciensGestionController);

  /** @ngInject */
  function AdminTechniciensGestionController($filter, $scope, $state, ErrorService, LoadingService, ModalService, TechniciensService) {
    var vm = this;

    vm.afficheListeTechniciens = false;
    vm.listeTechniciens = [];
    vm.listeTechniciensFiltree = [];

    LoadingService.show();
    TechniciensService.getListeTechniciens().then(function (liste) {
      vm.listeTechniciens = liste;
      vm.listeTechniciensFiltree = vm.listeTechniciens.slice();
      vm.afficheListeTechniciens = true;
    }, function (error) {
      ErrorService.alert(error);
    }).finally(function () {
      LoadingService.hide();
    });

    vm.appliqueFiltre = function () {
      return $filter('filter')(vm.listeTechniciens, function (tech) {
        var techLogin = angular.copy(tech.login) || '';
        var techMail = angular.copy(tech.mail) || '';
        var identifiant = angular.copy(vm.searchIdentifiant) || '';
        var mail = angular.copy(vm.searchEmail) || '';
        return techLogin.toLowerCase().indexOf(identifiant.toLowerCase()) !== -1 &&
        techMail.toLowerCase().indexOf(mail.toLowerCase()) !== -1;
      });
    };

    $scope.$watch(function () {
      return vm.searchIdentifiant;
    }, function () {
      vm.listeTechniciensFiltree = vm.appliqueFiltre();
    });

    $scope.$watch(function () {
      return vm.searchEmail;
    }, function () {
      vm.listeTechniciensFiltree = vm.appliqueFiltre();
    });

    vm.suppressionTechnicien = function (technicien) {
      ModalService.confirm({
        template: "Souhaitez-vous vraiment supprimer le technicien " + technicien.login + " ?"
      }).then(function () {
        LoadingService.show();
        TechniciensService.supprimeTechnicien(technicien)
        .then(function () {
          LoadingService.show();
          TechniciensService.getListeTechniciens().then(function (liste) {
            vm.listeTechniciens = liste;
            vm.listeTechniciensFiltree = vm.appliqueFiltre();
          }, function (error) {
            ErrorService.alert(error);
          }).finally(function () {
            LoadingService.hide();
          });
        }, function (error) {
          ErrorService.alert(error);
        })
        .finally(function () {
          LoadingService.hide();
        });
      });
    };

    vm.goToAffectations = function (technicien) {
      $state.go('app.admin.techniciens.affectation', {
        technicien: technicien
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminTechniciensCreationController', AdminTechniciensCreationController);

  /** @ngInject */
  function AdminTechniciensCreationController($state, ErrorService, LoadingService, TechniciensService) {
    var vm = this;

    vm.afficheFormDetails = false;

    vm.saisieTechnicien = {};

    vm.rechercheTechnicien = function () {
      vm.afficheFormDetails = false;
      vm.saisieTechnicien = {};
      LoadingService.show();
      TechniciensService.verifTechnicienSSO(vm.identifiant).then(function (technicien) {
        if (technicien.profil === 'TECHNICIEN') {
          vm.saisieTechnicien = technicien;
          if (technicien.dejaCree) {
            $state.go('app.admin.techniciens.affectation', {
              technicien: vm.saisieTechnicien
            });
          } else {
            vm.afficheFormDetails = true;
          }
        } else {
          ErrorService.alert(null, {message: "Ce compte n'est pas associé à un profil technicien"});
        }
      }, function (error) {
        if (angular.isDefined(_.get(error, 'data.code')) && error.data.code === 1025) {
          ErrorService.alert(null, {message: "Ce compte n'existe pas dans le SSO"});
        } else {
          ErrorService.alert(error);
        }
      }).finally(function () {
        LoadingService.hide();
      });
    };

    vm.ajoutTechnicien = function () {
      LoadingService.show();
      TechniciensService.creationTechnicien(vm.saisieTechnicien).then(function () {
        $state.go('app.admin.techniciens.affectation', {
          technicien: vm.saisieTechnicien
        });
      }, function (error) {
        ErrorService.alert(error);
      }).finally(function () {
        LoadingService.hide();
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminTechniciensAffectationController', AdminTechniciensAffectationController);

  /** @ngInject */
  function AdminTechniciensAffectationController($filter, $scope, $stateParams, cheptelsAffectables, cheptelsAffectes, ErrorService, LoadingService, TechniciensService, UserService) {
    var vm = this;

    vm.curentDepartement = UserService.get('deptRatt');

    vm.technicien = $stateParams.technicien;

    vm.exploitationInconnue = false;
    vm.dejaAffecte = false;

    vm.filterAffectes = '';

    cheptelsAffectes = $filter('orderBy')(cheptelsAffectes, 'numExploitation');

    $scope.$watch(function () {
      return vm.filterAffectes;
    }, function () {
      vm.cheptelsAffectes = $filter('filter')(cheptelsAffectes, function (cheptel) {
        var numex = angular.copy(cheptel.numExploitation) || '';
        var raisoc = angular.copy(cheptel.raisonSociale) || '';
        return numex.toLowerCase().indexOf(vm.filterAffectes.toLowerCase()) !== -1 ||
               raisoc.toLowerCase().indexOf(vm.filterAffectes.toLowerCase()) !== -1;
      });
    }, true);

    $scope.$watch(function () {
      return cheptelsAffectes;
    }, function () {
      vm.cheptelsAffectes = $filter('filter')(cheptelsAffectes, function (cheptel) {
        var numex = angular.copy(cheptel.numExploitation) || '';
        var raisoc = angular.copy(cheptel.raisonSociale) || '';
        return numex.toLowerCase().indexOf(vm.filterAffectes.toLowerCase()) !== -1 ||
               raisoc.toLowerCase().indexOf(vm.filterAffectes.toLowerCase()) !== -1;
      });
    }, true);

    vm.isOfCurrentDepartement = function (cheptel) {
      var cheptelAutorise = _.find(cheptelsAffectables, {numExploitation: cheptel.numExploitation});
      if (angular.isDefined(cheptelAutorise)) {
        return true;
      }
      return false;
    };

    vm.ajoutCheptel = function (numCheptel) {
      if (angular.isDefined(numCheptel) && numCheptel !== null && numCheptel !== '') {
        LoadingService.show();
        var cheptel = _.find(cheptelsAffectables, {numExploitation: numCheptel});
        if (angular.isDefined(cheptel)) {
          vm.exploitationInconnue = false;
          if (_.some(cheptelsAffectes, {numExploitation: numCheptel})) {
            vm.dejaAffecte = true;
            LoadingService.hide();
          } else {
            vm.dejaAffecte = false;
            TechniciensService.ajoutCheptel(vm.technicien, cheptel).then(function () {
              vm.saisieExploitation = null;
              vm.affectationForm.$setPristine();
              vm.affectationForm.$setUntouched();
              vm.filterAffectes = '';
              cheptelsAffectes.unshift(cheptel);
            }, function (error) {
              ErrorService.alert(error);
            }).finally(function () {
              LoadingService.hide();
            });
          }
        } else {
          vm.exploitationInconnue = true;
          LoadingService.hide();
        }
      }
    };

    vm.supprimeCheptel = function (cheptel) {
      if (vm.isOfCurrentDepartement(cheptel)) {
        LoadingService.show();
        TechniciensService.supprimeCheptel(vm.technicien, cheptel).then(function () {
          _.remove(cheptelsAffectes, {numExploitation: cheptel.numExploitation});
        }, function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });
      }
      if (angular.isUndefined(vm.saisieExploitation) || vm.saisieExploitation === null || vm.saisieExploitation === '') {
        vm.saisieExploitation = null;
        vm.affectationForm.$setPristine();
        vm.affectationForm.$setUntouched();
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminGestionModalesListController', AdminGestionModalesListController);

  /** @ngInject */
  function AdminGestionModalesListController($scope, $filter, InformationService, ModalService, $state) {

    var vm = this;

    vm.initModales = function () {
      vm.allModalesList = [];
      vm.modalesListAffichees = [];
      InformationService.getAllModaleConfigurations()
        .then(function (allModalesResponse) {
          const modalesWithDates = vm.getModalesWithDates(allModalesResponse);
          vm.allModalesList = modalesWithDates;
          vm.modalesListAffichees = modalesWithDates;
        });
    };

    vm.initModales();

    vm.currentPage = 0;
    vm.pageSize = 10;
    vm.numberOfPages = function () {
      return Math.ceil(vm.modalesListAffichees.length / vm.pageSize);
    };

    vm.filter = {
      search: {
        value: '',
        properties: ['code', 'titre', 'dateCreation', 'debutAffichage', 'finAffichage']
      }
    };

    vm.order = {
      default: {
        reverse: false,
        property: "debutAffichage"
      }
    };

    $scope.$watch(function () {
      return vm.filter;
    }, function () {
      vm.modalesListAffichees = $filter('filterModale')(vm.allModalesList, vm.filter);
    }, true);

    vm.editer = function (modale) {
      $state.go('app.admin.gestionModalesCreate', {mode: 'edition', code: modale.code});
    };

    vm.dupliquer = function (modale) {
      $state.go('app.admin.gestionModalesCreate', {mode: 'duplication', code: modale.code});
    };

    vm.supprimer = function (modale) {

      ModalService.confirm({
        template: "Êtes-vous sûr de vouloir supprimer la modale " + modale.code + " ?"
      }).then(function () {
        InformationService.deleteModaleConfiguration(modale.code, true)
          .then(function () {
            vm.initModales();
          });
      });

    };

    vm.getModaleWithDates = function (modaleStrDate) {
      var newModale = angular.copy(modaleStrDate); // Copie l'objet sans modifier l'original
      if (newModale.periodes && newModale.periodes.length > 0) {
        newModale.debutAffichage = newModale.periodes[0].debut + ".00000";
        newModale.finAffichage = newModale.periodes[0].fin + ".00000";
      }
      return newModale;
    };

    vm.getModalesWithDates = function (modalesStrDate) {
      return modalesStrDate.map(function (modaleStrDate) {
        return vm.getModaleWithDates(modaleStrDate);
      });
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminGestionModalesCreerController', AdminGestionModalesCreerController);

  /** @ngInject */
  function AdminGestionModalesCreerController(
    $state, $stateParams, $document, $log, $scope,
    InformationService, ModalService, LoadingService, DateTools) {

    var vm = this;

    vm.init = function () {

      LoadingService.show();

      vm.mode = $stateParams.mode; // Récupération du mode
      vm.codeModale = $stateParams.code; // Code de la modale (si édition ou duplication)

      vm.exploitationsOption = 'all'; // Par défaut, "Toutes les exploitations"

      vm.dateDebut = null;
      vm.dateFin = null;

      vm.actionBoutonValider = "open";
      vm.actionBoutonFermer = "open";

      // Gestion des boutons de la modale
      vm.afficherBoutonFermer = true;

      // Liste des profils possibles
      vm.profilsDisponibles = [
        {id: "RESPONSABLE_ASSOCIE_FACTURATION", label: "Responsable/associé Facturation"},
        {id: "RESPONSABLE_ASSOCIE", label: "Responsable/associé"},
        {id: "SALARIE", label: "Salarié"},
        {id: "TECHNICIEN", label: "Technicien"},
        {id: "AUTRE", label: "Autre"}
      ];

      // MODALE
      if (vm.mode === 'creation') {
        // Initialisation d'une nouvelle modale
        vm.modale = {
          modale: {
            code: "MODALE_",
            priorite: null,
            titre: "",
            contenu: "",
            boutonValider: {
              libelle: "",
              urlRedirection: "",
              ouvrirOnglet: false
            },
            boutonFermer: {
              libelle: "",
              urlRedirection: "",
              ouvrirOnglet: false
            }
          },
          periodes: [
            {
              debut: null,
              fin: null
            }
          ],
          exploitations: [],
          profils: []
        };
        LoadingService.hide();

      } else if (vm.mode === 'edition' || vm.mode === 'duplication') {

        // Récupération de la configuration existante
        InformationService.getModaleConfiguration(vm.codeModale).then(function (modaleResponse) {
          vm.modale = modaleResponse;

          // Marquer les profils déjà sélectionnés
          vm.profilsDisponibles.forEach(function (profil) {
            profil.checked = vm.modale.profils.includes(profil.id);
          });

          if (vm.modale.exploitations.length > 0) {
            vm.exploitationsOption = 'defined'; // Par défaut, "Toutes les exploitations"
            vm.nomFichier = 'fichier';
          }

          vm.dateDebut = new Date(vm.modale.periodes[0].debut);
          vm.dateFin = new Date(vm.modale.periodes[0].fin);

          if (!vm.modale.modale.boutonValider) {
            vm.modale.modale.boutonValider = {
              libelle: "",
              urlRedirection: "",
              ouvrirOnglet: false
            };
          }

          if (!vm.modale.modale.boutonFermer) {
            vm.afficherBoutonFermer = false;
          }

          if (_.isEmpty(vm.modale.modale.boutonValider.urlRedirection)) {
            vm.actionBoutonValider = "close";
          }
          if (!vm.afficherBoutonFermer || _.isEmpty(vm.modale.modale.boutonFermer.urlRedirection)) {
            vm.actionBoutonFermer = "close";
          }

          if (vm.mode === 'duplication') {
            vm.modale.modale.code = "MODALE_"; // Réinitialiser le code en mode duplication
          }

          LoadingService.hide();
        });
      }

    };

    vm.init();

    // Gestion des profils sélectionnés
    vm.toggleProfil = function (profil) {
      var index = vm.modale.profils.indexOf(profil.id);
      // si le profil existe, il est retiré
      if (index > -1) {
        vm.modale.profils.splice(index, 1);
        profil.checked = false;
      } else {
        // si le profil n'est pas présent, il est ajouté
        vm.modale.profils.push(profil.id);
        profil.checked = true;
      }
    };

    // EXPLOITATIONS

    vm.onExploitationsChange = function () {
      if (vm.exploitationsOption === 'all') {
        vm.modale.exploitations = [];
        vm.nomFichier = null;
      }
    };

    // Vérification des exploitations
    vm.isExploitationsValid = function () {
      return vm.modale.exploitations.length > 0 &&
        vm.modale.exploitations
          .every(function (exp) {
            return /^\d{8}$/.test(exp); // Vérifie que toutes les exploitations ont exactement 8 chiffres
          });
    };

    vm.triggerFileInput = function () {
      $document[0].getElementById('fileInput').click();
    };

    // Importation du fichier .csv
    vm.importerExploitations = function (event) {

      LoadingService.show();

      var file = event.target.files[0];
      if (!file) {
        LoadingService.hide();
        return;
      }

      vm.nomFichier = file.name;

      var reader = new FileReader();

      reader.onload = function (readerOnload) {
        $scope.$apply(function () { // pour mettre à jour la vue AngularJS
          var rows = readerOnload.target.result.split(/\r?\n/);
          vm.modale.exploitations = rows
            .map(function (row) {
              return row.trim();
            })
            .filter(function (row) {
              return row.length > 0;
            });
          LoadingService.hide();
        });
      };

      reader.onerror = function (e) {
        $log.error('Erreur lors du chargement du fichier : ', e);
        LoadingService.hide();
      };

      reader.readAsText(file);
    };

    // Vérification des dates
    vm.isDatesValid = function () {
      return vm.dateDebut !== null &&
        vm.dateFin !== null &&
        vm.dateDebut < vm.dateFin;
    };

    // BOUTONS

    vm.updateButtonAction = function (button) {
      button.urlRedirection = null;
      button.ouvrirOnglet = false;
    };

    vm.toggleAfficherBoutonFermer = function () {
      if (vm.afficherBoutonFermer) {
        vm.modale.modale.boutonFermer = {
          libelle: "",
          urlRedirection: "",
          ouvrirOnglet: false
        };
        vm.actionBoutonFermer = "open";
      } else {
        delete vm.modale.modale.boutonFermer;
      }
    };

    vm.isButtonValiderValid = function () {
      if (!vm.modale.modale.boutonValider) {
        return true;
      }
      return !_.isEmpty(vm.modale.modale.boutonValider.libelle) &&
        (vm.actionBoutonValider === 'close' || !_.isEmpty(vm.modale.modale.boutonValider.urlRedirection));
    };

    vm.isButtonFermerValid = function () {
      if (!vm.afficherBoutonFermer) {
        return true;
      }
      return !_.isEmpty(vm.modale.modale.boutonFermer.libelle) &&
        (vm.actionBoutonFermer === 'close' || !_.isEmpty(vm.modale.modale.boutonFermer.urlRedirection));
    };

    // Vérification de la validité du formulaire avant publication
    vm.isFormValid = function () {
      return vm.modale &&
        vm.modale.profils &&
        vm.modale.profils.length > 0 &&
        (vm.exploitationsOption === 'all' || vm.isExploitationsValid()) &&
        vm.isDatesValid() &&
        vm.modale.modale.priorite !== null &&
        !_.isEmpty(vm.modale.modale.titre) &&
        !_.isEmpty(vm.modale.modale.code) &&
        !_.isEmpty(vm.modale.modale.contenu) &&
        vm.isButtonValiderValid() &&
        vm.isButtonFermerValid();
    };

    vm.retour = function () {

      ModalService.confirm({
        template: "Êtes-vous sûr de quitter la page de la modale sans sauvegarder ?"
      }).then(function () {
        $state.go('app.admin.gestionModales'); // Redirection vers la liste des modales
      });

    };

    vm.publier = function () {

      LoadingService.show();

      // DATES
      vm.modale.periodes[0].debut = DateTools.getDateToString(vm.dateDebut);
      vm.modale.periodes[0].fin = DateTools.getDateToString(vm.dateFin);

      if (vm.mode === 'edition') {
        vm.editer();
      } else {
        // vm.mode === 'creation' || vm.mode === 'duplication'
        vm.creer();
      }

    };

    vm.creer = function () {

      InformationService.createModaleConfiguration(vm.modale)
        .then(function () {
          vm.redirectInEditAfterSave();
        })
        .catch(function (error) {
          LoadingService.hide();
          if (error && error.data && error.data.cause && error.data.cause.includes("existe déjà")) {
            ModalService.confirm({
              template: "Il existe déjà une modale ayant pour code " + vm.modale.modale.code + ".<br>" +
                "Souhaitez-vous écraser la modale déjà existante portant ce code ?"
            }).then(function () {
              vm.replaceModale();
            });
          } else {
            // Autre erreur
            $log.error("Erreur lors de la création de la modale :", error);
          }
        });
    };

    vm.editer = function () {

      // contrôle que le code de la modale n'a pas été modifié
      if (vm.codeModale !== vm.modale.modale.code) {
        $log.error("Erreur le code de la modale a été modifiée en édition");
        LoadingService.hide();
        return;
      }
      vm.replaceModale();

    };

    vm.redirectInEditAfterSave = function () {
      // Redirection vers la liste des modales
      $state.go('app.admin.gestionModales');
    };

    vm.replaceModale = function () {
      LoadingService.show();
      // Suppression de l'ancienne modale puis recréation
      InformationService.deleteModaleConfiguration(vm.modale.modale.code, true)
        .then(function () {
          InformationService.createModaleConfiguration(vm.modale)
            .then(function () {
              vm.redirectInEditAfterSave();
            });
        });
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminGestionAbonnementSelectionController', AdminGestionAbonnementSelectionController);

  /** @ngInject */
  function AdminGestionAbonnementSelectionController($document, $filter, $scope, $state, AdminGestionAbonnementService, DownloadFileService, ErrorService, LoadingService, ReferentielService, abonnement, listAbonnements, ModalService) {

    var vm = this;
    vm.afficheListAbonnements = false;
    vm.listActifs = true;
    vm.listTous = false;

    vm.currentPage = 0;
    vm.pageSize = 25;
    vm.numberOfPages = function () {
        return Math.ceil(vm.abonnementsAffiches.length / vm.pageSize);
    };

    vm.niveaux = ReferentielService.getNiveauxAbonnements();
    vm.types = ReferentielService.getTypeAbonnements();

    if (angular.isDefined(abonnement) && !_.isEmpty(abonnement)) {
      if (abonnement.numExploitation) {
        vm.numExploitation = abonnement.numExploitation;
      }

      if (abonnement.identifiant) {
        vm.identifiant = abonnement.identifiant;
      }

      if (abonnement.infos) {
        loadListActifs();
        if (vm.abonnementsAffiches.length === 0) {
          loadListTous();
        }
        vm.afficheListAbonnements = true;
      }
    }

    vm.filter = {
      search: {
        value: '',
        properties: ['numExploitation', 'identifiant', 'typeAbonnement.libelle', 'niveau.libelle', 'dateDebut', 'dateFin', 'dateFinDifferee', 'profil.libelle', 'email']
      }
    };

    // redmine 32680 : si un filtrage existe déjà on le restitue
    vm.previousFilter = AdminGestionAbonnementService.getFilter();
    if (angular.isDefined(vm.previousFilter)) {
      vm.showSouffleur = !angular.equals({}, vm.previousFilter.souffleurs);
      vm.filter = vm.previousFilter;
    }
    vm.order = {
      default: {
        reverse: true,
        property: "numExploitation"
      }
    };

    // redmine 32680 : si il existe un odre de tri on le restitue
    vm.previousOrder = AdminGestionAbonnementService.getOrder();
    if (angular.isDefined(vm.previousOrder)) {

      vm.order = vm.previousOrder;
    }
    $scope.$watch(function () {
      return vm.filter;
    }, function () {
      if (vm.listActifs) {
        vm.abonnementsAffiches = $filter('filterAbonnement')(vm.listAbonnementsActifs, vm.filter);

      } else {
        vm.abonnementsAffiches = $filter('filterAbonnement')(vm.listAbonnements, vm.filter);
      }
    }, true);

    vm.openListAbonnements = function () {
      loadListActifs();

      if (vm.abonnementsAffiches.length === 0) {
        loadListTous();
      }

      if (vm.abonnementsAffiches.length === 1) {
        abonnement.infos = vm.abonnementsAffiches[0];
        loadInput();
        saveFilters(abonnement.infos);
        $state.go('app.admin.gestionAbonnement.detail');
      }
      vm.afficheListAbonnements = true;
    };

    vm.goToDetails = function (abonnementSelectionne) {
      removeAbonnementSelectedKey();
      abonnement.infos = abonnementSelectionne;
      loadInput();
      saveFilters(abonnementSelectionne);
      $state.go('app.admin.gestionAbonnement.detail');
    };

    vm.afficheListActifs = function () {
      loadListActifs();
    };

    vm.afficheListTous = function () {
      loadListTous();
    };

    vm.getSelectedText = function (values) {
      var text;
      var listeNiveau = [];
      if (values) {
        angular.forEach(values, function (value) {
          text = value.libelle.charAt(0);
          listeNiveau.push(text);
        });
        return listeNiveau;
      }
      return "Définir";
    };
    vm.export = function () {
      ModalService.popupChoixExport();
    };
    vm.exportToExcel = function () {
      LoadingService.show();
      AdminGestionAbonnementService.getExportListAbonnements().then(function (file) {
        DownloadFileService.downloadFromFile(file);
      }, function (error) {
        ErrorService.alert(error);
      }).finally(function () {
        LoadingService.hide();
      });
    };

    vm.exportAutorisationsToExcel = function () {
      LoadingService.show();
      AdminGestionAbonnementService.getExportListAutorisations().then(function (file) {
        DownloadFileService.downloadFromFile(file);
      }, function (error) {
        ErrorService.alert(error);
      }).finally(function () {
        LoadingService.hide();
      });
    };

    function loadAbonnementsActifs() {
      vm.listAbonnementsActifs = _.filter(listAbonnements, function (abonnement) {
        return (!abonnement.dateFin);
      });
      if ((angular.isUndefined(vm.numExploitation) || _.isEmpty(vm.numExploitation)) && (angular.isUndefined(vm.identifiant) || _.isEmpty(vm.identifiant))) {
        return vm.listAbonnementsActifs;
      } else if (vm.numExploitation && (angular.isUndefined(vm.identifiant) || _.isEmpty(vm.identifiant))) {
        vm.listAbonnementsActifs = _.filter(vm.listAbonnementsActifs, function (abonnement) {
          return vm.numExploitation === abonnement.numExploitation;
        });
        return vm.listAbonnementsActifs;
      }
      vm.listAbonnementsActifs = _.filter(vm.listAbonnementsActifs, function (abonnement) {
        return vm.identifiant === abonnement.identifiant;
      });
      return vm.listAbonnementsActifs;
    }

    function loadAbonnementsTous() {
      vm.listAbonnements = listAbonnements;
      if ((angular.isUndefined(vm.numExploitation) || _.isEmpty(vm.numExploitation)) && (angular.isUndefined(vm.identifiant) || _.isEmpty(vm.identifiant))) {
        return vm.listAbonnements;
      } else if (vm.numExploitation && (angular.isUndefined(vm.identifiant) || _.isEmpty(vm.identifiant))) {
        vm.listAbonnements = _.filter(vm.listAbonnements, function (abonnement) {
          return vm.numExploitation === abonnement.numExploitation;
        });
        return vm.listAbonnements;
      }
      vm.listAbonnements = _.filter(vm.listAbonnements, function (abonnement) {
        return vm.identifiant === abonnement.identifiant;
      });
      return vm.listAbonnements;
    }

    function loadListActifs() {
      vm.listActifs = true;
      vm.listTous = false;
      vm.abonnementsAffiches = loadAbonnementsActifs();
    }

    function loadListTous() {
      vm.listActifs = false;
      vm.listTous = true;
      vm.abonnementsAffiches = loadAbonnementsTous();
    }

    function loadInput() {
      if (_.isEmpty(vm.numExploitation)) {
        abonnement.numExploitation = undefined;
      } else {
        abonnement.numExploitation = vm.numExploitation;
      }
      if (_.isEmpty(vm.identifiant)) {
        abonnement.identifiant = undefined;
      } else {
        abonnement.identifiant = vm.identifiant;
      }
    }

    // redmine 32680 Retirer la propriété qui permet de placer en tête de liste le cheptel selectionné
    function removeAbonnementSelectedKey() {
      var previousAbonnementSelected = AdminGestionAbonnementService.getAbonnementSelectionne();
      if (angular.isDefined(previousAbonnementSelected)) {
        delete previousAbonnementSelected.abonnementSelectionne;
      }
    }

    // redmine 32680 Sauvegarde des filtres et ajout de la propriété permettant de placer le cheptel selectionné en tête de liste lors du retour à la liste
    function saveFilters(abonnementSelectionne) {
      AdminGestionAbonnementService.setFilter(vm.filter);
      abonnementSelectionne.abonnementSelectionne = "true";
      AdminGestionAbonnementService.setAbonnementSelectionne(abonnementSelectionne);
      vm.order.property = "abonnementSelectionne";
      vm.order.reverse = true;
      AdminGestionAbonnementService.setOrder(vm.order);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminGestionAbonnementMainController', AdminGestionAbonnementMainController);

  /** @ngInject */
  function AdminGestionAbonnementMainController($state, abonnement) {
    var vm = this;

    vm.steps = [
      {
        libelle: 'Sélection',
        state: 'app.admin.gestionAbonnement.selection',
        isCompleted: function () {
          return angular.isDefined(abonnement.infos);
        }
      },
      {
        libelle: 'Détails',
        state: 'app.admin.gestionAbonnement.detail',
        isCompleted: function () {
          return false;
        }

      }
    ];

    $state.go('app.admin.gestionAbonnement.selection');
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminGestionAbonnementDetailController', AdminGestionAbonnementDetailController);

  /** @ngInject */
  function AdminGestionAbonnementDetailController($filter, $scope, $state, AdminGestionAbonnementService, CompteService, DownloadFileService, ErrorService, LoadingService, ModalService, ReferentielService, abonnement) {
    var vm = this;

    var contact;
    vm.infosAbonnement = {};
    var listAbonnements = [];

    vm.niveaux = ReferentielService.getNiveauxAbonnements();
    vm.types = ReferentielService.getTypeAbonnements();

    if (angular.isDefined(abonnement) && !_.isEmpty(abonnement)) {
      init();
    }

    vm.filter = {
      search: {
        value: '',
        properties: ['numExploitation', 'numDetenteur', 'dateOuverture', 'dateCloture', 'niveau.libelle', 'typeAbonnement.libelle', 'dateDebut', 'dateFin', 'dateFinDifferee']
      }
    };

    vm.order = {
      default: {
        reverse: true,
        property: "numExploitation"
      }
    };

    vm.getSelectedText = function (values) {
      var text;
      var listeNiveau = [];
      if (values) {
        angular.forEach(values, function (value) {
          text = value.libelle.charAt(0);
          listeNiveau.push(text);
        });
        return listeNiveau;
      }
      return "Définir";
    };

    $scope.$watch(function () {
      return vm.filter;
    }, function () {
      vm.listAbonnementsAffiches = $filter('filterAbonnement')(listAbonnements, vm.filter);
    }, true);

    vm.onglets = [
      {
        libelle: 'informations'
      },
      {
        libelle: 'services'
      },
      {
        libelle: 'facturation'
      }
    ];
    vm.onglet = 'informations';

    vm.gotoSelection = function () {

      if (vm.contactForm.$valid) {
        if (vm.contact.mail !== vm.origineContact.mail && vm.contact.mail !== vm.confirmMail && angular.isDefined(vm.confirmMail)) {
          ModalService.alert({
            template: "La confirmation de l’e-mail ne correspond pas à l’e-mail initialement saisi."
          });
        } else if (vm.infosAbonnement.raisonSociale !== vm.origineRaisonSociale && vm.infosAbonnement.raisonSociale !== vm.confirmRaisonSociale && angular.isDefined(vm.confirmRaisonSociale)) {
          ModalService.alert({
            template: "La confirmation de la raison sociale ne correspond pas à la raison sociale initialement saisie."
          });
        } else if (vm.confirmAdressRequired() && vm.infosAbonnement.adresse.adress !== vm.confirmAdresse &&
        vm.infosAbonnement.adresse.adress && vm.confirmAdresse) {
          ModalService.alert({
            template: "La confirmation de l'adresse ne correspond pas à l'adresse initialement saisie."
          });
        } else if (vm.confirmAdressRequired() && vm.infosAbonnement.adresse.complementAdresse !== vm.confirmComplementAdresse &&
        vm.infosAbonnement.adresse.complementAdresse && vm.confirmComplementAdresse) {
          ModalService.alert({
            template: "La confirmation du complément d'adresse ne correspond pas au complement d'adresse initialement saisie."
          });
        } else if (vm.confirmAdressRequired() && vm.infosAbonnement.adresse.codePostal !== vm.confirmCodePostal) {
          ModalService.alert({
            template: "La confirmation du code postal ne correspond pas au code postal initialement saisi."
          });
        } else if (vm.confirmAdressRequired() && vm.infosAbonnement.adresse.ville !== vm.confirmVille) {
          ModalService.alert({
            template: "La confirmation de la ville ne correspond pas à la ville initialement saisie."
          });
        } else {
          var errors = [];
          if (vm.contact.mail !== vm.origineContact.mail) {
            CompteService.modifieMailContact(abonnement.infos.identifiant, vm.contact.mail)
              .then(function () {
                abonnement.infos.email = vm.contact.mail;
              }, function (error) {
                errors.push("Erreur lors de la tentative de modification de l'adresse mail (" + error + ")");
                // ErrorService.alert(error);
              });
          }

          if (vm.contact.telMobile !== vm.origineContact.telMobile) {
            CompteService.modifieTelPortableContact(abonnement.infos.identifiant, vm.contact.telMobile)
              .then(function () {
              }, function (error) {
                errors.push("Erreur lors de la tentative de modification du numéro de téléphone mobile (" + error + ")");
                // ErrorService.alert(error);
              });
          }

          if (vm.contact.telFixe !== vm.origineContact.telFixe) {
            CompteService.modifieTelFixeContact(abonnement.infos.identifiant, vm.contact.telFixe)
              .then(function () {
              }, function (error) {
                errors.push("Erreur lors de la tentative de modification du numéro de téléphone fixe (" + error + ")");
                // ErrorService.alert(error);
              });
          }

          if (vm.infosAbonnement.raisonSociale !== vm.origineRaisonSociale) {
             CompteService.modifieRaisonSociale(vm.infosAbonnement)
              .then(function () {
              }, function (error) {
                errors.push("Erreur lors de la tentative de modification de la raison sociale (" + error + ")");
                // ErrorService.alert(error);
              });
          }

          if (vm.adressUpdated()) {
            CompteService.modifieAdresse(vm.infosAbonnement)
              .then(function () {
              }, function (error) {
                errors.push("Erreur lors de la tentative de modification de l'adresse (" + error + ")");
                // ErrorService.alert(error);
              });
          }
          if (!angular.equals(vm.contact, vm.origineContact) || !angular.equals(vm.infosAbonnement.adresse, vm.origineAdresse) ||
            !angular.equals(vm.infosAbonnement.raisonSociale, vm.origineRaisonSociale)) {
            ModalService.alert({
              template: "Les informations ont bien été modifiées."
            }).then(function () {
              if (errors.length) {
                var errorMessage = "";
                for (var i = 0; i < errors.length; i++) {
                  errorMessage += errors[i];
                }
                ErrorService.alert(errorMessage);
              } else {
                $state.go('app.admin.gestionAbonnement.selection');
              }
            });
          } else {
            $state.go('app.admin.gestionAbonnement.selection');
          }
        }
      }
    };

    function init() {
      CompteService.getInfosContact(abonnement.infos.identifiant, abonnement.infos.numExploitation)
        .then(function (profil) {
          contact = {
            mail: profil.mail,
            telMobile: profil.telMobile,
            telFixe: profil.telFixe
          };
          vm.contact = contact;
          vm.origineContact = angular.copy(contact);
        }, function (error) {
          ErrorService.alert(error);
        });

      AdminGestionAbonnementService.getListAbonnementsByEleveur(abonnement.infos.identifiant)
        .then(function (result) {
          angular.forEach(result.eleveurOrganismeAbonnements, function (eleveurOrganismeAbonnement) {
            angular.forEach(eleveurOrganismeAbonnement.eleveurAbonnementExploitations, function (eleveurAbonnementExploitation) {
              var abo = {};
              var diffDateFinEngagement = _.add(new Date(eleveurOrganismeAbonnement.debutAbonnement).getTime(), eleveurOrganismeAbonnement.organismeAbonnement.engagementMiniMois * (1000 * 3600 * 24 * 30.5));
              var diffDateFinRetractation = _.add(new Date(eleveurOrganismeAbonnement.debutAbonnement).getTime(), eleveurOrganismeAbonnement.organismeAbonnement.retractationMaxJours * (1000 * 3600 * 24));
              var dateFinRetractation = _.subtract(_.now(), diffDateFinRetractation);
              var dateFinEngagementMini = _.subtract(_.now(), diffDateFinEngagement);
              if (dateFinRetractation <= 0) {
                vm.dateAvecRetractationDepassee = true;
              }
              if (dateFinEngagementMini <= 0) {
                vm.dateAvecEngagementDepasse = true;
              }
              abo.numExploitation = eleveurAbonnementExploitation.exploitation.numExploitation;
              abo.niveau = eleveurOrganismeAbonnement.organismeAbonnement.abonnement.niveauAbonnement;
              abo.typeAbonnement = eleveurOrganismeAbonnement.organismeAbonnement.abonnement.typeAbonnement;
              abo.dateDebut = eleveurOrganismeAbonnement.debutAbonnement;
              abo.dateFin = eleveurOrganismeAbonnement.finAbonnement;
              abo.dateFinDifferee = eleveurOrganismeAbonnement.finDifferee;
              abo.dateLimiteRetractation = $filter('date')(diffDateFinRetractation, 'dd/MM/yyyy');
              abo.dateFinEngagement = $filter('date')(diffDateFinEngagement, 'dd/MM/yyyy');
              abo.dureeRetractation = eleveurOrganismeAbonnement.organismeAbonnement.retractationMaxJours;
              abo.finEngagement = eleveurOrganismeAbonnement.organismeAbonnement.engagementMiniMois;
              abo.idEleveurAbonnementExploitation = eleveurOrganismeAbonnement.id;
              abo.numDetenteur = eleveurAbonnementExploitation.exploitation.numDetenteur;
              abo.raisonSociale = eleveurAbonnementExploitation.exploitation.raisonSociale;
              vm.infosAbonnement.identifiant = result.identifiant;
              vm.infosAbonnement.profil = result.profil;
              listAbonnements.push(abo);
              AdminGestionAbonnementService.getInformationExploitation(abo.numExploitation)
              .then(function (result) {
                vm.infosAbonnement.numExploitation = result.numExploitation;
                vm.infosAbonnement.numSiren = result.numSiren;
                vm.infosAbonnement.numagrin = result.numagrin;
                vm.infosAbonnement.numDetenteur = result.numDetenteur;
                vm.infosAbonnement.raisonSociale = result.raisonSociale;
                vm.origineRaisonSociale = result.raisonSociale;
                vm.infosAbonnement.adresse = result.adresse;
                vm.origineAdresse = angular.copy(vm.infosAbonnement.adresse);
                vm.infosAbonnement.autorisationsAccesExist = result.autorisationsAccesExist;
              });
            });
          });
        });
    }

    vm.exportToExcel = function () {
      LoadingService.show();

      AdminGestionAbonnementService.getExportListAbonnementsByEleveur(abonnement.infos.identifiant).then(function (file) {
        DownloadFileService.downloadFromFile(file);
      }, function (error) {
        ErrorService.alert(error);
      }).finally(function () {
        LoadingService.hide();
      });
    };

    vm.confirmAdressRequired = function () {
      if (angular.isDefined(vm.infosAbonnement.adresse)) {
        if (vm.infosAbonnement.adresse.adress !== vm.origineAdresse.adress ||
          vm.infosAbonnement.adresse.complementAdresse !== vm.origineAdresse.complementAdresse ||
          vm.infosAbonnement.adresse.codePostal !== vm.origineAdresse.codePostal ||
          vm.infosAbonnement.adresse.ville !== vm.origineAdresse.ville) {
            return true;
        }
      }
      return false;
    };

    vm.adressUpdated = function () {
      if (angular.isDefined(vm.infosAbonnement.adresse)) {
        if (vm.infosAbonnement.adresse.adress !== vm.origineAdresse.adress ||
          (vm.infosAbonnement.adresse.complementAdresse !== vm.origineAdresse.complementAdresse) ||
          vm.infosAbonnement.adresse.codePostal !== vm.origineAdresse.codePostal ||
          vm.infosAbonnement.adresse.ville !== vm.origineAdresse.ville) {
          return true;
        }
      }
      return false;
    };
  }
})();

(function () {
  angular
    .module('app')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('app.admin.gestionAbonnement', {
        url: '/gestion-abonnement',
        templateUrl: 'app/admin/gestionAbonnement/main/main.html',
        controller: 'AdminGestionAbonnementMainController',
        controllerAs: 'ctrl',
        resolve: {
          abonnement: [function () {
            return {};
          }],
          listAbonnements: ['AdminGestionAbonnementService', function (AdminGestionAbonnementService) {
            return AdminGestionAbonnementService.getListAbonnements();
          }]
        }
      })
      .state('app.admin.gestionAbonnement.selection', {
        url: '/selection',
        templateUrl: 'app/admin/gestionAbonnement/selection/selection.html',
        controller: 'AdminGestionAbonnementSelectionController',
        controllerAs: 'ctrl'
      })
      .state('app.admin.gestionAbonnement.detail', {
        url: '/detail',
        templateUrl: 'app/admin/gestionAbonnement/detail/detail.html',
        controller: 'AdminGestionAbonnementDetailController',
        controllerAs: 'ctrl'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('AdminFonctionnaliteService', AdminFonctionnaliteService);

  /* @ngInject */
  function AdminFonctionnaliteService($http, $q, $state, $window, ErrorService, BACKEND) {
    var service = {
      goToFonctionnalite: goToFonctionnalite,
      completeAcces: completeAcces,
      getFonctionnalite: getFonctionnalite
    };
    return service;

    function goToFonctionnalite(fonctionnalite, options) {
      return $q(function (resolve, reject) {
        if (fonctionnalite === null) {
          reject({
            userMessage: 'Fonctionnalité non disponible'
          });
        } else {
          switch (fonctionnalite.acces.application) {
            case 'IPG':
              resolve();

              $state.go('app.admin.fonctionnalite', {
                code: fonctionnalite.code.toLowerCase()
              });
              break;
            default:
              var url = '/redirection/' + fonctionnalite.code + '/';
              delete options.newPage;
              if (angular.isDefined(options) && !_.isEmpty(options)) {
                url += angular.toJson(options);
              }
              $window.open(url);
              resolve();
          }
        }
      });
    }

    function completeAcces(code, options) {
      return $q(function (resolve, reject) {
        var url = BACKEND.url + '/services/' + code.toUpperCase();
        if (angular.isObject(options)) {
          url += '?' + _.map(options, function (value, key) {
            return key + '=' + value;
          }).join('&');
        }

        $http.get(url).then(function (response) {
          resolve(response.data);
        }, reject);

      });
    }

    function getFonctionnalite(code) {
      return $q(function (resolve) {
        completeAcces(code).then(function (fonctionnalite) {
          resolve(fonctionnalite);
        }, function (error) {
          ErrorService.log(error);

          resolve(null);
        });
      });
    }
  }
})();

(function () {
  'use strict';
  var CONFIRM_TPL =
    '<md-dialog aria-label="confirm-dialog" class="confirm-dialog">' +
    '  <md-dialog-content class="md-dialog-content">' +
    '    <h2 ng-bind-html="ctrl.options.title"></h2>' +
    '    <div class="md-dialog-content-body">' +
    '      <div ng-bind-html="ctrl.options.template"></div>' +
    '    </div>' +
    '  </md-dialog-content>' +
    '  <md-dialog-actions>' +
    '    <md-button ng-click="ctrl.cancel()" class="md-raised md-primary">{{ctrl.options.cancelText}}</md-button>' +
    '    <md-button ng-click="ctrl.ok()" class="md-raised md-primary">{{ctrl.options.okText}}</md-button>' +
    '  </md-dialog-actions>' +
    '</md-dialog>';

  var ALERT_TPL =
    '<md-dialog aria-label="confirm-dialog" class="confirm-dialog">' +
    '  <md-dialog-content class="md-dialog-content">' +
    '    <h2 ng-bind-html="ctrl.options.title"></h2>' +
    '    <div class="md-dialog-content-body">' +
    '      <div ng-bind-html="ctrl.options.template"></div>' +
    '      <div ng-bind-html="ctrl.options.template2"></div>' +
    '    </div>' +
    '  </md-dialog-content>' +
    '  <md-dialog-actions>' +
    '    <md-button ng-click="ctrl.ok()" class="md-raised md-primary">{{ctrl.options.okText}}</md-button>' +
    '  </md-dialog-actions>' +
    '</md-dialog>';

  var FLORE_INFOS =
    '<md-dialog aria-label="confirm-dialog" class="confirm-dialog">' +
    '  <md-dialog-content class="md-dialog-content">' +
    '    <h2>Service FLORE : gestion des sorties présumées</h2>' +
    '    <div class="md-dialog-content-body">' +
    '      <div>' +
    '           <p><b>FLORE est un robot conversationnel</b> qui à l\'aide de SMS <b>permet de vous alerter</b> en cas de sortie présumée.</p>' +
    '           <p>Ce service est <b>inclus sans surcoût</b> dans vos abonnements Pilot\'Elevage Essentiel et Performance bovins.</p>' +
    '           <p style="text-align: justify;">Un SMS vous sera envoyé lorsqu\'une notification d’abattage ou d\'entrée d’un de vos bovins' +
    '           dans une autre exploitation est enregistrée mais également lorsque des bovins sont enlevés par l\'équarrissage (et que vous ne les avez pas encore sortis de votre inventaire). Pour précision : le robot Flore envoie l’alerte SMS si vous n’avez pas notifié ces sorties au bout de 4 jours.</p>' +
    '           <p><b>Le fait de répondre et de valider la sortie de l’animal via un sms adressé au service FLORE, tient lieu de notification</b> (en allant jusqu’au terme de la conversation). Vous n’avez pas d’autres opérations à réaliser.<p>' +
    '           <p>Des questions ? Contactez votre service assistance.<p>' +
    '           <p>L\'équipe Pilot\'Elevage</p>' +
    '      </div>' +
    '    </div>' +
    '  </md-dialog-content>' +
    '  <md-dialog-actions>' +
    '    <md-button ng-click="ctrl.ok()" class="md-raised md-primary">OK</md-button>' +
    '  </md-dialog-actions>' +
    '</md-dialog>';

  var CONFIRM_FLORE =
    '<md-dialog aria-label="confirm-dialog" class="confirm-dialog">' +
    '<md-dialog-content class="md-dialog-content">' +
    '  <h2>Demande de confirmation</h2>' +
    '  <div class="md-dialog-content-body">' +
    '    <div>' +
    '        <md-checkbox ng-model="acceptCGV" aria-label="acceptCGV" tabindex="0" type="checkbox" role="checkbox"></md-checkbox>' +
    '       Je souhaite m\'abonner au Service Flore (sans surcoût), j’ai lu et j’accepte ' +
    '      <a href="assets/documents/cgu.pdf" target="_blank" class="light-link">La politique de Confidentialité de Flore.</a>' +
    '    </div>' +
    '   </div>' +
    '</md-dialog-content>' +
    '<md-dialog-actions>' +
    '  <md-button ng-click="ctrl.cancel()" class="md-raised md-primary">NON</md-button>' +
    '  <md-button ng-click="ctrl.ok()" class="md-raised md-primary" ng-disabled="!acceptCGV">OUI</md-button>' +
    '</md-dialog-actions>' +
    '</md-dialog>';

  var FLORE_ALERTE =
    '<md-dialog aria-label="confirm-dialog" class="confirm-dialog">' +
    '  <md-dialog-content class="md-dialog-content">' +
    '    <h2>Activation du Service Flore Sorties Présumées</h2>' +
    '    <div class="md-dialog-content-body">' +
    '      <div>' +
    '         <p>Vous pouvez maintenant <b>recevoir une alerte par SMS</b> si vous avez des sorties présumées. </p>' +
    '         <p>Souhaitez-vous activer ce nouveau service inclus dans votre abonnement (sans surcoût) ? </p>' +
    '       </div>' +
    '    </div>' +
    '  </md-dialog-content>' +
    '  <md-dialog-actions>' +
    '    <md-button ng-click="ctrl.cancel()" class="md-raised md-primary">Non</md-button>' +
    '    <md-button ng-click="ctrl.ok()" class="md-raised md-primary">Oui</md-button>' +
    '  </md-dialog-actions>' +
    '</md-dialog>';

  var CONFIRM_AUTORISATION_ACCES =
    '<md-dialog aria-label="confirm-dialog" class="confirm-dialog">' +
    '<md-dialog-content class="md-dialog-content">' +
    '  <h2>Demande de confirmation</h2>' +
    '  <div class="md-dialog-content-body">' +
    '    <div>' +
    '        <md-checkbox ng-model="acceptPolitiquePE" aria-label="acceptPolitiquePE" tabindex="0" type="checkbox" role="checkbox"></md-checkbox>' +
    '       En tant que responsable de l\'exploitation, j\'accepte les termes de la  ' +
    '      <a href="/politiqueConfidentialite" target="_blank" class="light-link">La politique de Confidentialité de Pilot\'Elevage.</a>' +
    '       concernant les données personnelles renseignées.' +
    '    </div>' +
    '   </div>' +
    '</md-dialog-content>' +
    '<md-dialog-actions>' +
    '  <md-button ng-click="ctrl.cancel()" class="md-raised md-primary">ANNULER</md-button>' +
    '  <md-button ng-click="ctrl.ok()" class="md-raised md-primary" ng-disabled="!acceptPolitiquePE">VALIDER</md-button>' +
    '</md-dialog-actions>' +
    '</md-dialog>';

  var AUTORISATION_ACCES_INFOS =
    '<md-dialog aria-label="confirm-dialog" class="confirm-dialog">' +
    '  <md-dialog-content class="md-dialog-content">' +
    '    <h2>Changement du système d’authentification à Pilot’Elevage</h2>' +
    '    <div class="md-dialog-content-body">' +
    '      <div>' +
    '           <p style="text-indent: 4em;">Pour plus de sécurité, nous devrons prochainement changer de système d\'authentification.' +
    '              Dans le cadre de ce changement technique, nous souhaitons vous offrir l\'opportunité de créer des comptes personnels.' +
    '              Ainsi chaque responsable de l\'exploitation pourra bénéficier de son accès personnel et sécurisé au portail Pilot\'Elevage de votre exploitation.' +
    '              L\'abonnement restera bien sûr à l\'exploitation, aucun frais ne sera demandé pour la mise en place des comptes personnels sécurisés.</p>' +
    '           <p style="text-indent: 4em;">Ces modifications de fonctionnement vont nous permettre de vous offrir une autre nouveauté: ' +
    '              la gestion des accès à votre compte Pilot\'Elevage par des tiers extérieurs (salariés, stagiaires, conseiller..). ' +
    '              Vous pourrez gérer vous-même les autorisations que vous déciderez de donner à ces différentes personnes.' +
    '              La gestion des droits d\'accès arrivera dans un second temps.</p>' +
    '           <p>Ces nouveautés ne sont pas encore fonctionnelles mais en cours de développement. Vous serez prévenus avant leur déploiement.</p>' +
    '           <p>En cas de difficultés, vos équipes habituelles d\'assistance Pilot\'Elevage vous accompagnent : n\'hésitez pas à les contacter.<p>' +
    '           <p>L\'équipe Pilot\'Elevage</p>' +
    '      </div>' +
    '    </div>' +
    '  </md-dialog-content>' +
    '  <md-dialog-actions>' +
    '    <md-button ng-click="ctrl.ok()" class="md-raised md-primary">OK</md-button>' +
    '  </md-dialog-actions>' +
    '</md-dialog>';

  var CHANNGEMENT_SYSTEME_AUTENTIFICATION =
    '<md-dialog aria-label="confirm-dialog" class="confirm-dialog">' +
    '  <md-dialog-content class="md-dialog-content">' +
    '    <div class="md-dialog-content-body">' +
    '      <div layout="row">' +
    '         <p><b>Le système de connexion change</b></p>' +
    '       </div>' +
    '       <p>Vous devez créer les profils qui pourront se connecter à votre compte Pilot\'Elevage (<span ng-click="ctrl.afficherAide()"><u>lire les explications</u></span>).</p>' +
    '    </div>' +
    '  </md-dialog-content>' +
    '  <md-dialog-actions style="padding-left:5px; padding-right: 5px; justify-content: center">' +
    '    <md-button ng-click="ctrl.ok(true)" class="md-raised md-primary">J\'y vais !</md-button>' +
    '  </md-dialog-actions>' +
    '</md-dialog>';

    var SAISIE_IBAN =
      '<md-dialog aria-label="confirm-dialog" class="confirm-dialog">' +
      '    <md-dialog-content class="md-dialog-content">' +
      '        <h2>SAISIE IBAN</h2>' +
      '        <div class="md-dialog-content-body">' +
      '            <div>' +
      '                <p>Si vous ne parvenez pas à renseigner votre IBAN ou si vous ne recevez pas de SMS lors de l’enregistrement de votre mandat, veuillez imprimer l’autorisation de prélèvement automatique ci-joint et le retourner complété par mail à <b style="color: #0055BC; font-size: 15px; text-decoration: underline;">facturation@pilotelevage.fr</b></p>' +
      '            </div>' +
      '        </div>' +
      '      </md-dialog-content>' +
      '      <md-dialog-actions>' +
      '        <md-button class="red-button md-raised" type="button" ng-click="ctrl.download()">' +
      '            Télécharger l\'autorisation de mandat de prélèvement automatique SEPA' +
      '        </md-button>' +
      '    </md-dialog-actions>' +
      '</md-dialog>';

  var varPopupCommandeAuto;
  angular
    .module('app')
    .service('ModalService', ModalService);

  /* @ngInject */
  function ModalService($mdDialog, $q) {
    var service = {
      alert: alert,
      confirm: confirm,
      floreAlerte: floreAlerte,
      floreInfos: floreInfos,
      optionInfos: optionInfos,
      confirmAboFlore: confirmAboFlore,
      confirmAutorisationAcces: confirmAutorisationAcces,
      autorisationAccesInfos: autorisationAccesInfos,
      changementSystemeAuthentification: changementSystemeAuthentification,
      popupIncitation: popupIncitation,
      popupAideIncitation: popupAideIncitation,
      alertResultValidationIdentite: alertResultValidationIdentite,
      popupObligatoinKeycloak: popupObligatoinKeycloak,
      popupCommandeAuto: popupCommandeAuto,
      popupValiderCommandeAuto: popupValiderCommandeAuto,
      popupAnnulerModifierCommandeAuto: popupAnnulerModifierCommandeAuto,
      popupRaisonAnnulerModifierCommandeAuto: popupRaisonAnnulerModifierCommandeAuto,
      popupChoixExport: popupChoixExport,
      popupInformation: popupInformation,
      popupSuspensionAccesResponsable: popupSuspensionAccesResponsable,
      popupSuspensionAccesAutre: popupSuspensionAccesAutre,
      popupAccesFacturationNonDisponible: popupAccesFacturationNonDisponible,
      facturePapierInfos: facturePapierInfos,
      saisieIBAN: saisieIBAN
    };
    return service;

    function confirm(options) {
      options = angular.extend({
        title: 'Demande de confirmation',
        template: '',
        cancelText: 'Non',
        okText: 'Oui'
      }, options || {});

      return $q(function (resolve, reject) {
        $mdDialog.show({
          template: CONFIRM_TPL,
          controller: ConfirmController,
          controllerAs: 'ctrl',
          backdrop: 'static'
        }).then(resolve, reject);
      });

      function ConfirmController() {
        var vm = this;

        vm.options = options;

        vm.cancel = function () {
          $mdDialog.cancel();
        };

        vm.ok = function () {
          $mdDialog.hide();
        };
      }
    }

    function alert(options) {
      options = angular.extend({
        template: '',
        template2: '',
        okText: 'OK',
        title: 'Information'
      }, options || {});

      return $q(function (resolve, reject) {
        $mdDialog.show({
          template: ALERT_TPL,
          controller: AlertController,
          controllerAs: 'ctrl',
          backdrop: 'static'
        }).then(resolve, reject);
      });

      function AlertController() {
        var vm = this;

        vm.options = options;

        vm.ok = function () {
          $mdDialog.hide();
        };
      }
    }

    function confirmAboFlore() {
      return $q(function (resolve, reject) {
        $mdDialog.show({
          template: CONFIRM_FLORE,
          controller: ConfirmAboFloreController,
          controllerAs: 'ctrl',
          backdrop: 'static'
        }).then(resolve, reject);
      });

      function ConfirmAboFloreController() {
        var vm = this;
        vm.cancel = function () {
          $mdDialog.cancel();
        };

        vm.ok = function () {
          $mdDialog.hide();
        };
      }
    }

    function floreInfos() {

      return $q(function (resolve, reject) {
        $mdDialog.show({
          template: FLORE_INFOS,
          controller: FloreInfosController,
          controllerAs: 'ctrl',
          backdrop: 'static'
        }).then(resolve, reject);
      });

      function FloreInfosController() {
        var vm = this;
        vm.ok = function () {
          $mdDialog.hide();
        };
      }
    }

    function optionInfos(options) {
      options = angular.extend({
        title: 'Title',
        nom: options.nom,
        body: '<p><b>FLORE est un robot conversationnel</b> qui à l\'aide de SMS, Facebook Messenger ou Skype, <b>permet de vous alerter</b> en cas de sortie présumée.</p>' +
          '<p>Ce service est <b>inclus sans surcoût</b> dans vos abonnements Pilot\'Elevage Essentiel et Performance bovins.</p>' +
          '<p style="text-align: justify;">Un message automatique vous sera envoyé dès lors qu’une notification d’abattage ou d’entrée d’un de vos bovins dans une autre exploitation est enregistrée. L’envoi de ce message se déclenche au 4ème jour qui suit la date de la sortie présumée. <b>Le fait de répondre et de valider la sortie de l\'animal via FLORE, tient lieu de notification</b> (en allant jusqu\'au terme de la conversation). Vous n\'avez pas d\'autres opérations à réaliser.</p>' +
          '<p>Des questions ? Contactez votre service assistance.<p>' +
          '<p>L\'équipe Pilot\'Elevage</p>'
      }, options || {});
      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/optionInfos.html",
          controller: OptionInfosController,
          controllerAs: 'ctrl',
          backdrop: 'static'
        }).then(resolve, reject);
      });

      function OptionInfosController() {
        var vm = this;
        vm.options = options;
        vm.ok = function () {
          $mdDialog.hide();
        };
      }
    }

    function floreAlerte() {

      return $q(function (resolve, reject) {
        $mdDialog.show({
          template: FLORE_ALERTE,
          controller: ConfirmController,
          controllerAs: 'ctrl',
          backdrop: 'static'
        }).then(resolve, reject);
      });

      function ConfirmController() {
        var vm = this;
        vm.cancel = function () {
          $mdDialog.cancel();
        };

        vm.ok = function () {
          $mdDialog.hide();
        };
      }
    }

    function confirmAutorisationAcces() {
      return $q(function (resolve, reject) {
        $mdDialog.show({
          template: CONFIRM_AUTORISATION_ACCES,
          controller: ConfirmAutorisationAccesController,
          controllerAs: 'ctrl',
          backdrop: 'static'
        }).then(resolve, reject);
      });

      function ConfirmAutorisationAccesController() {
        var vm = this;
        vm.cancel = function () {
          $mdDialog.cancel();
        };

        vm.ok = function () {
          $mdDialog.hide();
        };
      }
    }

    function autorisationAccesInfos() {

      return $q(function (resolve, reject) {
        $mdDialog.show({
          template: AUTORISATION_ACCES_INFOS,
          controller: AutorisationAccesController,
          controllerAs: 'ctrl',
          backdrop: 'static',
          multiple: true
        }).then(resolve, reject);
      });

      function AutorisationAccesController() {
        var vm = this;
        vm.ok = function () {
          $mdDialog.hide();
        };
      }
    }

    function changementSystemeAuthentification() {
      return $q(function (resolve, reject) {
        $mdDialog.show({
          template: CHANNGEMENT_SYSTEME_AUTENTIFICATION,
          controller: ChangementSystemeAuthentificationController,
          controllerAs: 'ctrl',
          backdrop: 'static',
          escapeToClose: false
        }).then(resolve, reject);
      });

      function ChangementSystemeAuthentificationController($state, ModalService) {
        var vm = this;
        vm.cancel = function () {
          $mdDialog.cancel();
        };

        vm.ok = function () {
          $mdDialog.hide();
        };

        vm.afficherAide = function () {
          ModalService.autorisationAccesInfos().then(function () {

          });
        };
      }
    }

    function popupIncitation(nbJours, urlMireKc) {

      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/incitationCreationCompteKc.html",
          controller: PopupIncitationController,
          controllerAs: 'ctrl',
          backdrop: 'static',
          escapeToClose: false
        }).then(resolve, reject);
      });

      function PopupIncitationController(ModalService) {
        var vm = this;
        vm.nbJours = nbJours;
        vm.urlMireKc = urlMireKc;
        vm.cancel = function () {
          $mdDialog.cancel();
        };

        vm.ok = function () {
          $mdDialog.hide();
        };

        vm.afficherAide = function () {
          ModalService.popupAideIncitation().then(function () {

          });
        };
      }
    }

    function popupAideIncitation() {

      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/aideIncitationCreationCompteKc.html",
          controller: PopupAideIncitationController,
          controllerAs: 'ctrl',
          backdrop: 'static',
          multiple: true
        }).then(resolve, reject);
      });

      function PopupAideIncitationController() {
        var vm = this;
        vm.ok = function () {
          $mdDialog.hide();
        };
      }
    }

    function alertResultValidationIdentite(templateUrl, urlMireKc) {
      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: templateUrl,
          controller: PopupValidationCompteKcKoController,
          controllerAs: 'ctrl',
          backdrop: 'static'
        }).then(resolve, reject);
      });

      function PopupValidationCompteKcKoController() {
        var vm = this;
        vm.urlMireKc = urlMireKc;
        vm.ok = function () {
          $mdDialog.hide();
        };
      }
    }

    function popupObligatoinKeycloak(identifiantKc, urlMireKc) {

      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/obligationUseKeycloak.html",
          controller: PopupIncitationController,
          controllerAs: 'ctrl',
          backdrop: 'static'
        }).then(resolve, reject);
      });

      function PopupIncitationController() {
        var vm = this;
        vm.identifiantKc = identifiantKc;
        vm.urlMireKc = urlMireKc;

        vm.ok = function () {
          $mdDialog.hide();
        };
      }
    }

    function popupCommandeAuto(commandeAuto) {

      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/commandeAuto.html",
          controller: PopupCommandeAutoController,
          controllerAs: 'ctrl',
          backdrop: 'static'
        }).then(resolve, reject);
      });

      function PopupCommandeAutoController(ModalService) {
        var vm = this;
        varPopupCommandeAuto = this;
        vm.quantite = commandeAuto.quantite;
        vm.typeBoucle = commandeAuto.typeAdhesionBoucleCommandeAuto;
        vm.cancel = function () {
          ModalService.popupAnnulerModifierCommandeAuto(commandeAuto).then(function () {

          });
        };
        vm.close = function () {
          $mdDialog.hide();
        };

        vm.ok = function () {
          ModalService.popupValiderCommandeAuto(commandeAuto).then(function () {

          });
        };
        vm.afficherAide = function () {

        };
      }
    }

    function popupValiderCommandeAuto(commandeAuto) {

      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/validerCommandeAuto.html",
          controller: PopupValiderCommandeAutoController,
          controllerAs: 'ctrl',
          backdrop: 'static',
          multiple: true
        }).then(resolve, reject);
      });

      function PopupValiderCommandeAutoController(ModalService, $http, BACKEND, UserService) {
        var vm = this;
        vm.ok = function () {
          $mdDialog.hide();
          commandeAuto.estAccepte = true;
          return $q(function (resolve, reject) {
            $http.post(BACKEND.url + '/exploitations/' + UserService.getNumeroExploitation() + '/commandesAuto', commandeAuto).then(function (response) {
              resolve(response.data);
              ModalService.alert({
                title: "CONFIRMATION",
                template: "La commande est prise en compte et vous sera livrée dans les meilleurs délais."
              }).then(function () {

              });
            }, reject);
          });
        };

        vm.cancel = function () {
          $mdDialog.hide();
        };
      }
    }
    function popupAnnulerModifierCommandeAuto(commandeAuto) {
      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/confirmAnnulerModifierCommandeAuto.html",
          controller: PopupAnnulerModifierCommandeAutoController,
          controllerAs: 'ctrl',
          backdrop: 'static',
          multiple: true
        }).then(resolve, reject);
      });

      function PopupAnnulerModifierCommandeAutoController(ModalService) {
        var vm = this;
        vm.ok = function () {
          $mdDialog.hide();
          ModalService.popupRaisonAnnulerModifierCommandeAuto(commandeAuto).then(function () {

          });
        };
        vm.cancel = function () {
          $mdDialog.hide();
        };
      }
    }

    function popupRaisonAnnulerModifierCommandeAuto(commandeAuto) {
      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/annulerModifierCommandeAuto.html",
          controller: PopupRaisonAnnulerModifierCommandeAutoController,
          controllerAs: 'ctrl',
          backdrop: 'static',
          multiple: true
        }).then(resolve, reject);
      });

      function PopupRaisonAnnulerModifierCommandeAutoController(ModalService, ReferentielService, UserService, $http, BACKEND, $q) {
        var vm = this;
        vm.commandeAuto = commandeAuto;
        vm.commandeAuto.raisonModif = [];
        vm.raisons = ReferentielService.getRaisonsModifAnnulCommande();
        vm.resetSaisie = function () {
          vm.commandeAuto.saisieRaison = "";
          vm.commandeAuto.saisieQuantite = "";
        };
        vm.ok = function () {
          $mdDialog.hide();
          vm.commandeAuto.estAccepte = false;
          return $q(function (resolve, reject) {
            varPopupCommandeAuto.close();
            $http.post(BACKEND.url + '/exploitations/' + UserService.getNumeroExploitation() + '/commandesAuto', vm.commandeAuto).then(function (response) {
              ModalService.alert({
                title: "CONFIRMATION",
                template: "La demande d'annulation ou de modification de votre commande est prise en compte."
              }).then(function () {

              });
              resolve(response.data);
            }, reject);
          });
        };
      }
    }

    function popupChoixExport() {
      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/choixExport.html",
          controller: PopupChoixExportController,
          controllerAs: 'ctrl',
          backdrop: 'static',
          multiple: true
        }).then(resolve, reject);
      });

      function PopupChoixExportController(AdminGestionAbonnementService) {
        var vm = this;
        vm.choix = "";
        vm.listChoix = [
          "Abonnements", "Autorisations d'accès et connexions SSO"
        ];
        vm.cancel = function () {
          $mdDialog.cancel();
        };

        vm.ok = function () {
          AdminGestionAbonnementService.getExportSelonChoix(vm.choix);
          $mdDialog.hide();
        };
      }
    }

    /**
     * Affichage de la modale pour les messages d'information.
     *
     * @param {*} informationModale
     */
    function popupInformation(informationModale) {
      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/information.html",
          controller: InformationController,
          controllerAs: 'ctrl',
          backdrop: 'static',
          multiple: true
        }).then(resolve, reject);
      });

      function InformationController($window, InformationService) {
        var vm = this;
        vm.informationModale = informationModale;

        vm.valider = function (bouton) {
          // la modale a été affichée
          InformationService.signalerInformationModaleVue(informationModale);
          // le cas échéant, rediriger vers l'url indiquée
          if (angular.isDefined(bouton.urlRedirection)) {
            if (angular.isDefined(bouton.ouvrirOnglet) && bouton.ouvrirOnglet === true) {
              $window.open(bouton.urlRedirection, '_blank');
            } else {
              $window.open(bouton.urlRedirection, '_self');
            }
            $mdDialog.hide();
          }
          $mdDialog.cancel();
        };
      }
    } // fin popup Information

    function popupSuspensionAccesResponsable(isMultiCheptel) {
      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/suspensionAccesReponsable.html",
          controller: popupSuspensionAccesResponsableController,
          controllerAs: 'ctrl',
          backdrop: 'static',
          multiple: true
        }).then(resolve, reject);
      });

      function popupSuspensionAccesResponsableController() {
        var vm = this;
        vm.isMultiCheptel = isMultiCheptel;
        vm.gererMesFactures = function () {
          $mdDialog.hide();
        };

        vm.changerDeCheptel = function () {
          $mdDialog.cancel();
        };
      }
    }

    function popupSuspensionAccesAutre(emailResponsable, isMultiCheptel) {
      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/suspensionAccesAutre.html",
          controller: popupSuspensionAccesAutreController,
          controllerAs: 'ctrl',
          backdrop: 'static',
          multiple: true
        }).then(resolve, reject);
      });

      function popupSuspensionAccesAutreController() {
        var vm = this;
        vm.isMultiCheptel = isMultiCheptel;
        vm.emailResponsable = emailResponsable;
        vm.fermer = function () {
          $mdDialog.hide();
        };

        vm.changerDeCheptel = function () {
          $mdDialog.cancel();
        };
      }
    }

    function popupAccesFacturationNonDisponible(emailResponsableFacturation, showBoutonAutorisationAcces) {
      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/accesFacturationNonDisponible.html",
          controller: popupAccesFacturationNonDisponibleController,
          controllerAs: 'ctrl',
          backdrop: 'static',
          multiple: true
        }).then(resolve, reject);
      });

      function popupAccesFacturationNonDisponibleController() {
        var vm = this;
        vm.emailResponsableFacturation = emailResponsableFacturation;
        vm.showBoutonAutorisationAcces = showBoutonAutorisationAcces;
        vm.fermer = function () {
          $mdDialog.cancel();
        };

        vm.voirAutorisationsAcces = function () {
          $mdDialog.hide();
        };
      }
    }

    function facturePapierInfos(tarifCentimes, periodicite) {

      return $q(function (resolve, reject) {
        $mdDialog.show({
          templateUrl: "app/_common/services/modal/templates/facturePapierInfos.html",
          controller: FacturePapierController,
          controllerAs: 'ctrl',
          backdrop: 'static'
        }).then(resolve, reject);
      });

      function FacturePapierController() {
        var vm = this;
        vm.tarif = tarifCentimes;
        vm.periodicite = periodicite;
        vm.ok = function () {
          $mdDialog.hide();
        };
      }
    }

    function saisieIBAN() {

      return $q(function (resolve, reject) {
        $mdDialog.show({
          template: SAISIE_IBAN,
          controller: SaisieIbanController,
          controllerAs: 'ctrl',
          backdrop: 'static'
        }).then(resolve, reject);
      });

      function SaisieIbanController($window) {
        this.download = function () {
          const pathPdf = "/assets/documents/Mandat_SAS_Pilot'Elevage.pdf";
          $window.open(pathPdf, '_blank');
          $mdDialog.hide();
        };
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('LoadingService', LoadingService);

  /* @ngInject */
  function LoadingService(usSpinnerService) {
    var service = {
      show: show,
      hide: hide
    };

    return service;

    function show() {
      usSpinnerService.spin();
    }

    function hide() {
      usSpinnerService.stop();
    }
  }
})();

(function () {
  'use strict';

  var TPL =
    '<md-dialog aria-label="Error" class="error-dialog">' +
    '  <md-dialog-content class="md-dialog-content">' +
    '    <h2>{{ctrl.titre}}</h2>' +
    '    <div class="md-dialog-content-body">' +
    '      <p>{{ctrl.message}}</p>' +
    '    </div>' +
    '  </md-dialog-content>' +
    '  <md-dialog-actions>' +
    '    <md-button ng-click="ctrl.close()" class="md-raised md-primary">Fermer</md-button>' +
    '  </md-dialog-actions>' +
    '</md-dialog>';

    var nbModalsSessionExpired = 0;

  angular
    .module('app')
    .service('ErrorService', ErrorService);

  /* @ngInject */
  function ErrorService($log, $mdDialog, AdvErrorService, MESSAGES) {
    var service = {
      alert: alert,
      log: log,
      isAuthentificationError: isAuthentificationError,
      isFatalError: isFatalError,
      isNetworkError: isNetworkError,
      getNbModalsSessionExpired: getNbModalsSessionExpired,
      setNbModalsSessionExpired: setNbModalsSessionExpired
    };

    return angular.extend(AdvErrorService, service);

    function alert(error, options) {
      if (!_.isObject(error)) {
        var e = error;
        error = {};

        if (_.isString(e)) {
          error.userMessage = e;
        }
      }

      if (_.get(error, 'ishandled') !== true) {
        if (angular.isDefined(error)) {
          log(error);

          error.ishandled = true;
        }

        var titre = 'Erreur';
        var message = '';

        if (angular.isDefined(options)) {
          if (angular.isDefined(options.titre)) {
            titre = options.titre;
          }
          if (angular.isDefined(options.message)) {
            message += options.message;
          }
        }

        if (angular.isDefined(_.get(error, 'userMessage'))) {
          message += error.userMessage;
        }

        if (message === '') {
          message = MESSAGES.ERREUR_TECHNIQUE;
        }

        if (message === MESSAGES.SESSION_EXPIREE) {
          nbModalsSessionExpired++;
        }

          return $mdDialog.show({
            controller: DialogController,
            controllerAs: 'ctrl',
            bindToController: true,
            template: TPL,
            multiple: true,
            locals: {
              titre: titre,
              message: message
            }
          });
      }
    }

    function DialogController() {
      var vm = this;

      vm.close = function () {
        $mdDialog.hide();
      };
    }

    function log(error) {
      $log.error('Error : ', error);
    }

    function isAuthentificationError(error) {
      return (_.get(error, 'status') === 401);
    }

    function isFatalError(error) {
      return (error.fatal === true);
    }

    function isNetworkError(error) {
      return (error.status < 200);
    }

    function getNbModalsSessionExpired() {
      return nbModalsSessionExpired;
    }

    function setNbModalsSessionExpired(nb) {
      nbModalsSessionExpired = nb;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('FacturationController', FacturationController);

  /** @ngInject */

  function FacturationController($state, $stateParams, $timeout,
      ModalService, UserService, DetenteurService, AdminGestionAbonnementService,
      LoadingService, ErrorService, FonctionnaliteService, CompteService,
      AutorisationAccesService, EnvoiSmsService, ReferentielService) {

    var vm = this;

    vm.state = $state.current;
    vm.detenteur = {};
    vm.iban = "";

    // en prod commenter
    // en local décommenter pour saisie auto
    // vm.iban = "FR1420041010050500013M02606";

    vm.prelevementMobile = "";
    vm.detenteur.adresse = {};

    vm.codeVerificationEnabled = false;
    /*      vm.detenteur = {
            adresse: {
              adress: '',
              complementAdresse: '',
              codePostal: '',
              ville: ''
            }
          };*/
    vm.isTechnicien = UserService.get('profil') === 'TECHNICIEN';

    // infos d'accès au portail facturation
    vm.serviceOdoo = {};

    // par défaut, le bouton "Pas de code reçu" est caché
    vm.afficherPasCodeRecuButton = false;

    // par défaut, le pdf prélèvement n'est pas téléchargé
    vm.pdfPrelevementDownloaded = false;

    var numExploitation;
    var isAdminSide = false;
    vm.contact = {};

    // inscription
    if (vm.state.name === "abonnement.facturation") {
      vm.saisie = $stateParams.saisie;
      var codeRef = "TARIF_PRELEVEMENT_AUTO";
      ReferentielService.getReferentielsEntiers(codeRef).then(function (result) {
        vm.tarifPrelevementAuto = result.value;
      });
      const codeRefDureePasCodeRecu = "DUREE_AFFICHER_PAS_CODE_SMS_RECU";
      ReferentielService.getReferentielsEntiers(codeRefDureePasCodeRecu).then(function (result) {
        vm.dureePasCodeRecu = result.value;
      });
    } else if (vm.state.name === "app.admin.gestionAbonnement.detail") {
      // gestion admin
      numExploitation = AdminGestionAbonnementService.getAbonnementSelectionne().numExploitation;
      isAdminSide = true;
    } else {
      // mon compte
      numExploitation = UserService.getNumeroExploitation();
      // préchargement de l'accès au portail facturation (réduire la latence)
      FonctionnaliteService.getFonctionnalite('ODOO').then(function (fonctionnalite) {
        vm.serviceOdoo = fonctionnalite;
      });
    }

    if (angular.isDefined(vm.saisie) && !_.isEmpty(vm.saisie) && angular.isDefined(vm.saisie.infosExploitation)) {
      // chargement à l'inscription
      vm.raisonSociale = vm.saisie.infosExploitation.raisonSociale;
      vm.numeroExploitation = vm.saisie.infosExploitation.numExploitation;

      vm.detenteur = vm.saisie.infosExploitation.detenteur;
      vm.detenteur.numero = vm.saisie.infosExploitation.detenteur.numDetenteur;

      // préchargement du formulaire si dispo (retour arrière sur le fil d'ariane)
      if (angular.isDefined(vm.saisie.contactFacturation)) {
        vm.contact = vm.saisie.contactFacturation.contact;
        vm.contact.telMobile = vm.saisie.contactFacturation.contact.numeroMobile;
      }
      if (angular.isDefined(vm.saisie.iban)) {
        vm.iban = vm.saisie.iban;
      }
      if (angular.isDefined(vm.saisie.prelevementMobile)) {
        vm.prelevementMobile = vm.saisie.prelevementMobile;
      }
    } else {
      // chargement mon compte/gestion admin
      // infos détenteurs
      DetenteurService.getDetenteur(numExploitation)
        .then(function (result) {
          vm.raisonSociale = result.raisonSociale;
          vm.numeroExploitation = result.numExploitation;
          var adresse = {
            adress: result.adresse.adress,
            complementAdresse: result.adresse.complementAdresse,
            codePostal: result.adresse.codePostal,
            ville: result.adresse.ville
          };
          vm.detenteur.adresse = adresse;
          vm.detenteur.numero = result.numDetenteur;
        });

      // infos contact facturation
      loadContact();
    }

    vm.goToValidation = function () {
      $stateParams.saisie.contactFacturation = {
        numeroExploitation: vm.numeroExploitation,
        numeroDetenteur: vm.detenteur.numero,
        contact: {
          email: vm.contact.email,
          nom: vm.contact.nom,
          prenom: vm.contact.prenom,
          numeroMobile: vm.contact.telMobile,
          numeroExploitation: vm.numeroExploitation
        }
      };
      $stateParams.saisie.iban = vm.iban;
      $stateParams.saisie.prelevementMobile = vm.prelevementMobile;
      $stateParams.saisie.codeVerification = vm.codeVerification;
      $stateParams.saisie.pdfPrelevementDownloaded = vm.pdfPrelevementDownloaded;

      // enregistrer option facture papier si souscrite
      checkOptionFacturePapier();

      $state.go('abonnement.validation');
    };

    // enregistrement (Mon compte)
    vm.enregistrerModifications = function (modifierAdresse) {
      LoadingService.show();
      // alerte si aucun changement ?
      var contactFacturation = {
        numeroDetenteur: vm.detenteur.numero,
        numeroExploitation: vm.numeroExploitation,
        contact: {
          email: vm.contact.email,
          nom: vm.contact.nom,
          prenom: vm.contact.prenom,
          numeroMobile: vm.contact.telMobile,
          numeroExploitation: vm.numeroExploitation
        }
      };

      DetenteurService.setContactFacturation(contactFacturation).then(function (result) {
        LoadingService.hide();
        if (modifierAdresse) {
          modifierAdresseDetenteur();
        }
        var message = '';
        if (angular.isDefined(result.errors) && !_.isEmpty(result.errors)) {
          angular.forEach(result.errors, function (error) {
            if (_.isEqual(error, 'KO_EMAIL_DEJA_UTILISE')) {
              message += '- Email déjà utilisé pour un autre détenteur.<br>';
            }
            // (admin uniquement) la modification d'adresse invalide le fait que les coordonnées facturation restent inchangées
            if (_.isEqual(error, 'KO_DONNEES_INCHANGEES') && !modifierAdresse) {
              message += '- Données identiques aux précédentes.<br>';
            }
          });
        }
        if (message.length > 0) {
          // infos contact facturation
          ModalService.alert({
            template: "Les modifications n'ont pas été enregistrées: <br>" + message
          }).then(function () {
            loadContact();
          });
        } else {
          ModalService.alert({
            template: "Les modifications ont bien été enregistrées"}).then(function () {
            // appliquons ce chef-d'oeuvre d'ergonomie côté admin qui consiste à faire du ping pong...
            if (isAdminSide) {
              $state.go('app.admin.gestionAbonnement.selection');
            }
          });
        }
      }, function (error) {
        LoadingService.hide();
        if (_.get(error, 'data.code')) {
          dialog(error.data.message);
        } else {
          ErrorService.alert(error);
        }
      });
    };

    // retour accueil (éleveur)
    vm.annuler = function () {
      if (angular.isDefined(abonnementBov)) {
        $state.go('app.eleveur.bovin.home');
      } else {
        $state.go('app.eleveur.woc.home');
      }
    };

    function dialog(text) {
      ModalService.alert({
        template: text
      });
      LoadingService.hide();
    }

    // charger les données du contact facturation
    function loadContact() {
      DetenteurService.getContactFacturation(numExploitation)
        .then(function (result) {
          vm.contact.nom = result.contact.nom;
          vm.contact.prenom = result.contact.prenom;
          vm.contact.telMobile = result.contact.numeroMobile;
          vm.contact.email = result.contact.email;
          vm.contact.numeroExploitation = numExploitation;
        });
    }

    function modifierAdresseDetenteur() {
      var detenteur = {
        numExploitation: vm.numeroExploitation,
        numDetenteur: vm.detenteur.numero,
        raisonSociale: vm.raisonSociale,
        adresse: {
          adress: vm.detenteur.adresse.adress,
          complementAdresse: vm.detenteur.adresse.complementAdresse,
          codePostal: vm.detenteur.adresse.codePostal,
          ville: vm.detenteur.adresse.ville
        }
      };

      DetenteurService.modifierAdresseDetenteur(detenteur).then(function () {
      }, function (error) {
        ErrorService.alert("Erreur lors de la tentative de modification de l'adresse (" + error + ")");
      });
    }

    vm.goToGestionFactures = function () {
      // si profil responsable responsable/associé - ouverture odoo dans nouvel onglet
      if (UserService.get('mailLogin') === UserService.getEmailResponsableAssocieFacturation()) {
        FonctionnaliteService.goToFonctionnalite(vm.serviceOdoo, {
          menu: false,
          newPage: true
        }).catch(function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });
      } else { // sinon modale (avec responsable) avec redirection possible vers les autorisations d'accès
        vm.showButton = false;
        AutorisationAccesService.getCurrentAutorisationAcces().then(function (result) {
          if (angular.equals(result.profil.libelle, 'Responsable/associé Facturation') === true || angular.equals(result.profil.libelle, 'Responsable/associé') === true) {
            vm.showButton = true;
           }

          ModalService.popupAccesFacturationNonDisponible(UserService.getEmailResponsableAssocieFacturation(), vm.showButton).then(function () {
            $state.go('app.eleveur.compte.compte', {
                onglet: 'autorisations d\'accès'
            });
          });
        });
      }
    };

    /* OPTION FACTURE PAPIER */
    var abonnementFacturePapier;
    var abonnementBov;
    // le paramétrage quant à lui est accessible via vm.configurationOptionFacturePapier
    // (id à utiliser pour la souscription + tarif)

    initOptionFacturePapier();

    // tarif d'après les abonnements
    // état de l'option (abonné ou non)
    function initOptionFacturePapier() {
      if (vm.state.name === "abonnement.facturation") {
        /* ABONNEMENT */
        // récupération des données abonnement facture papier depuis les infos du fil d'abonnement
        var configurationsFacturePapier = _.get(vm.saisie.listAbonnements, 'FACTURE_PAPIER');
        vm.configurationOptionFacturePapier = _.find(configurationsFacturePapier, {
          disponible: true
        });
        computeTarif();
        // option à récupérer

        // option indeterminée à ce stade
        vm.hasOptionFacturePapier = undefined;
      } else if (vm.state.name === "app.eleveur.compte.compte") {
        /* MON COMPTE */
        // récupération des données abonnement facture papier depuis le numéro d'exploitation (accès tarif)
        CompteService.getNiveaux(numExploitation).then(function (niveaux) {
          var niveauxFacturePapier = _.get(niveaux, 'FACTURE_PAPIER');
          vm.configurationOptionFacturePapier = _.find(niveauxFacturePapier,
            ['typeAbonnement.code', 'FACTURE_PAPIER']
          );
          computeTarif();
          // récupération de l'option (indique l'état actuel si option souscrite et avec quel idEleveurAbonnementExploitation le cas échéant)
          loadAbonnementFacturePapier();
        }, function (error) {
          ErrorService.alert(error);
        });
      }
    }

    // calcul tarif annuel
    function computeTarif() {
      if (angular.isDefined(vm.configurationOptionFacturePapier)) {
        vm.tarifOptionFacturePapier = vm.configurationOptionFacturePapier.prix.toFixed();
        vm.periodiciteOptionFacturePapier = vm.configurationOptionFacturePapier.periodicite.libelle;
      }
    }

    // récupérer de l'abonnement si souscrit (via Mon Compte uniquement)
    function loadAbonnementFacturePapier() {
        CompteService.getAbonnements(UserService.get('login')).then(function (abonnements) {
          angular.forEach(abonnements, function (abonnement) {
            if (_.isEqual(abonnement.typeAbonnement.code, 'FACTURE_PAPIER')) {
              abonnementFacturePapier = abonnement;
            }
            if (_.isEqual(abonnement.typeAbonnement.code, 'BOV')) {
              abonnementBov = abonnement;
            }
          });
          // état des boutons oui/non
          if (angular.isDefined(abonnementFacturePapier)) {
            vm.hasOptionFacturePapier = true;
          } else {
            vm.hasOptionFacturePapier = false;
          }
      }, function (error) {
        LoadingService.hide();
        if (_.get(error, 'data.code')) {
          dialog(error.data.message);
        } else {
          ErrorService.alert(error);
        }
      });
    }

    // modales description
    vm.showDescriptionFacturePapier = function () {
      ModalService.facturePapierInfos(vm.configurationOptionFacturePapier.prix, vm.configurationOptionFacturePapier.periodicite.libelle);
    };

    // souscription option facture papier
    vm.activerOptionFacturePapier = function () {
      if (vm.state.name === "abonnement.facturation") {
        /* ABONNEMENT */
        vm.hasOptionFacturePapier = true;
      } else if (vm.state.name === "app.eleveur.compte.compte") {
        /* MON COMPTE */
        LoadingService.show();
        if (angular.isUndefined(abonnementFacturePapier)) {
            CompteService.ajoutAbonnement(UserService.get('login'), vm.configurationOptionFacturePapier.idTarifAbonnementOrganisme).then(function () {
            LoadingService.hide();
            $stateParams.onglet = 'facturation';
            $state.transitionTo($state.current, $stateParams, {
              reload: true
            });
          }, function (error) {
            if (_.get(error, 'data.code')) {
              ModalService.alert({
                template: error.data.message
              });
            } else {
              ErrorService.alert(error);
            }
          });
        } else {
          LoadingService.hide();
        }
      }
    };

    // annuler option facture papier
    vm.annulerOptionFacturePapier = function () {
      if (vm.state.name === "abonnement.facturation") {
        vm.hasOptionFacturePapier = false;
      } else if (vm.state.name === "app.eleveur.compte.compte") {
        /* MON COMPTE */
        LoadingService.show();
        if (angular.isDefined(abonnementFacturePapier)) {
          // dans processus inscription : différé à la validation finale
            CompteService.resiliationAbonnement(UserService.get('login'), abonnementFacturePapier.idEleveurAbonnementExploitation, '').then(function () {
            LoadingService.hide();
            $stateParams.onglet = 'facturation';
            $state.transitionTo($state.current, $stateParams, {
              reload: true
            });
          }, function (error) {
            LoadingService.hide();
            if (_.get(error, 'data.code')) {
              ModalService.alert({
                template: error.data.message
              });
            } else {
              ErrorService.alert(error);
            }
          });
        } else {
          LoadingService.hide();
        }
      }
    };

    // (inscription) souscription ou non à l'option facture papier
    function checkOptionFacturePapier() {
      if (angular.isDefined(vm.hasOptionFacturePapier) && vm.hasOptionFacturePapier && angular.isDefined(vm.configurationOptionFacturePapier) && angular.isDefined(vm.configurationOptionFacturePapier.idTarifAbonnementOrganisme)) {
          $stateParams.saisie.listAbonnementsSelectionnes.push(vm.configurationOptionFacturePapier);
          $stateParams.saisie.activeAbonnement.push(vm.configurationOptionFacturePapier.idTarifAbonnementOrganisme);
      }
    }

    // Demande pour envoyer le code par SMS
    vm.sendSms = function () {
      if (
        angular.isDefined(vm.iban) &&
        angular.isDefined(vm.prelevementMobile)
      ) {
        vm.codeVerificationEnabled = true;
        LoadingService.show();
        EnvoiSmsService.envoiCodeSms(vm.prelevementMobile, vm.iban).then(
          function () {
            LoadingService.hide();
            ModalService.alert({
              template:
                "Un SMS avec un code de vérification va vous être envoyé",
              title: "Confirmation"
            }).then(function () {
              // Une fois la modale confirmée, le timer pour afficher le bouton "Pas de code reçu" démarre
              startTimerPasCodeRecu();
            });
          },
          function (error) {
            LoadingService.hide();
            if (_.get(error, 'data.code')) {
              dialog(error.data.message);
            } else {
              ErrorService.alert(error);
            }
          });
      }
    };

    // Fonction pour démarrer le timer pour afficher le bouton "Pas de code reçu"
    function startTimerPasCodeRecu() {
      vm.afficherPasCodeRecuButton = false;
      $timeout(function () {
        // Affiche le bouton après vm.dureePasCodeRecu secondes
        vm.afficherPasCodeRecuButton = true;
      }, 1000 * vm.dureePasCodeRecu);
    }

    // Pas de code reçu / Problème d’enregistrement du mandat
    vm.pasCodeRecuOnClick = function () {
      ModalService.saisieIBAN(vm.pdfPrelevementDownloaded).then(function () {
        vm.pdfPrelevementDownloaded = true;
      });
    };

    vm.onIbanChange = function () {
      vm.codeVerification = '';
      vm.codeVerificationEnabled = false;
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('AutorisationsAccesController', AutorisationsAccesController);

    /** @ngInject */
    function AutorisationsAccesController($state, $stateParams, $anchorScroll, $location, $document, ModalService, ReferentielService,
        CompteService, UserService, LoadingService, ErrorService, AutorisationAccesService, AdminService, OrganismeMigrationService, FloreService) {

        var vm = this;
        vm.isTechnicien = UserService.get('profil') === 'TECHNICIEN';
        vm.state = $state.current;
        vm.typesTel = ["Android", "IOS", "AUTRE"];
        if (angular.isDefined(ReferentielService.getProfilsAutorisationsAcces())) {
            vm.profils = ReferentielService.getProfilsAutorisationsAcces();
            vm.droits = ReferentielService.getDroitsAutorisationsAcces();
        } else {
            ReferentielService.load().then(function () {
                vm.profils = ReferentielService.getProfilsAutorisationsAcces();
                vm.droits = ReferentielService.getDroitsAutorisationsAcces();
            });
        }

        vm.personne = {};
        // Permet de switch le mode de saisie du formulaire
        vm.modeCreation = true;
        // Param pour gérer le bouton enregistrer
        vm.disableEnregistrer = true;
        vm.listAssocies = [];
        if (vm.state.name === "abonnement.autorisations") {
            vm.saisie = $stateParams.saisie;

            // en prod commenter
            // en local décommenter pour saisie auto
            /* vm.saisie.listAutorisationsAcces = [
                {
                    email: 'olivier.plateau@adventiel.fr',
                    niveauDroit: { id: 1, libelle: 'Saisie autorisée' },
                    nom: 'PLATEAU',
                    numExploitation: '86056548', // Olivier=44200020 Alex=86056548
                    prenom: 'OLIVIER',
                    profil: { id: 8, libelle: 'Responsable/associé Facturation' }
                }
            ];*/

            vm.numExploitation = vm.saisie.infosAbonne.numExploitation;
            if (vm.saisie.listAutorisationsAcces && vm.saisie.listAutorisationsAcces.length > 0) {
                vm.listAssocies = vm.saisie.listAutorisationsAcces;
            }
        } else if (vm.state.name === 'app.admin.gestionAssocies') {
            // loadAboFloreActif();
            // élements du formulaire de recherche
            vm.identifiant = '';
            vm.numExploitation = '';
        } else {
            loadAboFloreActif();
            loadList();
            vm.numExploitation = UserService.getNumeroExploitation();
        }

        function loadAboFloreActif() {
            CompteService.getAbonnements(UserService.get('login')).then(function (result) {
                angular.forEach(result, function (abonnement) {
                    if (_.isEqual(abonnement.typeAbonnement.code, 'FLORE')) {
                        FloreService.getAbonneFlore(UserService.get('login')).then(function (result) {
                            vm.aboFloreActif = result;
                        });
                    }
                });
            }, function (error) {
                ErrorService.alert(error);
            });
        }

        vm.changeProfile = function () {
            var saisieAutorise;
            if (vm.personne.profil.libelle === "Technicien") {
                if (vm.modeCreation) {
                    saisieAutorise = _.find(vm.droits, function (droit) {
                        return droit.libelle === "Saisie interdite";
                    });
                    vm.personne.niveauDroit = saisieAutorise;
                }
                $document[0].getElementById('2').removeAttribute("disabled");
                vm.isProfilResponsableAssocie = false;
            } else {
                $document[0].getElementById('2').setAttribute("disabled", "disabled");
                if (vm.personne.profil.libelle === "Responsable/associé Facturation" || vm.personne.profil.libelle === "Responsable/associé") {
                    saisieAutorise = _.find(vm.droits, function (droit) {
                        return droit.libelle === "Saisie autorisée";
                    });
                    vm.personne.niveauDroit = saisieAutorise;
                    vm.isProfilResponsableAssocie = true;
                } else {
                    vm.isProfilResponsableAssocie = false;
                    vm.personne.niveauDroit = '';
                }
            }
        };

        vm.ajouterAutorisationAcces = function () {
            if (vm.state.name !== 'app.admin.gestionAssocies') {
                vm.personne.numExploitation = vm.numExploitation;
            }
            if (verifierSaisieDoublon()) {
                dialog("Une autorisation pour l'utilisateur " + vm.personne.email + " existe déjà pour cette exploitation.");
            } else {
                if (vm.personne.niveauDroit === "") {
                    vm.personne.niveauDroit = null;
                }
                vm.listAssocies.push(vm.personne);
                vm.disableEnregistrer = false;
                // CompteService.modificationNonEnregistree = true;
                AdminService.setHasChanges(true);
                CompteService.aucunResponsable = !verifierResponsableExiste(vm.listAssocies);
                clearForm();
            }
        };

        vm.editerPersonne = function (personne, index) {
            vm.index = index;
            vm.modeCreation = false;
            vm.personne = angular.copy(personne);
            vm.personne.confirmationEmail = undefined;
            vm.origineEmail = vm.personne.email;
            vm.changeProfile();
            $location.hash('div-form');
            $anchorScroll();
        };

        function verifierTelephoneFlore(personne) {
            if (vm.aboFloreActif && vm.aboFloreActif.telephoneSms) {
                const telephoneFlore = vm.aboFloreActif.telephoneSms.replaceAll(' ', '');
                if (telephoneFlore === personne.telMobile) {
                    return ModalService.alert({
                        template: "Attention cet identifiant reçoit sur son n° de téléphone les alertes du Service Flore Sorties Présumées : pensez à modifier le n° utilisé dans le cadre de ce service (Mon compte/Options/Option Flore Sorties Présumées)."
                    });
                }
            }
            return Promise.resolve();
        }

        vm.modifierPersonne = function () {
            if (verifierSaisieDoublon()) {
                dialog("Une autorisation pour l'utilisateur " + vm.personne.email + " existe déjà pour cette exploitation.");
            } else if (vm.state.name === "abonnement.autorisations") {
                confirmModifierPersonne();
            } else {
                AutorisationAccesService.compteKcExist(vm.listAssocies[vm.index].email, vm.listAssocies[vm.index].numExploitation).then(function (compteKcExist) {
                    if (compteKcExist) {
                        if (vm.listAssocies[vm.index].email === vm.personne.email) {
                            confirmModifierPersonne();
                        } else {
                            ModalService.confirm({
                                template: "En modifiant l'adresse email, vous modifiez l'identifiant permettant d'accéder à Pilot'Elevage. En conséquence, un email va être envoyé sur la nouvelle adresse indiquée afin de réinitialiser le mot de passe et sécuriser l'accès à Pilot'Elevage (vérifiez dans les spams/pub)."
                            }).then(function () {
                                confirmModifierPersonne();
                            });
                        }
                    } else {
                        confirmModifierPersonne();
                    }
                }, function (error) {
                    if (_.get(error, 'data.code')) {
                        dialog(error.data.message);
                    } else {
                        ErrorService.alert(error);
                    }
                });
            }
        };

        function confirmModifierPersonne() {
            verifierTelephoneFlore(vm.listAssocies[vm.index]);
            if (vm.personne.niveauDroit === "") {
                vm.personne.niveauDroit = null;
            }
            vm.listAssocies[vm.index] = angular.copy(vm.personne);
            vm.disableEnregistrer = false;
            AdminService.setHasChanges(true);
            CompteService.aucunResponsable = !verifierResponsableExiste(vm.listAssocies);
            clearForm();

        }

        vm.supprimerPersonne = function (personne, index) {
            if (vm.state.name === "abonnement.autorisations") {
                confirmSupprimerPersonne(index);
            } else {
                AutorisationAccesService.compteKcExist(personne.email, personne.numExploitation).then(function (compteKcExist) {
                    if (compteKcExist) {
                        ModalService.confirm({
                            template: "Si vous supprimez cet identifiant, il ne pourra plus accéder à Pilot’Elevage. Confirmez-vous la suppression de cet identifiant?"
                        }).then(function () {
                            confirmSupprimerPersonne(index);
                        });
                    } else {
                        ModalService.confirm({
                            template: "Souhaitez-vous vraiment supprimer " + personne.nom + " " + personne.prenom + " de la liste ?"
                        }).then(function () {
                            confirmSupprimerPersonne(index);
                        });
                    }
                }, function (error) {
                    if (_.get(error, 'data.code')) {
                        dialog(error.data.message);
                    } else {
                        ErrorService.alert(error);
                    }
                });
            }
        };

        function confirmSupprimerPersonne(index) {

            var listApresSuppression = angular.copy(vm.listAssocies);
            listApresSuppression.splice(index, 1);

            if (listApresSuppression.length === 0 || (listApresSuppression.length >= 1 && !verifierResponsableExiste(listApresSuppression))) {
                ModalService.alert({
                    template: "Il faut un responsable/associé Facturation pour cette exploitation, la suppression de cette ligne est donc impossible."
                }).then(function () {

                });
            } else {
                verifierTelephoneFlore(vm.listAssocies[index]);
                vm.listAssocies.splice(index, 1);
                vm.disableEnregistrer = false;
                AdminService.setHasChanges(true);
                CompteService.aucunResponsable = !verifierResponsableExiste(vm.listAssocies);
            }

        }

        vm.annulerModification = function () {
            clearForm();
        };

        vm.afficherAide = function () {
            ModalService.autorisationAccesInfos();
        };

        vm.enregistrerModifications = function () {
            if (!vm.disableEnregistrer) {
                if (verifierResponsableUnique(vm.listAssocies)) {
                    LoadingService.show();
                    AutorisationAccesService.enregistrerAutorisationsAcces(vm.listAssocies).then(function (result) {
                        var phraseComplementaire = '';
                        if (result === true) {
                            phraseComplementaire = 'Vous venez d’autoriser au moins une personne à se connecter au compte Pilot’Elevage de l’exploitation. Un mail va être envoyé sur les adresses mail ajoutées afin de créer les accès personnels (vérifiez dans les spams/pub).';
                        }
                        LoadingService.hide();
                        ModalService.alert({
                            template: "Les modifications ont bien été enregistrées.",
                            template2: phraseComplementaire
                        }).then(function () {
                            AdminService.setHasChanges(false);
                            goToHome();
                        });
                    }, function (error) {
                        LoadingService.hide();
                        if (_.get(error, 'data.code')) {
                            dialog(error.data.message);
                            vm.disableEnregistrer = false;
                        } else {
                            ErrorService.alert(error);
                        }
                    });
                    CompteService.aucunResponsable = !verifierResponsableExiste(vm.listAssocies);
                    vm.disableEnregistrer = true;
                } else if (verifierResponsableExiste(vm.listAssocies)) {
                    dialog("Il ne doit y avoir qu'un seul responsable/associé Facturation pour cette exploitation.");
                } else {
                    dialog("Il faut saisir un responsable/associé Facturation pour cette exploitation.");
                }
            }
        };

        vm.enregistrerModificationsAdmin = function () {
            LoadingService.show();
            AutorisationAccesService.enregistrerAutorisationsAccesAdmin(vm.listAssocies, vm.numExploitation, vm.identifiant).then(function (result) {
                var phraseComplementaire = '';
                if (result === true) {
                    phraseComplementaire = 'Vous venez d’autoriser au moins une personne à se connecter au compte Pilot’Elevage de l’exploitation. Un mail va être envoyé sur les adresses mail ajoutées afin de créer les accès personnels (vérifiez dans les spams/pub).';
                }
                LoadingService.hide();
                ModalService.alert({
                    template: "Les modifications ont bien été enregistrées.",
                    template2: phraseComplementaire
                }).then(function () {
                    AdminService.setHasChanges(false);
                    if (vm.state.name === 'app.admin.gestionAssocies') {
                        loadListNumExploitOrIdentifiant();
                    } else {
                        loadList();
                    }
                });
            }, function (error) {
                LoadingService.hide();
                if (_.get(error, 'data.code')) {
                    dialog(error.data.message);
                } else {
                    ErrorService.alert(error);
                }
            });
        };

        function dialog(text) {
            ModalService.alert({
                template: text
            });
            LoadingService.hide();
        }

        function clearForm() {
            vm.modeCreation = true;
            vm.associeForm.$setPristine();
            vm.associeForm.$setUntouched();
            vm.personne = {};
            updateNumExploitAndIdentifiant();
            vm.index = undefined;
        }

        vm.goToAbonnementService = function () {
            if (vm.listAssocies.length > 0 && verifierResponsableUnique(vm.listAssocies)) {
                vm.saisie.listAutorisationsAcces = vm.listAssocies;
                AdminService.setHasChanges(false);
                $state.go('abonnement.services');
            } else if (vm.listAssocies.length > 0 && verifierResponsableExiste(vm.listAssocies)) {
                dialog("Il ne doit y avoir qu'un seul responsable/associé Facturation pour cette exploitation.");
            } else {
                dialog("Il faut saisir au moins un responsable/associé Facturation pour cette exploitation.");
            }
        };

        vm.validerRecherche = function () {
            if (vm.identifiant !== '') {
                vm.recherchePar = 'IDENTIFIANT';
            }
            if (vm.numExploitation !== '') {
                vm.recherchePar = 'NUMEXPLOIT';
            }
            loadListNumExploitOrIdentifiant();
        };

        function verifierResponsableExiste(listPersonnes) {
            var personne = _.find(listPersonnes, function (personne) {
                return personne.profil.libelle === "Responsable/associé Facturation";
            });
            return angular.isDefined(personne);
        }

        // faux si le nombre de responsables facturation dans la liste est différent de 1
        function verifierResponsableUnique(listPersonnes) {
            var count = _.filter(listPersonnes, function (personne) {
                return personne.profil.libelle === "Responsable/associé Facturation";
            }).length;

            return count === 1;
        }

        function verifierSaisieDoublon() {
            var personne = {};
            var listAutresPersonnes = angular.copy(vm.listAssocies);
            if (angular.isDefined(vm.index)) {
                listAutresPersonnes.splice(vm.index, 1);
            }

            if (vm.recherchePar === 'IDENTIFIANT') {
                personne = _.find(listAutresPersonnes, function (personne) {
                    return personne.numExploitation === vm.personne.numExploitation;
                });
            } else {
                personne = _.find(listAutresPersonnes, function (personne) {
                    return personne.email === vm.personne.email;
                });
            }
            return angular.isDefined(personne);

        }

        function loadList() {
            AutorisationAccesService.getAutorisationsAcces().then(function (result) {
                vm.listAssocies = result;
                if (vm.listAssocies.length > 0) {
                    CompteService.aucunResponsable = !verifierResponsableExiste(vm.listAssocies);
                } else {
                    OrganismeMigrationService.getOrganismeMigration().then(function (result) {
                        if (angular.isDefined(result.codeOrganisme)) {
                            CompteService.aucunResponsable = true;
                        } else {
                            CompteService.aucunResponsable = false;
                        }
                    }, function (error) {
                        if (_.get(error, 'data.code')) {
                            dialog(error.data.message);
                        } else {
                            ErrorService.alert(error);
                        }
                    });
                }
            }, function (error) {
                if (_.get(error, 'data.code')) {
                    dialog(error.data.message);
                } else {
                    ErrorService.alert(error);
                }
            });
        }

        function loadListNumExploitOrIdentifiant() {
            checkHasModifications(function () {
                AutorisationAccesService.getAutorisationsAccesAdmin(vm.numExploitation, vm.identifiant).then(function (result) {
                    vm.listAssocies = result;
                    clearForm();
                }, function (error) {
                    if (_.get(error, 'data.code')) {
                        dialog(error.data.message);
                    } else {
                        ErrorService.alert(error);
                    }
                });
            });
        }

        function updateNumExploitAndIdentifiant() {
            vm.personne.numExploitation = '';
            vm.personne.email = '';
            if (vm.recherchePar === 'IDENTIFIANT') {
                vm.personne.email = vm.identifiant;
            } else {
                vm.personne.numExploitation = vm.numExploitation;
            }
        }

        function checkHasModifications(callback) {
            if (AdminService.hasChanges()) {
                ModalService.confirm({
                    template: "Vos modifications n’ont pas été enregistrées, souhaitez-vous continuer et donc perdre vos saisies ?",
                    cancelText: 'Non',
                    okText: 'Oui'
                }).then(function () {
                    AdminService.setHasChanges(false);
                    callback();
                }, function () { });
            } else {
                callback();
            }
        }

        function goToHome() {
            UserService.getListTypeAbonnement(UserService.get('login')).then(function (response) {
                var listAbonnements = response.listeTypeAbonnement;
                if (listAbonnements.indexOf("BOV") !== -1) {
                    $state.go('app.eleveur.bovin.home');
                    return;
                }
                if (listAbonnements.indexOf("OVCAP") !== -1) {
                    $state.go('app.eleveur.woc.home');
                    return;
                }
                $state.go('auth');
            });
        }

        vm.afficherConfirmationEmail = function () {
            var afficherInput = false;
            var condition1 = vm.recherchePar !== 'IDENTIFIANT' && !vm.isTechnicien || vm.state.name !== 'app.admin.gestionAssocies';
            var condition2 = vm.associeForm.email.$touched && !vm.associeForm.email.$invalid;
            var condition3 = vm.modeCreation === false && vm.origineEmail !== vm.personne.email;

            if (condition1 && condition2) {
                if (vm.modeCreation === true) {
                    afficherInput = true;
                } else if (condition3) {
                    afficherInput = true;
                }
            }
            return afficherInput;
        };
    }

})();

(function () {
  'use strict';

  var TPL =
    '<md-button type="button" ng-click="ctrl.showSouffleur = !ctrl.showSouffleur" title="Filtres avancées" ng-class="{\'active\': ctrl.showSouffleur}" class="souffleur-button md-icon-button">' +
    '  <md-icon>filter_list</md-icon>' +
    '  <md-icon class="active-icon" aria-hidden="true">close</md-icon>' +
    '</md-button>';

  angular
    .module('app')
    .directive('advSouffleurButton', advSouffleurButton);

  /* @ngInject */
  function advSouffleurButton() {
    var directive = {
      restrict: 'E',
      controller: AdvSouffleurButtonController,
      controllerAs: 'ctrl',
      bindToController: true,
      template: TPL,
      scope: {
        showSouffleur: '=',
        filter: '='
      }
    };

    AdvSouffleurButtonController.$inject = ['$scope'];

    /* @inject */
    function AdvSouffleurButtonController($scope) {
      var vm = this;

      if (angular.isUndefined(vm.showSouffleur)) {
        vm.showSouffleur = false;
      }

      $scope.$watch(function () {
        return vm.showSouffleur;
      }, function () {
        if (!vm.showSouffleur) {
          vm.filter.souffleurs = {};
        }
      });
    }

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advSouffleur', advSouffleur);

  /* @ngInject */
  function advSouffleur() {
    var directive = {
      require: ['ngModel'],
      restrict: 'E',
      controller: AdvSouffleurController,
      controllerAs: 'ctrl',
      bindToController: true,
      transclude: true,
      templateUrl: 'app/_common/directives/souffleur/souffleur.html',
      scope: {
        ngModel: '=',
        type: '='
      }
    };

    /* @inject */
    function AdvSouffleurController() {
      var vm = this;

      if (angular.isUndefined(vm.ngModel)) {
        vm.ngModel = {
          type: vm.type,
          value: undefined
        };
      }
      vm.isEmpty = function () {
        switch (vm.ngModel.type) {
          case 'date':
            return angular.isUndefined(vm.ngModel.value);
          case 'dateMin':
            return angular.isUndefined(vm.ngModel.value);
          case 'dateMax':
            return angular.isUndefined(vm.ngModel.value);
          case 'multiple':
            return angular.isUndefined(vm.ngModel.value) || (vm.ngModel.value.length === 0);
          default:
            return angular.isUndefined(vm.ngModel.value) || (vm.ngModel.value === '');
        }
      };

      vm.clear = function () {
        switch (vm.ngModel.type) {
          default:
            vm.ngModel.value = undefined;
            break;
        }
      };
      // redmine 32697 : les filtres avec un type de renseignés ne marchent pas (la propriété 'type' n'apparaissait pas dans le json)
      vm.$onInit = function () {
        if (angular.isUndefined(vm.ngModel)) {
          vm.ngModel = {
            type: vm.type,
            value: undefined
          };
        }
      };
    }

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advScale', advScale);

  advScale.$inject = ['$timeout', '$window'];

  /* @ngInject */
  function advScale($timeout, $window) {
    var directive = {
      restrict: 'A',
      link: link
    };

    function link(scope, element) {
      $timeout(function () {
        var parent = element.parent()[0];

        $timeout(function () {
          resize(element, parent);
        });

        $window.onresize = function () {
          resize(element, parent);
        };
      });
    }

    function resize(element, parent) {
      element.attr('width', parent.clientWidth);
      element.attr('height', parent.clientHeight);
    }

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advProfil', advProfil);

  advProfil.$inject = ['UserService'];

  /* @ngInject */
  function advProfil(UserService) {
    var directive = {
      restrict: 'E',
      template: '<span>{{value}}</span>',
      replace: true,
      scope: {
        key: '=',
        default: '='
      },
      link: link
    };

    function link(scope) {
      scope.value = UserService.get(scope.key, scope.default);
    }

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('plainTextMaxLength', plainTextMaxLength);

  plainTextMaxLength.$inject = [];

  /* @ngInject */
  function plainTextMaxLength() {
    var directive = {
      require: 'ngModel',
      restrict: 'A',
      link: link
    };

    function stripHtmlTags(v) {
      return reverseHtmleEntities(String(v));

    }

    function link(scope, element, attributes, ngModel) {
      var maxLength;
      var validPlainTextLength;

      validPlainTextLength = function (v) {
        if (!v) {
          return true;
        }
        return stripHtmlTags(v).length <= maxLength;
      };
      maxLength = undefined;
      scope.$watch(attributes.plainTextMaxLength, function (newValue) {
        if (maxLength !== newValue) {
          maxLength = newValue;
          return ngModel.$validate();
        }
      });

      // eslint-disable-next-line
      return ngModel.$validators['plainTextMaxLength'] = function (modelValue, viewValue) {
        // eslint-disable-next-line
        if (viewValue.$$unwrapTrustedValue) {
          // eslint-disable-next-line
          return validPlainTextLength(viewValue.$$unwrapTrustedValue());
        }
        return validPlainTextLength(viewValue);
      };
    }

    return directive;
  }

  function reverseHtmleEntities(texte) {
    texte = texte.replace(/&egrave;/g, 'è');
    texte = texte.replace(/&eacute;/g, 'é');
    texte = texte.replace(/&ecirc;/g, 'ê');
    texte = texte.replace(/&euml;/g, 'ë');
    texte = texte.replace(/&agrave;/g, 'à');
    texte = texte.replace(/&acirc;/g, 'ä');
    texte = texte.replace(/&auml;/g, 'â');
    texte = texte.replace(/&ograve;/g, 'ò');
    texte = texte.replace(/&ocirc;/g, 'ô');
    texte = texte.replace(/&ouml;/g, 'ö');
    texte = texte.replace(/&igrave;/g, 'ì');
    texte = texte.replace(/&icirc;/g, 'î');
    texte = texte.replace(/&iuml;/g, 'ï');
    texte = texte.replace(/&ugrave;/g, 'ù');
    texte = texte.replace(/&uuml;/g, 'ü');
    texte = texte.replace(/&ucirc;/g, 'û');
    texte = texte.replace(/<[^>]+>/gm, '');
    return texte;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advParametre', advParametre);

  advParametre.$inject = ['ParametresService'];

  /* @ngInject */
  function advParametre(ParametresService) {
    var directive = {
      restrict: 'E',
      template: '<span>{{value}}</span>',
      replace: true,
      scope: {
        key: '=',
        default: '='
      },
      link: link
    };

    function link(scope) {
      scope.value = ParametresService.get(scope.key, scope.default);
    }

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advNumbersOnly', advNumbersOnly);

  /* @ngInject */
  function advNumbersOnly() {
    var directive = {
      require: 'ngModel',
      link: link
    };

     function link(scope, element, attrs, modelCtrl) {
       modelCtrl.$parsers.push(function (inputValue) {
           if (angular.isUndefined(inputValue)) {
             return '';
           }
           var transformedInput = inputValue.replace(/[^0-9]/g, '');
           if (transformedInput !== inputValue) {
              modelCtrl.$setViewValue(transformedInput);
              modelCtrl.$render();
           }

           return transformedInput;
       });
     }

    return directive;
}
})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('match', function ($parse) {
            return {
                require: 'ngModel',
                link: function (scope, elem, attrs, ctrl) {
                    scope.$watch(function () {
                        return $parse(attrs.match)(scope) === ctrl.$modelValue;
                    }, function (currentValue) {
                        ctrl.$setValidity('mismatch', currentValue);
                    });
                }
            };
        });
})();

(function () {
  'use strict';

  var TPL =
    '<div class="input-search" ng-model-options="{ debounce: 250 }">' +
    '  <md-icon>search</md-icon>' +
    '  <input type="text" ng-model="ctrl.ngModel" placeholder="Rechercher">' +
    '  <md-icon ng-show="ctrl.ngModel" ng-click="ctrl.reset()">clear</md-icon>' +
    '</div>';

  angular
    .module('app')
    .directive('advInputSearch', advInputSearch);

  /* @ngInject */
  function advInputSearch() {
    var directive = {
      require: 'ngModel',
      restrict: 'E',
      controller: AdvInputSearchController,
      controllerAs: 'ctrl',
      bindToController: true,
      template: TPL,
      replace: true,
      scope: {
        ngModel: '=',
        ngChange: '&'
      }
    };

    AdvInputSearchController.$inject = ['$scope', '$attrs'];

    /* @inject */
    function AdvInputSearchController($scope, $attrs) {
      var vm = this;

      vm.reset = function () {
        vm.ngModel = '';
      };

      $scope.$watch(function () {
        return vm.ngModel;
      }, function () {
        $scope.$parent.$eval($attrs.ngChange);
      });
    }

    return directive;
  }
})();

(function () {
  'use strict';

  angular.module('app')
    .directive('ibanValidator', ibanValidator);

  /* @ngInject */
  function ibanValidator() {
    var directive = {
      require: 'ngModel', // Spécifie que la directive nécessite ngModel pour interagir avec le contrôle du formulaire.
      link: link // Définit la fonction de lien qui est exécutée pour chaque instance de la directive.
    };

    // La fonction 'link' est exécutée lors de l'initialisation de la directive sur l'élément HTML.
    function link(scope, element, attrs, ngModel) {

      // Un objet qui mappe les codes des pays (code ISO à 2 lettres) à la longueur de l'IBAN attendue pour ce pays.
      var codeLengths = {
        AD: 24, AE: 23, AL: 28, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29, CH: 21, CR: 21, CY: 28, CZ: 24,
        DE: 22, DK: 18, DO: 28, EE: 20, ES: 24, LC: 30, FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28,
        HR: 21, HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28, LI: 21, LT: 20, LU: 20, LV: 21,
        MC: 27, MD: 24, ME: 22, MK: 19, MR: 27, MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
        RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
      };

      // Fonction utilitaire pour calculer la somme de contrôle mod 97 utilisée pour la validation de l'IBAN.
      function mod97(digital) {
        digital = digital.toString(); // Convertit les chiffres en chaîne si nécessaire.
        var checksum = digital.slice(0, 2); // Prend les 2 premiers caractères.
        for (var offset = 2; offset < digital.length; offset += 7) {
          var fragment = checksum + digital.substring(offset, offset + 7); // Traite par fragments de 7 chiffres.
          checksum = parseInt(fragment, 10) % 97; // Calcule le reste de la division par 97.
        }
        return checksum; // Retourne le reste final.
      }

      // Fonction principale pour valider l'IBAN.
      function validateIban(iban) {
        if (!iban || !angular.isString(iban)) {
          return false; // Retourne false si l'IBAN est vide ou n'est pas une chaîne.
        }

        // Nettoie l'IBAN en supprimant les espaces et autres caractères non alphanumériques.
        var formattedIban = iban.toUpperCase().replace(/[^A-Z0-9]/g, '');
        // Utilise une expression régulière pour séparer l'IBAN en différentes parties (pays, clé de contrôle, etc.).
        var match = formattedIban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);

        // Vérifie si l'IBAN correspond bien au format attendu.
        if (!match || !match[1] || !match[2] || !match[3]) {
          return false;
        }

        // Vérifie que la longueur de l'IBAN correspond à la longueur attendue pour le pays.
        if (!codeLengths[match[1]] || formattedIban.length !== codeLengths[match[1]]) {
          return false;
        }

        // Transforme la partie alphanumérique en chiffres selon l'algorithme de validation IBAN.
        var digits = (match[3] + match[1] + match[2]).replace(/[A-Z]/g, function (letter) {
          return letter.charCodeAt(0) - 55; // Convertit les lettres en valeurs numériques.
        });

        // Vérifie la validité de l'IBAN avec l'algorithme mod 97.
        return mod97(digits) === 1;
      }

      // Définit le validateur pour 'ngModel' (celui qui valide les entrées de l'utilisateur).
      ngModel.$validators.ibanValid = function (modelValue) {
        // Si le champ est vide, il est considéré comme valide (utilisez 'required' pour rendre le champ obligatoire).
        if (!modelValue) {
          return true;
        }
        // Valide l'IBAN et retourne 'true' ou 'false' pour indiquer si l'IBAN est valide.
        return validateIban(modelValue);
      };
    }

    // Retourne la directive à AngularJS.
    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('focusMe', focusMe);

  /* @ngInject */
  function focusMe($window, $timeout, $parse) {
    var directive = {
      link: link
    };

     function link(scope, element, attrs) {
      var model = $parse(attrs.focusMe);
      scope.$watch(model, function (value) {
        if (value === true) {
          $timeout(function () {
            element[0].focus({preventScroll: true});
          });
        }
      });
      //  element.bind('blur', function () {
      //    scope.$apply(model.assign(scope, false));
      //  });
    }

    return directive;
}
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('filterDatePicker', filterDatePicker);

  /* @ngInject */
  function filterDatePicker() {
    var directive = {
      restrict: 'A',
      link: link
    };

    function link(scope, element) {
      var input = element.find('input');

      input.on('click', function () {
        var button = element.find('button');
        button[0].click();
      });

    }

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advHeader', advHeader);

  /* @ngInject */
  function advHeader() {
    var directive = {
      restrict: 'A',
      controller: AdvHeaderController,
      controllerAs: 'ctrl',
      bindToController: true,
      scope: {
        order: '=?advOrder'
      }
    };

    /* @inject */
    function AdvHeaderController() { }

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advColumn', advColumn);

  /* @ngInject */
  function advColumn() {
    var directive = {
      require: ['^^advHeader'],
      restrict: 'A',
      scope: {
        orderBy: '@?advOrderBy'
      },
      link: link
    };

    function link(scope, element, attrs, controllers) {
      var headerCtrl = controllers.shift();

      element.on('click', setOrder);

      element.addClass('column');
      if (angular.isDefined(scope.orderBy)) {
        element.addClass('sort');
      }

      function setOrder() {
        scope.$applyAsync(function () {
          headerCtrl.order.reverse = isActive() ? !headerCtrl.order.reverse : false;
          headerCtrl.order.property = scope.orderBy;
        });
      }

      function isActive() {
        return (headerCtrl.order.property === scope.orderBy);
      }

      scope.$watch(isActive, function (active) {
        if (active) {
          element.addClass('active');
        } else {
          element.removeClass('active');
        }
      });

      scope.$watch(function () {
        return headerCtrl.order.reverse;
      }, function (reverse) {
        if (reverse) {
          element.addClass('reverse');
        } else {
          element.removeClass('reverse');
        }
      });
    }

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advConstant', advConstant);

  advConstant.$inject = ['$injector'];

  /* @ngInject */
  function advConstant($injector) {
    var directive = {
      restrict: 'E',
      template: '<span>{{value}}</span>',
      replace: true,
      scope: {
        key: '=',
        default: '='
      },
      link: link
    };

    function link(scope) {
      if (angular.isString(scope.key) && scope.key !== '') {
        var keys = scope.key.split('.');

        var mainKey = keys.shift();

        var mainConstant = $injector.get(mainKey);

        var value;
        if (keys.length > 0) {
          value = _.get(mainConstant, keys.join('.'));
        } else {
          value = mainConstant;
        }
        scope.value = value;
      }
    }

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('advBreadcrumbs', advBreadcrumbs);

  /* @ngInject */
  function advBreadcrumbs() {
    var directive = {
      restrict: 'E',
      controller: BreadcrumbsController,
      controllerAs: 'ctrl',
      bindToController: true,
      templateUrl: 'app/_common/directives/breadcrumbs/breadcrumbs.html',
      scope: {
        steps: '='
      }
    };

    BreadcrumbsController.$inject = ['$state'];

    /* @inject */
    function BreadcrumbsController($state) {
      var vm = this;

      vm.isStepActive = function (step) {
        return ($state.current.name.indexOf(step.state) !== -1);
      };

      vm.goToStep = function (step) {
        if (!vm.isStepActive(step) && step.isCompleted()) {
          if ((step.state === "abonnement.autorisations") || (step.state === "abonnement.facturation")) {
            $state.go(step.state, {saisie: step.saisie});
          } else {
            $state.go(step.state);
          }
        }
      };

      vm.isStepDisabled = function (step) {
        if (vm.isStepActive(step)) {
          return false;
        }
        if (step.isCompleted()) {
          return false;
        }

        return true;
      };
    }

    return directive;
  }
})();

!function(){var e={},t=function(t){for(var n=e[t],i=n.deps,o=n.defn,a=i.length,s=new Array(a),l=0;l<a;++l)s[l]=r(i[l]);var c=o.apply(null,s);if(void 0===c)throw"module ["+t+"] returned undefined";n.instance=c},n=function(t,n,r){if("string"!=typeof t)throw"module id must be a string";if(void 0===n)throw"no dependencies for "+t;if(void 0===r)throw"no definition function for "+t;e[t]={deps:n,defn:r,instance:void 0}},r=function(n){var r=e[n];if(void 0===r)throw"module ["+n+"] was undefined";return void 0===r.instance&&t(n),r.instance},i=function(e,t){for(var n=e.length,i=new Array(n),o=0;o<n;++o)i[o]=r(e[o]);t.apply(null,i)},o={};o.bolt={module:{api:{define:n,require:i,demand:r}}};var a=n,s=function(e,t){a(e,[],function(){return t})};s("1",tinymce.Env),s("2",tinymce.EditorManager),s("3",tinymce.ThemeManager),s("8",tinymce.util.Tools),s("9",tinymce.ui.Factory),s("a",tinymce.DOM),a("b",["8","9"],function(e,t){var n="undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image",r=function(n,r,i){var o,a=[];if(r)return e.each(r.split(/[ ,]/),function(e){var r,s=function(){var t=n.selection;e.settings.stateSelector&&t.selectorChanged(e.settings.stateSelector,function(t){e.active(t)},!0),e.settings.disabledStateSelector&&t.selectorChanged(e.settings.disabledStateSelector,function(t){e.disabled(t)})};"|"==e?o=null:t.has(e)?(e={type:e,size:i},a.push(e),o=null):(o||(o={type:"buttongroup",items:[]},a.push(o)),n.buttons[e]&&(r=e,e=n.buttons[r],"function"==typeof e&&(e=e()),e.type=e.type||"button",e.size=i,e=t.create(e),o.items.push(e),n.initialized?s():n.on("init",s)))}),{type:"toolbar",layout:"flow",items:a}},i=function(t,i){var o=[],a=t.settings,s=function(e){if(e)return o.push(r(t,e,i)),!0};if(e.isArray(a.toolbar)){if(0===a.toolbar.length)return;e.each(a.toolbar,function(e,t){a["toolbar"+(t+1)]=e}),delete a.toolbar}for(var l=1;l<10&&s(a["toolbar"+l]);l++);if(o.length||a.toolbar===!1||s(a.toolbar||n),o.length)return{type:"panel",layout:"stack",classes:"toolbar-grp",ariaRoot:!0,ariaRemember:!0,items:o}};return{createToolbar:r,createToolbars:i}}),a("c",["8"],function(e){var t={file:{title:"File",items:"newdocument"},edit:{title:"Edit",items:"undo redo | cut copy paste pastetext | selectall"},insert:{title:"Insert",items:"|"},view:{title:"View",items:"visualaid |"},format:{title:"Format",items:"bold italic underline strikethrough superscript subscript | formats | removeformat"},table:{title:"Table"},tools:{title:"Tools"}},n=function(e,t){var n;return"|"==t?{text:"|"}:n=e[t]},r=function(r,i,o){var a,s,l,c,u;if(u=e.makeMap((i.removed_menuitems||"").split(/[ ,]/)),i.menu?(s=i.menu[o],c=!0):s=t[o],s){a={text:s.title},l=[],e.each((s.items||"").split(/[ ,]/),function(e){var t=n(r,e);t&&!u[e]&&l.push(n(r,e))}),c||e.each(r,function(e){e.context==o&&("before"==e.separator&&l.push({text:"|"}),e.prependToContext?l.unshift(e):l.push(e),"after"==e.separator&&l.push({text:"|"}))});for(var d=0;d<l.length;d++)"|"==l[d].text&&(0!==d&&d!=l.length-1||l.splice(d,1));if(a.menu=l,!a.menu.length)return null}return a},i=function(e){var n,i=[],o=e.settings,a=[];if(o.menu)for(n in o.menu)a.push(n);else for(n in t)a.push(n);for(var s="string"==typeof o.menubar?o.menubar.split(/[ ,]/):a,l=0;l<s.length;l++){var c=s[l];c=r(e.menuItems,e.settings,c),c&&i.push(c)}return i};return{createMenuButtons:i}}),s("j",tinymce.util.Delay),s("k",tinymce.geom.Rect),a("d",["a","8","j","b","9","k"],function(e,t,n,r,i,o){var a=function(e){return{left:e.x,top:e.y,width:e.w,height:e.h,right:e.x+e.w,bottom:e.y+e.h}},s=function(e){t.each(e.contextToolbars,function(e){e.panel&&e.panel.hide()})},l=function(e,t){e.moveTo(t.left,t.top)},c=function(e,n,r){n=n?n.substr(0,2):"",t.each({t:"down",b:"up"},function(t,i){e.classes.toggle("arrow-"+t,r(i,n.substr(0,1)))}),t.each({l:"left",r:"right"},function(t,i){e.classes.toggle("arrow-"+t,r(i,n.substr(1,1)))})},u=function(e,t,n,r,i,o){return o=a({x:t,y:n,w:o.w,h:o.h}),e&&(o=e({elementRect:a(r),contentAreaRect:a(i),panelRect:o})),o},d=function(a){var d,f=a.settings,p=function(){return a.contextToolbars||[]},m=function(t){var n,r,i;return n=e.getPos(a.getContentAreaContainer()),r=a.dom.getRect(t),i=a.dom.getRoot(),"BODY"===i.nodeName&&(r.x-=i.ownerDocument.documentElement.scrollLeft||i.scrollLeft,r.y-=i.ownerDocument.documentElement.scrollTop||i.scrollTop),r.x+=n.x,r.y+=n.y,r},g=function(t,n){var r,i,d,p,g,h,v,b,y=f.inline_toolbar_position_handler;if(!a.removed){if(!t||!t.toolbar.panel)return void s(a);v=["bc-tc","tc-bc","tl-bl","bl-tl","tr-br","br-tr"],g=t.toolbar.panel,n&&g.show(),d=m(t.element),i=e.getRect(g.getEl()),p=e.getRect(a.getContentAreaContainer()||a.getBody()),b=25,"inline"!==e.getStyle(t.element,"display",!0)&&(d.w=t.element.clientWidth,d.h=t.element.clientHeight),a.inline||(p.w=a.getDoc().documentElement.offsetWidth),a.selection.controlSelection.isResizable(t.element)&&d.w<b&&(d=o.inflate(d,0,8)),r=o.findBestRelativePosition(i,d,p,v),d=o.clamp(d,p),r?(h=o.relativePosition(i,d,r),l(g,u(y,h.x,h.y,d,p,i))):(p.h+=i.h,d=o.intersect(p,d),d?(r=o.findBestRelativePosition(i,d,p,["bc-tc","bl-tl","br-tr"]),r?(h=o.relativePosition(i,d,r),l(g,u(y,h.x,h.y,d,p,i))):l(g,u(y,d.x,d.y,d,p,i))):g.hide()),c(g,r,function(e,t){return e===t})}},h=function(e){return function(){var t=function(){a.selection&&g(x(a.selection.getNode()),e)};n.requestAnimationFrame(t)}},v=function(){d||(d=a.selection.getScrollContainer()||a.getWin(),e.bind(d,"scroll",h(!0)),a.on("remove",function(){e.unbind(d,"scroll")}))},b=function(e){var t;return e.toolbar.panel?(e.toolbar.panel.show(),void g(e)):(v(),t=i.create({type:"floatpanel",role:"dialog",classes:"tinymce tinymce-inline arrow",ariaLabel:"Inline toolbar",layout:"flex",direction:"column",align:"stretch",autohide:!1,autofix:!0,fixed:!0,border:1,items:r.createToolbar(a,e.toolbar.items),oncancel:function(){a.focus()}}),e.toolbar.panel=t,t.renderTo(document.body).reflow(),void g(e))},y=function(){t.each(p(),function(e){e.panel&&e.panel.hide()})},x=function(e){var t,n,r,i=p();for(r=a.$(e).parents().add(e),t=r.length-1;t>=0;t--)for(n=i.length-1;n>=0;n--)if(i[n].predicate(r[t]))return{toolbar:i[n],element:r[t]};return null};a.on("click keyup setContent ObjectResized",function(e){("setcontent"!==e.type||e.selection)&&n.setEditorTimeout(a,function(){var e;e=x(a.selection.getNode()),e?(y(),b(e)):y()})}),a.on("blur hide contextmenu",y),a.on("ObjectResizeStart",function(){var e=x(a.selection.getNode());e&&e.toolbar.panel&&e.toolbar.panel.hide()}),a.on("ResizeEditor ResizeWindow",h(!0)),a.on("nodeChange",h(!1)),a.on("remove",function(){t.each(p(),function(e){e.panel&&e.panel.remove()}),a.contextToolbars={}}),a.shortcuts.add("ctrl+shift+e > ctrl+shift+p","",function(){var e=x(a.selection.getNode());e&&e.toolbar.panel&&e.toolbar.panel.items()[0].focus()})};return{addContextualToolbars:d}}),a("e",[],function(){var e=function(e,t){return function(){var n=e.find(t)[0];n&&n.focus(!0)}},t=function(t,n){t.shortcuts.add("Alt+F9","",e(n,"menubar")),t.shortcuts.add("Alt+F10,F10","",e(n,"toolbar")),t.shortcuts.add("Alt+F11","",e(n,"elementpath")),n.on("cancel",function(){t.focus()})};return{addKeys:t}}),a("f",["8","9","1"],function(e,t,n){var r=function(e){return{element:function(){return e}}},i=function(e,t,n){var i=e.settings[n];i&&i(r(t.getEl("body")))},o=function(t,n,r){e.each(r,function(e){var r=n.items().filter("#"+e.name)[0];r&&r.visible()&&e.name!==t&&(i(e,r,"onhide"),r.visible(!1))})},a=function(e){e.items().each(function(e){e.active(!1)})},s=function(t,n){return e.grep(t,function(e){return e.name===n})[0]},l=function(e,n,r){return function(l){var c=l.control,u=c.parents().filter("panel")[0],d=u.find("#"+n)[0],f=s(r,n);o(n,u,r),a(c.parent()),d&&d.visible()?(i(f,d,"onhide"),d.hide(),c.active(!1)):(d?(d.show(),i(f,d,"onshow")):(d=t.create({type:"container",name:n,layout:"stack",classes:"sidebar-panel",html:""}),u.prepend(d),i(f,d,"onrender"),i(f,d,"onshow")),c.active(!0)),e.fire("ResizeEditor")}},c=function(){return!n.ie||n.ie>=11},u=function(e){return!(!c()||!e.sidebars)&&e.sidebars.length>0},d=function(t){var n=e.map(t.sidebars,function(e){var n=e.settings;return{type:"button",icon:n.icon,image:n.image,tooltip:n.tooltip,onclick:l(t,e.name,t.sidebars)}});return{type:"panel",name:"sidebar",layout:"stack",classes:"sidebar",items:[{type:"toolbar",layout:"stack",classes:"sidebar-toolbar",items:n}]}};return{hasSidebar:u,createSidebar:d}}),a("g",[],function(){var e=function(e){var t=function(){e._skinLoaded=!0,e.fire("SkinLoaded")};return function(){e.initialized?t():e.on("init",t)}};return{fireSkinLoaded:e}}),a("6",["a"],function(e){var t=function(e){return{width:e.clientWidth,height:e.clientHeight}},n=function(n,r,i){var o,a,s,l,c=n.settings;o=n.getContainer(),a=n.getContentAreaContainer().firstChild,s=t(o),l=t(a),null!==r&&(r=Math.max(c.min_width||100,r),r=Math.min(c.max_width||65535,r),e.setStyle(o,"width",r+(s.width-l.width)),e.setStyle(a,"width",r)),i=Math.max(c.min_height||100,i),i=Math.min(c.max_height||65535,i),e.setStyle(a,"height",i),n.fire("ResizeEditor")},r=function(e,t,r){var i=e.getContentAreaContainer();n(e,i.clientWidth+t,i.clientHeight+r)};return{resizeTo:n,resizeBy:r}}),a("4",["8","9","a","b","c","d","e","f","g","6"],function(e,t,n,r,i,o,a,s,l,c){var u=function(e){return function(t){e.find("*").disabled("readonly"===t.mode)}},d=function(e){return{type:"panel",name:"iframe",layout:"stack",classes:"edit-area",border:e,html:""}},f=function(e){return{type:"panel",layout:"stack",classes:"edit-aria-container",border:"1 0 0 0",items:[d("0"),s.createSidebar(e)]}},p=function(e,p,m){var g,h,v,b=e.settings;return m.skinUiCss&&n.styleSheetLoader.load(m.skinUiCss,l.fireSkinLoaded(e)),g=p.panel=t.create({type:"panel",role:"application",classes:"tinymce",style:"visibility: hidden",layout:"stack",border:1,items:[b.menubar===!1?null:{type:"menubar",border:"0 0 1 0",items:i.createMenuButtons(e)},r.createToolbars(e,b.toolbar_items_size),s.hasSidebar(e)?f(e):d("1 0 0 0")]}),b.resize!==!1&&(h={type:"resizehandle",direction:b.resize,onResizeStart:function(){var t=e.getContentAreaContainer().firstChild;v={width:t.clientWidth,height:t.clientHeight}},onResize:function(t){"both"===b.resize?c.resizeTo(e,v.width+t.deltaX,v.height+t.deltaY):c.resizeTo(e,null,v.height+t.deltaY)}}),b.statusbar!==!1&&g.add({type:"panel",name:"statusbar",classes:"statusbar",layout:"flow",border:"1 0 0 0",ariaRoot:!0,items:[{type:"elementpath",editor:e},h]}),e.fire("BeforeRenderUI"),e.on("SwitchMode",u(g)),g.renderBefore(m.targetNode).reflow(),b.readonly&&e.setMode("readonly"),b.width&&n.setStyle(g.getEl(),"width",b.width),e.on("remove",function(){g.remove(),g=null}),a.addKeys(e,g),o.addContextualToolbars(e),{iframeContainer:g.find("#iframe")[0].getEl(),editorContainer:g.getEl()}};return{render:p}}),s("h",tinymce.ui.FloatPanel),a("5",["8","9","a","h","b","c","d","e","g"],function(e,t,n,r,i,o,a,s,l){var c=function(e,c,u){var d,f,p=e.settings;p.fixed_toolbar_container&&(f=n.select(p.fixed_toolbar_container)[0]);var m=function(){if(d&&d.moveRel&&d.visible()&&!d._fixed){var t=e.selection.getScrollContainer(),r=e.getBody(),i=0,o=0;if(t){var a=n.getPos(r),s=n.getPos(t);i=Math.max(0,s.x-a.x),o=Math.max(0,s.y-a.y)}d.fixed(!1).moveRel(r,e.rtl?["tr-br","br-tr"]:["tl-bl","bl-tl","tr-br"]).moveBy(i,o)}},g=function(){d&&(d.show(),m(),n.addClass(e.getBody(),"mce-edit-focus"))},h=function(){d&&(d.hide(),r.hideAll(),n.removeClass(e.getBody(),"mce-edit-focus"))},v=function(){return d?void(d.visible()||g()):(d=c.panel=t.create({type:f?"panel":"floatpanel",role:"application",classes:"tinymce tinymce-inline",layout:"flex",direction:"column",align:"stretch",autohide:!1,autofix:!0,fixed:!!f,border:1,items:[p.menubar===!1?null:{type:"menubar",border:"0 0 1 0",items:o.createMenuButtons(e)},i.createToolbars(e,p.toolbar_items_size)]}),e.fire("BeforeRenderUI"),d.renderTo(f||document.body).reflow(),s.addKeys(e,d),g(),a.addContextualToolbars(e),e.on("nodeChange",m),e.on("activate",g),e.on("deactivate",h),void e.nodeChanged())};return p.content_editable=!0,e.on("focus",function(){u.skinUiCss?n.styleSheetLoader.load(u.skinUiCss,v,v):v()}),e.on("blur hide",h),e.on("remove",function(){d&&(d.remove(),d=null)}),u.skinUiCss&&n.styleSheetLoader.load(u.skinUiCss,l.fireSkinLoaded(e)),{}};return{render:c}}),s("i",tinymce.ui.Throbber),a("7",["i"],function(e){var t=function(t,n){var r;t.on("ProgressState",function(t){r=r||new e(n.panel.getEl("body")),t.state?r.show(t.time):r.hide()})};return{setup:t}}),a("0",["1","2","3","4","5","6","7"],function(e,t,n,r,i,o,a){var s=function(n,o,s){var l=n.settings,c=l.skin!==!1&&(l.skin||"lightgray");if(c){var u=l.skin_url;u=u?n.documentBaseURI.toAbsolute(u):t.baseURL+"/skins/"+c,e.documentMode<=7?s.skinUiCss=u+"/skin.ie7.min.css":s.skinUiCss=u+"/skin.min.css",n.contentCSS.push(u+"/content"+(n.inline?".inline":"")+".min.css")}return a.setup(n,o),l.inline?i.render(n,o,s):r.render(n,o,s)};return n.add("modern",function(e){return{renderUI:function(t){return s(e,this,t)},resizeTo:function(t,n){return o.resizeTo(e,t,n)},resizeBy:function(t,n){return o.resizeBy(e,t,n)}}}),function(){}}),r("0")()}();
(function () {

var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}

// Used when there is no 'main' module.
// The name is probably (hopefully) unique so minification removes for releases.
var register_3795 = function (id) {
  var module = dem(id);
  var fragments = id.split('.');
  var target = Function('return this;')();
  for (var i = 0; i < fragments.length - 1; ++i) {
    if (target[fragments[i]] === undefined)
      target[fragments[i]] = {};
    target = target[fragments[i]];
  }
  target[fragments[fragments.length - 1]] = module;
};

var instantiate = function (id) {
  var actual = defs[id];
  var dependencies = actual.deps;
  var definition = actual.defn;
  var len = dependencies.length;
  var instances = new Array(len);
  for (var i = 0; i < len; ++i)
    instances[i] = dem(dependencies[i]);
  var defResult = definition.apply(null, instances);
  if (defResult === undefined)
     throw 'module [' + id + '] returned undefined';
  actual.instance = defResult;
};

var def = function (id, dependencies, definition) {
  if (typeof id !== 'string')
    throw 'module id must be a string';
  else if (dependencies === undefined)
    throw 'no dependencies for ' + id;
  else if (definition === undefined)
    throw 'no definition function for ' + id;
  defs[id] = {
    deps: dependencies,
    defn: definition,
    instance: undefined
  };
};

var dem = function (id) {
  var actual = defs[id];
  if (actual === undefined)
    throw 'module [' + id + '] was undefined';
  else if (actual.instance === undefined)
    instantiate(id);
  return actual.instance;
};

var req = function (ids, callback) {
  var len = ids.length;
  var instances = new Array(len);
  for (var i = 0; i < len; ++i)
    instances[i] = dem(ids[i]);
  callback.apply(null, instances);
};

var ephox = {};

ephox.bolt = {
  module: {
    api: {
      define: def,
      require: req,
      demand: dem
    }
  }
};

var define = def;
var require = req;
var demand = dem;
// this helps with minification when using a lot of global references
var defineGlobal = function (id, ref) {
  define(id, [], function () { return ref; });
};
/*jsc
["tinymce.modern.Theme","global!tinymce.Env","global!tinymce.EditorManager","global!tinymce.ThemeManager","tinymce.modern.modes.Iframe","tinymce.modern.modes.Inline","tinymce.modern.ui.Resize","tinymce.modern.ui.ProgressState","global!tinymce.util.Tools","global!tinymce.ui.Factory","global!tinymce.DOM","tinymce.modern.ui.Toolbar","tinymce.modern.ui.Menubar","tinymce.modern.ui.ContextToolbars","tinymce.modern.ui.A11y","tinymce.modern.ui.Sidebar","tinymce.modern.ui.SkinLoaded","global!tinymce.ui.FloatPanel","global!tinymce.ui.Throbber","global!tinymce.util.Delay","global!tinymce.geom.Rect"]
jsc*/
defineGlobal("global!tinymce.Env", tinymce.Env);
defineGlobal("global!tinymce.EditorManager", tinymce.EditorManager);
defineGlobal("global!tinymce.ThemeManager", tinymce.ThemeManager);
defineGlobal("global!tinymce.util.Tools", tinymce.util.Tools);
defineGlobal("global!tinymce.ui.Factory", tinymce.ui.Factory);
defineGlobal("global!tinymce.DOM", tinymce.DOM);
/**
 * Toolbar.js
 *
 * Released under LGPL License.
 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
 *
 * License: http://www.tinymce.com/license
 * Contributing: http://www.tinymce.com/contributing
 */

define('tinymce.modern.ui.Toolbar', [
	'global!tinymce.util.Tools',
	'global!tinymce.ui.Factory'
], function (Tools, Factory) {
	var defaultToolbar = "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | " +
		"bullist numlist outdent indent | link image";

	var createToolbar = function (editor, items, size) {
		var toolbarItems = [], buttonGroup;

		if (!items) {
			return;
		}

		Tools.each(items.split(/[ ,]/), function(item) {
			var itemName;

			var bindSelectorChanged = function () {
				var selection = editor.selection;

				if (item.settings.stateSelector) {
					selection.selectorChanged(item.settings.stateSelector, function(state) {
						item.active(state);
					}, true);
				}

				if (item.settings.disabledStateSelector) {
					selection.selectorChanged(item.settings.disabledStateSelector, function(state) {
						item.disabled(state);
					});
				}
			};

			if (item == "|") {
				buttonGroup = null;
			} else {
				if (Factory.has(item)) {
					item = {type: item, size: size};
					toolbarItems.push(item);
					buttonGroup = null;
				} else {
					if (!buttonGroup) {
						buttonGroup = {type: 'buttongroup', items: []};
						toolbarItems.push(buttonGroup);
					}

					if (editor.buttons[item]) {
						// TODO: Move control creation to some UI class
						itemName = item;
						item = editor.buttons[itemName];

						if (typeof item == "function") {
							item = item();
						}

						item.type = item.type || 'button';
						item.size = size;

						item = Factory.create(item);
						buttonGroup.items.push(item);

						if (editor.initialized) {
							bindSelectorChanged();
						} else {
							editor.on('init', bindSelectorChanged);
						}
					}
				}
			}
		});

		return {
			type: 'toolbar',
			layout: 'flow',
			items: toolbarItems
		};
	};

	/**
	 * Creates the toolbars from config and returns a toolbar array.
	 *
	 * @param {String} size Optional toolbar item size.
	 * @return {Array} Array with toolbars.
	 */
	var createToolbars = function (editor, size) {
		var toolbars = [], settings = editor.settings;

		var addToolbar = function (items) {
			if (items) {
				toolbars.push(createToolbar(editor, items, size));
				return true;
			}
		};

		// Convert toolbar array to multiple options
		if (Tools.isArray(settings.toolbar)) {
			// Empty toolbar array is the same as a disabled toolbar
			if (settings.toolbar.length === 0) {
				return;
			}

			Tools.each(settings.toolbar, function(toolbar, i) {
				settings["toolbar" + (i + 1)] = toolbar;
			});

			delete settings.toolbar;
		}

		// Generate toolbar<n>
		for (var i = 1; i < 10; i++) {
			if (!addToolbar(settings["toolbar" + i])) {
				break;
			}
		}

		// Generate toolbar or default toolbar unless it's disabled
		if (!toolbars.length && settings.toolbar !== false) {
			addToolbar(settings.toolbar || defaultToolbar);
		}

		if (toolbars.length) {
			return {
				type: 'panel',
				layout: 'stack',
				classes: "toolbar-grp",
				ariaRoot: true,
				ariaRemember: true,
				items: toolbars
			};
		}
	};

	return {
		createToolbar: createToolbar,
		createToolbars: createToolbars
	};
});

/**
 * Menubar.js
 *
 * Released under LGPL License.
 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
 *
 * License: http://www.tinymce.com/license
 * Contributing: http://www.tinymce.com/contributing
 */

define('tinymce.modern.ui.Menubar', [
	'global!tinymce.util.Tools'
], function (Tools) {
	var defaultMenus = {
		file: {title: 'File', items: 'newdocument'},
		edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall'},
		insert: {title: 'Insert', items: '|'},
		view: {title: 'View', items: 'visualaid |'},
		format: {title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat'},
		table: {title: 'Table'},
		tools: {title: 'Tools'}
	};

	var createMenuItem = function (menuItems, name) {
		var menuItem;

		if (name == '|') {
			return {text: '|'};
		}

		menuItem = menuItems[name];

		return menuItem;
	};

	var createMenu = function (editorMenuItems, settings, context) {
		var menuButton, menu, menuItems, isUserDefined, removedMenuItems;

		removedMenuItems = Tools.makeMap((settings.removed_menuitems || '').split(/[ ,]/));

		// User defined menu
		if (settings.menu) {
			menu = settings.menu[context];
			isUserDefined = true;
		} else {
			menu = defaultMenus[context];
		}

		if (menu) {
			menuButton = {text: menu.title};
			menuItems = [];

			// Default/user defined items
			Tools.each((menu.items || '').split(/[ ,]/), function(item) {
				var menuItem = createMenuItem(editorMenuItems, item);

				if (menuItem && !removedMenuItems[item]) {
					menuItems.push(createMenuItem(editorMenuItems, item));
				}
			});

			// Added though context
			if (!isUserDefined) {
				Tools.each(editorMenuItems, function(menuItem) {
					if (menuItem.context == context) {
						if (menuItem.separator == 'before') {
							menuItems.push({text: '|'});
						}

						if (menuItem.prependToContext) {
							menuItems.unshift(menuItem);
						} else {
							menuItems.push(menuItem);
						}

						if (menuItem.separator == 'after') {
							menuItems.push({text: '|'});
						}
					}
				});
			}

			for (var i = 0; i < menuItems.length; i++) {
				if (menuItems[i].text == '|') {
					if (i === 0 || i == menuItems.length - 1) {
						menuItems.splice(i, 1);
					}
				}
			}

			menuButton.menu = menuItems;

			if (!menuButton.menu.length) {
				return null;
			}
		}

		return menuButton;
	};

	var createMenuButtons = function (editor) {
		var name, menuButtons = [], settings = editor.settings;

		var defaultMenuBar = [];
		if (settings.menu) {
			for (name in settings.menu) {
				defaultMenuBar.push(name);
			}
		} else {
			for (name in defaultMenus) {
				defaultMenuBar.push(name);
			}
		}

		var enabledMenuNames = typeof settings.menubar == "string" ? settings.menubar.split(/[ ,]/) : defaultMenuBar;
		for (var i = 0; i < enabledMenuNames.length; i++) {
			var menu = enabledMenuNames[i];
			menu = createMenu(editor.menuItems, editor.settings, menu);

			if (menu) {
				menuButtons.push(menu);
			}
		}

		return menuButtons;
	};

	return {
		createMenuButtons: createMenuButtons
	};
});

defineGlobal("global!tinymce.util.Delay", tinymce.util.Delay);
defineGlobal("global!tinymce.geom.Rect", tinymce.geom.Rect);
/**
 * ContextToolbars.js
 *
 * Released under LGPL License.
 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
 *
 * License: http://www.tinymce.com/license
 * Contributing: http://www.tinymce.com/contributing
 */

define('tinymce.modern.ui.ContextToolbars', [
	'global!tinymce.DOM',
	'global!tinymce.util.Tools',
	'global!tinymce.util.Delay',
	'tinymce.modern.ui.Toolbar',
	'global!tinymce.ui.Factory',
	'global!tinymce.geom.Rect'
], function (DOM, Tools, Delay, Toolbar, Factory, Rect) {
	var toClientRect = function (geomRect) {
		return {
			left: geomRect.x,
			top: geomRect.y,
			width: geomRect.w,
			height: geomRect.h,
			right: geomRect.x + geomRect.w,
			bottom: geomRect.y + geomRect.h
		};
	};

	var hideAllFloatingPanels = function (editor) {
		Tools.each(editor.contextToolbars, function(toolbar) {
			if (toolbar.panel) {
				toolbar.panel.hide();
			}
		});
	};

	var movePanelTo = function (panel, pos) {
		panel.moveTo(pos.left, pos.top);
	};

	var togglePositionClass = function (panel, relPos, predicate) {
		relPos = relPos ? relPos.substr(0, 2) : '';

		Tools.each({
			t: 'down',
			b: 'up'
		}, function(cls, pos) {
			panel.classes.toggle('arrow-' + cls, predicate(pos, relPos.substr(0, 1)));
		});

		Tools.each({
			l: 'left',
			r: 'right'
		}, function(cls, pos) {
			panel.classes.toggle('arrow-' + cls, predicate(pos, relPos.substr(1, 1)));
		});
	};

	var userConstrain = function (handler, x, y, elementRect, contentAreaRect, panelRect) {
		panelRect = toClientRect({x: x, y: y, w: panelRect.w, h: panelRect.h});

		if (handler) {
			panelRect = handler({
				elementRect: toClientRect(elementRect),
				contentAreaRect: toClientRect(contentAreaRect),
				panelRect: panelRect
			});
		}

		return panelRect;
	};

	var addContextualToolbars = function (editor) {
		var scrollContainer, settings = editor.settings;

		var getContextToolbars = function () {
			return editor.contextToolbars || [];
		};

		var getElementRect = function (elm) {
			var pos, targetRect, root;

			pos = DOM.getPos(editor.getContentAreaContainer());
			targetRect = editor.dom.getRect(elm);
			root = editor.dom.getRoot();

			// Adjust targetPos for scrolling in the editor
			if (root.nodeName === 'BODY') {
				targetRect.x -= root.ownerDocument.documentElement.scrollLeft || root.scrollLeft;
				targetRect.y -= root.ownerDocument.documentElement.scrollTop || root.scrollTop;
			}

			targetRect.x += pos.x;
			targetRect.y += pos.y;

			return targetRect;
		};

		var reposition = function (match, shouldShow) {
			var relPos, panelRect, elementRect, contentAreaRect, panel, relRect, testPositions, smallElementWidthThreshold;
			var handler = settings.inline_toolbar_position_handler;

			if (editor.removed) {
				return;
			}

			if (!match || !match.toolbar.panel) {
				hideAllFloatingPanels(editor);
				return;
			}

			testPositions = [
				'bc-tc', 'tc-bc',
				'tl-bl', 'bl-tl',
				'tr-br', 'br-tr'
			];

			panel = match.toolbar.panel;

			// Only show the panel on some events not for example nodeChange since that fires when context menu is opened
			if (shouldShow) {
				panel.show();
			}

			elementRect = getElementRect(match.element);
			panelRect = DOM.getRect(panel.getEl());
			contentAreaRect = DOM.getRect(editor.getContentAreaContainer() || editor.getBody());
			smallElementWidthThreshold = 25;

			if (DOM.getStyle(match.element, 'display', true) !== 'inline') {
				// We need to use these instead of the rect values since the style
				// size properites might not be the same as the real size for a table
				elementRect.w = match.element.clientWidth;
				elementRect.h = match.element.clientHeight;
			}

			if (!editor.inline) {
				contentAreaRect.w = editor.getDoc().documentElement.offsetWidth;
			}

			// Inflate the elementRect so it doesn't get placed above resize handles
			if (editor.selection.controlSelection.isResizable(match.element) && elementRect.w < smallElementWidthThreshold) {
				elementRect = Rect.inflate(elementRect, 0, 8);
			}

			relPos = Rect.findBestRelativePosition(panelRect, elementRect, contentAreaRect, testPositions);
			elementRect = Rect.clamp(elementRect, contentAreaRect);

			if (relPos) {
				relRect = Rect.relativePosition(panelRect, elementRect, relPos);
				movePanelTo(panel, userConstrain(handler, relRect.x, relRect.y, elementRect, contentAreaRect, panelRect));
			} else {
				// Allow overflow below the editor to avoid placing toolbars ontop of tables
				contentAreaRect.h += panelRect.h;

				elementRect = Rect.intersect(contentAreaRect, elementRect);
				if (elementRect) {
					relPos = Rect.findBestRelativePosition(panelRect, elementRect, contentAreaRect, [
						'bc-tc', 'bl-tl', 'br-tr'
					]);

					if (relPos) {
						relRect = Rect.relativePosition(panelRect, elementRect, relPos);
						movePanelTo(panel, userConstrain(handler, relRect.x, relRect.y, elementRect, contentAreaRect, panelRect));
					} else {
						movePanelTo(panel, userConstrain(handler, elementRect.x, elementRect.y, elementRect, contentAreaRect, panelRect));
					}
				} else {
					panel.hide();
				}
			}

			togglePositionClass(panel, relPos, function(pos1, pos2) {
				return pos1 === pos2;
			});

			//drawRect(contentAreaRect, 'blue');
			//drawRect(elementRect, 'red');
			//drawRect(panelRect, 'green');
		};

		var repositionHandler = function (show) {
			return function () {
				var execute = function () {
					if (editor.selection) {
						reposition(findFrontMostMatch(editor.selection.getNode()), show);
					}
				};

				Delay.requestAnimationFrame(execute);
			};
		};

		var bindScrollEvent = function () {
			if (!scrollContainer) {
				scrollContainer = editor.selection.getScrollContainer() || editor.getWin();
				DOM.bind(scrollContainer, 'scroll', repositionHandler(true));

				editor.on('remove', function() {
					DOM.unbind(scrollContainer, 'scroll');
				});
			}
		};

		var showContextToolbar = function (match) {
			var panel;

			if (match.toolbar.panel) {
				match.toolbar.panel.show();
				reposition(match);
				return;
			}

			bindScrollEvent();

			panel = Factory.create({
				type: 'floatpanel',
				role: 'dialog',
				classes: 'tinymce tinymce-inline arrow',
				ariaLabel: 'Inline toolbar',
				layout: 'flex',
				direction: 'column',
				align: 'stretch',
				autohide: false,
				autofix: true,
				fixed: true,
				border: 1,
				items: Toolbar.createToolbar(editor, match.toolbar.items),
				oncancel: function() {
					editor.focus();
				}
			});

			match.toolbar.panel = panel;
			panel.renderTo(document.body).reflow();
			reposition(match);
		};

		var hideAllContextToolbars = function () {
			Tools.each(getContextToolbars(), function(toolbar) {
				if (toolbar.panel) {
					toolbar.panel.hide();
				}
			});
		};

		var findFrontMostMatch = function (targetElm) {
			var i, y, parentsAndSelf, toolbars = getContextToolbars();

			parentsAndSelf = editor.$(targetElm).parents().add(targetElm);
			for (i = parentsAndSelf.length - 1; i >= 0; i--) {
				for (y = toolbars.length - 1; y >= 0; y--) {
					if (toolbars[y].predicate(parentsAndSelf[i])) {
						return {
							toolbar: toolbars[y],
							element: parentsAndSelf[i]
						};
					}
				}
			}

			return null;
		};

		editor.on('click keyup setContent ObjectResized', function(e) {
			// Only act on partial inserts
			if (e.type === 'setcontent' && !e.selection) {
				return;
			}

			// Needs to be delayed to avoid Chrome img focus out bug
			Delay.setEditorTimeout(editor, function() {
				var match;

				match = findFrontMostMatch(editor.selection.getNode());
				if (match) {
					hideAllContextToolbars();
					showContextToolbar(match);
				} else {
					hideAllContextToolbars();
				}
			});
		});

		editor.on('blur hide contextmenu', hideAllContextToolbars);

		editor.on('ObjectResizeStart', function() {
			var match = findFrontMostMatch(editor.selection.getNode());

			if (match && match.toolbar.panel) {
				match.toolbar.panel.hide();
			}
		});

		editor.on('ResizeEditor ResizeWindow', repositionHandler(true));
		editor.on('nodeChange', repositionHandler(false));

		editor.on('remove', function() {
			Tools.each(getContextToolbars(), function(toolbar) {
				if (toolbar.panel) {
					toolbar.panel.remove();
				}
			});

			editor.contextToolbars = {};
		});

		editor.shortcuts.add('ctrl+shift+e > ctrl+shift+p', '', function() {
			var match = findFrontMostMatch(editor.selection.getNode());
			if (match && match.toolbar.panel) {
				match.toolbar.panel.items()[0].focus();
			}
		});
	};

	return {
		addContextualToolbars: addContextualToolbars
	};
});

/**
 * A11y.js
 *
 * Released under LGPL License.
 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
 *
 * License: http://www.tinymce.com/license
 * Contributing: http://www.tinymce.com/contributing
 */

define('tinymce.modern.ui.A11y', [
], function () {
	var focus = function (panel, type) {
		return function () {
			var item = panel.find(type)[0];

			if (item) {
				item.focus(true);
			}
		};
	};

	var addKeys = function (editor, panel) {
		editor.shortcuts.add('Alt+F9', '', focus(panel, 'menubar'));
		editor.shortcuts.add('Alt+F10,F10', '', focus(panel, 'toolbar'));
		editor.shortcuts.add('Alt+F11', '', focus(panel, 'elementpath'));
		panel.on('cancel', function() {
			editor.focus();
		});
	};

	return {
		addKeys: addKeys
	};
});

/**
 * Sidebar.js
 *
 * Released under LGPL License.
 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
 *
 * License: http://www.tinymce.com/license
 * Contributing: http://www.tinymce.com/contributing
 */

define('tinymce.modern.ui.Sidebar', [
	'global!tinymce.util.Tools',
	'global!tinymce.ui.Factory',
	'global!tinymce.Env'
], function (Tools, Factory, Env) {
	var api = function (elm) {
		return {
			element: function () {
				return elm;
			}
		};
	};

	var trigger = function (sidebar, panel, callbackName) {
		var callback = sidebar.settings[callbackName];
		if (callback) {
			callback(api(panel.getEl('body')));
		}
	};

	var hidePanels = function (name, container, sidebars) {
		Tools.each(sidebars, function (sidebar) {
			var panel = container.items().filter('#' + sidebar.name)[0];

			if (panel && panel.visible() && sidebar.name !== name) {
				trigger(sidebar, panel, 'onhide');
				panel.visible(false);
			}
		});
	};

	var deactivateButtons = function (toolbar) {
		toolbar.items().each(function (ctrl) {
			ctrl.active(false);
		});
	};

	var findSidebar = function (sidebars, name) {
		return Tools.grep(sidebars, function (sidebar) {
			return sidebar.name === name;
		})[0];
	};

	var showPanel = function (editor, name, sidebars) {
		return function (e) {
			var btnCtrl = e.control;
			var container = btnCtrl.parents().filter('panel')[0];
			var panel = container.find('#' + name)[0];
			var sidebar = findSidebar(sidebars, name);

			hidePanels(name, container, sidebars);
			deactivateButtons(btnCtrl.parent());

			if (panel && panel.visible()) {
				trigger(sidebar, panel, 'onhide');
				panel.hide();
				btnCtrl.active(false);
			} else {
				if (panel) {
					panel.show();
					trigger(sidebar, panel, 'onshow');
				} else {
					panel = Factory.create({
						type: 'container',
						name: name,
						layout: 'stack',
						classes: 'sidebar-panel',
						html: ''
					});

					container.prepend(panel);
					trigger(sidebar, panel, 'onrender');
					trigger(sidebar, panel, 'onshow');
				}

				btnCtrl.active(true);
			}

			editor.fire('ResizeEditor');
		};
	};

	var isModernBrowser = function () {
		return !Env.ie || Env.ie >= 11;
	};

	var hasSidebar = function (editor) {
		return isModernBrowser() && editor.sidebars ? editor.sidebars.length > 0 : false;
	};

	var createSidebar = function (editor) {
		var buttons = Tools.map(editor.sidebars, function (sidebar) {
			var settings = sidebar.settings;

			return {
				type: 'button',
				icon: settings.icon,
				image: settings.image,
				tooltip: settings.tooltip,
				onclick: showPanel(editor, sidebar.name, editor.sidebars)
			};
		});

		return {
			type: 'panel',
			name: 'sidebar',
			layout: 'stack',
			classes: 'sidebar',
			items: [
				{
					type: 'toolbar',
					layout: 'stack',
					classes: 'sidebar-toolbar',
					items: buttons
				}
			]
		};
	};

	return {
		hasSidebar: hasSidebar,
		createSidebar: createSidebar
	};
});
/**
 * SkinLoaded.js
 *
 * Released under LGPL License.
 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
 *
 * License: http://www.tinymce.com/license
 * Contributing: http://www.tinymce.com/contributing
 */

define('tinymce.modern.ui.SkinLoaded', [
], function () {
	var fireSkinLoaded = function (editor) {
		var done = function () {
			editor._skinLoaded = true;
			editor.fire('SkinLoaded');
		};

		return function() {
			if (editor.initialized) {
				done();
			} else {
				editor.on('init', done);
			}
		};
	};

	return {
		fireSkinLoaded: fireSkinLoaded
	};
});

/**
 * Resize.js
 *
 * Released under LGPL License.
 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
 *
 * License: http://www.tinymce.com/license
 * Contributing: http://www.tinymce.com/contributing
 */

define('tinymce.modern.ui.Resize', [
	'global!tinymce.DOM'
], function (DOM) {
	var getSize = function (elm) {
		return {
			width: elm.clientWidth,
			height: elm.clientHeight
		};
	};

	var resizeTo = function (editor, width, height) {
		var containerElm, iframeElm, containerSize, iframeSize, settings = editor.settings;

		containerElm = editor.getContainer();
		iframeElm = editor.getContentAreaContainer().firstChild;
		containerSize = getSize(containerElm);
		iframeSize = getSize(iframeElm);

		if (width !== null) {
			width = Math.max(settings.min_width || 100, width);
			width = Math.min(settings.max_width || 0xFFFF, width);

			DOM.setStyle(containerElm, 'width', width + (containerSize.width - iframeSize.width));
			DOM.setStyle(iframeElm, 'width', width);
		}

		height = Math.max(settings.min_height || 100, height);
		height = Math.min(settings.max_height || 0xFFFF, height);
		DOM.setStyle(iframeElm, 'height', height);

		editor.fire('ResizeEditor');
	};

	var resizeBy = function (editor, dw, dh) {
		var elm = editor.getContentAreaContainer();
		resizeTo(editor, elm.clientWidth + dw, elm.clientHeight + dh);
	};

	return {
		resizeTo: resizeTo,
		resizeBy: resizeBy
	};
});

/**
 * Iframe.js
 *
 * Released under LGPL License.
 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
 *
 * License: http://www.tinymce.com/license
 * Contributing: http://www.tinymce.com/contributing
 */

define('tinymce.modern.modes.Iframe', [
	'global!tinymce.util.Tools',
	'global!tinymce.ui.Factory',
	'global!tinymce.DOM',
	'tinymce.modern.ui.Toolbar',
	'tinymce.modern.ui.Menubar',
	'tinymce.modern.ui.ContextToolbars',
	'tinymce.modern.ui.A11y',
	'tinymce.modern.ui.Sidebar',
	'tinymce.modern.ui.SkinLoaded',
	'tinymce.modern.ui.Resize'
], function (Tools, Factory, DOM, Toolbar, Menubar, ContextToolbars, A11y, Sidebar, SkinLoaded, Resize) {
	var switchMode = function (panel) {
		return function(e) {
			panel.find('*').disabled(e.mode === 'readonly');
		};
	};

	var editArea = function (border) {
		return {
			type: 'panel',
			name: 'iframe',
			layout: 'stack',
			classes: 'edit-area',
			border: border,
			html: ''
		};
	};

	var editAreaContainer = function (editor) {
		return {
			type: 'panel',
			layout: 'stack',
			classes: 'edit-aria-container',
			border: '1 0 0 0',
			items: [
				editArea('0'),
				Sidebar.createSidebar(editor)
			]
		};
	};

	var render = function (editor, theme, args) {
		var panel, resizeHandleCtrl, startSize, settings = editor.settings;

		if (args.skinUiCss) {
			DOM.styleSheetLoader.load(args.skinUiCss, SkinLoaded.fireSkinLoaded(editor));
		}

		panel = theme.panel = Factory.create({
			type: 'panel',
			role: 'application',
			classes: 'tinymce',
			style: 'visibility: hidden',
			layout: 'stack',
			border: 1,
			items: [
				settings.menubar === false ? null : {type: 'menubar', border: '0 0 1 0', items: Menubar.createMenuButtons(editor)},
				Toolbar.createToolbars(editor, settings.toolbar_items_size),
				Sidebar.hasSidebar(editor) ? editAreaContainer(editor) : editArea('1 0 0 0')
			]
		});

		if (settings.resize !== false) {
			resizeHandleCtrl = {
				type: 'resizehandle',
				direction: settings.resize,

				onResizeStart: function() {
					var elm = editor.getContentAreaContainer().firstChild;

					startSize = {
						width: elm.clientWidth,
						height: elm.clientHeight
					};
				},

				onResize: function(e) {
					if (settings.resize === 'both') {
						Resize.resizeTo(editor, startSize.width + e.deltaX, startSize.height + e.deltaY);
					} else {
						Resize.resizeTo(editor, null, startSize.height + e.deltaY);
					}
				}
			};
		}

		// Add statusbar if needed
		if (settings.statusbar !== false) {
			panel.add({type: 'panel', name: 'statusbar', classes: 'statusbar', layout: 'flow', border: '1 0 0 0', ariaRoot: true, items: [
				{type: 'elementpath', editor: editor},
				resizeHandleCtrl
			]});
		}

		editor.fire('BeforeRenderUI');
		editor.on('SwitchMode', switchMode(panel));
		panel.renderBefore(args.targetNode).reflow();

		if (settings.readonly) {
			editor.setMode('readonly');
		}

		if (settings.width) {
			DOM.setStyle(panel.getEl(), 'width', settings.width);
		}

		// Remove the panel when the editor is removed
		editor.on('remove', function() {
			panel.remove();
			panel = null;
		});

		// Add accesibility shortcuts
		A11y.addKeys(editor, panel);
		ContextToolbars.addContextualToolbars(editor);

		return {
			iframeContainer: panel.find('#iframe')[0].getEl(),
			editorContainer: panel.getEl()
		};
	};

	return {
		render: render
	};
});

defineGlobal("global!tinymce.ui.FloatPanel", tinymce.ui.FloatPanel);
/**
 * Inline.js
 *
 * Released under LGPL License.
 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
 *
 * License: http://www.tinymce.com/license
 * Contributing: http://www.tinymce.com/contributing
 */

define('tinymce.modern.modes.Inline', [
	'global!tinymce.util.Tools',
	'global!tinymce.ui.Factory',
	'global!tinymce.DOM',
	'global!tinymce.ui.FloatPanel',
	'tinymce.modern.ui.Toolbar',
	'tinymce.modern.ui.Menubar',
	'tinymce.modern.ui.ContextToolbars',
	'tinymce.modern.ui.A11y',
	'tinymce.modern.ui.SkinLoaded'
], function (Tools, Factory, DOM, FloatPanel, Toolbar, Menubar, ContextToolbars, A11y, SkinLoaded) {
	var render = function (editor, theme, args) {
		var panel, inlineToolbarContainer, settings = editor.settings;

		if (settings.fixed_toolbar_container) {
			inlineToolbarContainer = DOM.select(settings.fixed_toolbar_container)[0];
		}

		var reposition = function () {
			if (panel && panel.moveRel && panel.visible() && !panel._fixed) {
				// TODO: This is kind of ugly and doesn't handle multiple scrollable elements
				var scrollContainer = editor.selection.getScrollContainer(), body = editor.getBody();
				var deltaX = 0, deltaY = 0;

				if (scrollContainer) {
					var bodyPos = DOM.getPos(body), scrollContainerPos = DOM.getPos(scrollContainer);

					deltaX = Math.max(0, scrollContainerPos.x - bodyPos.x);
					deltaY = Math.max(0, scrollContainerPos.y - bodyPos.y);
				}

				panel.fixed(false).moveRel(body, editor.rtl ? ['tr-br', 'br-tr'] : ['tl-bl', 'bl-tl', 'tr-br']).moveBy(deltaX, deltaY);
			}
		};

		var show = function () {
			if (panel) {
				panel.show();
				reposition();
				DOM.addClass(editor.getBody(), 'mce-edit-focus');
			}
		};

		var hide = function () {
			if (panel) {
				// We require two events as the inline float panel based toolbar does not have autohide=true
				panel.hide();

				// All other autohidden float panels will be closed below.
				FloatPanel.hideAll();

				DOM.removeClass(editor.getBody(), 'mce-edit-focus');
			}
		};

		var render = function () {
			if (panel) {
				if (!panel.visible()) {
					show();
				}

				return;
			}

			// Render a plain panel inside the inlineToolbarContainer if it's defined
			panel = theme.panel = Factory.create({
				type: inlineToolbarContainer ? 'panel' : 'floatpanel',
				role: 'application',
				classes: 'tinymce tinymce-inline',
				layout: 'flex',
				direction: 'column',
				align: 'stretch',
				autohide: false,
				autofix: true,
				fixed: !!inlineToolbarContainer,
				border: 1,
				items: [
					settings.menubar === false ? null : {type: 'menubar', border: '0 0 1 0', items: Menubar.createMenuButtons(editor)},
					Toolbar.createToolbars(editor, settings.toolbar_items_size)
				]
			});

			// Add statusbar
			/*if (settings.statusbar !== false) {
				panel.add({type: 'panel', classes: 'statusbar', layout: 'flow', border: '1 0 0 0', items: [
					{type: 'elementpath'}
				]});
			}*/

			editor.fire('BeforeRenderUI');
			panel.renderTo(inlineToolbarContainer || document.body).reflow();

			A11y.addKeys(editor, panel);
			show();
			ContextToolbars.addContextualToolbars(editor);

			editor.on('nodeChange', reposition);
			editor.on('activate', show);
			editor.on('deactivate', hide);

			editor.nodeChanged();
		};

		settings.content_editable = true;

		editor.on('focus', function() {
			// Render only when the CSS file has been loaded
			if (args.skinUiCss) {
				DOM.styleSheetLoader.load(args.skinUiCss, render, render);
			} else {
				render();
			}
		});

		editor.on('blur hide', hide);

		// Remove the panel when the editor is removed
		editor.on('remove', function() {
			if (panel) {
				panel.remove();
				panel = null;
			}
		});

		// Preload skin css
		if (args.skinUiCss) {
			DOM.styleSheetLoader.load(args.skinUiCss, SkinLoaded.fireSkinLoaded(editor));
		}

		return {};
	};

	return {
		render: render
	};
});

defineGlobal("global!tinymce.ui.Throbber", tinymce.ui.Throbber);
/**
 * ProgressState.js
 *
 * Released under LGPL License.
 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
 *
 * License: http://www.tinymce.com/license
 * Contributing: http://www.tinymce.com/contributing
 */

define('tinymce.modern.ui.ProgressState', [
	'global!tinymce.ui.Throbber'
], function (Throbber) {
	var setup = function (editor, theme) {
		var throbber;

		editor.on('ProgressState', function(e) {
			throbber = throbber || new Throbber(theme.panel.getEl('body'));

			if (e.state) {
				throbber.show(e.time);
			} else {
				throbber.hide();
			}
		});
	};

	return {
		setup: setup
	};
});

/**
 * Theme.js
 *
 * Released under LGPL License.
 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
 *
 * License: http://www.tinymce.com/license
 * Contributing: http://www.tinymce.com/contributing
 */

define('tinymce.modern.Theme', [
	'global!tinymce.Env',
	'global!tinymce.EditorManager',
	'global!tinymce.ThemeManager',
	'tinymce.modern.modes.Iframe',
	'tinymce.modern.modes.Inline',
	'tinymce.modern.ui.Resize',
	'tinymce.modern.ui.ProgressState'
], function (Env, EditorManager, ThemeManager, Iframe, Inline, Resize, ProgressState) {
	var renderUI = function(editor, theme, args) {
		var settings = editor.settings;
		var skin = settings.skin !== false ? settings.skin || 'lightgray' : false;

		if (skin) {
			var skinUrl = settings.skin_url;

			if (skinUrl) {
				skinUrl = editor.documentBaseURI.toAbsolute(skinUrl);
			} else {
				skinUrl = EditorManager.baseURL + '/skins/' + skin;
			}

			// Load special skin for IE7
			// TODO: Remove this when we drop IE7 support
			if (Env.documentMode <= 7) {
				args.skinUiCss = skinUrl + '/skin.ie7.min.css';
			} else {
				args.skinUiCss = skinUrl + '/skin.min.css';
			}

			// Load content.min.css or content.inline.min.css
			editor.contentCSS.push(skinUrl + '/content' + (editor.inline ? '.inline' : '') + '.min.css');
		}

		ProgressState.setup(editor, theme);

		if (settings.inline) {
			return Inline.render(editor, theme, args);
		}

		return Iframe.render(editor, theme, args);
	};

	ThemeManager.add('modern', function (editor) {
		return {
			renderUI: function (args) {
				return renderUI(editor, this, args);
			},
			resizeTo: function (w, h) {
				return Resize.resizeTo(editor, w, h);
			},
			resizeBy: function (dw, dh) {
				return Resize.resizeBy(editor, dw, dh);
			}
		};
	});

	return function () {
	};
});

dem('tinymce.modern.Theme')();
})();

(function () {
    'use strict';

    angular
        .module('app')
        .service('ValidationIdentiteService', ValidationIdentiteService);

    /* @ngInject */
    function ValidationIdentiteService($http, $q, BACKEND) {

        var service = {
            checkIdentite: checkIdentite
        };
        return service;

        function checkIdentite(validationIdentite) {
            return $q(function (resolve, reject) {
                $http({
                    url: BACKEND.url + '/validation-identite',
                    method: "POST",
                    data: validationIdentite
                })
                    .then(function (response) {
                        resolve(response.data);
                    }, reject);
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('SelectionCheptelTechnicienController', SelectionCheptelTechnicienController);

  /** @ngInject */
  function SelectionCheptelTechnicienController($filter, $scope, $state, AuthentService, ErrorService, ExploitationService,
    LoadingService, SessionService, TechniciensService, UserService, StatutRecouvrementService, ModalService, FonctionnaliteService) {
    var vm = this;

    vm.filter = '';

    LoadingService.show();
    vm.cheptels = [];
    vm.cheptelsFiltre = [];
    vm.noCheptel = false;
    vm.profilAssistance = false;
    TechniciensService.getCheptelsTechnicien({login: UserService.get('login')}).then(function (cheptels) {
      vm.profilAssistance = UserService.get('profilAssistance');
      vm.cheptels = cheptels;
      if (vm.profilAssistance === false) {
        vm.cheptelsFiltre = vm.cheptels.slice();
      }
      vm.noCheptel = cheptels.length === 0;
    }, function (error) {
      ErrorService.alert(error);
    }).finally(function () {
      LoadingService.hide();
    });

    $scope.$watch(function () {
      return vm.filter;
    }, function () {
      if (vm.filter === "") {
        vm.cheptelsFiltre = [];
      } else {
        vm.cheptelsFiltre = $filter('filter')(vm.cheptels, function (cheptel) {
          var numex = angular.copy(cheptel.numExploitation) || '';
          var raisoc = angular.copy(cheptel.raisonSociale) || '';
          return numex.toLowerCase().indexOf(vm.filter.toLowerCase()) !== -1 ||
            raisoc.toLowerCase().indexOf(vm.filter.toLowerCase()) !== -1;
        });
      }
    }, true);
    function goToOdoo() {
      FonctionnaliteService.getFonctionnalite('ODOO').then(function (fonctionnalite) {
        FonctionnaliteService.goToFonctionnalite(fonctionnalite, {
          menu: false,
          newPage: true
        }).catch(function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });
      });
    }
    vm.selectionCheptel = function (cheptel) {
      StatutRecouvrementService.getEstSuspendus(cheptel.numExploitation).then(function (suspensionDto) {
        if (suspensionDto.suspendu) {
          if (suspensionDto.estResponsable) {
            ModalService.popupSuspensionAccesResponsable(UserService.isMultiExploitation()).then(function () {
              goToOdoo();
            });
          } else {
            ModalService.popupSuspensionAccesAutre(suspensionDto.emailResponsable, UserService.isMultiExploitation()).then(function () { });
          }
        } else {
          LoadingService.show();
          AuthentService.setExploitation(cheptel).then(function (token) {
            SessionService.setCredentials({
              token: token
            });
            LoadingService.show();
            UserService.loadProfil().then(function () {
              LoadingService.show();
              redirectionByTypeAbo();
            }, function (error) {
              ErrorService.alert(error);
            }).finally(function () {
              LoadingService.hide();
            });
          }, function (error) {
            if (angular.isDefined(_.get(error, 'data.cause'))) {
              ErrorService.alert(error, {message: _.get(error, 'data.cause')});
            } else {
              ErrorService.alert(error);
            }
          }).finally(function () {
            LoadingService.hide();
          });
        }
      });
    };

    function redirectionByTypeAbo() {
      UserService.getListTypeAbonnement(UserService.get('login')).then(function (response) {
        // eslint-disable-next-line
        var estBovin = _.find(response.listeTypeAbonnement, function (typeAbonnement) {
          return typeAbonnement === "BOV";
        });
        if (estBovin) {
          $state.go('app.eleveur.bovin');
        } else {
          $state.go('app.eleveur.woc');
        }
      }, function (error) {
        ErrorService.alert(error);
      }).finally(function () {
        LoadingService.hide();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('SelectionCheptelController', SelectionCheptelController);

  /** @ngInject */
  function SelectionCheptelController($state, AuthentService, UserService, versionBack, VERSION) {
    var vm = this;

    vm.isAssistance = UserService.get('profilAssistance');
    vm.version = versionBack.version + " - " + VERSION;
    vm.logout = function () {
      AuthentService.logout();
    };

    vm.isMultiProfil = function () {
      return UserService.isMultiProfil();
    };

    vm.goToSelectionProfil = function () {
      $state.go('selectionProfil');
    };
    // if (vm.isAssistance) {
    //   $state.go('app.selectioncheptel.assistance');
    // } else { */
      $state.go('app.selectioncheptel.technicien');
    // }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('SelectionCheptelAssistanceController', SelectionCheptelAssistanceController);

  /** @ngInject */
  function SelectionCheptelAssistanceController($filter, $scope, $state, ContactService, AuthentService, ErrorService, LoadingService, SessionService, TechniciensService, UserService) {
    var vm = this;

    vm.departements = [];
    vm.showCheptels = false;
    vm.cheptels = [];
    vm.cheptelsFiltre = [];
    vm.filtre = '';

    LoadingService.show();
    ContactService.getDepartements().then(function (departements) {
      vm.departements = departements;
    }, function (error) {
      ErrorService.alert(error);
    }).finally(function () {
      LoadingService.hide();
    });

    $scope.$watch(function () {
      return vm.selectedDepartement;
    }, function () {
      if (angular.isDefined(vm.selectedDepartement)) {
        LoadingService.show();
        TechniciensService.getCheptelsAffectables(vm.selectedDepartement).then(function (cheptels) {
          vm.cheptels = cheptels;
          vm.cheptelsFiltre = vm.cheptels.slice();
          vm.filtre = '';
          vm.showCheptels = true;
        }, function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });
      }
    });

    $scope.$watch(function () {
      return vm.filter;
    }, function () {
      vm.cheptelsFiltre = $filter('filter')(vm.cheptels, function (cheptel) {
        var numex = angular.copy(cheptel.numExploitation) || '';
        var raisoc = angular.copy(cheptel.raisonSociale) || '';
        return numex.toLowerCase().indexOf(vm.filter.toLowerCase()) !== -1 ||
          raisoc.toLowerCase().indexOf(vm.filter.toLowerCase()) !== -1;
      });
    }, true);

    vm.selectionCheptel = function (cheptel) {
      LoadingService.show();
      AuthentService.setExploitation(cheptel).then(function (token) {
        SessionService.setCredentials({
          token: token
        });
        LoadingService.show();
        UserService.loadProfil().then(function () {
          LoadingService.show();
          UserService.getListTypeAbonnement(UserService.get('login')).then(function (response) {
             // eslint-disable-next-line
            var estBovin = _.find(response.listeTypeAbonnement, function (typeAbonnement) {
              return typeAbonnement === "BOV";
            });
            if (estBovin) {
              $state.go('app.eleveur.bovin');
            } else {
              $state.go('app.eleveur.woc');
            }
          }, function (error) {
            ErrorService.alert(error);
          }).finally(function () {
            LoadingService.hide();
          });
        }, function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });
      }, function (error) {
        if (angular.isDefined(_.get(error, 'data.cause'))) {
          ErrorService.alert(error, {message: _.get(error, 'data.cause')});
        } else {
          ErrorService.alert(error);
        }
      }).finally(function () {
        LoadingService.hide();
      });
    };
  }
})();

(function () {
  angular
    .module('app')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('app.selectioncheptel', {
        url: 'selectionCheptel',
        templateUrl: 'app/selectionCheptel/main/main.html',
        controller: 'SelectionCheptelController',
        controllerAs: 'ctrl'
      }).state('app.selectioncheptel.technicien', {
        url: '/technicien',
        templateUrl: 'app/selectionCheptel/technicien/technicien.html',
        controller: 'SelectionCheptelTechnicienController',
        controllerAs: 'ctrl'
      }).state('app.selectioncheptel.assistance', {
        url: '/assistance',
        templateUrl: 'app/selectionCheptel/assistance/assistance.html',
        controller: 'SelectionCheptelAssistanceController',
        controllerAs: 'ctrl'
      });
  }
})();

(function () {
  angular
    .module('app')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {

    $stateProvider
      .state('pertemdp', {
        url: '/perte-mot-de-passe',
        templateUrl: 'app/perteMdp/perteMdp.html',
        controller: 'PerteMdpController',
        controllerAs: 'ctrl',
        params: {
          identifiant: null
        },
        resolve: {
          departements: ['ContactService', function (ContactService) {
            return ContactService.getDepartements();
          }],
          versionBack: ['ParametresService', function (ParametresService) {
            return ParametresService.getVersion();
          }]
        },
        authenticated: false
      });
  }
})();

(function () {
  angular
    .module('app')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('dossieranimal', {
        url: '/dossieranimal?animal',
        controller: 'OuvertureDossierAnimalController',
        controllerAs: 'ctrl',
        resolve: {
          fonctionnalite: ['$stateParams', 'FonctionnaliteService', function ($stateParams, FonctionnaliteService) {
            return FonctionnaliteService.completeAcces('DOSSIER_ANIMAL', {
              numeroNational: $stateParams.animal
            });
          }]
        }
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AbonnnementValidationController', AbonnnementValidationController);

  /** @ngInject */
  function AbonnnementValidationController($state, saisie, NouvelAbonnementService, FloreService, ErrorService, LoadingService, ModalService) {

    var vm = this;
    var message;
    vm.saisie = saisie;
    vm.aboFloreActive = angular.isDefined(vm.saisie.abonneFloreInfos) && angular.isDefined(vm.saisie.abonneFloreInfos.media);
    vm.msgPromo = false;
    vm.sms = true;
    var description = "";
    if (angular.isDefined(saisie) && !_.isEmpty(saisie)) {
      var listLibelleAboOption = [];
      saisie.listAbonnementsSelectionnes.forEach(function (abonnement) {
        listLibelleAboOption.push(abonnement.libelleAbonnement);
      });
      if (angular.isDefined(saisie.options)) {
        saisie.options.forEach(function (option) {
          if (option.isSelected && option.allowed) {
            listLibelleAboOption.push(option.libelle);
          }
        });
      }

      listLibelleAboOption.forEach(function (element, index, list) {
        description += element;
        if (index < list.length - 2) {
          description += ", ";
        } else if (index === list.length - 2) {
          description += " et à l'offre ";
        }
      });

      vm.description = description;
    }

    message = '<p>Votre abonnement a bien été enregistré. Un e-mail contenant les informations permettant de vous connecter va vous être envoyé.</p>';

    vm.confirmAbonnement = function () {
      if (saisie.infosAbonne.typeMobile) {
        saisie.typeMobile = saisie.infosAbonne.typeMobile.libelle;
      } else {
        saisie.typeMobile = undefined;
      }

      LoadingService.show();
      NouvelAbonnementService.ajoutNouvelAbonnement(saisie).then(function () {
        LoadingService.hide();
        ModalService.alert({
          template: message,
          title: "Confirmation"
        }).then(function () {
          $state.go('auth');
        });
      }, function (error) {
        LoadingService.hide();
        if (_.get(error, 'data.code')) {
          dialog(error.data.message);
        } else {
          ErrorService.alert(error);
        }
      });
    };

    function dialog(text) {
      ModalService.alert({
        template: text
      });
      LoadingService.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AbonnementServicesController', AbonnementServicesController);

  /** @ngInject */
  function AbonnementServicesController($scope, $state, saisie, REDUCTION, ParametresService) {

    var vm = this;
    var list = [];
    var listId = [];
    if (angular.isUndefined(saisie.anyOptionEnabled)) {
      saisie.anyOptionEnabled = false;
    }

    if (saisie.ovin) {
      vm.ovin = saisie.ovin;
    } else {
      vm.ovin = 0;
    }
    if (saisie.bovin) {
      vm.bovin = saisie.bovin;
    }

    ParametresService.load().then(function (result) {
      vm.parametres = result;
    });
    if (angular.isDefined(saisie) && !_.isEmpty(saisie)) {
      vm.raisonSociale = saisie.infosExploitation.raisonSociale;
      vm.numeroExploitation = saisie.infosExploitation.numExploitation;
      vm.abonnementsBovin = _.get(saisie.listAbonnements, 'BOV');
      vm.abonnementsOvCap = _.get(saisie.listAbonnements, 'OVCAP');
      vm.abonnementFlore = _.get(saisie.listAbonnements, 'FLORE');
      var reduc = _.find(REDUCTION, {departement: saisie.infosExploitation.numExploitation.substring(0, 2)});
      vm.reduction = angular.isDefined(reduc);
      vm.reductionTxt = vm.reduction ? reduc.texte : '';
    }

    $scope.$watch(function () {
      if (_.isEqual(vm.bovin, 0) && _.isEqual(vm.ovin, 0)) {
        vm.disabled = true;
      } else if (angular.isDefined(vm.bovin) && angular.isDefined(vm.ovin) || (angular.isDefined(vm.bovin) && _.isEqual(vm.ovin, 0)) || (angular.isDefined(vm.ovin) && _.isEqual(vm.bovin, 0)) || (angular.isUndefined(vm.abonnementsOvCap) && angular.isDefined(vm.bovin) && !_.isEqual(vm.bovin, 0)) || (angular.isUndefined(vm.abonnementsBovin) && angular.isDefined(vm.ovin) && !_.isEqual(vm.ovin, 0))) {
        vm.disabled = false;
      } else {
        vm.disabled = true;
      }
    }, true);

    vm.goToFacturation = function () {
      if (!vm.disabled) { // #28488
        if (angular.isDefined(vm.bovin) && !_.isEqual(vm.bovin, 0)) {
          list.push(vm.bovin);
          listId.push(vm.bovin.idTarifAbonnementOrganisme);
          saisie.bovin = vm.bovin;
          saisie.isBovin = true;
        } else {
          saisie.bovin = undefined;
          saisie.isBovin = false;
        }
        if (angular.isDefined(vm.ovin) && !_.isEqual(vm.ovin, 0)) {
          list.push(vm.ovin);
          listId.push(vm.ovin.idTarifAbonnementOrganisme);
          saisie.isOvin = true;
          saisie.ovin = vm.ovin;
        } else {
          saisie.isOvin = false;
          saisie.ovin = undefined;
        }
        saisie.listAbonnementsSelectionnes = list;
        saisie.activeAbonnement = listId;
        setOptionsEnabled();

        if (shouldGoToOptions()) {
          $state.go('abonnement.options');
        } else if (saisie.isBovin) {
          $state.go('abonnement.facturation', {saisie: saisie});
        } else {
          clearPreviousEntries();
          $state.go('abonnement.validation');
        }
      }
    };

    // Fonction pour déterminer si l'on doit aller à la page d'options
    function shouldGoToOptions() {
      return (angular.isDefined(saisie.options) && saisie.options.length > 0 && saisie.anyOptionEnabled === true) || (saisie.hasFlore && saisie.isBovin);
    }

    // Cette fonction nettoie les anciennes saisies
    function clearPreviousEntries() {
    // On vérifie d'abord que l'objet 'saisie' est défini et qu'il n'est pas vide.
      if (angular.isDefined(saisie) && !_.isEmpty(saisie)) {

        // Si 'saisie.options' est défini, on boucle sur chaque option.
        if (angular.isDefined(saisie.options)) {
          // Pour chaque option, si 'isSelected' est défini et vrai (l'option est sélectionnée),
          // on désélectionne cette option en mettant 'isSelected' à false.
          saisie.options.forEach(function (option) {
            if (angular.isDefined(option.isSelected) && option.isSelected) {
              option.isSelected = false;
            }
          });
        }

        // Si un contact de facturation ('contactFacturation') est défini, on l'efface en le mettant à 'undefined'.
        if (angular.isDefined(saisie.contactFacturation)) {
          saisie.contactFacturation = undefined;
        }

        // Si un IBAN est défini, on l'efface également en le mettant à 'undefined'.
        if (angular.isDefined(saisie.iban)) {
          saisie.iban = undefined;
        }

        // Si le prélèvement mobile est défini, on l'efface aussi en le mettant à 'undefined'.
        if (angular.isDefined(saisie.prelevementMobile)) {
          saisie.prelevementMobile = undefined;
        }
      }
    }

    function setOptionsEnabled() {
      var isPerformance = false;
      var isEssentiel = false;
      var isOvin = false;
      saisie.anyOptionEnabled = false;
      if (saisie.isOvin) {
        isOvin = true;
      }
      if (angular.isDefined(saisie.isBovin) && angular.isDefined(saisie.bovin) && angular.isDefined(saisie.bovin.niveauAbonnement)) {
        if (saisie.bovin.niveauAbonnement.libelle === 'Performance') {
          isPerformance = true;
        } else if (saisie.bovin.niveauAbonnement.libelle === 'Essentiel') {
          isEssentiel = true;
        }
      }
      angular.forEach(saisie.options, function (option) {
        if (angular.isUndefined(option.dependances) || (angular.isDefined(option.dependances) && option.dependances.length === 0)) {
          option.allowed = true;
          saisie.anyOptionEnabled = true;
        } else {
          option.allowed = false;
        }
        angular.forEach(option.dependances, function (dependance) {
          if (option.allowed === false) {
            if (_.isEqual(dependance, 'Performance')) {
              if (isPerformance) {
                option.allowed = true;
                saisie.anyOptionEnabled = true;
              }
            } else if (_.isEqual(dependance, 'Essentiel')) {
              if (isEssentiel) {
                option.allowed = true;
                saisie.anyOptionEnabled = true;
              }
            } else if (_.isEqual(dependance, 'Ovin/Caprin')) {
              if (isOvin) {
                option.allowed = true;
                saisie.anyOptionEnabled = true;
              }
            }
          }
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AbonnementOptionsController', AbonnementOptionsController);

  /** @ngInject */
  function AbonnementOptionsController($scope, $state, $location, $anchorScroll, $timeout, saisie, ModalService) {
    var vm = this;
    vm.monCompte = false;
    vm.formDataHubValid = false;
    vm.showDataHub = _.get(saisie.listAbonnements, 'DATAHUB');

    if (saisie.abonneFloreInfos) {
      vm.flore = saisie.abonneFloreInfos;
    } else {
      vm.flore = {
        utilisateurTelephone: {},
        utilisateurEmail: {}
      };
    }
    vm.options = saisie.options;
    var continuer = true;
    angular.forEach(saisie.listAutorisationsAcces, function (autorisation) {
      if (continuer) {
        // un code serait préférable mais le libellé reste plus lisible que l'id ici...
        if (angular.isDefined(autorisation.telMobile) && autorisation.profil.libelle === "Responsable/associé Facturation") {
          vm.flore.utilisateurTelephone.telMobile = autorisation.telMobile;
          vm.telephoneModileDefaut = autorisation.telMobile;
          continuer = false;
        }
      }
    });

    if (angular.isDefined(vm.telephoneModileDefaut)) {
      angular.forEach(vm.options, function (option) {
        if (_.isEqual(option.nom, 'dataHUB')) {
          var telephone = _.find(option.optionDonneesComplementaires, function (donnee) {
            return donnee.libelle === "N° de téléphone à contacter";
          });
          telephone.valeur = vm.telephoneModileDefaut;
        }
      });
    }

    $scope.$watch(function () {
      vm.disabled = false;
      vm.testValiditeFormDataHub();
      var disabled = _.find(vm.options, function (option) {
        if (!option.hasOwnProperty('isSelected') && option.allowed) {
          return true;
        }
      });
      if (disabled) {
        vm.disabled = true;
      } else if (saisie.isBovin && saisie.hasFlore && (angular.equals(vm.showNotification, {}) ||
        vm.showNotification === true && (angular.isUndefined(vm.flore.media) ||
          angular.isUndefined(vm.flore.utilisateurTelephone.telMobile)))) {
        vm.disabled = true;
      } else if (vm.showDataHub === true && (vm.formDataHubValid === false)) {
          vm.disabled = true;
      } else {
        vm.disabled = false;
      }
    }, true);

    if (angular.isDefined(saisie) && !_.isEmpty(saisie) && angular.isDefined(saisie.infosExploitation)) {
      vm.raisonSociale = saisie.infosExploitation.raisonSociale;
      vm.numeroExploitation = saisie.infosExploitation.numExploitation;
    }
    vm.bovin = saisie.isBovin;
    vm.abonnementFlore = _.get(saisie.listAbonnements, 'FLORE');
    if (saisie.showNotification === true || saisie.showNotification === false) {
      vm.showNotification = saisie.showNotification;
    } else {
      vm.showNotification = {};
    }

    vm.showingNotification = function () {
      vm.showNotification = true;
      saisie.showNotification = true;
      $location.hash('div-bottom');
      $anchorScroll();
    };

    vm.optionDataHubNonButtonClic = function (option) {
      option.isSelected = false;
      $location.hash('bottom-' + option.idAbonnement);
      $anchorScroll();
    };

    vm.optionOuiButtonClic = function (option) {
      option.isSelected = true;
      $location.hash('bottom-' + option.idAbonnement);
      $anchorScroll();
    };
    vm.optionNonButtonClic = function (option) {
      option.isSelected = false;
      $location.hash('bottom-' + option.idAbonnement);
      $anchorScroll();
    };
    vm.datahubNonButton = function (option) {
      option.isSelected = false;
      vm.showDataHub = false;
      $location.hash('bottom-' + option.idAbonnement);
      $anchorScroll();
    };
    vm.datahubOuiButton = function (option, value) {
      vm.showDataHub = true;
      option.isSelected = value;
      $timeout(function () {
        $location.hash('bottom-' + option.idAbonnement);
        $anchorScroll();
      });
    };

    vm.hidingNotification = function () {
      vm.showNotification = false;
      saisie.showNotification = false;
    };

    vm.showHelp = function () {
      ModalService.floreInfos();
    };

    vm.showOptionHelp = function (option) {
      ModalService.optionInfos({
        title: option.titrePopup,
        nom: option.nom,
        body: option.contenuPopup
      });
    };

    vm.goToFacturation = function () {
      if (angular.isDefined(vm.abonnementFlore) && !_.includes(saisie.listAbonnementsSelectionnes, vm.abonnementFlore[0])) {
        if (angular.equals(vm.showNotification, true) && vm.bovin) {
          saisie.abonneFloreInfos = vm.flore;
          saisie.listAbonnementsSelectionnes.push(vm.abonnementFlore[0]);
          saisie.activeAbonnement.push(vm.abonnementFlore[0].idTarifAbonnementOrganisme);
        }
      }
      $state.go('abonnement.facturation', {saisie: saisie});
    };

    vm.getTemplateHtmlUrl = function (templateName) {
      return 'app/_common/partials/optionTemplates/' + templateName;
    };

    vm.testValiditeFormDataHub = function () {
      angular.forEach(vm.options, function (option) {
        if (_.isEqual(option.nom, 'dataHUB')) {
          var telephone = _.find(option.optionDonneesComplementaires, function (donnee) {
            return donnee.libelle === "N° de téléphone à contacter";
          });
          var marque = _.find(option.optionDonneesComplementaires, function (donnee) {
            return donnee.libelle === "Marque";
          });
          var typeMobile = _.find(option.optionDonneesComplementaires, function (donnee) {
            return donnee.libelle === "Type de matériel";
          });
          var retour = angular.isDefined(telephone.valeur) && angular.isDefined(marque.valeur) && angular.isDefined(typeMobile.valeur);
          vm.formDataHubValid = retour;
        }
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('OffresPilotElevageController', OffresPilotElevageController);

  /** @ngInject */
  function OffresPilotElevageController($state, saisie) {
    var vm = this;

    vm.goToAutorisationsAcces = function () {
      $state.go('abonnement.autorisations', {saisie: saisie});
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AbonnementMainController', AbonnementMainController);

  /** @ngInject */
  function AbonnementMainController($state, saisie, versionBack, VERSION) {
    var vm = this;

    vm.version = versionBack.version + " - " + VERSION;
    vm.saisie = saisie;
    vm.getTitle = function () {
      var step = $state.current.name;
      if (step === 'abonnement.informations' || step === 'abonnement.offres') {
        return "Accéder aux détails de l'offre";
      }
      if (step === 'abonnement.autorisations') {
        return 'Autorisations d\'accès';
      }
      if (step === 'abonnement.options') {
        return 'Mes options';
      }
      if (step === 'abonnement.facturation') {
        return 'Facturation';
      }
      return "Mon abonnement Pilot'Elevage";
    };

    vm.saisie.steps = [
      {
        libelle: 'Mon Elevage',
        state: 'abonnement.informations',
        isCompleted: function () {
          return angular.isDefined(saisie.infosExploitation);
        }
      },
      {
        libelle: 'Les offres Pilot\'Elevage',
        state: 'abonnement.offres',
        isCompleted: function () {
          return (($state.current.name !== "abonnement.informations" && $state.current.name !== "abonnement.offres") || angular.isDefined(saisie.infosExploitation));
        }
      },
      {
        libelle: 'Autorisations d\'accès',
        state: 'abonnement.autorisations',
        saisie: saisie,
        isCompleted: function () {
          return angular.isDefined(saisie.listAutorisationsAcces) && saisie.listAutorisationsAcces.length > 0;
        }
      },
      {
        libelle: 'Mes services',
        state: 'abonnement.services',
        isCompleted: function () {
          return angular.isDefined(saisie.activeAbonnement) && angular.isDefined(saisie.listAutorisationsAcces) && saisie.listAutorisationsAcces.length > 0;
        }
      },
      // {
      //   libelle: 'Mes options',
      //   state: 'abonnement.options',
      //   isCompleted: function () {
      //     return angular.isDefined(saisie.activeAbonnement);
      //   },
      //   isVisible: function () {
      //     return angular.isDefined(saisie.hasOptions);
      //   }
      // },
      {
        libelle: 'Facturation',
        state: 'abonnement.facturation',
        saisie: saisie,
        isCompleted: function () {
          return angular.isDefined(saisie.contactFacturation) && angular.isDefined(saisie.activeAbonnement) && angular.isDefined(saisie.listAutorisationsAcces) && saisie.listAutorisationsAcces.length > 0;
        }
      },
      {
        libelle: 'Validation',
        state: 'abonnement.validation',
        isCompleted: function () {
          return false;
        }
      }
    ];

    $state.go('abonnement.informations');
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AbonnementInformationsController', AbonnementInformationsController);

  /** @ngInject */
  function AbonnementInformationsController($mdDialog, $state, $filter, $stateParams, ErrorService, CompteService, LoadingService,
    ModalService, NouvelAbonnementService, UserService, listeDpt, saisie, AbonnementOptionService) {
    var vm = this;
    var listAbonnements = [];
    var numagrin;
    vm.numeroAssistance = '09.99.99.99.99';
    vm.hideSiren = false;

    if (saisie.infosAbonne) {
      vm.nouvelAbonnement = angular.copy(saisie.infosAbonne);
    } else {
      vm.nouvelAbonnement = {};

      // en prod commenter
      // en local décommenter pour saisie auto
      // vm.nouvelAbonnement.numExploitation = "86056548"; // Olivier=37037305 Alex=86056548
      // vm.nouvelAbonnement.numSiren = "353871593"; // Olivier=753097708 Alex=353871593

    }

    if (angular.isDefined($stateParams.numExploitation)) {
      vm.nouvelAbonnement.numExploitation = $stateParams.numExploitation;
    }

    if (angular.isDefined($stateParams.numSiren)) {
      if (_.isEqual($stateParams.numSiren, 'true')) {
        vm.nouvelAbonnement.numSiren = undefined;
      } else {
        vm.nouvelAbonnement.numSiren = $stateParams.numSiren;
      }
    }

    if (angular.isDefined($stateParams.numNumagrin)) {
      if (_.isEqual($stateParams.numNumagrin, 'true')) {
        vm.nouvelAbonnement.numagrin = undefined;
      } else {
        vm.nouvelAbonnement.numagrin = $stateParams.numNumagrin;
        vm.hasNumagrin = true;
      }
    }

    if (angular.isDefined($stateParams.hideSiren)) {
      vm.hideSiren = _.isEqual($stateParams.hideSiren, 'true');
    }

    vm.clearInput = function (numagrin) {
      vm.hasNumagrin = numagrin;
      if (vm.hasNumagrin) {
        vm.nouvelAbonnement.numSiren = "";
      } else {
        vm.nouvelAbonnement.numagrin = "";
      }
      saisie.hasNumagrin = vm.hasNumagrin;
    };

    if (saisie.hasNumagrin) {
      vm.hasNumagrin = saisie.hasNumagrin;
    }

    // redmine 32596 : afficher le numéro d'assistance de l'organisme correspondant
    vm.setNumeroAssistance = function () {
      if (vm.nouvelAbonnement.numExploitation) {
        var codeDepartement = vm.nouvelAbonnement.numExploitation.substring(0, 2);
        var result = _.find(listeDpt, function (obj) {
          return obj.code === codeDepartement;
        });
        if (result) {
          vm.numeroAssistance = result.organismeAssistance.telephone.replace(/^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1.$2.$3.$4.$5');
        } else {
          vm.numeroAssistance = '09.99.99.99.99';
        }
      } else {
        vm.numeroAssistance = '09.99.99.99.99';
      }
    };
    vm.goToServices = function () {
      if (vm.authentForm.$valid) {
        if (_.find(listeDpt, function (dpt) {
          return vm.nouvelAbonnement.numExploitation.substring(0, 2) === dpt.code;
        })) {
          LoadingService.show();

          CompteService.getNiveaux(vm.nouvelAbonnement.numExploitation).then(function (list) {
            LoadingService.hide();
            var abonnement;
            listAbonnements = list;
            _.find(listAbonnements, function (niveaux) {
              _.find(niveaux, function (niveau) {
                if (niveau.disponible === false) {
                  abonnement = niveau;
                }
              });
            });
            // abonnement = undefined;
            if (angular.isDefined(vm.nouvelAbonnement.numagrin) && !_.isEmpty(vm.nouvelAbonnement.numagrin)) {
              numagrin = vm.nouvelAbonnement.numagrin.toUpperCase();
            }

            LoadingService.show();
            NouvelAbonnementService.getInfosExploitation(vm.nouvelAbonnement).then(function (result) {
              LoadingService.hide();

              if (vm.nouvelAbonnement.numSiren !== result.siren && angular.isDefined(vm.nouvelAbonnement.numSiren) && !_.isEmpty(vm.nouvelAbonnement.numSiren)) {
                ModalService.alert({
                  template: "Le N° Siren ne correspond pas à l’exploitation indiquée. Veuillez contacter votre service identification."
                });
              } else if (numagrin !== result.numagrin && angular.isDefined(vm.nouvelAbonnement.numagrin) && !_.isEmpty(vm.nouvelAbonnement.numagrin)) {
                vm.nouvelAbonnement.numagrin = numagrin;

                ModalService.alert({
                  template: "Le N° Numagrin ne correspond pas à l’exploitation indiquée. Veuillez contacter votre service identification."
                });
              } else if (angular.isUndefined(abonnement)) {
                AbonnementOptionService.getOptions(vm.nouvelAbonnement.numExploitation).then(function (options) {
                  var anyOption = angular.isDefined(options) && options.length > 0;
                  if (anyOption) {
                    saisie.options = options;
                  }
                  saisie.listAbonnements = listAbonnements;
                  vm.abonnementFlore = _.get(saisie.listAbonnements, 'FLORE');
                  saisie.hasFlore = angular.isDefined(vm.abonnementFlore);
                  if ((anyOption || angular.isDefined(vm.abonnementFlore)) && saisie.steps.length === 6) {
                    saisie.steps.splice(4, 0, {
                      libelle: 'Mes options',
                      state: 'abonnement.options',
                      isCompleted: function () {
                        return angular.isDefined(saisie.activeAbonnement) &&
                        angular.isDefined(saisie.activeAbonnement) &&
                        angular.isDefined(saisie.listAutorisationsAcces) &&
                        saisie.listAutorisationsAcces.length > 0 &&
                        (saisie.anyOptionEnabled === true || (saisie.hasFlore && saisie.isBovin));
                      }
                    });
                  }
                  saisie.infosExploitation = result;
                  saisie.infosAbonne = vm.nouvelAbonnement;
                  saisie.isBovin = undefined;
                  saisie.hasOptions = undefined;
                  saisie.listAutorisationsAcces = undefined;
                  saisie.anyOptionEnabled = undefined;
                  saisie.activeAbonnement = undefined;
                  saisie.ovin = undefined;
                  saisie.bovin = undefined;
                  $state.go('abonnement.offres', {saisie: saisie});
                });
              } else {
                var login = result.login;
                $mdDialog.show({
                  controller: 'DejaAbonneController',
                  controllerAs: 'ctrl',
                  bindToController: true,
                  templateUrl: 'app/nouvelAbonnement/informations/dejaAbonne/dejaAbonne.html',
                  locals: {
                    login: login
                  }
                });
              }
            }, function (error) {
              LoadingService.hide();
              ModalService.alert({
                template: error.data.message
              });
            });
          }, function (error) {
            LoadingService.hide();

            ErrorService.alert(error);
          });
        } else {
          ModalService.alert({
            template: "Votre département ne diffuse pas Pilot' Elevage. Merci de vous adresser à votre service identification."
          });
        }
      }
    };
  }
})();

(function () {
  angular
    .module('app')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('abonnement', {
        url: '/abonnement',
        templateUrl: 'app/nouvelAbonnement/main/main.html',
        controller: 'AbonnementMainController',
        controllerAs: 'ctrl',
        resolve: {
          saisie: [function () {
            return {};
          }],
          listeDpt: ['ContactService', function (ContactService) {
            return ContactService.getDepartements();
          }],
          versionBack: ['ParametresService', function (ParametresService) {
            return ParametresService.getVersion();
          }]
        },
        authenticated: false
      }).state('abonnement.informations', {
        url: '/informations?numExploitation&numSiren&numNumagrin&hideSiren',
        templateUrl: 'app/nouvelAbonnement/informations/informations.html',
        controller: 'AbonnementInformationsController',
        controllerAs: 'ctrl',
        authenticated: false
      }).state('abonnement.offres', {
        url: '/offres',
        templateUrl: 'app/nouvelAbonnement/offresPilotElevage/offresPilotElevage.html',
        controller: 'OffresPilotElevageController',
        controllerAs: 'ctrl',
        authenticated: false
      }).state('abonnement.autorisations', {
        url: '/autorisations',
        templateUrl: 'app/nouvelAbonnement/autorisationsAcces/autorisationsAcces.html',
        controller: 'AutorisationsAccesController',
        controllerAs: 'ctrl',
        authenticated: false,
        params: {
          saisie: null
      }
      }).state('abonnement.services', {
        url: '/services',
        templateUrl: 'app/nouvelAbonnement/services/services.html',
        controller: 'AbonnementServicesController',
        controllerAs: 'ctrl',
        authenticated: false
      }).state('abonnement.options', {
        url: '/options',
        templateUrl: 'app/nouvelAbonnement/options/options.html',
        controller: 'AbonnementOptionsController',
        controllerAs: 'ctrl',
        authenticated: false
      }).state('abonnement.facturation', {
        url: '/facturation',
        templateUrl: 'app/nouvelAbonnement/facturation/facturation.html',
        controller: 'FacturationController',
        controllerAs: 'ctrl',
        params: {
          saisie: null
        },
        authenticated: false
      }).state('abonnement.validation', {
        url: '/validation',
        templateUrl: 'app/nouvelAbonnement/validation/validation.html',
        controller: 'AbonnnementValidationController',
        controllerAs: 'ctrl',
        authenticated: false
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('PolitiqueConfidentialiteController', PolitiqueConfidentialiteController);

  /** @ngInject */
  function PolitiqueConfidentialiteController($state, UserService) {
    var vm = this;
    vm.isBovin = false;
    vm.isOvinCaprin = false;
    vm.login = UserService.get('login');
    if (angular.isDefined(vm.login)) {
      UserService.getListTypeAbonnement(vm.login).then(function (response) {
        var listAbonnements = response.listeTypeAbonnement;
        if (listAbonnements.indexOf("BOV") !== -1) {
          vm.isBovin = true;
        }
        if (listAbonnements.indexOf("OVCAP") !== -1) {
          vm.isOvinCaprin = true;
        }
      });
    }

    vm.goToHome = function () {
      if (vm.isBovin) {
        $state.go('app.eleveur.bovin.home');
      } else if (vm.isOvinCaprin) {
        $state.go('app.eleveur.woc.home');
      } else {
        $state.go('auth');
      }
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('PartenairesController', PartenairesController);

  /** @ngInject */
  function PartenairesController($state, UserService, LISTEPARTENAIRES) {
    var vm = this;
    vm.listePatenaires = LISTEPARTENAIRES;
    vm.isBovin = false;
    vm.isOvinCaprin = false;
    vm.login = UserService.get('login');
    if (angular.isDefined(vm.login)) {
      UserService.getListTypeAbonnement(vm.login).then(function (response) {
        var listAbonnements = response.listeTypeAbonnement;
        if (listAbonnements.indexOf("BOV") !== -1) {
          vm.isBovin = true;
        }
        if (listAbonnements.indexOf("OVCAP") !== -1) {
          vm.isOvinCaprin = true;
        }
      });
    }

    vm.goToHome = function () {
      if (vm.isBovin) {
        $state.go('app.eleveur.bovin.home');
      } else if (vm.isOvinCaprin) {
        $state.go('app.eleveur.woc.home');
      } else {
        $state.go('auth');
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('MentionsLegalesController', MentionsLegalesController);

  /** @ngInject */
  function MentionsLegalesController($state, UserService) {
    var vm = this;
    vm.isBovin = false;
    vm.isOvinCaprin = false;
    vm.login = UserService.get('login');
    if (angular.isDefined(vm.login)) {
      UserService.getListTypeAbonnement(vm.login).then(function (response) {
        var listAbonnements = response.listeTypeAbonnement;
        if (listAbonnements.indexOf("BOV") !== -1) {
          vm.isBovin = true;
        }
        if (listAbonnements.indexOf("OVCAP") !== -1) {
          vm.isOvinCaprin = true;
        }
      });
    }

    vm.goToHome = function () {
      if (vm.isBovin) {
        $state.go('app.eleveur.bovin.home');
      } else if (vm.isOvinCaprin) {
        $state.go('app.eleveur.woc.home');
      } else {
        $state.go('auth');
      }
    };

  }
})();

(function () {
  angular
    .module('app')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('mentionsLegales', {
        url: '/mentionsLegales',
        templateUrl: 'app/footer/mentionsLegales/mentionsLegales.html',
        controller: 'MentionsLegalesController',
        controllerAs: 'ctrl',
        authenticated: false
      }).state('partenaires', {
        url: '/partenaires',
        templateUrl: 'app/footer/partenaires/partenaires.html',
        controller: 'PartenairesController',
        controllerAs: 'ctrl',
        authenticated: false
      }).state('politiqueConfidentialite', {
        url: '/politiqueConfidentialite',
        templateUrl: 'app/footer/politiqueConfidentialite/politiqueConfidentialite.html',
        controller: 'PolitiqueConfidentialiteController',
        controllerAs: 'ctrl',
        authenticated: false
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('EleveurMainController', EleveurMainController);

  /** @ngInject */
  function EleveurMainController($state, $window, AuthentService, CommandeAutoService, ErrorService, ExploitationService,
    FonctionnaliteService, LoadingService, ModalService, SessionService, UserService,
    gedFonctionnalite, mailFonctionnalite, parametresFonctionnalite, profil, versionBack, VERSION, AdminService, ASSISTANCE_FACTURATION, AutorisationAccesService) {
    var vm = this;
    vm.version = versionBack.version + " - " + VERSION;
    vm.responsableAssocie = false;
    vm.isAssistance = UserService.get('profilAssistance');

    vm.login = UserService.get('login');
    vm.loginKc = '';
    if (UserService.getEstKeyCloak() && UserService.get('mailLogin') && UserService.get('mailLogin') !== "") {
      vm.loginKc = UserService.get('mailLogin') + ' / ';
    }

    vm.assistanceFacturation = ASSISTANCE_FACTURATION;
    // préchargement de l'accès au portail facturation (réduire la latence)
    FonctionnaliteService.getFonctionnalite('ODOO').then(function (fonctionnalite) {
      vm.serviceOdoo = fonctionnalite;
    });

    vm.modalTemplate = 'Vos modifications n’ont pas été enregistrées, souhaitez-vous continuer et donc perdre vos saisies ?';
    setEstResponsable();
    UserService.getListTypeAbonnement(vm.login).then(function (response) {

      var listAbonnements = response.listeTypeAbonnement;
      var isBovin = false;
      var isOvinCaprin = false;
      if (listAbonnements.indexOf("BOV") !== -1) {
        isBovin = true;
      }
      if (listAbonnements.indexOf("OVCAP") !== -1) {
        isOvinCaprin = true;
      }
      if (isBovin) {
        if (isOvinCaprin) {
          vm.typeAbo = 'typeBovinEtOvCap';
        } else {
          vm.typeAbo = 'typeBovin';
        }
      } else if (isOvinCaprin) {
        vm.typeAbo = 'typeOvCap';
        vm.isHidden = true;
      }
    });
    vm.exploitationActive = UserService.get('exploitationActive');

    if (_.isEqual($state.current.name, 'app.eleveur.woc.home')) {
      vm.onglet = "woc";
      vm.isHidden = true;
    } else {
      vm.onglet = "bov";
      vm.isHidden = false;
    }

    function goToFonctionnalite(fonctionnalite) {
      LoadingService.show();
      FonctionnaliteService.goToFonctionnalite(fonctionnalite, {
        newPage: true
      }).catch(function (error) {
        ErrorService.alert(error);
      }).finally(function () {
        LoadingService.hide();
      });
    }

    vm.goToCompte = function () {
      if (AdminService.hasChanges()) {
        ModalService.confirm({template: vm.modalTemplate}).then(function () {
          AdminService.setHasChanges(false);
          goToCompteFunction();
        }, function () { });
      } else {
        goToCompteFunction();
      }
    };
    function goToCompteFunction() {
      if (_.isEqual($state.current.name, 'app.eleveur.compte.compte')) {
        $state.reload();
      } else if (_.isEqual($state.current.name, 'app.eleveur.woc.home')) {
        $state.go('app.eleveur.compte', {
          bov: 'false'
        });
      } else {
        $state.go('app.eleveur.compte');
      }
    }

    vm.goToEspaceFacturation = function () {
      // si profil responsable responsable/associé - ouverture odoo dans nouvel onglet
      if (UserService.get('mailLogin') === UserService.getEmailResponsableAssocieFacturation()) {
        FonctionnaliteService.goToFonctionnalite(vm.serviceOdoo, {
          menu: false,
          newPage: true
        }).catch(function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });
      } else { // sinon modale (avec responsable) avec redirection possible vers les autorisations d'accès
        vm.showButton = false;
        AutorisationAccesService.getCurrentAutorisationAcces().then(function (result) {
          if (angular.equals(result.profil.libelle, 'Responsable/associé Facturation') === true || angular.equals(result.profil.libelle, 'Responsable/associé') === true) {
            vm.showButton = true;
           }

          ModalService.popupAccesFacturationNonDisponible(UserService.getEmailResponsableAssocieFacturation(), vm.showButton).then(function () {
            $state.go('app.eleveur.compte.compte', {
                onglet: 'autorisations d\'accès'
            });
          });
        });

      }
    };

    // Lien application
    vm.goToLienApplication = function () {
      if (AdminService.hasChanges()) {
        ModalService.confirm({template: vm.modalTemplate}).then(function () {
          AdminService.setHasChanges(false);
          $state.go('app.eleveur.lienApplication');
        }, function () { });
      } else {
        $state.go('app.eleveur.lienApplication');
      }
    };

    vm.goToChangeMdp = function () {
      if (AdminService.hasChanges()) {
        ModalService.confirm({template: vm.modalTemplate}).then(function () {
          AdminService.setHasChanges(false);
          $state.go('app.eleveur.changeMdp');
        }, function () { });
      } else {
        $state.go('app.eleveur.changeMdp');
      }
    };

    vm.goToMentionLegales = function () {
      if (AdminService.hasChanges()) {
        ModalService.confirm({template: vm.modalTemplate}).then(function () {
          AdminService.setHasChanges(false);
          var url = $state.href('mentionsLegales');
          $window.open(url, '_blank');
        }, function () { });
      } else {
        var url = $state.href('mentionsLegales');
        $window.open(url, '_blank');
      }
    };

    vm.goToPolitiqueConfidentialite = function () {
      if (AdminService.hasChanges()) {
        ModalService.confirm({template: vm.modalTemplate}).then(function () {
          AdminService.setHasChanges(false);
          var url = $state.href('politiqueConfidentialite');
          $window.open(url, '_blank');
        }, function () { });
      } else {
        var url = $state.href('politiqueConfidentialite');
        $window.open(url, '_blank');
      }
    };

    vm.goToPartenaire = function () {
      if (AdminService.hasChanges()) {
        ModalService.confirm({template: vm.modalTemplate}).then(function () {
          AdminService.setHasChanges(false);
          $state.go('partenaires');
        }, function () { });
      } else {
        $state.go('partenaires');
      }
    };

    // GED
    vm.goToGed = function () {
      if (AdminService.hasChanges()) {
        ModalService.confirm({template: vm.modalTemplate}).then(function () {
          AdminService.setHasChanges(false);
          goToFonctionnalite(gedFonctionnalite);
        }, function () { });
      } else {
        goToFonctionnalite(gedFonctionnalite);
      }
    };

    // MAIL
    vm.goToMail = function () {
      if (AdminService.hasChanges()) {
        ModalService.confirm({template: vm.modalTemplate}).then(function () {
          AdminService.setHasChanges(false);
          goToFonctionnalite(mailFonctionnalite);
        }, function () { });
      } else {
        goToFonctionnalite(mailFonctionnalite);
      }
    };

    // Paramètre
    vm.goToParametres = function () {
      if (AdminService.hasChanges()) {
        ModalService.confirm({template: vm.modalTemplate}).then(function () {
          AdminService.setHasChanges(false);
          goToFonctionnalite(parametresFonctionnalite);
        }, function () { });
      } else {
        goToFonctionnalite(parametresFonctionnalite);
      }
    };

    // User
    vm.isMultiExploitation = function () {
      return UserService.isMultiExploitation();
    };

    vm.isMultiProfil = function () {
      return UserService.isMultiProfil();
    };

    vm.goToSelectionProfil = function () {
      $state.go('selectionProfil');
    };

    vm.goToSelectionExploitation = function () {
      if (AdminService.hasChanges()) {
        ModalService.confirm({template: vm.modalTemplate}).then(function () {
          AdminService.setHasChanges(false);
          goToSelectionExploitationFunction();
        }, function () { });
      } else {
        goToSelectionExploitationFunction();
      }
    };
    function goToSelectionExploitationFunction() {
      if (UserService.get('profil') === 'TECHNICIEN' && UserService.get('profilAssistance')) {
        $state.go('app.selectioncheptel');
      } else {
        LoadingService.show();

        ExploitationService.goToSelectionExploitation(null).then(function (token) {
          SessionService.setCredentials({
            token: token
          });
        }, function (error) {
          if (error) {
            ErrorService.alert(error);
          }
        });
      }
    }
    vm.changeTypeAbo = function (type) {
      if (AdminService.hasChanges()) {
        ModalService.confirm({template: vm.modalTemplate}).then(function () {
          AdminService.setHasChanges(false);
          changeTypeAboFunction(type);
        }, function () { });
      } else {
        changeTypeAboFunction(type);
      }
    };
    function changeTypeAboFunction(type) {
      if (_.isEqual(type, 'ovcap')) {
        vm.isHidden = true;
        vm.onglet = "woc";
        $state.go('app.eleveur.woc.home');
      } else {
        vm.onglet = "bov";
        vm.isHidden = false;
        $state.go('app.eleveur.bovin.home');
      }
    }

    vm.goToHome = function () {
      var path = '';
      if (vm.isHidden) {
        path = 'app.eleveur.woc.home';
      } else {
        path = 'app.eleveur.bovin.home';
      }
      if (AdminService.hasChanges()) {
        ModalService.confirm({template: vm.modalTemplate}).then(function () {
          AdminService.setHasChanges(false);
          $state.go(path);
        }, function () { });
      } else {
        $state.go(path);
      }
    };

    vm.logout = function () {
      if (AdminService.hasChanges()) {
        ModalService.confirm({template: vm.modalTemplate}).then(function () {
          AdminService.setHasChanges(false);
          AuthentService.logout();
        }, function () { });
      } else {
        AuthentService.logout();
      }
    };

    function setEstResponsable() {
      AutorisationAccesService.getCurrentAutorisationAcces().then(function (result) {
        if (result.profil.libelle === "Responsable/associé Facturation" || result.profil.libelle === "Responsable/associé") {
          vm.responsableAssocie = true;
        } else {
          vm.responsableAssocie = false;
        }
      }, function (error) {
        if (error) {
          vm.responsableAssocie = false;
        }
      });
    }
  }
})();

(function () {
    'use strict';

    angular
      .module('app')
      .controller('EleveurLienCommandesIAController', EleveurLienCommandesIAController);

    /** @ngInject */
    function EleveurLienCommandesIAController($state, LienCommandesIAService, ErrorService, LoadingService, $http, FonctionnaliteService, BACKEND, ModalService) {
        var vm = this;
        // récupération des sites de commandes IA à partir du type d'application ('COMMANDES_IA')
        // remarque : jusqu'ici on n'a pas eu ce type de cas de figure, donc pour éviter trop d'impacts back/front, on se sert au mieux du modèle pour contourner le souci

        // récupération des services de commandes IA
        LienCommandesIAService.getServicesIA().then(function (services) {
          vm.services = services;
        }, function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });

        // accès au portail idoine
        vm.goToCommandesIA = function (codeService) {
          // récupération de l'accès pour le service sélectionné
          var url = BACKEND.url + '/services/' + codeService;
//          $log.log(url);
          $http.get(url).then(function (response) {
//            $log.log(response.data);

            // pas d'url pour Gènes Diffusion... et aucun moyen de faire autrement dans l'immédiat
            if (codeService === 'COMMANDES_IA_GENES_DIFFUSION' && (angular.isUndefined(response.data.acces.url) || _.isEmpty(response.data.acces.url))) {
              ModalService.alert({
                template: "Demande d’IA disponible uniquement via l’application mobile."
              });
            } else {
              FonctionnaliteService.goToFonctionnalite(response.data, {
                menu: false,
                newPage: true
              }).catch(function (error) {
                ErrorService.alert(error);
              }).finally(function () {
              LoadingService.hide();
              });
            }
          });
        };

        // retour accueil
        vm.goToHome = function () {
          if (vm.isHidden) {
            $state.go('app.eleveur.woc.home');
          } else {
            $state.go('app.eleveur.bovin.home');
          }
        };
    }
})();

(function () {
    'use strict';

    angular
      .module('app')
      .controller('EleveurLienBgtaController', EleveurLienBgtaController);

    /** @ngInject */
    function EleveurLienBgtaController($state, $http, fonctionnalite, LoadingService, LienBgtaService, FonctionnaliteService, ErrorService, BACKEND) {
        var vm = this;
        LienBgtaService.getListRaces().then(function (races) {
          vm.items = races;
        }, function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });
        // accès portail bgta
        vm.goToBGTA = function (codeRace) {
          // gestion spécifique pour code race (pallier au problème de l'url par code race)
          var url = BACKEND.url + '/races/preferenceBgta/' + codeRace;
          $http.patch(url).then(function () {

            FonctionnaliteService.goToFonctionnalite(fonctionnalite, {
              menu: false
            }).catch(function (error) {
              ErrorService.alert(error);
            }).finally(function () {
            LoadingService.hide();
            });
          });
        };
        // retour accueil
        vm.goToHome = function () {
          if (vm.isHidden) {
            $state.go('app.eleveur.woc.home');
          } else {
            $state.go('app.eleveur.bovin.home');
          }
        };
    }
})();

(function () {
    'use strict';

    angular
      .module('app')
      .controller('LienApplicationController', LienApplicationController);

    /** @ngInject */
    function LienApplicationController($state, $filter, $window, $document, CompteService, UserService, ErrorService, departements, LienApplicationService, EnvoiSmsService, ModalService, LoadingService) {
      var vm = this;
      vm.isMobile = $window.innerWidth <= 800;
      vm.listeTypeTel = [
        {
          value: "Android",
          code: "android"
        },
        {
          value: "Apple",
          code: "ios"
        }
      ];

     if (navigator.platform.match(/iPhone|iPod|iPad|Android/) || navigator.userAgent.match(/Android/)) {
      $document[0].getElementById("mainMdToolBar").style.display = "none";
      angular.element($document[0].querySelector("#divPrincipale")).removeClass("divPrincipale");
    } else {
      $document[0].getElementById("lienApplicationToolBar").style.display = "none";
      angular.element($document[0].querySelector("#divPrincipale")).addClass("divPrincipale");
    }

      vm.typeMobile = undefined;
      vm.numeroEleveur = '';
      vm.login = UserService.get('login');

      vm.goToHome = function () {
        if (vm.isHidden) {
          $state.go('app.eleveur.woc.home');
        } else {
          $state.go('app.eleveur.bovin.home');
        }
        $document[0].getElementById("mainMdToolBar").style.display = "block";
        $document[0].getElementById("lienApplicationToolBar").style.display = "none";
      };

      CompteService.getInfosContact(vm.login, UserService.getNumeroExploitation())
      .then(function (profil) {
        vm.numeroEleveur = profil.telMobile;
      }, function (error) {
        ErrorService.alert(error);
      });
      vm.sendSms = function () {
        LoadingService.show();
        EnvoiSmsService.envoiSms(UserService.getNumeroExploitation(), vm.numeroEleveur, vm.typeMobile.code).then(function () {
          LoadingService.hide();
          ModalService.alert({
            template: "Un SMS avec le lien de téléchargement de l'application Pilot'Elevage Mobile va vous être envoyé",
            title: "Confirmation"
          }).then(function () {
            vm.goToHome();
          });
        }, function (error) {
          ErrorService.alert(error);
          LoadingService.hide();
        });
      };
    }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('EleveurFonctionnaliteController', EleveurFonctionnaliteController);

  /** @ngInject */
  function EleveurFonctionnaliteController($filter, $sce, $stateParams, FonctionnaliteService, fonctionnalite) {
    var vm = this;

    // Fonctionnalite
    vm.acces = fonctionnalite.acces;

    vm.trustAsResourceUrl = function (src) {
      return $sce.trustAsResourceUrl(src);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ChangeMdpController', ChangeMdpController);

  /** @ngInject */
  function ChangeMdpController($state, ChangeMdpService, ErrorService, LoadingService, ModalService, UserService) {

    var vm = this;

    vm.showPassword = false;
    vm.estKeycloak = UserService.getEstKeyCloak();
    vm.infosUtilisateur = {
      login: UserService.get('login'),
      mailLogin: UserService.get('mailLogin'),
      numExploitation: UserService.getNumeroExploitation(),
      mdpActuel: undefined,
      mdpNouveau: undefined
    };

    vm.goHome = function () {
      LoadingService.show();
      UserService.getListTypeAbonnement(vm.infosUtilisateur.login).then(function (response) {
        LoadingService.hide();
        var estBovin = _.find(response.listeTypeAbonnement, function (typeAbonnement) {
          return typeAbonnement === "BOV";
        });
        if (estBovin) {
          $state.go('app.eleveur.bovin.home', {}, {reload: true});
        } else {
          $state.go('app.eleveur.woc.home', {}, {reload: true});
        }
      });
    };

    vm.changeMdp = function () {
      LoadingService.show();
      if (vm.changeMdpForm.$valid) {
        if (vm.infosUtilisateur.mdpNouveau === vm.infosUtilisateur.mdpConfirmNouveau) {
          ChangeMdpService.changePassword(vm.infosUtilisateur).then(function () {
            LoadingService.hide();
            ModalService.alert({
              template: "Votre mot de passe a été modifié."
            }).then(function () {
              vm.goHome();
            });
          }, function (error) {
            if (vm.infosUtilisateur.mdpNouveau === vm.infosUtilisateur.mdpActuel) {
              dialog('Le nouveau mot de passe doit être différent du mot de passe actuel.');
            } else if (vm.infosUtilisateur.mdpNouveau === vm.infosUtilisateur.login) {
              dialog("Le nouveau mot de passe doit être différent de l'identifiant.");
            } else if (angular.isDefined(_.get(error, 'status')) && _.get(error, 'status') === 403) {
              dialog(_.get(error, 'data.message'));
            } else {
              dialog('Ce mot de passe est incorrect.');
            }
          });
        } else {
          dialog('La confirmation du mot de passe ne correspond pas au nouveau mot de passe saisi.');
        }
      }
    };

    vm.showpassword = function () {
      vm.showPassword = !vm.showPassword;
    };

    function dialog(text) {
      ModalService.alert({
        template: text
      });
      LoadingService.hide();
    }
  }
})();

(function () {
  angular
    .module('app')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('app.eleveur', {
        url: 'eleveur',
        templateUrl: 'app/eleveur/main/main.html',
        controller: 'EleveurMainController',
        controllerAs: 'ctrl',
        resolve: {
          parametres: ['ParametresService', function (ParametresService) {
            return ParametresService.load();
          }],
          parametresFonctionnalite: ['FonctionnaliteService', function (FonctionnaliteService) {
            return FonctionnaliteService.getFonctionnalite('PARAM_GENERAL');
          }],
          gedFonctionnalite: ['FonctionnaliteService', function (FonctionnaliteService) {
            return FonctionnaliteService.getFonctionnalite('MENU_GED');
          }],
          mailFonctionnalite: ['FonctionnaliteService', function (FonctionnaliteService) {
            return FonctionnaliteService.getFonctionnalite('MESSAGERIE');
          }]
        }
      })
      .state('app.eleveur.changeMdp', {
        url: '/change-mot-de-passe',
        templateUrl: 'app/eleveur/changeMdp/changeMdp.html',
        controller: 'ChangeMdpController',
        controllerAs: 'ctrl'
      });
  }
})();

(function () {
  'use-strict';

  angular
    .module('app')
    .controller('GuideAbonnementController', GuideAbonnementController);

  /* @ngInject */
  function GuideAbonnementController($mdDialog) {
    var vm = this;

    vm.cancel = function () {
      $mdDialog.cancel();
    };
  }
})();

(function () {
  /**
   * Service métier d'authentification
   * @constructor
   */

  angular
    .module('app').factory('IncitationCreationCompteKcService', IncitationCreationCompteKcService);

  /* @ngInject */
  function IncitationCreationCompteKcService($http, $q, BACKEND) {
    var service = {
      getAfficherAlerte: getAfficherAlerte
    };

    return service;

    function getAfficherAlerte(username, password) {
      return $q(function (resolve, reject) {
        $http.post(BACKEND.url + '/incitation-kc/afficher-alerte', {
          username: username,
          password: password
        }).then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }
  }
})();

(function () {
  /**
   * Service métier d'authentification
   * @constructor
   */

  angular
    .module('app').factory('ContactService', ContactService);

  /* @ngInject */
  function ContactService($http, $q, BACKEND) {
    var service = {
      getDepartements: getDepartements,
      sendMessage: sendMessage
    };

    return service;

    function getDepartements() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/departements').then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function sendMessage(message) {
      return $q(function (resolve, reject) {
        var messageF = _.omitBy(message, _.isEmpty);

        if (angular.isDefined(messageF.departementRattachement)) {
          messageF.codeDepartementRattachement = messageF.departementRattachement.code;
          delete messageF.departementRattachement;
        }

        $http.post(BACKEND.url + '/mails', messageF).then(resolve, reject);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminPartenairesController', AdminPartenairesController);

  /** @ngInject */
  function AdminPartenairesController(LISTEPARTENAIRES) {

    var vm = this;

    vm.listePatenaires = LISTEPARTENAIRES;
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminMulticheptelsController', AdminMulticheptelsController);

  /** @ngInject */
  function AdminMulticheptelsController($filter, $mdDialog, exploitation, AdminClotureAbonnementService, LoadingService, ModalService, MulticheptelService) {
    var vm = this;

    vm.listExploitations = [];
    vm.afficheListExploitations = false;

    vm.exploitationInconnue = false;

    vm.loadListExploitations = function () {
      LoadingService.show();
      AdminClotureAbonnementService.getListAbonnements(exploitation)
        .then(function (result) {
          vm.exploitation = result[0];
          if (vm.exploitation) {
            vm.infoIdentifiant = vm.exploitation.identifiant;
            vm.infoNumExploitation = vm.exploitation.numExploitation;
            // récupération de la liste des exploitations déjà rattachées
            AdminClotureAbonnementService.getListAbonnementsByEleveur(vm.infoIdentifiant)
              .then(function (result) {
                vm.numSiren = result.eleveurOrganismeAbonnements[0].eleveurAbonnementExploitations[0].exploitation.numSiren;
                vm.numAgrin = result.eleveurOrganismeAbonnements[0].eleveurAbonnementExploitations[0].exploitation.numAgrin;
                vm.profil = result.profil;
                vm.numDetenteur = result.eleveurOrganismeAbonnements[0].eleveurAbonnementExploitations[0].exploitation.numDetenteur;
                vm.raisonSociale = result.eleveurOrganismeAbonnements[0].eleveurAbonnementExploitations[0].exploitation.raisonSociale;
                MulticheptelService.getMulticheptels(vm.infoIdentifiant)
                  .then(function (result) {
                    vm.listExploitations = result;
                    vm.afficheListExploitations = true;
                    vm.numExploitation = null;
                    vm.identifiant = null;
                    vm.authentForm.$setPristine();
                    vm.authentForm.$setUntouched();
                    LoadingService.hide();
                  }, function () {
                    LoadingService.hide();
                  });
              }, function () {
                LoadingService.hide();
              });
          } else {
            vm.afficheListExploitations = false;
            vm.exploitationInconnue = true;
            LoadingService.hide();
          }
        }, function () {
          LoadingService.hide();
        });
    };

    vm.openListExploitations = function () {
      vm.listExploitations = [];
      exploitation.numExploitation = vm.numExploitation;
      exploitation.identifiant = vm.identifiant;

      if (vm.authentForm.$valid) {
        vm.afficheListExploitations = false;
        vm.exploitationInconnue = false;
        vm.loadListExploitations();
      }
    };

    vm.suppressionExploitation = function (exploitation) {
      ModalService.confirm({
        template: 'Souhaitez-vous supprimer le rapprochement entre l\'exploitation ' + vm.infoNumExploitation + ' et l\'exploitation ' + exploitation.numExploitation + ' ?'
      }).then(function () {
        LoadingService.show();
        MulticheptelService.supprimerRapprochement(exploitation.login)
          .then(function () {
            vm.loadListExploitations();
          }).finally(function () {
            LoadingService.hide();
          });
      });
    };

    vm.openMulticheptels = function () {
      $mdDialog.show({
        controller: 'AdminSelectionExploitationController',
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'app/admin/multicheptels/_common/selectionExploitation/selectionExploitation.html',
        locals: {
          idExploitationOrigine: vm.infoIdentifiant
        }
      }).then(function () {
        vm.loadListExploitations();
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminMentionsLegalesController', AdminMentionsLegalesController);

  /** @ngInject */
  function AdminMentionsLegalesController() {

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminMainController', AdminMainController);

  /** @ngInject */
  function AdminMainController($scope, $state, ModalService, gedFonctionnalite, AuthentService, ErrorService,
      AdminFonctionnaliteService, LoadingService, versionBack, VERSION, AdminService, UserService,
      HabilitationsService) {

    var vm = this;
    vm.isOpen = true;
    vm.isOpenMenuTechniciens = true;
    vm.displayModalMenu = false;

    vm.version = versionBack.version + " - " + VERSION;

    vm.menus = [
      {
        libelle: "Gestion des abonnements",
        path: "app.admin.gestionAbonnement.selection"
      },
      {
        libelle: "Résilier / Clôturer",
        path: "app.admin.clotureAbonnement"
      },
      {
        libelle: "Gestion des autorisations d'accès",
        path: "app.admin.gestionAssocies"
      },
      {
        libelle: "Multicheptels",
        path: "app.admin.multicheptels"
      }
    ];

    vm.menuTechniciens = [
      {
        libelle: "Gestion des techniciens",
        path: "app.admin.techniciens.gestion"
      },
      {
        libelle: "Création d'un technicien",
        path: "app.admin.techniciens.creation"
      }
    ];

    vm.logout = function () {
      AuthentService.logout();
    };

    vm.ouvreSousMenu = function () {
      vm.isOpen = !vm.isOpen;
    };

    // GED
    vm.goToGed = function () {
      LoadingService.show();

      AdminFonctionnaliteService.goToFonctionnalite(gedFonctionnalite).catch(function (error) {
        ErrorService.alert(error);
      }).finally(function () {
        LoadingService.hide();
      });
    };

    vm.isActive = function (path) {
      return $state.current.name === path;
    };

    vm.isMultiProfil = function () {
      return UserService.isMultiProfil();
    };

    // Vérifie si l'utilisateur a l'habilitation "W_API_MODALES"
    HabilitationsService.hasGestionModaleHabilitation().then(function (hasAccess) {
      vm.displayModalMenu = hasAccess;
    });

    vm.goToSelectionProfil = function () {
      $state.go('selectionProfil');
    };

    vm.goTo = function (path) {
      if (AdminService.hasChanges() && path !== $state.current.name) {
        ModalService.confirm({
          template: "Vos modifications n’ont pas été enregistrées, souhaitez-vous continuer et donc perdre vos saisies ?",
          cancelText: 'Non',
          okText: 'Oui'
        }).then(function () {
          AdminService.setHasChanges(false);
          $state.go(path);
        }, function () { });
      } else {
        $state.go(path);
      }
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminHomeController', AdminHomeController);

  /** @ngInject */
  function AdminHomeController($state) {

    $state.go('app.admin.gestionAbonnement');

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminFonctionnaliteController', AdminFonctionnaliteController);

  /** @ngInject */
  function AdminFonctionnaliteController($filter, $sce, $stateParams, fonctionnalite) {
    var vm = this;

    // Fonctionnalite
    vm.acces = fonctionnalite.acces;

    vm.trustAsResourceUrl = function (src) {
      return $sce.trustAsResourceUrl(src);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminCreationCompteController', AdminCreationCompteController);

  /** @ngInject */
  function AdminCreationCompteController(ModalService, ReferentielService) {

    var vm = this;

    vm.indicateursProfils = ReferentielService.getIndicateursProfils();

    vm.listeOrganismes = [
      {
        libelle: "AIAM",
        estDisponible: true
      },
      {
        libelle: "ARICH",
        estDisponible: true
      },
      {
        libelle: "EDE14",
        estDisponible: true
      },
      {
        libelle: "AICC",
        estDisponible: false
      }
    ];

    vm.userSite = '';
    vm.listSites = [
      {
        libelle: "AIAM",
        estDisponible: true
      },
      {
        libelle: "ARICH",
        estDisponible: true
      },
      {
        libelle: "EDE14",
        estDisponible: true
      },
      {
        libelle: "AICC",
        estDisponible: false
      }
    ];

    vm.listeOrganismesDispo = [];
    vm.listeOrganismesSelectionnes = [];

    angular.forEach(vm.listeOrganismes, function (organisme) {
      if (organisme.estDisponible === true) {
        vm.listeOrganismesDispo.push(organisme);
      } else {
        vm.listeOrganismesSelectionnes.push(organisme);
      }
    });

    vm.changeProfil = function (indicateur) {
      vm.code = indicateur.code;
      vm.activeProfil = indicateur;
    };

    vm.changeDispo = function (organisme) {
      vm.listeOrganismesDispo = [];
      vm.listeOrganismesSelectionnes = [];
      organisme.estDisponible = !organisme.estDisponible;
      angular.forEach(vm.listeOrganismes, function (organisme) {
        if (organisme.estDisponible === true) {
          vm.listeOrganismesDispo.push(organisme);
        } else {
          vm.listeOrganismesSelectionnes.push(organisme);
        }
      });
    };

    vm.valideCreationCompte = function () {
      if (vm.creationCompteForm.$valid && vm.activeProfil) {
        if (vm.compte.email !== vm.compte.confirmEmail) {
          ModalService.alert({
            template: "La confirmation de l’e-mail ne correspond pas à l’e-mail initialement saisi."
          });
        } else if (vm.activeProfil.code === 'A' && vm.listeOrganismesSelectionnes.length === 0) {
          ModalService.alert({
            template: "La sélection d’un organisme de rattachement est obligatoire pour un profil de type Assistance."
          });
        } else {

        }
      }
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminCommunicationController', AdminCommunicationController);

  /** @ngInject */
  function AdminCommunicationController(AdminCommunicationService, ErrorService, LoadingService, ModalService, communication) {
    var vm = this;

    vm.communication = communication || {};

    vm.niveaux = [
      {
        code: 'Faible',
        libelle: 'Faible'
      },
      {
        code: 'Moyen',
        libelle: 'Moyen'
      },
      {
        code: 'Haut',
        libelle: 'Haut'
      }
    ];

    vm.onSubmit = function () {
      if (vm.communicationForm.$valid) {
        LoadingService.show();

        AdminCommunicationService.save(vm.communication).then(function () {
          ModalService.alert({
            template: "La communication a bien été publiée."
          });
        }, function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AdminClotureAbonnementController', AdminClotureAbonnementController);

  /** @ngInject */
  function AdminClotureAbonnementController($filter, $mdDialog, $scope, $state, AdminClotureAbonnementService, ErrorService, LoadingService, ModalService, abonnement) {

    var vm = this;
    vm.listAbonnements = [];
    vm.afficheListAbonnements = false;

    vm.openListAbonnements = function () {
      vm.listAbonnements = [];
      abonnement.numExploitation = vm.numExploitation;
      abonnement.identifiant = vm.identifiant;

      if (vm.authentForm.$valid) {
        AdminClotureAbonnementService.getListAbonnements(abonnement)
          .then(function (result) {
            if (result.length > 0) {
              vm.infoIdentifiant = result[0].identifiant;
              vm.infoNumExploitation = result[0].numExploitation;
            }
            if (result.length > 0) {
              AdminClotureAbonnementService.getListAbonnementsByEleveur(vm.infoIdentifiant)
                .then(function (result) {
                  vm.numSiren = result.eleveurOrganismeAbonnements[0].eleveurAbonnementExploitations[0].exploitation.numSiren;
                  vm.numAgrin = result.eleveurOrganismeAbonnements[0].eleveurAbonnementExploitations[0].exploitation.numAgrin;
                  vm.profil = result.profil;
                  vm.numDetenteur = result.eleveurOrganismeAbonnements[0].eleveurAbonnementExploitations[0].exploitation.numDetenteur;
                  vm.raisonSociale = result.eleveurOrganismeAbonnements[0].eleveurAbonnementExploitations[0].exploitation.raisonSociale;
                  angular.forEach(result.eleveurOrganismeAbonnements, function (eleveurOrganismeAbonnement) {
                    if (!eleveurOrganismeAbonnement.finAbonnement) {
                      var diffDateFinEngagement = _.add(new Date(eleveurOrganismeAbonnement.debutAbonnement).getTime(), eleveurOrganismeAbonnement.organismeAbonnement.engagementMiniMois * (1000 * 3600 * 24 * 30.5));
                      var diffDateFinRetractation = _.add(new Date(eleveurOrganismeAbonnement.debutAbonnement).getTime(), eleveurOrganismeAbonnement.organismeAbonnement.retractationMaxJours * (1000 * 3600 * 24));
                      var dateFinRetractation = _.subtract(_.now(), diffDateFinRetractation);
                      var dateFinEngagementMini = _.subtract(_.now(), diffDateFinEngagement);
                      if (dateFinRetractation <= 0) {
                        vm.dateAvecRetractationDepassee = true;
                      }
                      if (dateFinEngagementMini <= 0) {
                        vm.dateAvecEngagementDepasse = true;
                      }
                      var abo = {};
                      abo.numExploitation = vm.infoNumExploitation;
                      abo.dateOuverture = eleveurOrganismeAbonnement.debutAbonnement;
                      abo.niveauAbonnement = eleveurOrganismeAbonnement.organismeAbonnement.abonnement.niveauAbonnement.libelle;
                      abo.typeAbonnement = eleveurOrganismeAbonnement.organismeAbonnement.abonnement.typeAbonnement.libelle;
                      abo.dateFinDifferee = eleveurOrganismeAbonnement.finDifferee;
                      abo.dateLimiteRetractation = $filter('date')(diffDateFinRetractation, 'dd/MM/yyyy');
                      abo.dateFinEngagement = $filter('date')(diffDateFinEngagement, 'dd/MM/yyyy');
                      abo.dureeRetractation = eleveurOrganismeAbonnement.organismeAbonnement.retractationMaxJours;
                      abo.finEngagement = eleveurOrganismeAbonnement.organismeAbonnement.engagementMiniMois;
                      abo.idEleveurAbonnementExploitation = eleveurOrganismeAbonnement.id;
                      vm.listAbonnements.push(abo);
                    }
                  });
                });
            }
          });

        vm.afficheListAbonnements = true;
      }
    };

    vm.suppressionAbonnement = function (abonnement) {
      $mdDialog.show({
        controller: 'ResiliationController',
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'app/admin/clotureAbonnement/_common/resiliation/resiliation.html',
        locals: {
          identifiant: vm.identifiant,
          numExploitation: vm.infoNumExploitation,
          abonnement: abonnement,
          abonnements: undefined,
          nbAbonnements: vm.listAbonnements.length
        }
      });
    };

    vm.clotureCompte = function () {
      $mdDialog.show({
        controller: 'ResiliationController',
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'app/admin/clotureAbonnement/_common/resiliation/resiliation.html',
        locals: {
          identifiant: vm.infoIdentifiant,
          numExploitation: vm.infoNumExploitation,
          abonnement: undefined,
          abonnements: vm.listAbonnements,
          nbAbonnements: vm.listAbonnements.length
        }
      });
    };

  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .service('AdminService', AdminService);

    /* @ngInject */
    function AdminService() {

        var _hasChanges = false;

        var service = {
            hasChanges: hasChanges,
            setHasChanges: setHasChanges
        };
        return service;

        function hasChanges() {
            return _hasChanges;
        }

        function setHasChanges(bool) {
            _hasChanges = bool;
        }
    }
})();

(function () {
  angular
    .module('app')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('app.admin', {
        url: 'admin',
        templateUrl: 'app/admin/main/main.html',
        controller: 'AdminMainController',
        controllerAs: 'ctrl',
        resolve: {
          gedFonctionnalite: ['AdminFonctionnaliteService', function (AdminFonctionnaliteService) {
            return AdminFonctionnaliteService.getFonctionnalite('MENU_GED');
          }]
        }
      })
      .state('app.admin.home', {
        url: '/home',
        templateUrl: 'app/admin/home/home.html',
        controller: 'AdminHomeController',
        controllerAs: 'ctrl'
      }).state('app.admin.communication', {
        url: '/communication',
        templateUrl: 'app/admin/communication/communication.html',
        controller: 'AdminCommunicationController',
        controllerAs: 'ctrl',
        resolve: {
          communication: ['AdminCommunicationService', function (AdminCommunicationService) {
            return AdminCommunicationService.get();
          }]
        }
      })
      .state('app.admin.gestionModales', {
        url: '/modales',
        templateUrl: 'app/admin/gestionModales/modalesList/modalesList.html',
        controller: 'AdminGestionModalesListController',
        controllerAs: 'ctrl',
        resolve: {
          hasAccess: function (AdminGestionModalesService) {
            return AdminGestionModalesService.checkAccess();
          }
        }
      })
      .state('app.admin.gestionModalesCreate', {
        url: '/modales/:mode?code',
        templateUrl: 'app/admin/gestionModales/creerModale/creerModale.html',
        controller: 'AdminGestionModalesCreerController',
        controllerAs: 'ctrl',
        resolve: {
          hasAccess: function (AdminGestionModalesService) {
            return AdminGestionModalesService.checkAccess();
          }
        }
      })
      .state('app.admin.creationCompte', {
        url: '/creation-compte',
        templateUrl: 'app/admin/creationCompte/creationCompte.html',
        controller: 'AdminCreationCompteController',
        controllerAs: 'ctrl'
      }).state('app.admin.clotureAbonnement', {
        url: '/cloture-abonnement',
        templateUrl: 'app/admin/clotureAbonnement/clotureAbonnement.html',
        controller: 'AdminClotureAbonnementController',
        controllerAs: 'ctrl',
        resolve: {
          abonnement: [function () {
            return {};
          }]
        }
      }).state('app.admin.gestionAssocies', {
        url: '/gestionAssocies',
        templateUrl: 'app/_common/partials/autorisationsAcces/autorisationsAcces.html',
        controller: 'AutorisationsAccesController',
        controllerAs: 'ctrl'
        /*        resolve: {
                  exploitation: [function () {
                    return {};
                  }]
                }*/
      }).state('app.admin.multicheptels', {
        url: '/multicheptels',
        templateUrl: 'app/admin/multicheptels/multicheptels.html',
        controller: 'AdminMulticheptelsController',
        controllerAs: 'ctrl',
        resolve: {
          exploitation: [function () {
            return {};
          }]
        }
      }).state('app.admin.mentionsLegales', {
        url: '/mentionsLegales',
        templateUrl: 'app/admin/mentionsLegales/mentionsLegales.html',
        controller: 'AdminMentionsLegalesController',
        controllerAs: 'ctrl'
      }).state('app.admin.partenaires', {
        url: '/partenaires',
        templateUrl: 'app/admin/partenaires/partenaires.html',
        controller: 'AdminPartenairesController',
        controllerAs: 'ctrl'
      }).state('app.admin.fonctionnalite', {
        url: '/fonctionnalite/:code',
        templateUrl: 'app/admin/fonctionnalite/fonctionnalite.html',
        controller: 'AdminFonctionnaliteController',
        controllerAs: 'ctrl',
        resolve: {
          fonctionnalite: ['$stateParams', 'AdminFonctionnaliteService', function ($stateParams, AdminFonctionnaliteService) {
            return AdminFonctionnaliteService.completeAcces($stateParams.code);
          }]
        }
      }).state('app.admin.techniciens', {
        url: '/techniciens',
        abstract: true,
        template: '<ui-view flex layout="column"></ui-view>'
      }).state('app.admin.techniciens.gestion', {
        url: '/gestion',
        templateUrl: 'app/admin/techniciens/gestion/gestion.html',
        controller: 'AdminTechniciensGestionController',
        controllerAs: 'ctrl'
      }).state('app.admin.techniciens.creation', {
        url: '/creation',
        templateUrl: 'app/admin/techniciens/creation/creation.html',
        controller: 'AdminTechniciensCreationController',
        controllerAs: 'ctrl'
      }).state('app.admin.techniciens.affectation', {
        url: '/affectation',
        templateUrl: 'app/admin/techniciens/affectation/affectation.html',
        controller: 'AdminTechniciensAffectationController',
        controllerAs: 'ctrl',
        params: {
          technicien: null
        },
        onEnter: ['$state', '$stateParams', function ($state, $stateParams) {
          if (!$stateParams.technicien) {
            $state.go('app.admin.techniciens.gestion');
          }
        }],
        resolve: {
          technicien: ['$stateParams', function ($stateParams) {
            return $stateParams.technicien;
          }],
          cheptelsAffectables: ['TechniciensService', 'UserService', 'profil', function (TechniciensService, UserService) {
            return TechniciensService.getCheptelsAffectables(UserService.get('deptRatt'));
          }],
          cheptelsAffectes: ['$stateParams', 'TechniciensService', 'technicien', function ($stateParams, TechniciensService, technicien) {
            if (technicien) {
              return TechniciensService.getCheptelsTechnicien($stateParams.technicien);
            }
          }]
        }
      });
  }
})();

angular.module('app')
    .factory('DateTools', function () {
        return {
            getDateToString: function (date) {
                if (!(date instanceof Date)) {
                    return '';
                }

                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');

                return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds;
            }
        };
    });

(function () {
  angular
    .module('app').factory('UtilisateurMigrationService', UtilisateurMigrationService);

  /* @ngInject */
  function UtilisateurMigrationService($http, $q, BACKEND) {
    var service = {
      getUserMigration: getUserMigration
    };

    return service;

    function getUserMigration(email) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/utilisateur-migration/',
          method: "GET",
          params: {
            email: email
          }
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }
  }
})();

(function () {
  angular
    .module('app').factory('UserService', UserService);

  /* @ngInject */
  function UserService($http, $q, BACKEND, MulticheptelService) {
    var service = {
      getProfil: getProfil,
      loadProfil: loadProfil,
      clean: clean,
      get: get,
      getExploitation: getExploitation,
      getNumeroExploitation: getNumeroExploitation,
      getEmailResponsableAssocieFacturation: getEmailResponsableAssocieFacturation,
      isMultiExploitation: isMultiExploitation,
      getExploitations: getExploitations,
      getListTypeAbonnement: getListTypeAbonnement,
      getTypeProfil: getTypeProfil,
      getEstKeyCloak: getEstKeyCloak,
      getMultiProfil: getMultiProfil,
      isMultiProfil: isMultiProfil,
      hasAutorisationTechnicien: hasAutorisationTechnicien
    };

    var exploitations;
    var profil;

    return service;

    function getProfil(token) {
      var config = {};
      if (angular.isDefined(token)) {
        config.headers = {
          Authorization: 'Bearer ' + token
        };
      }

      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/profil', config).then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function loadProfil() {
      return $q(function (resolve, reject) {
        getProfil().then(function (p) {
          profil = p;
            MulticheptelService.getMulticheptels(profil.login).then(function (e) {
              exploitations = e;
              resolve(profil);
            });
        }, function (error) {
          error.fatal = true;

          reject(error);
        });
      });
    }

    function clean() {
      profil = undefined;
      exploitations = undefined;
    }

    function get(key, defaultValue) {
      var value = _.get(profil, key);

      if (angular.isUndefined(value)) {
        value = defaultValue;
      }

      return value;
    }

    function getExploitation() {
      return get('exploitationActive');
    }

    function getEstKeyCloak() {
      return get('estKeycloak');
    }

    function getNumeroExploitation() {
      return get('exploitationActive.numExploitation');
    }

    function getEmailResponsableAssocieFacturation() {
      return get('exploitationActive.emailResponsableAssocieFacturation');
    }

    function isMultiExploitation() {
      return angular.isDefined(exploitations) && exploitations.length > 0;
    }

    function isMultiProfil() {
      return get('estMultiProfil');
    }

    function getExploitations() {
      return exploitations;
    }

    function getTypeProfil() {
      return profil;
    }

    function getListTypeAbonnement(identifiant) {

      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/eleveurs/' + identifiant + '/typeAbonnement').then(function (response) {
          resolve(response.data);
        }, reject).catch(function () {});
      });
    }

    function getMultiProfil() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/profils').then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function hasAutorisationTechnicien(login) {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/utilisateurs/' + login + '/has-autorisation-technicien').then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('TechniciensService', TechniciensService);

  /* @ngInject */
  function TechniciensService($http, $q, BACKEND) {

    var service = {
      getListeTechniciens: getListeTechniciens,
      supprimeTechnicien: supprimeTechnicien,
      verifTechnicienSSO: verifTechnicienSSO,
      creationTechnicien: creationTechnicien,
      getCheptelsTechnicien: getCheptelsTechnicien,
      getCheptelsAffectables: getCheptelsAffectables,
      ajoutCheptel: ajoutCheptel,
      supprimeCheptel: supprimeCheptel
    };

    return service;

    function getListeTechniciens() {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/technicien/',
          method: "GET"
        })
        .then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function supprimeTechnicien(technicien) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/technicien/' + technicien.login + '/supprimer',
          method: "DELETE"
        })
        .then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function verifTechnicienSSO(login) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/technicien/login_sso/' + login + '/verification',
          method: "GET"
        })
        .then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function creationTechnicien(technicien) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/technicien/' + technicien.login + '/creer',
          method: "POST",
          data: technicien
        })
        .then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function getCheptelsTechnicien(technicien) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/technicien/' + technicien.login + '/cheptelassocie',
          method: "GET"
        })
        .then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function getCheptelsAffectables(codeDepartement) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/departements/' + codeDepartement + '/cheptel',
          method: "GET"
        })
        .then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function ajoutCheptel(technicien, cheptel) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/technicien/' + technicien.login + '/cheptelassocie',
          method: "POST",
          data: cheptel
        })
        .then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function supprimeCheptel(technicien, cheptel) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/technicien/' + technicien.login + '/cheptelassocie/' + cheptel.numExploitation,
          method: "DELETE"
        })
        .then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .service('StatutRecouvrementService', StatutRecouvrementService);

    /* @ngInject */
    function StatutRecouvrementService($http, $q, BACKEND) {

        var service = {
            getEstSuspendus: getEstSuspendus
        };
        return service;

        function getEstSuspendus(numExploitation) {
            return $q(function (resolve, reject) {
                $http({
                    url: BACKEND.url + '/exploitations/' + numExploitation + '/suspendue',
                    method: "GET"
                })
                    .then(function (response) {
                        resolve(response.data);
                    }, reject);
            });
        }
    }
})();

(function () {
  /**
   * Service métier de gestion de la session utilisateur
   * @constructor
   */

  angular
    .module('app').factory('SessionService', SessionService);

  /* @ngInject */
  function SessionService(AdvSessionService, CookiesService, STORAGE) {
    var service = {
      setCredentials: setCredentials,
      getCredentials: getCredentials,
      isAuthenticated: isAuthenticated,
      clean: clean
    };

    return angular.extend(AdvSessionService, service);

    function setCredentials(credentials) {
      CookiesService.set(STORAGE.SESSION.CREDENTIALS, credentials);
    }

    function getCredentials() {
      return CookiesService.get(STORAGE.SESSION.CREDENTIALS);
    }

    function isAuthenticated() {
      return CookiesService.has(STORAGE.SESSION.CREDENTIALS);
    }

    function clean() {
      return CookiesService.remove(STORAGE.SESSION.CREDENTIALS);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('ReferentielService', ReferentielService);

  /* @ngInject */
  function ReferentielService($http, $q, BACKEND) {

    var referentiel = {};

    var service = {
      load: load,
      getAllIndicateursProfils: getAllIndicateursProfils,
      getIndicateursProfils: getIndicateursProfils,
      getTypeAbonnements: getTypeAbonnements,
      getPeriodicite: getPeriodicite,
      getNiveauxAbonnements: getNiveauxAbonnements,
      getSsoCookieSetterUrl: getSsoCookieSetterUrl,
      getProfilsAutorisationsAcces: getProfilsAutorisationsAcces,
      getDroitsAutorisationsAcces: getDroitsAutorisationsAcces,
      getRaisonsResiliations: getRaisonsResiliations,
      getRaisonsModifAnnulCommande: getRaisonsModifAnnulCommande,
      getReferentielsEntiers: getReferentielsEntiers
    };
    return service;

    function load() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/referentiels').then(function (response) {
          referentiel = response.data;
          resolve();
        }, function (error) {
          error.fatal = true;

          reject(error);
        });
      });
    }

    function getAllIndicateursProfils() {
      return [{
        code: '1',
        libelle: 'Assistance'
      }, {
        code: '2',
        libelle: 'Technicien'
      },
      {
        code: '3',
        libelle: 'Eleveur'
      }];
    }

    function getIndicateursProfils() {
      return [{
        code: '1',
        libelle: 'Assistance'
      }, {
        code: '2',
        libelle: 'Technicien'
      }];
    }

    function getNiveauxAbonnements() {
      return referentiel.niveauxAbonnements;
    }

    function getPeriodicite() {
      return referentiel.periodicites;
    }

    function getTypeAbonnements() {
      return referentiel.typesAbonnements;
    }

    function getSsoCookieSetterUrl() {
      return referentiel.ssoCookieSetterUrl;
    }

    function getProfilsAutorisationsAcces() {
      return referentiel.profilsAutorisationsAcces;
    }

    function getDroitsAutorisationsAcces() {
      return referentiel.droitsAutorisationsAcces;
    }

    function getRaisonsResiliations() {
      return referentiel.raisonsResiliations;
    }

    function getRaisonsModifAnnulCommande() {
      return referentiel.raisonsModifAnnulCommande;
    }

    function getReferentielsEntiers(code) {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/referentiels/entiers/' + code).then(function (response) {
          resolve(response.data);
        }, function (error) {
          error.fatal = true;

          reject(error);
        });
      });
    }
  }
})();

(function () {
  angular
    .module('app').factory('ParametresService', ParametresService);

  /* @ngInject */
  function ParametresService($http, $q, BACKEND) {
    var service = {
      load: load,
      get: get,
      getVersion: getVersion
    };

    var parametres;

    return service;

    function load() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/parametres').then(function (response) {
          resolve(response.data);
        }, function (error) {
          error.fatal = true;

          reject(error);
        });
      });
    }

    function getVersion() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/version').then(function (response) {
          resolve(response.data);
        }, function (error) {
          reject(error);
        });
      });
    }

    function get(key, defaultValue) {
      var value = _.get(parametres, key);

      if (angular.isUndefined(value)) {
        value = defaultValue;
      }

      return value;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .service('OrganismeMigrationService', OrganismeMigrationService);

    /* @ngInject */
    function OrganismeMigrationService($http, $q, BACKEND) {

        var service = {
            getOrganismeMigration: getOrganismeMigration
        };
        return service;

        function getOrganismeMigration() {
            return $q(function (resolve, reject) {
                $http({
                    url: BACKEND.url + '/organisme-migration/',
                    method: "GET"
                })
                .then(function (response) {
                    resolve(response.data);
                }, reject);
            });
        }
    }
})();

(function () {
    /**
     * Service métier de configuration de l'application
     * @constructor
     */

    angular
        .module('app').provider('OptionsService', OptionsService);

    function OptionsService() {
        var service = {
            load: load,
            $get: $get
        };

        var options = {};

        return service;

        function load(data) {
            angular.extend(options, data);
        }

        function $get() {
            return options;
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('MulticheptelService', MulticheptelService);

  /* @ngInject */
  function MulticheptelService($http, $q, BACKEND) {

    var service = {
      getMulticheptels: getMulticheptels,
      rapprocherCheptels: rapprocherCheptels,
      supprimerRapprochement: supprimerRapprochement
    };

    return service;

    function getMulticheptels(identifiant) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/multicheptels/identifiant/' + identifiant,
          method: "GET"
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function rapprocherCheptels(identifiant, exploitation) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/multicheptels/identifiant/' + identifiant,
          method: 'POST',
          data: exploitation
        }).then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function supprimerRapprochement(identifiant) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/multicheptels/identifiant/' + identifiant,
          method: 'DELETE'
        }).then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('LienCommandesIAService', LienCommandesIAService);

  /* @ngInject */
  function LienCommandesIAService($http, $q, BACKEND) {

    var service = {
      getServicesIA: getServicesIA
    };

    return service;

    function getServicesIA() {
      return $q(function (resolve, reject) {
        // récupération des codes services de commandes IA disponibles
        $http({
          url: BACKEND.url + '/services/application/COMMANDES_IA',
          method: "GET"
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }
  }
})();

(function () {
    'use strict';

    angular
      .module('app')
      .service('LienBgtaService', LienBgtaService);

    /* @ngInject */
    function LienBgtaService($http, $q, BACKEND) {

      var service = {
        getListRaces: getListRaces
      };

      return service;

      function getListRaces() {
        return $q(function (resolve, reject) {
          $http({
            url: BACKEND.url + '/races/',
            method: "GET"
          })
            .then(function (response) {
              resolve(response.data);
            }, reject);
        });
      }
    }
  })();

(function () {
    'use strict';

    angular
      .module('app')
      .service('LienApplicationService', LienApplicationService);

    /* @ngInject */
    function LienApplicationService($http, $q, BACKEND) {

      var service = {
        getListUrls: getListUrls
      };

      return service;

      function getListUrls(numeroExploitation) {
        return $q(function (resolve, reject) {
          $http({
            url: BACKEND.url + '/liensApplication/' + numeroExploitation,
            method: "GET"
          })
            .then(function (response) {
              resolve(response.data);
            }, reject);
        });
      }
    }
  })();

(function () {
  'use strict';

  angular
    .module('app')
    .service('JsonService', JsonService);

  /* @ngInject */
  function JsonService() {
    var service = {
      stringify: stringify,
      parse: parse
    };
    return service;

    function replacer(key, value) {
      var val = value;

      if (angular.isDate(value)) {
        val = value.toISOString();
      } else if (angular.isString(key) && (key.charAt(0) === '$') && (key.charAt(1) === '$')) {
        val = undefined;
      }

      return val;
    }

    function reviver(key, value) {
      var a;
      if (angular.isString(value)) {
        a = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
        if (a) {
          return new Date(Date.UTC(Number(a[1]), Number(a[2]) - 1, Number(a[3]), Number(a[4]), Number(a[5]), Number(a[6])));
        }
      }

      return value;
    }

    function stringify(data) {
      // eslint-disable-next-line
      return JSON.stringify(data, replacer);
    }

    function parse(data) {
      // eslint-disable-next-line
      return JSON.parse(data, reviver);
    }
  }
})();

(function () {
    'use strict';

    angular
      .module('app')
      .service('InformationService', InformationService);

    /* @ngInject */
    function InformationService($filter, $http, $q, ModalService, BACKEND) {
      var service = {
        displayNextModaleInformation: displayNextModaleInformation,
        getNextInformationModale: getNextInformationModale,
        showInformationModale: showInformationModale,
        signalerInformationModaleVue: signalerInformationModaleVue,
        getAllModaleConfigurations: getAllModaleConfigurations,
        getModaleConfiguration: getModaleConfiguration,
        createModaleConfiguration: createModaleConfiguration,
        deleteModaleConfiguration: deleteModaleConfiguration
      };
      return service;

      /**
       * récupérer et afficher la prochaine modale d'information le cas échéant
       */
      function displayNextModaleInformation() {
        return $q(function (resolve) {
            getNextInformationModale().then(function (informationModale) {
                showInformationModale(informationModale);
            }, resolve);
        });
      }

      /**
       * Récupérer la prochaine modale d'informations à afficher le cas échéant
       */
      function getNextInformationModale() {
        return $q(function (resolve, reject) {
            var now = $filter('date')(new Date(), 'yyyy-MM-ddTHH:mm:ss');
            $http.get(BACKEND.url + '/modales/next/' + now).then(function (response) {
              if (response.data === '') {
                reject();
              } else {
                resolve(response.data);
              }
            }, reject);
          });
      }

      /**
       * Présenter la modale
       */
      function showInformationModale(informationModale) {
        ModalService.popupInformation(informationModale);
      }

      /**
       * indiquer que la modale a été vue
       */
      function signalerInformationModaleVue(informationModale) {
        return $q(function (resolve, reject) {
            var now = $filter('date')(new Date(), 'yyyy-MM-ddTHH:mm:ss');
            $http.patch(BACKEND.url + '/modales/view/' + informationModale.code + '/' + now).then(function (response) {
              resolve(response.data);
            }, reject);
          });
      }

      /**
       *
  [
    {
        "code": "MODALE_1",
        "dateCreation": "2024-01-23T12:16:29.26158",
        "periodes": [
            {
                "debut": "2024-01-24T00:00:00",
                "fin": "2024-02-05T23:59:59"
            }
        ]
    },
    ...
  ]

       *
       * @returns La liste des modales actuelles et leur configuration
       */
      function getAllModaleConfigurations() {
        return $q(function (resolve, reject) {
            $http.get(BACKEND.url + '/modales/all').then(function (response) {
              resolve(response.data);
          }, reject);
        });
      }

      /**
       *
       * @returns La configuration d'une modale d'après son code
       */
      function getModaleConfiguration(codeModale) {
        return $q(function (resolve, reject) {
            $http.get(BACKEND.url + '/modales/' + codeModale).then(function (response) {
              resolve(response.data);
          }, reject);
        });
      }

      /**
       * Création d'une nouvelle modale.
       *
       * @param {*} configurationModale
       * @returns
       */
      function createModaleConfiguration(configurationModale) {
        return $q(function (resolve, reject) {
            $http.put(BACKEND.url + '/modales/creation', configurationModale).then(function (response) {
              resolve(response.data);
          }, reject);
        });
      }

      /**
       * Suppression de la modale indiquée.
       *
       * @param {*} codeModale
       * @param {*} forcerSuppression
       * @returns
       */
      function deleteModaleConfiguration(codeModale, forcerSuppression) {
        return $q(function (resolve, reject) {
          $http.delete(BACKEND.url + '/modales/suppression/' + codeModale + '?forcerSuppression=' + forcerSuppression).then(function (response) {
            resolve(response.data);
          }, reject);
        });
      }
    }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('HabilitationsService', HabilitationsService);

  /* @ngInject */
  function HabilitationsService($http, $q, BACKEND) {

    const MODALE_HABILITATION_CODE = "W_API_MODALES";

    var service = {
      getHabilitations: getHabilitations,
      hasHabilitation: hasHabilitation,
      hasGestionModaleHabilitation: hasGestionModaleHabilitation
    };
    return service;

    // Service HTTP appelant /profil et retournant les habilitations
    function getHabilitations() {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/profil').then(function (response) {
          resolve(response.data.habilitations);
        }, reject);
      });
    }

    // Vérifie si la liste des habilitations contient une habilitation dont le code est égal à habilitationCode
    function hasHabilitation(habilitationCode) {
      return getHabilitations().then(function (habilitations) {
        if (angular.isArray(habilitations)) {
          return habilitations.some(function (hab) {
            return hab.code === habilitationCode;
          });
        }
        return false;
      });
    }

    // Vérifie si l'utilisateur a l'habilitation "W_API_MODALES"
    function hasGestionModaleHabilitation() {
      return hasHabilitation(MODALE_HABILITATION_CODE);
    }

  }
})();

(function () {
    'use strict';

    angular
      .module('app')
      .service('FloreService', FloreService);

    /* @ngInject */
    function FloreService($http, $q, BACKEND) {

      var service = {
        updateAbonneFlore: updateAbonneFlore,
        getAbonneFlore: getAbonneFlore
      };
      return service;

      // Création ou modification du compte flore
      function updateAbonneFlore(numExploitation, infosAbonneFlore) {
        return $q(function (resolve, reject) {
          $http({
            url: BACKEND.url + '/flore/' + numExploitation,
            method: "PATCH",
            data: {
              media: infosAbonneFlore.preference,
              // utilisateurEmail: {
              //   mail: infosAbonneFlore.email
              // },
              utilisateurTelephone: {
                telMobile: infosAbonneFlore.telephoneSms
              }
            }
          })
            .then(function (response) {
              resolve(response.data);
            }, reject);
        });
      }

      // Retourne le compte flore courant pour l'élevage courant
      function getAbonneFlore(login) {
        return $q(function (resolve, reject) {
          $http({
            url: BACKEND.url + '/flore/' + login,
            method: "GET"
          })
            .then(function (response) {
              resolve(response.data);
            }, reject);
        });
      }

    }
})();

(function () {
    'use strict';

    angular
      .module('app')
      .service('EnvoiSmsService', EnvoiSmsService);

    /* @ngInject */
    function EnvoiSmsService($http, $q, BACKEND) {

      var service = {
        envoiSms: envoiSms,
        envoiCodeSms: envoiCodeSms
      };

      return service;

      function envoiSms(numeroExploitation, numeroTelephone, systemeExploitation) {
        return $q(function (resolve, reject) {
          $http({
            url: BACKEND.url + '/sms',
            method: "POST",
            data: {
                numeroExploitation: numeroExploitation,
                numeroMobile: numeroTelephone,
                systemeExploitation: systemeExploitation
              }
          })
            .then(function (response) {
              resolve(response.data);
            }, reject);
        });
      }

    function envoiCodeSms(numeroMobile, iban) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + "/sms/code",
          method: "POST",
          data: {
            numeroMobile: numeroMobile,
            iban: iban
          }
        }).then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }
    }
  })();

(function () {
  'use strict';

  angular
    .module('app')
    .service('DownloadFileService', DownloadFileService);

  /* @ngInject */
  function DownloadFileService($document, $timeout, $window, BACKEND) {
    var service = {
      downloadFromUri: downloadFromUri,
      downloadFromFile: downloadFromFile,
      downloadFromFilepath: downloadFromFilepath
    };
    return service;

    function downloadFromUri(uri, nom) {
      var url = BACKEND.url + uri;

      var a = angular.element('<a></a>');

      a.css('display', 'none');
      a.attr('target', '_self');

      a.attr('href', url);
      a.attr('download', nom);

      $document[0].body.appendChild(a[0]);

      $timeout(function () {
        a[0].click();
        $window.URL.revokeObjectURL(url);
      });
    }

    function downloadFromFile(file) {
      var nom = file.nom;

      var byteNumbers;
      if (_.isString(file.base64Content)) {
        var byteCharacters = atob(file.base64Content);
        byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
      } else {
        byteNumbers = file.base64Content;
      }

      var data = [new Uint8Array(byteNumbers)];

      var blob = new Blob(data, {
        type: "octet/stream"
      });

      if ($window.navigator.msSaveOrOpenBlob) {
        $window.navigator.msSaveBlob(blob, nom);
      } else {
        var url = $window.URL.createObjectURL(blob);

        var a = angular.element('<a></a>');

        a.css('display', 'none');
        a.attr('target', '_self');

        a.attr('href', url);
        a.attr('download', nom);

        $document[0].body.appendChild(a[0]);

        $timeout(function () {
          a[0].click();
          $window.URL.revokeObjectURL(url);
        });
      }
    }

    function downloadFromFilepath(filepath) {
      var a = angular.element('<a></a>');
      a.css('display', 'none');
      a.attr('target', '_self');
      a.attr('href', filepath);
      a.attr('download', filepath.split('/').pop());
      $document[0].body.appendChild(a[0]);
      $timeout(function () {
        a[0].click();
      });
    }

  }
})();

(function () {
  angular
    .module('app').factory('DetenteurService', DetenteurService);

  /* @ngInject */
  function DetenteurService($http, $q, BACKEND) {
    var service = {
      getDetenteur: getDetenteur,
      getContactFacturation: getContactFacturation,
      setContactFacturation: setContactFacturation,
      modifierAdresseDetenteur: modifierAdresseDetenteur
    };

    return service;

    function getDetenteur(numeroExploitation) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/detenteur/' + numeroExploitation,
          method: "GET"
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function getContactFacturation(numeroExploitation) {
      return $q(function (resolve, reject) {
        $http({
          url: BACKEND.url + '/contactFacturation/' + numeroExploitation,
          method: "GET"
        })
          .then(function (response) {
            resolve(response.data);
          }, reject);
      });
    }

    function setContactFacturation(contactFacturation) {
      return $q(function (resolve, reject) {
        $http.patch(BACKEND.url + '/contactFacturation', contactFacturation)
        .then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function modifierAdresseDetenteur(detenteur) {
      return $q(function (resolve, reject) {
        $http.patch(BACKEND.url + '/detenteur/adresse', detenteur)
        .then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('CookiesService', CookiesService);

  /* @ngInject */
  function CookiesService($cookies, JsonService) {
    var service = {
      get: get,
      set: set,
      has: has,
      remove: remove
    };
    return service;

    function get(entry, prefix) {
      var value = $cookies.get(getKey(entry, prefix));

      if (angular.isObject(entry)) {
        if (value === null || angular.isUndefined(value)) {
          return angular.copy(entry.default);
        }

        switch (entry.type) {
          case 'date':
            return new Date(parseInt(value, 10));
          case 'integer':
            return parseInt(value, 10);
          case 'json':
            return JsonService.parse(value);
          case 'boolean':
            return (value.toLowerCase() === 'true');
          default:
            return value;
        }
      } else if (value === null) {
        return undefined;
      }
      return value;
    }

    function set(entry, value, prefix) {
      var localValue;
      if (angular.isObject(entry)) {
        switch (entry.type) {
          case 'date':
            localValue = value.getTime();
            break;
          case 'json':
            localValue = JsonService.stringify(value);
            break;
          default:
            localValue = value;
        }
      }

      $cookies.put(getKey(entry, prefix), localValue);
    }

    function remove(entry, prefix) {
      $cookies.remove(getKey(entry, prefix));
    }

    function has(entry, prefix) {
      var value = $cookies.get(getKey(entry, prefix));

      if (value === null || angular.isUndefined(value)) {
        return false;
      }

      return true;
    }

    function getKey(entry, prefix) {
      var key = entry;
      if (angular.isObject(entry)) {
        key = entry.key;
      }
      if (angular.isDefined(prefix)) {
        return prefix + '-' + key;
      }
      return key;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('ConfigKcService', ConfigKcService);

    /* @ngInject */
    function ConfigKcService($http, $q) {

        this.keycloak = undefined;
        var service = {
            getKeyCloak: getKeyCloak,
            getUrlMireKc: getUrlMireKc,
            setKc: setKc,
            logoutKc: logoutKc

        };
        return service;

        function getKeyCloak() {
            return $q(function (resolve, reject) {
                $http.get('../../configKc.properties').then(function (response) {
                    var properties = extractProperties(response.data);
                    // eslint-disable-next-line
                    var keycloak = new Keycloak({
                        url: properties.kcUrl,
                        realm: properties.realm,
                        clientId: properties.clientId
                    });
                    resolve(keycloak);
                }, reject);
            });
        }

        function extractProperties(data) {
            var keyValuePairs = data.split("\n");
            var properties = {};
            for (var i = 0; i < keyValuePairs.length; i++) {
                var keyValueArr = keyValuePairs[i].trim().split("=");
                var key = keyValueArr[0];
                var value = keyValueArr[1];
                properties[key] = value;
            }
            return properties;
        }

        function getUrlMireKc() {
            return $q(function (resolve, reject) {
                $http.get('../../configKc.properties').then(function (response) {
                    var properties = extractProperties(response.data);
                    var mireUrl = properties.kcUrl + 'realms/' + properties.realm +
                        '/protocol/openid-connect/auth?client_id=' + properties.clientId +
                        '&redirect_uri=' + properties.redirectUrl + '&response_type=code';
                    resolve(mireUrl);
                }, reject);
            });
        }

        function setKc(kc) {
            this.keycloak = kc;
        }

        function logoutKc() {
            this.keycloak.logout();
        }
    }
})();

(function () {
    /**
     * Service métier de configuration de l'application
     * @constructor
     */

    angular
        .module('app').factory('ConfigService', ConfigService);

    function ConfigService(AdvConfigService) {

        // ce service hérite du service AdvConfigService
        var that = angular.extend(AdvConfigService, {});
        // ici poser les méthodes sur that pour enrichir le service
        return that;
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .service('AutorisationAccesService', AutorisationAccesService);

    /* @ngInject */
    function AutorisationAccesService($http, $q, BACKEND) {

        var service = {
            getAutorisationsAcces: getAutorisationsAcces,
            getAutorisationsAccesAdmin: getAutorisationsAccesAdmin,
            enregistrerAutorisationsAcces: enregistrerAutorisationsAcces,
            enregistrerAutorisationsAccesAdmin: enregistrerAutorisationsAccesAdmin,
            compteKcExist: compteKcExist,
            getCurrentAutorisationAcces: getCurrentAutorisationAcces
        };
        return service;

        function getAutorisationsAcces() {
            return $q(function (resolve, reject) {
                $http({
                    url: BACKEND.url + '/autorisation-acces/',
                    method: "GET"
                })
                    .then(function (response) {
                        resolve(response.data);
                    }, reject);
            });
        }

        function getAutorisationsAccesAdmin(numExploitation, email) {
            return $q(function (resolve, reject) {
                $http({
                    url: BACKEND.url + '/autorisation-acces/admin',
                    method: "GET",
                    params: {
                        numExploitation: numExploitation,
                        email: email
                    }
                })
                    .then(function (response) {
                        resolve(response.data);
                    }, reject);
            });
        }

        function enregistrerAutorisationsAcces(listAutorisationsAcces) {
            return $q(function (resolve, reject) {
                $http({
                    url: BACKEND.url + '/autorisation-acces/modify/',
                    method: "PATCH",
                    data: listAutorisationsAcces
                })
                    .then(function (response) {
                        resolve(response.data);
                    }, reject);
            });
        }

        function enregistrerAutorisationsAccesAdmin(listAutorisationsAcces, numExploitation, email) {
            return $q(function (resolve, reject) {
                $http({
                    url: BACKEND.url + '/autorisation-acces/admin/modify/',
                    method: "PATCH",
                    data: listAutorisationsAcces,
                    params: {
                        numExploitation: numExploitation,
                        email: email
                    }
                })
                    .then(function (response) {
                        resolve(response.data);
                    }, reject);
            });
        }

        function compteKcExist(email, numExploitation) {
            return $q(function (resolve, reject) {
                $http({
                    url: BACKEND.url + '/autorisation-acces/compte-kc-exist',
                    method: "GET",
                    params: {
                        email: email,
                        numExploitation: numExploitation
                    }
                })
                    .then(function (response) {
                        resolve(response.data);
                    }, reject);
            });
        }

        function getCurrentAutorisationAcces() {
            return $q(function (resolve, reject) {
                $http({
                    url: BACKEND.url + '/autorisation-acces/current',
                    method: "GET"
                }).then(function (response) {
                    resolve(response.data);
                }, reject);
            });
        }
    }
})();

(function () {
  /**
   * Service métier d'authentification
   * @constructor
   */

  angular
    .module('app').factory('AuthentService', AuthentService);

  /* @ngInject */
  function AuthentService($http, $q, $state, AdvAuthentService, ReferentielService, SessionService, UserService, LoadingService, BACKEND, $window, ErrorService) {
    var service = {
      login: login,
      logout: logout,
      setExploitation: setExploitation,
      setSsoCookie: setSsoCookie,
      deleteSsoCookie: deleteSsoCookie,
      getInfosSynel: getInfosSynel,
      logoutKc: logoutKc,
      loginKc: loginKc,
      selectProfil: selectProfil,
      selectProfilTechnicien: selectProfilTechnicien,
      hasModaleAccueil: hasModaleAccueil,
      setModaleAccueil: setModaleAccueil
    };

    return angular.extend(AdvAuthentService, service);

    function login(username, password) {
      return $q(function (resolve, reject) {
        $http.post(BACKEND.url + '/auth', {
          username: username,
          password: password
        }).then(function (response) {
          resolve(response.data.value);
          setModaleAccueil('true');
        }, reject);
      });
    }

    function loginKc(token, username) {
      var config = {};
      if (angular.isDefined(token)) {
        config.headers = {
          Authorization: 'Bearer ' + token
        };
      }

      return $q(function (resolve, reject) {
        var req = {
          method: 'POST',
          url: BACKEND.url + '/auth/kc',
          headers: {
             Authorization: 'Bearer ' + token
          },
          params: {
            identifiantKc: username
          }

       };
        $http(req).then(function (response) {
          resolve(response.data.value);
          setModaleAccueil('true');
        }, reject);
      });
    }

    function logout() {
      if (SessionService.isAuthenticated()) {
        LoadingService.show();
        if (UserService.getEstKeyCloak() && UserService.get('mailLogin') && UserService.get('mailLogin') !== "") {
          logoutKc();
          SessionService.clean();
          UserService.clean();
          ErrorService.setNbModalsSessionExpired(0);
        } else {
          SessionService.clean();
          UserService.clean();
          setModaleAccueil('true');
          ErrorService.setNbModalsSessionExpired(0);
          $state.go('auth');
        }
      }
    }

    function logoutKc() {
      return $q(function (resolve, reject) {
        $http.post(BACKEND.url + '/auth/logout', $window.localStorage.getItem('kc_refresh_token')).then(function () {
          SessionService.clean();
          UserService.clean();
          setModaleAccueil('true');
          $state.go('auth');
        }, reject);
      });
    }

    function setExploitation(exploitation, token) {
      var config = {};
      if (angular.isDefined(token)) {
        config.headers = {
          Authorization: 'Bearer ' + token
        };
      }

      return $q(function (resolve, reject) {
        $http.patch(BACKEND.url + '/auth', exploitation.numExploitation, config).then(function (response) {
          resolve(response.data.value);
          setModaleAccueil('true');
        }, reject);
      });
    }

    function setSsoCookie(token) {
      return $q(function (resolve, reject) {
        $http.post(ReferentielService.getSsoCookieSetterUrl(), {
          token: token
        }, {
          withCredentials: true
        }).then(resolve, reject);
      });
    }

    function deleteSsoCookie() {
      return $q(function (resolve, reject) {
        $http.delete(ReferentielService.getSsoCookieSetterUrl(), {
          withCredentials: true
        }).then(resolve, reject);
      });
    }

    function getInfosSynel(loginSynel) {
      return $q(function (resolve, reject) {
        $http.get(BACKEND.url + '/identifiantsynel/' + loginSynel).then(function (response) {
          resolve(response.data);
        }, reject);
      });
    }

    function selectProfil(profil) {
      return $q(function (resolve, reject) {
        $http.patch(BACKEND.url + '/auth/select-profil', profil).then(function (response) {
          resolve(response.data.value);
        }, reject);
      });
    }

    function selectProfilTechnicien() {
      return $q(function (resolve, reject) {
        $http.patch(BACKEND.url + '/auth/select-profil-technicien').then(function (response) {
          resolve(response.data.value);
        }, reject);
      });
    }

    function hasModaleAccueil() {
      return $window.localStorage.getItem('modaleAccueil');
    }

    function setModaleAccueil(shouldDisplay) {
      $window.localStorage.setItem('modaleAccueil', shouldDisplay);
    }
  }
})();

(function () {
    /**
     * Service métier de gestion de l'état de l'application
     * @constructor
     */

    angular
        .module('app').factory('ApplicationService', ApplicationService);

    function ApplicationService(AdvApplicationService) {

        // ce service hérite du service AdvApplicationService
        var that = angular.extend(AdvApplicationService, {});

        // ici poser les méthodes sur that pour enrichir le service
        return that;
    }
})();


(function () {
    'use strict';

    angular
        .module('app')
        .service('AlerteSaisieAutorisationsService', AlerteSaisieAutorisationsService);

    /* @ngInject */
    function AlerteSaisieAutorisationsService($http, $q, BACKEND) {

        var service = {
            getShowAlerteSaisieAutorisations: getShowAlerteSaisieAutorisations,
            saveAffichageAlerteSaisieAutorisation: saveAffichageAlerteSaisieAutorisation
        };
        return service;

        function getShowAlerteSaisieAutorisations() {
            return $q(function (resolve, reject) {
                $http({
                    url: BACKEND.url + '/exploitations/show-alerte-saisie-autorisations/',
                    method: "GET"
                })
                    .then(function (response) {
                        resolve(response.data);
                    }, reject);
            });
        }

        function saveAffichageAlerteSaisieAutorisation() {
            return $q(function (resolve, reject) {
                $http({
                    url: BACKEND.url + '/exploitations/save-affichage-alerte-saisie-autorisation/',
                    method: "PATCH"
                }).then(function (response) {
                    resolve(response.data);
                }, reject);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app')
        .service('AbonnementOptionService', AbonnementOptionService);

    /* @ngInject */
    function AbonnementOptionService($http, $q, BACKEND, UserService) {

        var service = {
            getOptions: getOptions,
            addOption: addOption,
            deleteOption: deleteOption,
            saveSaisie: saveSaisie
        };
        return service;

        function getOptions(numeroExploitation) {
            if (angular.isUndefined(numeroExploitation)) {
                numeroExploitation = UserService.get('exploitationActive.numExploitation');
              }
            return $q(function (resolve, reject) {
                $http({
                    url: BACKEND.url + '/options/' + numeroExploitation,
                    method: "GET"
                }).then(function (response) {
                    resolve(response.data);
                }, reject);
            });
        }

        function addOption(login, option) {
            return $q(function (resolve, reject) {
                $http({
                    url: BACKEND.url + '/options/' + login,
                    method: "POST",
                    data: option
                })
                    .then(function (response) {
                        resolve(response.data);
                    }, reject);
            });
        }

        function deleteOption(login, option) {
            return $q(function (resolve, reject) {
                $http({
                  url: BACKEND.url + '/options/' + login + '/' + option.idEleveurAbonnementExploitation,
                  method: 'DELETE'
                }).then(function (response) {
                  resolve(response.data);
                }, reject);
              });
        }

        function saveSaisie(numExploitation, option) {
            return $q(function (resolve, reject) {
                $http({
                  url: BACKEND.url + '/options/' + option.idAbonnement + '/saisie',
                  method: 'POST',
                  params: {
                    exploitation: numExploitation,
                    estsaisie: false
                }
                }).then(function (response) {
                  resolve(response.data);
                }, reject);
              });
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('RedirectionController', RedirectionController);

  /** @ngInject */
  function RedirectionController($document, $http, $stateParams, $window, LoadingService, BACKEND) {
    LoadingService.show();

    var url = BACKEND.url + '/services/' + $stateParams.fonctionnalite.toUpperCase();
    if (angular.isDefined($stateParams.options)) {
      var options = angular.fromJson($stateParams.options);
      if (angular.isObject(options)) {
        url += '?' + _.map(options, function (value, key) {
          return key + '=' + value;
        }).join('&');
      }
    }
    $http.get(url).then(function (response) {
      var acces = response.data.acces;
      switch (acces.application) { // faire la comparaison sur les types de paramètres
        case 'BGTA':
        case 'Milklic':
        case 'APPLI_EQUARRIS':
        case 'Infolabo':
          var form = angular.element('<form></form>');

          form.attr('method', 'POST');
          form.attr('action', acces.url);
          form.css('display', 'none');

          angular.forEach(_.filter(acces.parametres, {
            type: 'POST'
          }), function (parametre) {
            var element = angular.element('<input/>');
            element.attr('name', parametre.nom);
            element.attr('value', parametre.valeur);

            form.append(element);
          });

          angular.element($document[0].body).append(form);

          form[0].submit();
          break;
        default:
          $window.location.href = acces.url;
      }
    });
  }
})();

(function () {
  /**
   * Composant d'interception des appels http
   *
   * TODO : ajouter un autre intercepteur pour les retours dont le rôle est "Tout code http n'étant pas dans la tranche des 200 renvoie sur l'authent, avec message utilisateur"
   * @constructor
   */

  angular
    .module('app').service('HttpInterceptor', HttpInterceptor);

  /* @ngInject */
  function HttpInterceptor($injector, $log, $q, $window, SessionService, MESSAGES) {
    var service = {
      addListener: addListener,
      request: request,
      activate: activate,
      deactivate: deactivate,
      responseError: responseError
    };

    var listeners = [];
    var activated = true;

    return service;

    function addListener(listener) {
      listeners.push(listener);
    }

    function request(config) {
      var nbListeners = listeners.length;
      for (var i = 0; i < nbListeners; i++) {
        listeners[i].request(config);
      }

      // ajout du token dans les appels
      if (SessionService.isAuthenticated()) {
        var token = SessionService.getCredentials().token;
        if (token && token !== "") {
          config.headers.Authorization = "Bearer " + token;
        }
      }
      return config;
    }

    function activate() {
      activated = true;
    }

    function deactivate() {
      activated = false;
    }

    function responseError(error) {
      if (angular.isUndefined(_.get(error, 'config.url')) || (_.get(error, 'config.url').indexOf('ping') === -1)) {
        var $http = $injector.get('$http');
        $http.get('ping?' + Date.now()).catch(function () {
          $window.location.href = '/';
        });

        if (activated) {
          var ErrorService = $injector.get('ErrorService');

          if (ErrorService.isAuthentificationError(error)) {
            $log.log('Problème d\'authentification. Redirection vers la page d\'authentification.');
            if (!ErrorService.getNbModalsSessionExpired() > 0) {
              var AuthentService = $injector.get('AuthentService');
              ErrorService.alert(error, {
                message: MESSAGES.SESSION_EXPIREE
              }).then(function () {
                AuthentService.logout();
              }, function () {
                AuthentService.logout();
            });
            }
          }
        }
      }

      return $q.reject(error);
    }
  }
})();

(function () {
    'use strict';

    angular.module('app').filter('advStartFrom', AdvStartFromFilter);

    function AdvStartFromFilter() {
        return function (input, start) {
            start = Number(start);
            return input.slice(start);
        };
    }
  })();

(function () {
  'use strict';

  angular.module('app').filter('souffleur', SouffleurFilter);

  /* @ngInject */
  function SouffleurFilter($filter) {
    return function (elements, souffleurs) {
      return $filter('filter')(elements, function (element) {
        return _.every(souffleurs, function (souffleur, property) {
          if (angular.isUndefined(souffleur)) {
            return true;
          }

          var souffleurValue = souffleur.value;

          if (angular.isUndefined(souffleurValue) || (souffleurValue === '') || (souffleurValue === null) || (_.isPlainObject(souffleurValue) && _.isEmpty(souffleurValue))) {
            return true;
          }

          var actual = _.get(element, property);

          if (angular.isUndefined(actual)) {
            return false;
          }

          switch (souffleur.type) {
            case 'date':
              if (angular.isDefined(souffleurValue) && !moment(actual).isSame(souffleurValue, 'day')) {
                return false;
              }
              return true;
            case 'dateMin':
              if (angular.isDefined(souffleurValue) && !moment(actual).isSameOrAfter(souffleurValue, 'day')) {
                return false;
              }
              return true;
            case 'dateMax':
              if (angular.isDefined(souffleurValue) && !moment(actual).isSameOrBefore(souffleurValue, 'day')) {
                return false;
              }
              return true;
            case 'multiple':
              if (angular.isArray(souffleurValue) && (souffleurValue.length > 0)) {
                if ($filter('indexOf')(souffleurValue, actual) === -1) {
                  return false;
                }
              }

              return true;
            case 'interval':
              if (angular.isDefined(souffleurValue.min)) {
                if (souffleurValue.min.inclus && actual === souffleurValue.min.limit) {
                  return true;
                }
                if (actual > souffleurValue.min.limit) {
                  if (angular.isDefined(souffleurValue.max)) {
                    if (souffleurValue.max.inclus && actual === souffleurValue.max.limit) {
                      return true;
                    }
                    if (actual < souffleurValue.max.limit) {
                      return true;
                    }
                    return false;
                  }
                  return true;
                }
                return false;
              }
              if (angular.isDefined(souffleurValue.max)) {
                if (souffleurValue.max.inclus && actual === souffleurValue.max.limit) {
                  return true;
                }
                if (actual < souffleurValue.max.limit) {
                  if (angular.isDefined(souffleurValue.min)) {
                    if (souffleurValue.min.inclus && actual === souffleurValue.min.limit) {
                      return true;
                    }
                    if (actual > souffleurValue.min.limit) {
                      return true;
                    }
                    return false;
                  }
                  return true;
                }
                return false;
              }
              return false;
            default:
              if (angular.isObject(actual)) {
                return angular.equals(actual, souffleurValue);
              }

              actual = String(actual).toLowerCase();
              var expected = String(souffleurValue).toLowerCase();

              return actual.indexOf(expected) !== -1;
          }
        });
      });
    };
  }
})();

(function () {
  'use strict';

  angular.module('app').filter('search', SearchFilter);

  /* @ngInject */
  function SearchFilter($filter) {
    return function (elements, search) {
      if (angular.isUndefined(search)) {
        return elements;
      }

      var properties = search.properties;
      var value = search.value;

      if (angular.isUndefined(value) || (value === '')) {
        return elements;
      }

      var expected = String(value).toLowerCase();
      return $filter('filter')(elements, function (element) {
        return _.some(properties, function (property) {
          var actual = _.get(element, property);

          if (angular.isUndefined(actual) || (actual === '')) {
            return false;
          }

          if (!angular.isObject(actual)) {
            actual = String(actual).toLowerCase();
          }

          property = _.last(property.split('.'));

          if (property.indexOf('date') === 0) {
            actual = $filter('date')(actual, 'dd/MM/yy');
          }

          if ((property === 'age') && angular.isDefined(actual)) {
            actual = $filter('age')(actual);
          }

          return (actual.indexOf(expected) !== -1);
        });
      });
    };
  }
})();

(function () {
  'use strict';

  angular.module('app').filter('advOrderBy', AdvOrderByFilter);

  /* @ngInject */
  function AdvOrderByFilter($filter) {
    return function (collection, predicate) {
      // Valeurs par défaut si pas renseigné
      if (angular.isUndefined(predicate.property) && angular.isDefined(predicate.default)) {
        predicate.property = predicate.default.property;
        predicate.reverse = predicate.default.reverse;
      }

      if (angular.isDefined(predicate.property)) {
        var expressions = [];

        if (angular.isArray(predicate.property)) {
          angular.forEach(predicate.property, function (property) {
            expressions.push(getPrefix(property, predicate.reverse));
          });
        } else {
          expressions.push(getPrefix(predicate.property, predicate.reverse));
        }

        if (angular.isDefined(predicate.default) && (predicate.property !== predicate.default.property)) {
          if (angular.isArray(predicate.default.property)) {
            angular.forEach(predicate.default.property, function (property) {
              expressions.push(getPrefix(property, predicate.default.reverse));
            });
          } else {
            expressions.push(getPrefix(predicate.default.property, predicate.default.reverse));
          }
        }

        return $filter('orderBy')(collection, expressions);
      }

      return collection;
    };
  }

  function getPrefix(property, reverse) {
    if (angular.isDefined(reverse)) {
      return ((reverse === true) ? '+' : '-') + property;
    }

    return property;
  }
})();

(function () {
  'use strict';
  angular.module('app').filter('filterModale', function ($filter) {
    return function (items, filter) {
      if (!items || !filter || !filter.search || !filter.search.value) {
        return items;
      }

      var searchValue = filter.search.value.toLowerCase();

      return items.filter(function (item) {
        return filter.search.properties.some(function (prop) {
          var value = item[prop];

          // Si c'est une date, on la formate
          if (value instanceof Date) {
            value = $filter('date')(value, 'dd/MM/yyyy HH:mm');
          }

          // Si c'est une string ISO date, on tente de parser
          if (angular.isString(value) && !isNaN(Date.parse(value))) {
            value = $filter('date')(new Date(value), 'dd/MM/yyyy HH:mm');
          }

          return value && value.toString().toLowerCase().indexOf(searchValue) !== -1;
        });
      });
    };
  });

})();

(function () {
  'use strict';

  angular.module('app').filter('indexOf', IndexOfFilter);

  /* @ngInject */
  function IndexOfFilter() {
    return function (elements, value) {
      for (var i = 0; i < elements.length; i++) {
        if (angular.equals(elements[i], value)) {
          return i;
        }
      }

      return -1;
    };
  }
})();

(function () {
  'use strict';

  angular.module('app').filter('formatPhoneNumber', FormatPhoneNumberFilter);

  /* @ngInject */
  function FormatPhoneNumberFilter() {
    return function (phoneNumber) {
      var result = '';

      if (angular.isDefined(phoneNumber)) {
        result = phoneNumber.replace(/(?=(\d{2})+(?!\d))/g, " ");
      }

      return result;
    };
  }
})();

(function () {
  'use strict';

  angular.module('app').filter('findDeep', FindDeepFilter);

  /* @ngInject */
  function FindDeepFilter() {
    function findDeep(collection, predicate) {
      var result;

      _.forEach(collection, function (value) {
        if (angular.isUndefined(result) && _.isObject(value)) {
          result = _.find(collection, predicate);

          if (angular.isUndefined(result)) {
            result = findDeep(value, predicate);
          }
        }
      });

      return result;
    }

    return function (collection, predicate) {
      var result = _.find(collection, predicate);

      if (angular.isUndefined(result)) {
        result = findDeep(collection, predicate);
      }

      return result;
    };
  }
})();

(function () {
  'use strict';

  angular.module('app').filter('filterAbonnement', FilterAbonnementFilter);

  /* @ngInject */
  function FilterAbonnementFilter($filter) {
    return function (abonnements, filter) {
      var abonnementsFiltered = abonnements;
      if (angular.isDefined(filter.search)) {
        var search;
        if (angular.isObject(filter.search)) {
          search = filter.search;
        } else {
          search = {
            value: filter.search
          };
        }

        if (angular.isUndefined(filter.search.properties)) {
          search.properties = ['exploitation', 'identifiant'];
        }

        abonnementsFiltered = $filter('search')(abonnementsFiltered, search);
      }

      if (angular.isDefined(filter.souffleurs)) {
        abonnementsFiltered = $filter('souffleur')(abonnementsFiltered, filter.souffleurs);
      }

      return abonnementsFiltered;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('ValidationIdentiteController', ValidationIdentiteController);

  /** @ngInject */
  function ValidationIdentiteController($state, $stateParams, ValidationIdentiteService, ModalService, LoadingService, ErrorService, AuthentService, ConfigKcService) {
    var vm = this;
    ConfigKcService.getUrlMireKc().then(function (urlMireKc) {
      vm.urlMireKc = urlMireKc;
    });
    vm.validationIdentiteModel = {};
    if (angular.isDefined($stateParams.infosExploitation) && $stateParams.infosExploitation !== null) {
      vm.infosExploitation = $stateParams.infosExploitation;
      if (angular.isDefined($stateParams.infosExploitation.numeroExploitation)) {
        vm.validationIdentiteModel.numExploitation = vm.infosExploitation.numeroExploitation;
      }
      if (angular.isDefined($stateParams.infosExploitation.raisonSociale)) {
        vm.validationIdentiteModel.raisonSociale = vm.infosExploitation.raisonSociale;
      }
      if (angular.isDefined($stateParams.infosExploitation.identifiantKc)) {
        vm.validationIdentiteModel.email = vm.infosExploitation.identifiantKc;
      }
    } else {
      $state.go('auth');
    }

    vm.goToHome = function () {
      $state.go('auth');
    };

    vm.validationIdentite = function () {
      if (!vm.validationForm.$invalid) {
        checkIdentite();
      }
    };

    function checkIdentite() {
      LoadingService.show();
      ValidationIdentiteService.checkIdentite(vm.validationIdentiteModel).then(function (result) {
        LoadingService.hide();
        ModalService.alertResultValidationIdentite(getTemplateUrl(result), vm.urlMireKc).then(function () {
          if ((result === 'COMPTE_KC_EXISTANT') || (result === 'NOUVEAU_COMPTE_KC')) {
            AuthentService.logout();
          } else if (result === 'IDENTITE_NON_VALIDE') {
            $state.go('app.eleveur.compte.compte', {
              onglet: 'autorisations d\'accès'
            });
          }
        });
      }, function (error) {
        LoadingService.hide();
        if (_.get(error, 'data.code')) {
          ModalService.alert({template: error.data.message});
        } else {
          ErrorService.alert(error);
        }
      });
    }

    function getTemplateUrl(result) {
      if (result === 'COMPTE_KC_EXISTANT') {
        return "app/_common/services/modal/templates/validationCompteKcExistant.html";
      } else if (result === 'NOUVEAU_COMPTE_KC') {
        return "app/_common/services/modal/templates/validationNouveauCompteKc.html";
      } else if (result === 'IDENTITE_NON_VALIDE') {
        return "app/_common/services/modal/templates/validationCompteKcKo.html";
      }
    }
  }
})();

(function () {
    'use strict';

    angular
      .module('app')
      .controller('SelectionProfilController', SelectionProfilController);

    /** @ngInject */
    function SelectionProfilController(AuthentService, UserService, SessionService, $state, LoadingService, ErrorService) {
        var vm = this;
        vm.profils = [];

        vm.showTechnicienButton = false;

        UserService.getMultiProfil().then(function (response) {
            vm.profils = response;
        });
        UserService.loadProfil().then(function () {});
        vm.goToHome = function () {
            /* var login = UserService.get('login');
            if (login) {
                var profil = UserService.get('profil');
                if (profil === 'ADMIN') {
                    $state.go('app.admin.home');
                } else if (profil === 'TECHNICIEN' || profil === 'ASSISTANCE') {
                    $state.go('app.selectioncheptel');
                }
            } else { */
                AuthentService.logoutKc(UserService.get('mailLogin'));
            // }
        };
        UserService.hasAutorisationTechnicien(UserService.get('login')).then(function (response) {
            vm.showTechnicienButton = response;
        });
        vm.selectProfil = function (profil) {
            AuthentService.selectProfil(profil).then(function (token) {
                SessionService.setCredentials({
                  token: token
                });
                UserService.loadProfil().then(function () {});
                if (profil.profil === 'ADMIN') {
                    $state.go('app.admin.home');
                } else if (profil.profil === 'TECHNICIEN' || profil.profil === 'ASSISTANCE') {
                    $state.go('app.selectioncheptel');
                }
            });
        };

        vm.selectProfilTechnicien = function () {
            AuthentService.selectProfilTechnicien().then(function (token) {
                SessionService.setCredentials({
                    token: token
                });
                UserService.loadProfil().then(function () {});
                UserService.getProfil(token).then(function (profil) {
                    vm.profil = profil;
                    var login = vm.profil.mailLogin;
                    UserService.getListTypeAbonnement(login).then(function (response) {
                        var estBovin = _.find(response.listeTypeAbonnement, function (typeAbonnement) {
                            return typeAbonnement === "BOV";
                        });
                        if (estBovin) {
                            $state.go('app.eleveur.bovin');
                        } else {
                            $state.go('app.eleveur.woc');
                        }
                    });
                }, function (error) {
                    LoadingService.hide();
                    ErrorService.alert(error);
                });
            });
        };
    }
  })();

(function () {
    'use strict';

    angular
        .module('app')
        .controller('RoutageKcController', RoutageKcController);

    /** @ngInject */
    function RoutageKcController($state, AuthentService, LoadingService, SessionService, HttpInterceptor, UserService,
        ExploitationService, ErrorService, AdminService, ConfigKcService, $window, ModalService, FonctionnaliteService, StatutRecouvrementService) {
        var vm = this;
        vm.tokenKc = undefined;
        vm.profil = undefined;
        vm.keycloak = undefined;
        vm.username = undefined;

        function initKeycloak() {
            LoadingService.show();
            ConfigKcService.getKeyCloak().then(function (keycloak) {
                vm.keycloak = keycloak;
                vm.keycloak.init({onLoad: 'check-sso'}).then(function (authenticated) {
                    if (authenticated) {
                        vm.keycloak.loadUserProfile()
                            .then(function (profile) {
                                vm.username = profile.email;
                                vm.tokenKc = vm.keycloak.token;
                                $window.localStorage.setItem('kc_refresh_token', vm.keycloak.refreshToken);
                                ConfigKcService.setKc(vm.keycloak);
                                authenticate();
                            }).catch(function () {
                                ErrorService.alert('Failed to load user profile');
                            });
                    } else {
                        ErrorService.alert('Vous devez vous authentifier avec votre email');
                        $state.go('auth');
                    }
                }).catch(function () {
                    ErrorService.alert('error.data.message');
                    $state.go('auth');
                });
            });
        }
        initKeycloak();
        function authenticate() {
            SessionService.clean();
            HttpInterceptor.deactivate();
            AuthentService.loginKc(vm.tokenKc, vm.username).then(function (tokenPe) {
                UserService.getProfil(tokenPe).then(function (profil) {
                    vm.profil = profil;
                    if (profil.estMultiProfil) {
                        SessionService.setCredentials({
                            token: tokenPe
                        });
                        $state.go('selectionProfil');
                    } else if ((profil.profil !== 'ADMIN') && (profil.multiExploitation === true)) {
                        ExploitationService.goToSelectionExploitation(tokenPe).then(function (token) {
                            onFinishAuthent(token, profil);
                        }, function (error) {
                            LoadingService.hide();
                            ErrorService.alert(error);
                        });
                    } else if ((vm.profil.profil === 'ELEVEUR' || vm.profil.profil === 'TECHNICIEN') &&
                        vm.profil.exploitationActive) {
                        modalSuspension(tokenPe, profil);
                    } else {
                        onFinishAuthent(tokenPe, profil);
                    }
                });
            }, function (error) {
                if (_.get(error, 'data.code')) {
                    // vm.keycloak.logout()
                    ErrorService.alert(error.data.message);
                    // LoadingService.hide();
                    $state.go('auth');

                } else {
                    vm.keycloak.logout().then(function () {
                        // $state.go('auth');
                        ErrorService.alert(error.data.message);
                        LoadingService.hide();
                    });
                }

            }).finally(function () {
                HttpInterceptor.activate();
            });
        }

        function onFinishAuthent(token, profil) {
            SessionService.setCredentials({
                token: token
            });
            AdminService.setHasChanges(false);
            var login = vm.profil.mailLogin;
            if (profil.profil === 'ADMIN') {
                $state.go('app.admin.home');
            } else if (profil.profil === 'TECHNICIEN' && profil.profilAssistance) {
                $state.go('app.selectioncheptel');
            } else {
                UserService.getListTypeAbonnement(login).then(function (response) {
                    var estBovin = _.find(response.listeTypeAbonnement, function (typeAbonnement) {
                        return typeAbonnement === "BOV";
                    });
                    if (estBovin) {
                        $state.go('app.eleveur.bovin');
                    } else {
                        $state.go('app.eleveur.woc');
                    }
                }).catch(function (err) {
                    ErrorService.alert(err);
                });
            }
        }

        function modalSuspension(tokenPe, profil) {
            SessionService.setCredentials({
                token: tokenPe
            });
            StatutRecouvrementService.getEstSuspendus(profil.exploitationActive.numExploitation).then(function (suspensionDto) {
                if (suspensionDto.suspendu) {
                    LoadingService.hide();
                    UserService.loadProfil().then(function () {
                        if (suspensionDto.estResponsable) {
                            // affichage du bouton changer de cheptel à conditionner sur UserService.isMultiExploitation()
                            ModalService.popupSuspensionAccesResponsable(UserService.isMultiExploitation()).then(function () {
                                goToOdoo();
                            }, function () {
                                goToSelectionExploitation(tokenPe, profil);
                            });
                        } else {
                            ModalService.popupSuspensionAccesAutre(suspensionDto.emailResponsable, UserService.isMultiExploitation()).then(function () {
                                AuthentService.logout();
                            }, function () {
                                goToSelectionExploitation(tokenPe, profil);
                            });
                        }
                    });
                } else {
                    onFinishAuthent(tokenPe, profil);
                }
            }, function (error) {
                LoadingService.hide();
                ErrorService.alert(error);
            });
        }

        // la redirection est effectuée dans le même onglet
        function goToOdoo() {
            FonctionnaliteService.getFonctionnalite('ODOO').then(function (fonctionnalite) {
                FonctionnaliteService.goToFonctionnalite(fonctionnalite, {
                    menu: false,
                    newPage: false
                }).catch(function (error) {
                    ErrorService.alert(error);
                }).finally(function () {
                    LoadingService.hide();
                });
            });
        }

        function goToSelectionExploitation(tokenPe, profil) {
            ExploitationService.goToSelectionExploitation(tokenPe).then(function (token) {
                onFinishAuthent(token, profil);
            }, function () {
                AuthentService.logout();
            });
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('PerteMdpController', PerteMdpController);

  /** @ngInject */
  function PerteMdpController($state, $stateParams, ErrorService, LoadingService, ModalService, PerteMdpService, versionBack, VERSION) {

    var vm = this;

    vm.version = versionBack.version + " - " + VERSION;

    vm.utilisateur = {};
    if (angular.isDefined($stateParams.identifiant) && ($stateParams.identifiant !== null)) {
      vm.utilisateur.identifiant = $stateParams.identifiant;
    }

    vm.clearInput = function (numagrin) {
      if (numagrin) {
        vm.utilisateur.numSiren = "";
      } else {
        vm.utilisateur.numagrin = "";
      }
    };

    vm.valideDemandeMdp = function () {
      LoadingService.show();
      if (vm.perteMdpForm.$valid) {
        resetPassword();
      }
    };

    function dialog(text) {
      ModalService.alert({
        template: text
      }).then(function () {
        angular.element('#login')[0].focus({preventScroll: true});
      });
      LoadingService.hide();
    }

    function resetPassword() {
      if (vm.utilisateur.numagrin) {
        vm.utilisateur.numagrin = vm.utilisateur.numagrin.toUpperCase();
      }
      PerteMdpService.resetPassword(vm.utilisateur).then(function () {
        LoadingService.hide();
        ModalService.alert({
          template: "Votre mot de passe a été ré initialisé. Un mail contenant les informations permettant de vous reconnecter va vous être envoyé par mail. Pensez à vérifier dans les spams/publicités"
        }).then(function () {
          $state.go('auth');
        });
      }, function (error) {
        dialog(error.data.message);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('OuvertureDossierAnimalController', OuvertureDossierAnimalController);

  /** @ngInject */
  function OuvertureDossierAnimalController($stateParams, fonctionnalite, ErrorService, FonctionnaliteService, LoadingService) {

    LoadingService.show();

    FonctionnaliteService.goToFonctionnalite(fonctionnalite, {
      numeroNational: $stateParams.animal,
      newPage: false
    }).catch(function (error) {
      ErrorService.alert(error);
    }).finally(function () {
      LoadingService.hide();
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('AuthController', AuthController);

  /** @ngInject */
  function AuthController($anchorScroll, $cookies, $location, $mdDialog, $scope, $state, AuthentService, ExploitationService, ContactService,
    ErrorService, HttpInterceptor, LoadingService, ModalService, SessionService, UserService, IncitationCreationCompteKcService, AdminService, ConfigKcService) {
    var vm = this;

    vm.toogleAuthentForm = function () {
      vm.showAuthenticationForm = true;
    };

    vm.urlMireKc = undefined;
    vm.showAuthenticationForm = false;
    // Authent
    vm.authent = {
      username: undefined,
      password: undefined
    };
    ConfigKcService.getUrlMireKc().then(function (urlMireKc) {
      vm.urlMireKc = urlMireKc;
    });
    function onFinishAuthent(token, profil, goToValidationIdentite) {
      SessionService.setCredentials({
        token: token
      });
      AdminService.setHasChanges(false);
      var login = vm.authent.username;
      if (angular.isDefined(goToValidationIdentite) && !goToValidationIdentite) {
        if (profil.profil === 'ADMIN') {
          $state.go('app.admin.home');
        } else if (profil.profil === 'TECHNICIEN') {
          $state.go('app.selectioncheptel');
        } else {

          UserService.getListTypeAbonnement(login).then(function (response) {
            var estBovin = _.find(response.listeTypeAbonnement, function (typeAbonnement) {
              return typeAbonnement === "BOV";
            });
            if (estBovin) {
              $state.go('app.eleveur.bovin');
            } else {
              $state.go('app.eleveur.woc');
            }

          });
        }
      }
    }

    vm.onSubmitAuthent = function () {
      vm.authentError = undefined;
      if (vm.authentForm.$valid) {
        LoadingService.show();
        IncitationCreationCompteKcService.getAfficherAlerte(vm.authent.username, vm.authent.password).then(function (result) {
          LoadingService.hide();
          if (angular.isDefined(result) && result.showAlerteCompteKcExist) {
            ModalService.alert({
              template: "Un compte associé à l'identifiant est déjà créé. Veuillez utiliser se compte pour accèder à Pilot'Elevage."
            });
          } else if (angular.isDefined(result) && result.showAlerteIncitation) {
            if (result.forceKeycloak) {
              ModalService.popupObligatoinKeycloak(result.identifiantKc, vm.urlMireKc).then(function () {
                authenticate(true);
                $state.go('validationIdentite', {infosExploitation: result});
              }, function () {

              });
            } else {
              ModalService.popupIncitation(result.nombreJours, vm.urlMireKc).then(function () {
                authenticate(true);
                $state.go('validationIdentite', {infosExploitation: result});
              }, function () {
                authenticate(false);
              });
            }
          } else {
            authenticate(false);
          }
        }, function () {
          LoadingService.hide();
          authenticate(false);
        });
      }
    };

    function authenticate(goToValidationIdentite) {
      LoadingService.show();
      SessionService.clean();
      HttpInterceptor.deactivate();
      AuthentService.login(vm.authent.username, vm.authent.password).then(function (token) {
        UserService.getProfil(token).then(function (profil) {
          LoadingService.hide();

          if ((profil.profil !== 'ADMIN') && (profil.multiExploitation === true)) {
            ExploitationService.goToSelectionExploitation(token).then(function (token) {
              onFinishAuthent(token, profil, goToValidationIdentite);
            }, function (error) {
              ErrorService.alert(error);
            });
          } else {
            onFinishAuthent(token, profil, goToValidationIdentite);
          }
        }, function (error) {
          LoadingService.hide();
          ErrorService.alert(error);
        });
      }, function (error) {
        LoadingService.hide();
        if (_.get(error, 'data.code')) {
          vm.authentError = error.data.message;
        } else {
          ErrorService.alert(error);
        }

      }).finally(function () {
        HttpInterceptor.activate();
      });
    }

    vm.goToForm = function (x) {
      if ($location.hash() === x) {
        $anchorScroll();
      } else {
        $location.hash(x);
      }

      if (angular.equals(x, 'part1')) {
        // eslint-disable-next-line
        vm.authentForm.username.$$element.focus();
      }
    };

    // Contact
    vm.departements = undefined;
    ContactService.getDepartements().then(function (departements) {
      vm.departements = departements;
    }, function (error) {
      ErrorService.log(error);
    });

    function resetContact() {
      vm.contact = {
        nom: undefined,
        email: undefined,
        numeroExploitation: undefined,
        numeroTelephone: undefined,
        departementRattachement: undefined,
        message: undefined
      };
    }
    resetContact();

    vm.onFocusNumeroExploitation = function () {
      if (angular.isUndefined(vm.contactForm.numeroExploitation.$viewValue) || (vm.contactForm.numeroExploitation.$viewValue === '')) {
        vm.contact.numeroExploitation = 'FR';
      }
    };

    $scope.$watch(function () {
      // eslint-disable-next-line
      if (vm.contactForm.numeroExploitation.$$rawModelValue && !_.isEqual(vm.contactForm.numeroExploitation.$$rawModelValue, 'FR') && vm.contactForm.numeroExploitation.$$rawModelValue.length > 1) {
        _.forEach(vm.departements, function (departement) {
          // eslint-disable-next-line
          if (_.isEqual(String(departement.code), vm.contactForm.numeroExploitation.$$rawModelValue.substring(0, 2))) {
            vm.contact.departementRattachement = departement;
          }
        });
      }
    }, true);

    vm.onSubmitContact = function () {
      if (vm.contactForm.$valid) {
        LoadingService.show();
        if (vm.contact.numeroExploitation) {
          vm.contact.numeroExploitation = 'FR' + vm.contact.numeroExploitation;
        }

        ContactService.sendMessage(vm.contact).then(function () {

          ModalService.alert({
            template: "Votre message a bien été envoyé"
          }).then(function () {
            resetContact();
            vm.contactForm.$setPristine();

            $location.hash('part1');
            $anchorScroll();
          });
        }, function (error) {
          ErrorService.alert(error);
        }).finally(function () {
          LoadingService.hide();
        });
      }
    };

    vm.goToOubliMdp = function () {
      $state.go('pertemdp', {
        identifiant: vm.authent.username
      });
    };

    vm.openGuideAbonnement = function () {
      $mdDialog.show({
        templateUrl: 'app/auth/guideAbonnement/guideAbonnement.html',
        controller: 'GuideAbonnementController',
        controllerAs: 'ctrl'
      });
    };

    vm.openDialogLoginSynel = function () {
      $mdDialog.show({
        controller: 'PopupLoginSynelController',
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'app/auth/_common/popupLoginSynel/popupLoginSynel.html'
      }).then(function (result) {
        LoadingService.show();
        AuthentService.getInfosSynel(result).then(function (res) {
          var infos = {
            numExploitation: res.numExploitation,
            hideSiren: true
          };
          if (angular.isDefined(res.numsiren)) {
            infos.numSiren = res.numsiren;
          }
          if (angular.isDefined(res.numagri)) {
            infos.numNumagrin = res.numagri;
          }
          $state.go('abonnement.informations', infos);
        }, function () {
          ErrorService.alert(null, {
            titre: 'Identifiant inconnu',
            message: 'L\'identifiant renseigné est inconnu. Veuillez réessayer ou contacter l\'assistance.'
          });
        }).finally(function () {
          LoadingService.hide();
        });
      });
    };
  }
})();

(function () {
    /**
     * Session utilisateur générale à l'application.
     * @constructor
     */

    function AdvSessionService() {

        var that = this;

        that.authenticated = false;

        that.isAuthenticated = function () {
            return that.authenticated;
        };

        that.setAuthenticated = function (value) {
            that.authenticated = value;
        };

    }

    angular
        .module('app').service('AdvSessionService', AdvSessionService);
})();

(function () {
    /**
     * log général à l'application.
     * @constructor
     */

    function AdvLogDecorator() {

        var self = this;

        self.logToBeDecorated = null;
        self.oldLogFn = null;
        self.oldDebugFn = null;

        self.decorateLogger = function (logToBeDecorated) {

            self.logToBeDecorated = logToBeDecorated;
            self.oldLogFn = this.logToBeDecorated.log;
            self.oldDebugFn = this.logToBeDecorated.debug;

            self.logToBeDecorated.log = function () {
                self.oldLogFn.apply(self.logToBeDecorated, arguments);
            };

            // ajout pour qu'angular mock soit content, voir https://groups.google.com/forum/#!topic/angular/DWOMe6c7L_Q
            self.logToBeDecorated.log.logs = [];

        };

    }

    angular
        .module('app').service('AdvLogDecorator', AdvLogDecorator);
})();

(function () {
    /**
     * Service de gestion des erreurs
     * @constructor
     */

    function AdvErrorService($log) {

        var that = this;

        that.onError = function (error) {
            $log.error('Erreur : ' + error);
        };

    }

    angular
        .module('app').service('AdvErrorService', AdvErrorService);
})();

(function () {
    /**
     * Configuration générale à l'application.
     * @constructor
     */

    function AdvConfigService($location) {

        var that = this;

        // Contient les paramètres de configuration
        that.params = {};

        that.authentStateName = "auth";

        that.authentKcStateName = "routage";

        that.getAuthentStateName = function () {
            return that.authentStateName;
        };

        that.getAuthentKcStateName = function () {
            return that.authentKcStateName;
        };

        that.setAuthentStateName = function (value) {
            that.authentStateName = value;
        };

        that.params.backendUrl = $location.protocol() + "://" + $location.host() + ":" + $location.port();

        that.getBackendUrl = function () {
            return that.params.backendUrl;
        };

        that.setBackendUrl = function (value) {
            that.params.backendUrl = value;
        };

        that.mergeConfig = function (newParams) {
            if (newParams !== null && angular.isObject(newParams)) {
                for (var key in newParams) {
                    if (newParams.hasOwnProperty(key)) {
                        that.params[key] = newParams[key];
                    }
                }
            }
        };

    }

    angular
        .module('app').service('AdvConfigService', AdvConfigService);
})();

(function () {
    /**
     * Service d'authentification
     * @constructor
     */

    function AdvAuthentService() {

        var that = this;

        that.isAuthentNeeded = function () {
            return true;
        };

    }

    angular
        .module('app').service('AdvAuthentService', AdvAuthentService);
})();

(function () {
    /**
     * Service de gestion de l'application
     * @constructor
     */

    function AdvApplicationService() {

        var that = this;

        // vrai ssi l'application est compl�tement charg�e
        that.ready = false;

        that.isReady = function () {
            return that.ready;
        };

        that.setReady = function () {
            that.ready = true;
        };

        that.isAuthentNeeded = function () {
            return true;
        };

    }

    angular
        .module('app').service('AdvApplicationService', AdvApplicationService);
})();

(function () {
  'use strict';

  angular
    .module('app')
    .run(runBlock);

  /** @ngInject */
  function runBlock($location, $log, $rootScope, $state, $window, AuthentService, ConfigService, ErrorService, HttpInterceptor, LoadingService, OptionsService, SessionService, MESSAGES) {
    /* var ANALYTICS = OptionsService.ANALYTICS;
    if (angular.isDefined(ANALYTICS)) {
      $window.ga('create', ANALYTICS.ID, ANALYTICS.OPTIONS);
    } */

    var onStateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState) {
      HttpInterceptor.deactivate();

      var authentStateName = ConfigService.getAuthentStateName();
      if (toState.authenticated !== false && !SessionService.isAuthenticated()) {
        $log.info('Demande de la page \'' + toState.name + '\' alors que la session utilisateur n\'est pas authentifiée. Redirection sur \'' + authentStateName + '\'');
        event.preventDefault();
        $state.go(authentStateName);
      } else {
        LoadingService.show();
      }
    });
    $rootScope.$on('$destroy', onStateChangeStart);

    var onStateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
      if (_.get(fromState, 'name') === ConfigService.getAuthentStateName()) {
        toState.fromAuth = true;
      }
      if (_.get(fromState, 'name') === ConfigService.getAuthentKcStateName()) {
        toState.fromAuth = true;
      }

      HttpInterceptor.activate();

      LoadingService.hide();

      // $window.ga('send', 'pageview', $location.path());
    });
    $rootScope.$on('$destroy', onStateChangeSuccess);

    var onStateChangeError = $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
      HttpInterceptor.activate();

      LoadingService.hide();

      event.preventDefault();

      if (angular.isDefined(error)) {
        if (ErrorService.isAuthentificationError(error)) {
          $log.log('Problème d\'authentification. Redirection vers la page d\'authentification.');

          ErrorService.alert(error, {
            message: MESSAGES.SESSION_EXPIREE
          }).then(function () {
            AuthentService.logout();
          });
        } else if (ErrorService.isFatalError(error)) {
          $log.log('Erreur bloquante. Redirection vers la page d\'authentification.');

          delete error.service;

          ErrorService.alert(error, {
            message: MESSAGES.ERREUR_BLOQUANTE
          }).then(function () {
            AuthentService.logout();
          });
        } else if (ErrorService.isNetworkError(error)) {
          ErrorService.alert(error);
        } else {
          ErrorService.alert(error).then(function () {
            goToHome(toState);
          });
        }
      } else {
        ErrorService.alert().then(function () {
          goToHome(toState);
        });
      }
    });
    $rootScope.$on('$destroy', onStateChangeError);

    function goToHome(toState) {
      if (toState.name.indexOf('app.admin') === -1) {
        $state.go('app.eleveur.bovin.home');
      } else {
        $state.go('app.admin.home');
      }
    }
  }
})();

(function () {
  angular
    .module('app')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($stateProvider) {
    $stateProvider
      .state('auth', {
        url: '/auth',
        templateUrl: 'app/auth/auth.html',
        controller: 'AuthController',
        controllerAs: 'ctrl',
        authenticated: false,
        resolve: {
          referentiel: ['ReferentielService', function (ReferentielService) {
            return ReferentielService.load();
          }]
        }
      }).state('app', {
        url: '/',
        template: '<ui-view flex layout="column"></ui-view>',
        controller: 'MainController',
        controllerAs: 'ctrl',
        resolve: {
          profil: ['UserService', function (UserService) {
            return UserService.loadProfil();
          }],
          versionBack: ['ParametresService', function (ParametresService) {
            return ParametresService.getVersion();
          }],
          referentiel: ['ReferentielService', function (ReferentielService) {
            return ReferentielService.load();
          }]
        }
      })
      .state('redirection', {
        url: '/redirection/:fonctionnalite/:options',
        templateUrl: 'app/_common/redirection/redirection.html',
        controller: 'RedirectionController',
        controllerAs: 'ctrl',
        params: {
          options: null
        }
      }).state('maintenance', {
        url: '/maintenance',
        templateUrl: 'app/maintenance/pageMaintenance.html',
        authenticated: false
      }).state('validationIdentite', {
        url: '/validation-identite',
        templateUrl: 'app/validationIdentite/validationIdentite.html',
        authenticated: false,
        controller: 'ValidationIdentiteController',
        controllerAs: 'ctrl',
        params: {
          infosExploitation: null
        }
      }).state('routage', {
        url: '/routage',
        templateUrl: 'app/routageKc/routage.html',
        authenticated: false,
        controller: 'RoutageKcController',
        controllerAs: 'ctrl',
        resolve: {
          referentiel: ['ReferentielService', function (ReferentielService) {
            return ReferentielService.load();
          }]
        }
      }).state('selectionProfil', {
        url: '/selection-profil',
        templateUrl: 'app/selectionProfil/selectionProfil.html',
        authenticated: true,
        controller: 'SelectionProfilController',
        controllerAs: 'ctrl'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($locale, $state, UserService) {

    $locale.DATETIME_FORMATS.SHORTMONTH = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'];
    $locale.DATETIME_FORMATS.SHORTDAY = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];

    if (_.get($state, 'current.name') === 'app') {
      switch (UserService.get('profil')) {
        case 'ADMIN':
          $state.go('app.admin.home');
          break;
          case 'ELEVEUR':
          case 'TECHNICIEN':
            UserService.getListTypeAbonnement(UserService.get('login')).then(function (response) {
              var listAbonnements = response.listeTypeAbonnement;
              if (listAbonnements.indexOf("BOV") !== -1) {
                  $state.go('app.eleveur.bovin.home');
                  return;
              }
              if (listAbonnements.indexOf("OVCAP") !== -1) {
                  $state.go('app.eleveur.woc.home');
                  return;
              }
              $state.go('auth');
          });
          break;
        default:
          $state.go('app.eleveur.bovin.home');
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app')
    .constant('BACKEND', {

      url: './pilot-elevage-api/api/v1'

      /* dev */
//      url: 'http://localhost:8082/api/v1'

    })
    .constant('VERSION', '1.6.46')
    .constant('STORAGE', {
      SESSION: {
        CREDENTIALS: {
          key: 'pe_credentials',
          type: 'json'
        }
      }
    })
    .constant('LISTEPARTENAIRES', [
      {
        logo: 'assets/images/partenaires/AIAM.PNG',
        url: 'https://normandie.chambres-agriculture.fr/',
        libelle: 'AIAM'
      },
      {
        logo: 'assets/images/partenaires/capl.png',
        url: 'https://pays-de-la-loire.chambres-agriculture.fr/',
        libelle: "Chambre d'agriculture de Pays de Loire"
      },
      {
        logo: 'assets/images/partenaires/LN_logo.jpg',
        url: 'https://littoral-normand.fr',
        libelle: 'LN'
      },
      {
        logo: 'assets/images/partenaires/elvup2.jpg',
        url: 'https://www.orne-conseil-elevage.fr/',
        libelle: "Elv'up"
      },
      {
        logo: 'assets/images/partenaires/arichn.PNG',
        url: 'https://normandie.chambres-agriculture.fr/',
        libelle: 'ARICHN'
      },
      {
        logo: 'assets/images/partenaires/E140.JPG',
        url: 'https://www.aicc-identification.com',
        libelle: 'AICC'
      },
      {
        logo: 'assets/images/partenaires/conseil_elevage_41.png',
        url: 'https://centre-valdeloire.chambres-agriculture.fr/chambre-dagriculture-de-loir-et-cher/presentation/nos-collaborateurs/elevage/',
        libelle: 'Conseil Elevage Lait 41'
      },
      {
        logo: 'assets/images/partenaires/logo_CA28.jpg',
        url: 'http://www.eure-et-loir-conseil-elevage.fr/nos-services-eure-et-loir/services-elevage.html',
        libelle: 'CA 28'
      },
      {
        logo: 'assets/images/partenaires/Touraine_Conseil_Elevage.jpg',
        url: 'http://www.touraine-conseil-elevage.fr',
        libelle: 'Touraine Conseil Elevage'
      },
      {
        logo: 'assets/images/partenaires/aell.jpg',
        url: 'https://centre-valdeloire.chambres-agriculture.fr/alliance-elevage-loir-et-loire',
        libelle: 'AELL'
      },
      {
        logo: 'assets/images/partenaires/Logo_EdEi.jpg',
        url: 'https://nouvelle-aquitaine.chambres-agriculture.fr/',
        libelle: 'EdEI'
      },
      {
        logo: 'assets/images/partenaires/cran.jpg',
        url: 'https://normandie.chambres-agriculture.fr/',
        libelle: 'CRAN'
      },
      {
        logo: 'assets/images/partenaires/bc_loir_cher.JPG',
        url: 'https://centre-valdeloire.chambres-agriculture.fr/chambre-dagriculture-de-loir-et-cher/vous-etes-agriculteur/productions-animales/bovins-viande/',
        libelle: 'Bovin croissance loire et cher'
      },
      {
        logo: 'assets/images/partenaires/Logo_seenovia.jpg',
        url: 'https://www.seenovia.fr/',
        libelle: 'seenovia'
      },
      {
        logo: 'assets/images/partenaires/assel79.jpg',
        url: 'https://deux-sevres.chambre-agriculture.fr/techniquesinnovations/productions-animales/ede-identification-des-cheptels',
        libelle: 'ASSEL79'
      }
    ])
    .constant('MESSAGES', {
      SESSION_EXPIREE: 'Votre session a expiré, redirection vers la page d\'authentification.',
      ERREUR_TECHNIQUE: 'Une erreur technique s\'est produite. Merci de réessayer ultérieurement.',
      ERREUR_BLOQUANTE: 'Une erreur bloquante s\'est produite, redirection vers la page d\'authentification.',
      NO_ACCES: 'Vous n\'avez pas accés à cette fonctionnalité.'
    })
    .constant('NOMABONNEMENT', {
      PERFORMANCE: 'Performance Bovin',
      ESSENTIEL: 'Essentiel Bovin'
    })
    .constant('DELAICLOTURE', 1)
    .constant('REDUCTION', [])
    .constant('ASSISTANCE_FACTURATION', {
      TITRE: 'Assistance Facturation',
      TELEPHONE: '02 61 12 02 32',
      EMAIL: 'facturation@pilotelevage.fr',
      FREQUENCE: 'lundi, mardi, jeudi et vendredi, de 9h à 12h'
    });
})();

(function () {
  'use strict';

  angular
    .module('app')
    .config(config);

  /** @ngInject */
  function config($compileProvider, $httpProvider, $mdDateLocaleProvider, $mdGestureProvider, $mdThemingProvider) {
    $mdDateLocaleProvider.formatDate = function (date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    };

    $httpProvider.interceptors.push('HttpInterceptor');

    $mdThemingProvider.definePalette('primary', {
      50: 'ffebee',
      100: 'ffcdd2',
      200: 'ef9a9a',
      300: 'e57373',
      400: 'ef5350',
      500: '002a0c',
      600: '015433',
      700: 'd32f2f',
      800: 'c62828',
      900: 'b71c1c',
      A100: 'ff8a80',
      A200: 'ff5252',
      A400: 'ff1744',
      A700: 'd50000',
      contrastDefaultColor: 'light',

      contrastDarkColors: ['50', '100', '200', '300', '400', 'A100'],
      contrastLightColors: undefined
    });

    $mdThemingProvider.definePalette('secondary', {
      50: 'ffebee',
      100: 'ffcdd2',
      200: 'ef9a9a',
      300: 'e57373',
      400: 'ef5350',
      500: 'f44336',
      600: 'e53935',
      700: 'd32f2f',
      800: 'c62828',
      900: 'b71c1c',
      A100: 'ff8a80',
      A200: '3fae2a',
      A400: 'ff1744',
      A700: '007d00',
      contrastDefaultColor: 'light',

      contrastDarkColors: ['50', '100', '200', '300', '400', 'A100'],
      contrastLightColors: undefined
    });

    $mdThemingProvider.theme('default')
      .primaryPalette('primary')
      .accentPalette('secondary');

    /* Click mobile workaround */
    var userAgent = navigator.userAgent || navigator.vendor;
    // eslint-disable-next-line
    if (/android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)) {
      $mdGestureProvider.skipClickHijack();
    }
  }
})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/auth.html","<div flex layout=\"column\" class=\"adv-auth\">\n  <md-content flex>\n    <div class=\"part part1\" id=\"part1\">\n      <div class=\"part-content\" layout=\"column\">\n        <div layout-gt-sm=\"row\">\n          <div flex-gt-sm=\"50\" class=\"flex-50-left logo-accueil\">\n            <img src=\"assets/images/logo.png\">\n          </div>\n\n          <div flex-gt-sm=\"50\" flex-sm=\"70\" class=\"flex-50-right authent-form\">\n            <div layout=\"column\" class=\"connection md-whiteframe-4dp\">\n              <div layout-gt-sm=\"row\" layout-align=\"space-between center\" class=\"margin-auto-h3\">\n                <h3 class=\"title-mire\">\n                  <md-icon md-svg-src=\"assets/images/icones/account_circle.svg\" aria-label=\"account_circle\"></md-icon>\n                  Se connecter\n                </h3>\n              </div>\n              <div layout-gt-sm=\"row\">\n                <div class=\"wrapper\">\n                  <div class=\"auth-bloc-width\" ng-if=\"ctrl.showAuthenticationForm\">\n                    <form name=\"ctrl.authentForm\" ng-submit=\"ctrl.onSubmitAuthent()\" layout-align=\"space-between start\" ng-if=\"ctrl.showAuthenticationForm\" novalidate>\n                      <div layout=\"column\">\n                        <input type=\"text\" name=\"username\" ng-model=\"ctrl.authent.username\" required placeholder=\"Mon identifiant *\" style=\"margin-bottom: 10px\">\n                        <div ng-messages=\"ctrl.authentForm.username.$error\" ng-show=\"ctrl.authentForm.$submitted\">\n                          <div ng-message=\"required\">Donnée obligatoire</div>\n                        </div>\n                      </div>\n                      <div layout=\"column\">\n                        <input type=\"password\" name=\"password\" ng-model=\"ctrl.authent.password\" required placeholder=\"Mon mot de passe *\" style=\"margin-bottom: 10px\">\n\n                        <div ng-messages=\"ctrl.authentForm.password.$error\" ng-show=\"ctrl.authentForm.$submitted\">\n                          <div ng-message=\"required\">Donnée obligatoire</div>\n                        </div>\n                      </div>\n                      <md-button type=\"submit\" class=\"md-raised md-primary button-mire-pe\">Connexion</md-button>\n                    </form>\n                  </div>\n                  <div layout=\"column\" class=\"auth-bloc-width margin-auto\">\n                    <a class=\"md-raised md-primary md-button md-ink-ripple button-mire-kc\" ng-href=\"{{ctrl.urlMireKc}}\">Connexion avec <br>adresse email</a>\n                  </div>\n                </div>\n              </div>\n              <div layout-gt-sm=\"row\">\n                <div layout-align=\"space-between center\" class=\"margin-auto\" style=\"text-align: center\">\n                  <a ng-click=\"ctrl.goToOubliMdp()\" tabindex=\"-1\">Mot de passe oublié ?</a>\n                </div>\n              </div>\n              <div ng-if=\"ctrl.authentError\" class=\"error-message\">{{ctrl.authentError}}</div>\n            </div>\n          </div>\n        </div>\n        <div>\n          <p style=\"text-align: center\">\n            Le pilotage numérique de votre troupeau bovin lait ou viande\n          </p>\n          <div flex layout-gt-sm=\"row\" layout-align=\"center start\" style=\"gap:10px; padding: 10px\">\n            <span flex=\"25\"> <img src=\"app/auth/_common/images/telecharger.png\" style=\"float:right\"></span>\n            <span flex=\"75\">Vous pourrez envoyer le lien de téléchargement de l’application sur votre smartphone et ceux\n              de vos associés après connexion au portail.</span>\n          </div>\n        </div>\n        <div style=\"text-align: center\">\n          <p style=\"text-align: center\">Pas encore abonné ?</p>\n          <span>En cliquant sur <b>« Découvrez les Offres Pilot’Elevage »</b>, vous pourrez\n            visualiser les formules et souscrire un\n            abonnement.</span>\n        </div>\n        <div style=\"text-align: center\">\n          <md-button type=\"button\" class=\"md-raised md-accent btn-creer-compte\" ui-sref=\"abonnement\">Découvrez les Offres Pilot’Elevage</md-button>\n        </div>\n      </div>\n    </div>\n    \n    <div class=\"part part2\" id=\"part2\">\n      <div layout=\"column\" class=\"part-content\">\n        <div layout=\"column\" class=\"experience md-whiteframe-12dp\">\n          <h2>Découvrez Pilot\'Elevage</h2>\n          <div layout-gt-sm=\"row\">\n            <div flex-gt-sm=\"60\" class=\"media\">\n              <iframe class=\"video\" src=\"https://www.youtube-nocookie.com/embed/MzIKp9y9OfE\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>\n            </div>\n            <div flex-gt-sm=\"40\" class=\"piloter\">\n              <h3>Pilotez votre exploitation</h3>\n\n              <p>Pilot’Elevage est une solution de pilotage numérique de votre élevage intuitive et\n                performante, Co construite avec des éleveurs.<br>\n                Pour votre élevage bovin, Pilot’Elevage vous permet de gérer l’identification, la\n                reproduction, la santé, les performances lait et viande de votre troupeau.<br>\n                Disponible sur les différents supports (ordinateur, tablette et en version mobile sur\n                smartphone).</p>\n              <p>\n                Pour votre élevage ovin/caprin, Pilot’Elevage vous permet de réaliser et de consulter vos\n                enregistrements : recensements annuels (reproducteurs et béliers), documents de\n                circulation et commandes de repères.<br>\n                Disponible sur Ordinateur et tablette.\n              </p>\n            </div>\n          </div>\n        </div>\n\n      </div>\n    </div>\n    <div class=\"part part3\" id=\"part3\">\n      <div flex layout-gt-sm=\"row\" class=\"part-content\">\n        <form name=\"ctrl.contactForm\" ng-submit=\"ctrl.onSubmitContact()\" flex-gt-sm=\"60\" layout=\"column\" layout-align=\"start start\" novalidate>\n          <h3>Une question ?</h3>\n\n          <p>Vous souhaitez avoir plus d\'informations ?\n            <br>Contactez-nous !\n          </p>\n\n          <div class=\"input-container\">\n            <input type=\"text\" name=\"nom\" ng-model=\"ctrl.contact.nom\" maxlength=\"20\" placeholder=\"Mon nom *\" required>\n\n            <div ng-messages=\"ctrl.contactForm.nom.$error\" ng-show=\"ctrl.contactForm.$submitted\">\n              <div ng-message=\"required\">Donnée obligatoire</div>\n            </div>\n          </div>\n\n          <div class=\"input-container\">\n            <input type=\"email\" name=\"email\" ng-model=\"ctrl.contact.email\" required ng-pattern=\"/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$/\" placeholder=\"Mon adresse mail *\">\n\n            <div ng-messages=\"ctrl.contactForm.email.$error\" ng-show=\"ctrl.contactForm.$submitted\">\n              <div ng-message=\"required\">Donnée obligatoire</div>\n              <div ng-message=\"pattern\">Adresse incorrecte</div>\n            </div>\n          </div>\n\n          <div class=\"input-container\">\n            <input type=\"text\" name=\"numeroExploitation\" ng-model=\"ctrl.contact.numeroExploitation\" ng-focus=\"ctrl.onFocusNumeroExploitation()\" ng-pattern=\"/^[a-zA-Z]{2} [0-9]{2} [0-9]{3} [0-9]{3}$/\" ui-mask=\"FR ?9?9 ?9?9?9 ?9?9?9\" ui-mask-placeholder=\"\" ui-mask-placeholder-char=\"space\" placeholder=\"Mon numéro de cheptel\">\n\n            <div ng-messages=\"ctrl.contactForm.numeroExploitation.$error\" ng-show=\"ctrl.contactForm.$submitted\">\n              <div ng-message=\"pattern\">Numéro incorrect</div>\n            </div>\n          </div>\n\n          <div class=\"input-container\">\n            <input type=\"text\" name=\"numeroTelephone\" ng-model=\"ctrl.contact.numeroTelephone\" ng-pattern=\"/^[0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}$/\" ui-mask=\"?9?9 ?9?9 ?9?9 ?9?9 ?9?9\" ui-mask-placeholder=\"\" ui-mask-placeholder-char=\"space\" placeholder=\"Mon numéro de téléphone\">\n\n            <div ng-messages=\"ctrl.contactForm.numeroTelephone.$error\" ng-show=\"ctrl.contactForm.$submitted\">\n              <div ng-message=\"pattern\">Numéro incorrect</div>\n            </div>\n          </div>\n\n          <div ng-if=\"ctrl.departements && ctrl.departements.length > 0\" class=\"input-container\">\n            <select name=\"departementRattachement\" ng-model=\"ctrl.contact.departementRattachement\" ng-disabled=\"ctrl.contact.numeroExploitation\" ng-required=\"!ctrl.contact.numeroExploitation\" ng-class=\"{placeholder: !ctrl.contact.departementRattachement}\">\n              <option disabled=\"disabled\" selected=\"selected\" value=\"{{undefined}}\">Département de rattachement\n                {{!ctrl.contact.numeroExploitation ? \' *\' : \'\'}}</option>\n              <option ng-repeat=\" departement in ctrl.departements | orderBy: \'libelle\' \" ng-value=\"departement\">\n                {{departement.libelle}}</option>\n            </select>\n\n            <div ng-messages=\"ctrl.contactForm.departementRattachement.$error\" ng-show=\"ctrl.contactForm.$submitted\">\n              <div ng-message=\"required\">Donnée obligatoire</div>\n            </div>\n          </div>\n\n          <div class=\"input-container\">\n            <textarea name=\"message\" ng-model=\"ctrl.contact.message\" required placeholder=\"Votre message *\"></textarea>\n\n            <div ng-messages=\"ctrl.contactForm.message.$error\" ng-show=\"ctrl.contactForm.$submitted\">\n              <div ng-message=\"required\">Donnée obligatoire</div>\n            </div>\n          </div>\n\n          <md-button type=\"submit\" class=\"md-raised md-primary\">Envoyer</md-button>\n        </form>\n        <div class=\"img-contact\">\n          <img src=\"app/auth/_common/images/inscription.jpg\">\n        </div>\n\n\n        <div ng-if=\"ctrl.contact.departementRattachement.organismeAssistance\" flex=\"40\" layout=\"column\" class=\"assistance\">\n          <h3>Assistance</h3>\n\n          <p>Vous êtes déjà client et vous avez des difficultés à vous connecter ?</p>\n\n          <a ng-if=\"ctrl.contact.departementRattachement.organismeAssistance.email\" href=\"mailto:{{ctrl.contact.departementRattachement.organismeAssistance.email}}\">\n            <md-icon md-svg-src=\"assets/images/icones/email.svg\" aria-label=\"email\"></md-icon>\n            {{ctrl.contact.departementRattachement.organismeAssistance.email}}\n          </a>\n          <a ng-if=\"ctrl.contact.departementRattachement.organismeAssistance.telephone\" href=\"tel:{{ctrl.contact.departementRattachement.organismeAssistance.telephone}}\">\n            <md-icon md-svg-src=\"assets/images/icones/phone.svg\" aria-label=\"phone\"></md-icon>\n            {{ctrl.contact.departementRattachement.organismeAssistance.telephone | formatPhoneNumber}}\n          </a>\n        </div>\n      </div>\n\n      <div layout=\"column\" layout-align=\"start center\" class=\"footer\">\n        <h3>Qui sommes-nous ?</h3>\n\n        <p style=\"border: solid; padding:10px\">\n          L’offre Pilot’Elevage est développée par la SAS Pilot’Elevage dont les actionnaires sont : la Chambre\n          Régionale d’Agriculture de Normandie, Elvup, Littoral Normand, la Chambre\n          d’Agriculture des Pays de la Loire, Seenovia, la Chambre d\'agriculture d\'Eure et Loir, Touraine Conseil\n          Elevage, l\'Alliance Elevage Loir et Loire, Loir et Cher conseil élevage Lait, la Chambre\n          d\'agriculture du Loir et Cher et la Chambre régionale d’agriculture Nouvelle Aquitaine.\n          <br> Ces entreprises des réseaux Chambres d’Agriculture et Entreprises de conseil en élevage associent leurs\n          expertises pour proposer une offre de service complète de gestion numérique des\n          élevages bovins, ovins et caprins.\n        </p>\n        <a ui-sref=\"mentionsLegales\">Mentions légales</a>\n      </div>\n    </div>\n  </md-content>\n</div>");
$templateCache.put("app/maintenance/pageMaintenance.html","<style>\n	body {\n		background-image: url(\'/app/auth/_common/images/background.jpg\');\n		background-repeat: no-repeat;\n		background-size: 100% 100%;\n	}\n	.center {\n		margin-top:10vh;\n		display: flex;\n		justify-content: center;\n		align-items: center;	\n	}\n	.column {\n		display: flex;\n		flex-direction: column;\n		\n	}\n	p {\n		height: 10px;\n	}\n	.message-content {\n		padding: 30px;\n		font-size: 16px;\n		text-align: center;\n	}\n	h1 {\n		font-size: 32px;\n		font-family: \'Aldrich\', sans-serif;\n		font-weight: bold;\n		color: #015433;\n		letter-spacing: .1rem;\n	}\n	.p-top {\n		font-size: 20px;\n		margin-bottom: 10px;\n	}\n	.logo {\n		width: 210px;\n	}\n</style>\n	\n<div class=\"center column\">\n	<img src=\"assets/images/logo.png\" class=\"logo\">\n	<h1>Site en maintenance</h1>			\n	<div class=\"message-content\">\n		<p class=\"p-top\">Nous nous excusons pour la gêne occasionnée.</p>\n		<br>\n		<p>Merci d\'essayer de vous reconnecter plus tard dans la journée,</p>\n		<p>si le service n\'est pas rétabli,</p>\n		<p>contactez votre assistance Pilot\'Elevage habituelle.</p>\n	<div>\n</div></div></div>");
$templateCache.put("app/perteMdp/perteMdp.html","<div flex layout=\"column\" class=\"perte-mdp\">\n\n  <md-toolbar class=\"header-bar\">\n    <div class=\"md-toolbar-tools\">\n      <a ui-sref=\"auth\" flex layout=\"row\" layout-align=\"start center\">\n        <img src=\"assets/images/logo-plat.png\" class=\"logo\">\n      </a>\n    </div>\n  </md-toolbar>\n\n  <div class=\"title-bar\" layout=\"row\">\n    <h2 flex=\"30\">Mot de passe oublié</h2>\n    <div flex=\"30\" layout-align=\"center center\">\n    </div>\n    <div flex=\"30\"></div>\n  </div>\n\n  <form name=\"ctrl.perteMdpForm\" ng-submit=\"ctrl.valideDemandeMdp()\" novalidate flex layout=\"column\">\n\n    <md-content flex layout=\"column\" layout-align=\"start center\">\n\n      <div layout=\"column\" layout-align=\"left\" class=\"content\">\n\n        <div class=\"label-verification\">\n          <label>Afin de pouvoir vérifier votre identité, merci de renseigner les informations suivantes:</label>\n        </div>\n        <md-input-container>\n          <label>Identifiant ou Adresse Mail</label>\n          <input required name=\"login\" id=\"login\" ng-model=\"ctrl.utilisateur.identifiant\"> \n          <div ng-messages=\"ctrl.perteMdpForm.login.$error\" role=\"alert\">\n            <div ng-message=\"required\">La saisie de l\'identifiant est obligatoire.</div>\n          </div>\n        </md-input-container>\n        <i class=\"assistance\">En cas de perte de votre identifiant, veuillez contacter votre service d\'assistance.</i>\n\n        <div class=\"exploitation\">\n          <h4 class=\"codePays\">FR</h4>\n          <md-input-container>\n            <label>N° Exploitation</label>\n            <input required name=\"numExploitation\" ng-model=\"ctrl.utilisateur.numExploitation\" maxlength=\"8\" ng-pattern=\"/^[0-9]{8}$/\">\n            <div ng-messages=\"ctrl.perteMdpForm.numExploitation.$error\" role=\"alert\">\n              <div ng-message=\"required\">Donnée obligatoire</div>\n              <div ng-message=\"pattern\">Votre N° d\'exploitation doit contenir 8 caractères numériques.</div>\n            </div>\n          </md-input-container>\n        </div>\n\n        <md-input-container>\n          <label ng-class=\"numagrin ? \'disabled\' : \'\' \">N° Siren</label>\n          <input ng-required=\"!ctrl.utilisateur.numagrin\" name=\"numSiren\" adv-numbers-only ng-class=\"numagrin ? \'disabled\' : \'\' \" ng-model=\"ctrl.utilisateur.numSiren\" maxlength=\"9\" ng-pattern=\"/^[0-9]{9}$/\" ng-disabled=\"numagrin\">\n          <div ng-messages=\"ctrl.authentForm.numSiren.$error\" role=\"alert\">\n            <div ng-message=\"required\">La saisie du N° Siren ou N° Numagrin est obligatoire.</div>\n            <div ng-message=\"pattern\">Votre N° de Siren doit contenir 9 caractères numériques.</div>\n          </div>\n        </md-input-container>\n\n        <div>\n          <md-checkbox ng-model=\"numagrin\" aria-label=\"numagrin\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" ng-change=\"ctrl.clearInput(numagrin)\"></md-checkbox>\n          <label>Je ne dispose pas d\'un N° SIREN, je souhaite renseigner un Numagrin</label>\n        </div>\n\n        <md-input-container ng-show=\"numagrin\">\n          <label>Numagrin</label>\n          <input ng-required=\"!ctrl.utilisateur.numSiren\" name=\"numagrin\" ng-model=\"ctrl.utilisateur.numagrin\" maxlength=\"9\" ng-pattern=\"/^[a-zA-Z]{1}[0-9]{8}$/\">\n          <div ng-messages=\"ctrl.authentForm.numagrin.$error\" role=\"alert\">\n            <div ng-message=\"required\">La saisie du N° Siren ou N° Numagrin est obligatoire. Si vous ne connaissez pas/plus votre N° Siren ou N° Numagrin,\n              contactez votre service identification.</div>\n            <div ng-message=\"pattern\">Votre N° de Numagrin doit être composé d’une lettre suivie de 8 chiffres.</div>\n          </div>\n        </md-input-container>\n      </div>\n\n    </md-content>\n\n    <div class=\"actions-bar\">\n      <md-button type=\"button\" class=\"md-raised md-sample\" ui-sref=\"auth\">Annuler</md-button>\n      <md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"ctrl.perteMdpForm.$invalid\">Valider</md-button>\n    </div>\n\n  </form>\n\n  <div layout=\"row\" layout-align=\"space-between end\" class=\"footer-main\">\n    <div></div>\n    <div class=\"lien-footer\">\n      <a ui-sref=\"mentionsLegales\">Mentions légales</a>\n      <span class=\"separator\">/</span>\n      <a ui-sref=\"partenaires\">Partenaires</a>\n    </div>\n    <div>\n      <p class=\"version\">{{ctrl.version}}</p>\n    </div>\n  </div>\n\n</div>");
$templateCache.put("app/routageKc/routage.html","");
$templateCache.put("app/selectionProfil/selectionProfil.html","<div flex layout=\"column\" class=\"eleveur\">\n    <md-toolbar id=\"lienApplicationToolBar\" class=\"header-bar\"> \n        <div class=\"md-toolbar-tools\">\n            <a ng-click=\"ctrl.goToHome()\">\n              <img src=\"assets/images/logo-plat.png\" class=\"logo\">\n            </a>\n            <div flex></div>\n        </div>\n    </md-toolbar>\n    <div flex layout=\"column\" id=\"divWeb\">\n        <div id=\"divTitleLienApplication\" class=\"title-bar\" layout=\"row\">\n            <h2 flex>Choisissez un profil pour vous connecter</h2>\n        </div>\n        <form name=\"ctrl.lienApplicationForm\" flex layout=\"column\">\n            <md-content flex>\n                <div id=\"divPrincipale\" style=\"width: 20%\" layout=\"column\" layout-align=\"center\" class=\"divPrincipale\">\n                    <p ng-repeat=\"profil in ctrl.profils\" ng-click=\"ctrl.selectProfil(profil)\">{{profil.login}}</p>\n                </div>\n            </md-content>\n            <div class=\"actions-bar\">\n                <md-button class=\"md-raised\" ng-click=\"ctrl.selectProfilTechnicien()\" ng-if=\"ctrl.showTechnicienButton\">Technicien</md-button>\n                <md-button type=\"submit\" class=\"md-raised md-primary\" ng-click=\"ctrl.goToHome()\">Fermer</md-button>\n            </div>\n        </form>\n    </div>\n</div>\n<div layout=\"row\" layout-align=\"space-between center\" class=\"footer-main\">\n    <div class=\"\"></div>\n    <div class=\"\">\n        <a ui-sref=\"mentionsLegales\">Mentions légales</a>\n        <span class=\"separator\">/</span>\n        <a ui-sref=\"partenaires\">Partenaires</a>\n    </div>\n    <div class=\"\">\n        <adv-constant key=\"\'VERSION\'\" class=\"version\"></adv-constant>\n    </div>\n</div>");
$templateCache.put("app/validationIdentite/validationIdentite.html","<md-toolbar class=\"header-bar\">\n    <div class=\"md-toolbar-tools\">\n        <a ng-click=\"ctrl.goToHome()\" flex layout=\"row\" layout-align=\"start center\">\n            <img src=\"assets/images/logo-plat.png\" class=\"logo\">\n        </a>\n    </div>\n</md-toolbar>\n<div flex layout=\"raw\">\n    <div flex layout=\"column\">\n        <div class=\"title-bar\">\n            <h2>Renseignez votre adresse mail pour recevoir le lien de création de votre nouveau mot de passe</h2>\n        </div>\n        <form name=\"ctrl.validationForm\" ng-submit=\"ctrl.validationIdentite()\" novalidate flex layout=\"column\" class=\"validation-identite\">\n\n            <md-content flex>\n                <div layout-gt-sm=\"row\" layout-align=\"center\" class=\"h3\">\n                    <h3>FR</h3>\n                    <h3>{{ctrl.validationIdentiteModel.numExploitation}}</h3>\n                    <h3 class=\"\">{{ctrl.validationIdentiteModel.raisonSociale}}</h3>\n                </div>\n                <div layout-gt-sm=\"row\" layout-align=\"center\">\n                    <div layout=\"column\" class=\"informations-content\">\n                        <!-- <md-input-container>\n                            <label>Nom</label>\n                            <input name=\"nom\" aria-label=\"nom\" ng-model=\"ctrl.validationIdentiteModel.nom\">\n                        </md-input-container>\n                        <md-input-container>\n                            <label>Prénom</label>\n                            <input name=\"prenom\" aria-label=\"prénom\" ng-model=\"ctrl.validationIdentiteModel.prenom\">\n                        </md-input-container> -->\n                        <md-input-container>\n                            <label>Email</label>\n                            <input name=\"email\" aria-label=\"email\" ng-paste=\"$event.preventDefault()\" ng-model=\"ctrl.validationIdentiteModel.email\" type=\"email\" ng-pattern=\"/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$/\" required>\n                            <div ng-messages=\"ctrl.validationForm.email.$error\" role=\"alert\" class=\"maxwidth\">\n                                <div ng-message=\"required\">Donnée obligatoire</div>\n                                <div ng-message=\"pattern\">Donnée invalide</div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container>\n                            <label>Confirmation Email</label>\n                            <input name=\"confirmEmail\" ng-paste=\"$event.preventDefault()\" ng-copy=\"$event.preventDefault()\" autocomplete=\"off\" ng-model=\"ctrl.validationIdentiteModel.confirmEmail\" type=\"email\" ng-pattern=\"/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$/\" required>\n                            <div ng-messages=\"ctrl.validationForm.confirmEmail.$error\" role=\"alert\" class=\"maxwidth\">\n                                <div ng-message=\"required\">Donnée obligatoire</div>\n                                <div ng-message=\"pattern\">Donnée invalide</div>\n                                <div ng-if=\"ctrl.validationIdentiteModel.confirmEmail !== ctrl.validationIdentiteModel.email\">La\n                                    confirmation de l\'e-mail ne correspond pas à l\'e-mail initialement saisi.</div>\n                            </div>\n                        </md-input-container>\n                    </div>\n                </div>\n            </md-content>\n\n            <div class=\"actions-bar\">\n                <md-button type=\"button\" ui-sref=\"auth\" class=\"md-raised md-sample\">Annuler</md-button>\n                <md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"ctrl.validationForm.$invalid || ctrl.validationIdentite.confirmEmail !== ctrl.validationIdentite.email\">\n                    Suivant</md-button>\n            </div>\n        </form>\n    </div>\n</div>\n<div layout=\"row\" layout-align=\"space-between center\" class=\"footer-main\">\n    <div class=\"\"></div>\n    <div class=\"\">\n        <a ui-sref=\"mentionsLegales\">Mentions légales</a>\n        <span class=\"separator\">/</span>\n        <a ui-sref=\"partenaires\">Partenaires</a>\n    </div>\n    <div class=\"\">\n        <adv-constant key=\"\'VERSION\'\" class=\"version\"></adv-constant>\n    </div>\n</div>");
$templateCache.put("app/_common/redirection/redirection.html","");
$templateCache.put("app/admin/clotureAbonnement/clotureAbonnement.html","<div flex layout=\"column\" class=\"cloture-abonnement\">\n  <div class=\"title-bar\" layout=\"row\">\n    <h2> Résilier / clôturer</h2>\n  </div>\n  <md-content flex>\n    <form name=\"ctrl.authentForm\" ng-submit=\"ctrl.openListAbonnements()\" novalidate flex layout=\"column\">\n      <div class=\"selection-form\" layout=\"row\" layout-align=\"center\">\n        <div>\n          <h4 class=\"codePays\">FR</h4>\n          <md-input-container>\n            <label>N° Exploitation</label>\n            <input name=\"numExploitation\" ng-model=\"ctrl.numExploitation\" ng-required=\"!ctrl.identifiant\">\n          </md-input-container>\n        </div>\n        <div class=\"choixInfo\">\n          ou\n        </div>\n        <md-input-container>\n          <label>Identifiant</label>\n          <input name=\"identifiant\" ng-model=\"ctrl.identifiant\" ng-required=\"!ctrl.numExploitation\">\n        </md-input-container>\n        <md-button type=\"submit\" class=\"md-raised md-primary btn-valider\" ng-disabled=\"ctrl.authentForm.$invalid\">Valider</md-button>\n      </div>\n    </form>\n\n    <div ng-if=\"ctrl.afficheListAbonnements\">\n\n      <div class=\"content\" ng-if=\"ctrl.listAbonnements.length > 0\">\n        <div class=\"recapitulatif\">\n          <div flex=\"50\">\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Identifiant\n              </div>\n              <div class=\"value\">\n                {{ctrl.infoIdentifiant}}\n              </div>\n            </div>\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                N° Exploitation\n              </div>\n              <div class=\"value\">\n                {{ctrl.infoNumExploitation}}\n              </div>\n            </div>\n            <div class=\"recap-item\" ng-if=\"!ctrl.numAgrin\">\n              <div class=\"label\">\n                N° Siren\n              </div>\n              <div class=\"value\">\n                {{ctrl.numSiren}}\n              </div>\n            </div>\n            <div class=\"recap-item\" ng-if=\"!ctrl.numSiren\">\n              <div class=\"label\">\n                N° Numagrin\n              </div>\n              <div class=\"value\">\n                {{ctrl.numAgrin}}\n              </div>\n            </div>\n          </div>\n          <div flex=\"50\">\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Profil\n              </div>\n              <div class=\"value\">\n                {{ctrl.profil}}\n              </div>\n            </div>\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Numéro du détenteur\n              </div>\n              <div class=\"value\">\n                {{ctrl.numDetenteur}}\n              </div>\n            </div>\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Raison Sociale\n              </div>\n              <div class=\"value\">\n                {{ctrl.raisonSociale}}\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div layout=\"row\" layout-align=\"end\">\n          <md-button type=\"button\" class=\"md-raised md-primary\" ng-click=\"ctrl.clotureCompte(ctrl.listAbonnements)\">Clôturer le compte</md-button>\n        </div>\n      </div>\n\n      <adv-toolbar class=\"title-toolbar\" layout=\"row\">\n        <div layout=\"row\" layout-align=\"start center\">\n          <h2>Abonnements\n            <span class=\"compteur\">&nbsp;({{ctrl.listAbonnements.length}})</span>\n          </h2>\n        </div>\n        <div flex=\"40\"></div>\n      </adv-toolbar>\n\n      <adv-list-item adv-header class=\"data-list-header\">\n        <div flex=\"10\" class=\"column\">\n          <span>Exploitation</span>\n        </div>\n        <div flex=\"10\" class=\"column\">\n          <span> Ouverture</span>\n        </div>\n        <div flex=\"10\" class=\"column\">\n          <span>Niveau</span>\n        </div>\n        <div flex=\"10\" class=\"column\">\n          <span>Type d\'abonnement</span>\n        </div>\n        <div flex=\"10\" class=\"column\">\n          <span>Début</span>\n        </div>\n        <div flex=\"15\" class=\"column\">\n          <span>Date fin différée</span>\n        </div>\n        <div flex=\"15\" class=\"column\">\n          <span>Limite rétractation</span>\n        </div>\n        <div flex=\"15\" class=\"column\">\n          <span>Fin engagement</span>\n        </div>\n        <div flex class=\"column\">\n        </div>\n      </adv-list-item>\n\n      <adv-list-item ng-if=\" ctrl.listAbonnements.length === 0 \" class=\"empty-list\">\n        Aucun abonnement\n      </adv-list-item>\n\n\n      <adv-list class=\"data-list-body stripped\">\n        <adv-list-item ng-repeat=\"abonnement in ctrl.listAbonnements\">\n          <div flex=\"10\">\n            {{abonnement.numExploitation}}\n          </div>\n          <div flex=\"10\">\n            {{abonnement.dateOuverture | date: \'dd/MM/yyyy\'}}\n          </div>\n          <div flex=\"10\">\n            {{abonnement.niveauAbonnement}}\n          </div>\n          <div flex=\"10\">\n            {{abonnement.typeAbonnement }}\n          </div>\n          <div flex=\"10\">\n            {{abonnement.dateOuverture | date: \'dd/MM/yyyy\'}}\n          </div>\n          <div flex=\"15\">\n            {{abonnement.dateFinDifferee | date: \'dd/MM/yyyy\'}}\n          </div>\n          <div flex=\"15\">\n            {{abonnement.dateLimiteRetractation | date: \'dd/MM/yyyy\'}}\n          </div>\n          <div flex=\"15\">\n            {{abonnement.dateFinEngagement | date: \'dd/MM/yyyy\'}}\n          </div>\n          <div flex>\n            <md-icon md-svg-src=\"assets/images/icones/ic_delete.svg\" ng-click=\"ctrl.suppressionAbonnement(abonnement)\"></md-icon>\n          </div>\n\n        </adv-list-item>\n      </adv-list>\n    </div>\n  </md-content>\n</div>");
$templateCache.put("app/admin/communication/communication.html","<div flex layout=\"column\" class=\"communication\">\n  <div class=\"title-bar\" layout=\"row\">\n    <h2>Gérer la communication</h2>\n  </div>\n\n  <form name=\"ctrl.communicationForm\" ng-submit=\"ctrl.onSubmit()\" novalidate flex layout=\"column\">\n    <md-content flex>\n      <div layout=\"column\" layout-align=\"start center\" layout-padding>\n        <md-input-container>\n          <label>Titre</label>\n\n          <input name=\"titre\" ng-model=\"ctrl.communication.titre\" maxlength=\"70\" required class=\"input_titre\">\n\n          <div ng-messages=\"ctrl.communicationForm.titre.$error\">\n            <div ng-message=\"required\">Obligatoire.</div>\n          </div>\n        </md-input-container>\n\n        <md-input-container class=\"no-floating-label\">\n          <label>Texte</label>\n\n          <textarea name=\"message\" ui-tinymce=\"{width: 700, height: 250, menubar: false, toolbar: \'undo redo | bold italic underline | fontsizeselect\'}\" ng-model=\"ctrl.communication.message\" plain-text-max-length=\"550\" required></textarea>\n\n          <div ng-messages=\"ctrl.communicationForm.message.$error\">\n            <div ng-message=\"required\">Obligatoire.</div>\n            <div ng-message=\"plainTextMaxLength\">Champ limité à 550 caractères.</div>\n          </div>\n        </md-input-container>\n\n        <md-input-container>\n          <label>Niveau d\'alerte</label>\n          <md-select ng-model=\"ctrl.communication.niveauAlerte\" required>\n            <md-option ng-repeat=\"niveau in ctrl.niveaux\" value=\"{{niveau.code}}\">\n              {{niveau.libelle}}\n            </md-option>\n          </md-select>\n        </md-input-container>\n\n        <adv-alerte alerte=\"ctrl.communication\"></adv-alerte>\n      </div>\n    </md-content>\n\n    <div class=\"actions-bar\">\n      <md-button type=\"submit\" class=\"md-raised md-primary\">Publier</md-button>\n    </div>\n  </form>\n</div>");
$templateCache.put("app/admin/creationCompte/creationCompte.html","<div flex layout=\"column\" class=\"creation-compte\">\n  <div class=\"title-bar\" layout=\"row\">\n    <h2>Créer un compte technicien / assistance</h2>\n  </div>\n\n  <form name=\"ctrl.creationCompteForm\" ng-submit=\"ctrl.valideCreationCompte()\" novalidate flex layout=\"column\">\n    <md-content flex layout=\"column\" layout-align=\"left\">\n      <div class=\"creation-compte-content\">\n        <div class=\"\">\n          <div layout=\"row\">\n            <div layout=\"column\" class=\"compte-col-left\">\n              <md-input-container>\n                <label>Nom</label>\n                <input required name=\"nom\" ng-model=\"ctrl.compte.nom\">\n                <div ng-messages=\"ctrl.creationCompteForm.nom.$error\" role=\"alert\">\n                  <div ng-message=\"required\">Donnée obligatoire.</div>\n                </div>\n              </md-input-container>\n\n              <md-input-container>\n                <label>Prénom</label>\n                <input required name=\"prenom\" ng-model=\"ctrl.compte.prenom\">\n                <div ng-messages=\"ctrl.creationCompteForm.prenom.$error\" role=\"alert\">\n                  <div ng-message=\"required\">Donnée obligatoire.</div>\n                </div>\n              </md-input-container>\n\n              <md-input-container>\n                <label>Site de rattachement</label>\n                <md-select ng-model=\"ctrl.userSite\" required>\n                  <md-option ng-repeat=\"site in ctrl.listSites\" ng-value=\"site.libelle\">\n                    {{site.libelle}}\n                  </md-option>\n                </md-select>\n              </md-input-container>\n            </div>\n            <div layout=\"column\" layout-align=\"left\">\n              <md-input-container>\n                <label>N° Téléphone</label>\n                <input name=\"telephone\" ng-model=\"ctrl.compte.telephone\" type=\"text\" maxlength=\"10\" ng-pattern=\"/^[0-9]{10}$/\">\n                <div ng-messages=\"ctrl.creationCompteForm.telephone.$error\" role=\"alert\">\n                  <div ng-message=\"pattern\">Donnée invalide.</div>\n                </div>\n              </md-input-container>\n              <md-input-container>\n                <label>Email</label>\n                <input name=\"email\" aria-label=\"email\" ng-model=\"ctrl.compte.email\" type=\"email\" required>\n                <div ng-messages=\"ctrl.creationCompteForm.email.$error\" role=\"alert\">\n                  <div ng-message=\"required\">Donnée obligatoire.</div>\n                  <div ng-message=\"email\">Donnée invalide.</div>\n                </div>\n              </md-input-container>\n\n              <md-input-container ng-if=\"ctrl.compte.email\">\n                <label>Confirmation Email</label>\n                <input name=\"confirmEmail\" ng-paste=\"$event.preventDefault()\" ng-copy=\"$event.preventDefault()\" autocomplete=\"off\" ng-model=\"ctrl.compte.confirmEmail\" type=\"email\" required>\n                <div ng-messages=\"ctrl.creationCompteForm.confirmEmail.$error\" role=\"alert\">\n                  <div ng-message=\"required\">Donnée obligatoire</div>\n                  <div ng-message=\"email\">Donnée invalide</div>\n                </div>\n              </md-input-container>\n            </div>\n          </div>\n        </div>\n        <div>\n          <div class=\"compte-profil\" layout=\"column\">\n            <label>Profil *</label>\n            <div class=\"btn-group\">\n              <button type=\"button\" ng-required=\"indicateur\" name=\"indicateursProfils\" ng-model=\"ctrl.indicateursProfils\" ng-click=\"ctrl.changeProfil(indicateur)\" ng-repeat=\"indicateur in ctrl.indicateursProfils\" uib-btn-radio=\"indicateur\" uncheckable class=\"adv-button adv-raised\" ng-class=\"{active : ctrl.activeProfil === indicateur}\">{{indicateur.libelle}}</button>\n            </div>\n            <div ng-messages=\"ctrl.creationCompteForm.indicateursProfils.$error\" ng-show=\"ctrl.creationCompteForm.$submitted\">\n              <div ng-show=\"!ctrl.activeProfil\">Donnée obligatoire</div>\n            </div>\n          </div>\n        </div>\n        <div class=\"\" layout=\"row\" ng-if=\"ctrl.code == \'A\' \">\n          <label>Organismes associés *</label>\n          <div class=\"\" layout=\"row\">\n            <md-card>\n              <md-card-header>\n                <label flex>Organismes disponibles ({{ctrl.listeOrganismesDispo.length}})</label>\n              </md-card-header>\n              <div flex layout=\"column\">\n                <div flex layout=\"column\">\n                  <md-button class=\"compte-list\" required ng-repeat=\"organisme in ctrl.listeOrganismes | filter:{estDisponible:true}\" ng-click=\"ctrl.changeDispo(organisme)\">{{organisme.libelle}}\n                    <md-icon class=\"icon-arrow-right\">keyboard_arrow_right</md-icon>\n                  </md-button>\n                </div>\n              </div>\n            </md-card>\n            <md-card>\n              <md-card-header>\n                <label flex>Organismes sélectionnés ({{ctrl.listeOrganismesSelectionnes.length}})</label>\n              </md-card-header>\n              <div flex layout=\"column\">\n                <div flex layout=\"column\">\n                  <md-button class=\"compte-list\" required ng-repeat=\"organisme in ctrl.listeOrganismes | filter:{estDisponible:false}\" ng-click=\"ctrl.changeDispo(organisme)\">\n                    <md-icon class=\"icon-arrow-left\">keyboard_arrow_left</md-icon>{{organisme.libelle}}</md-button>\n                </div>\n              </div>\n            </md-card>\n          </div>\n        </div>\n      </div>\n    </md-content>\n\n    <div class=\"actions-bar\">\n      <md-button type=\"button\" ui-sref=\"app.admin.home\" class=\"md-raised md-sample\">Annuler</md-button>\n      <md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"ctrl.creationCompteForm.$invalid || (ctrl.creationCompteForm.$valid && !ctrl.activeProfil)\">Valider</md-button>\n    </div>\n\n  </form>\n\n</div>");
$templateCache.put("app/admin/fonctionnalite/fonctionnalite.html","<div flex layout=\"row\" class=\"fonctionnalite\">\n  <adv-menu menu=\"ctrl.menu\" orientation=\"\'vertical\'\"></adv-menu>\n\n  <md-content flex>\n    <iframe ng-src=\"{{ctrl.trustAsResourceUrl(ctrl.acces.url)}}\" scrolling=\"no\" adv-scale></iframe>\n  </md-content>\n</div>\n");
$templateCache.put("app/admin/home/home.html","<!--<div flex layout=\"row\" class=\"admin-menu\">\n  <md-content flex>\n    <div class=\"admin-menu-content\" flex layout=\"row\" layout-align=\"center left\">\n      <md-card>\n        <md-card-header>\n          <h3 flex>Abonnements</h3>\n        </md-card-header>\n        <div flex layout=\"column\">\n          <div flex layout=\"column\">\n            <md-button ng-repeat=\"menu in ctrl.menus\" ui-sref=\"{{menu.path}}\" class=\"menu\">&gt; {{menu.libelle}}</md-button>\n          </div>\n        </div>\n      </md-card>\n    </div>\n  </md-content>\n</div>\n-->\n");
$templateCache.put("app/admin/main/main.html","<div flex layout=\"column\" class=\"admin\">\n  <md-toolbar class=\"header-bar\">\n    <div class=\"md-toolbar-tools\">\n      <a ui-sref=\"app.admin.home\" flex layout=\"row\" layout-align=\"start center\">\n        <img src=\"assets/images/logo-plat.png\" class=\"logo\">\n\n        <h2>Administration</h2>\n      </a>\n\n      <div flex></div>\n      <div ng-click=\"ctrl.goToGed()\" class=\"menu-item doc\">\n        <span>Documents</span>\n        <md-icon md-svg-src=\"assets/images/icones/description.svg\" aria-label=\"settings\"></md-icon>\n      </div>\n\n      <md-menu-bar>\n        <md-menu>\n          <div ng-click=\"$mdMenu.open()\" class=\"menu-item account\">\n            <span>\n              <adv-profil key=\"\'login\'\"></adv-profil>\n            </span>\n            <md-icon md-svg-src=\"assets/images/icones/account_circle.svg\" aria-label=\"account_circle\"></md-icon>\n          </div>\n\n          <md-menu-content class=\"header-menu\">\n            <!--\n            <md-menu-item class=\"md-indent\">\n              <md-icon md-svg-src=\"assets/images/icones/account_circle.svg\" aria-label=\"account_circle\"></md-icon>\n              <md-button>\n                Mon compte\n              </md-button>\n            </md-menu-item>\n            <md-menu-divider></md-menu-divider>\n          -->\n          <md-menu-item ng-if=\"ctrl.isMultiProfil()\" class=\"md-indent\">\n            <md-icon md-svg-src=\"assets/images/icones/autorenew.svg\" aria-label=\"autorenew\"></md-icon>\n            <md-button ng-click=\"ctrl.goToSelectionProfil()\">\n              Changer de profil\n            </md-button>\n          </md-menu-item>\n          <md-menu-divider ng-if=\"ctrl.isMultiProfil()\"></md-menu-divider>\n            <md-menu-item class=\"md-indent\">\n              <md-icon md-svg-src=\"assets/images/icones/exit_to_app.svg\" aria-label=\"exit_to_app\"></md-icon>\n              <md-button ng-click=\"ctrl.logout()\">\n                Se déconnecter\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n      </md-menu-bar>\n    </div>\n  </md-toolbar>\n\n  <div flex layout=\"row\">\n    <div class=\"admin-menu\">\n      <md-button class=\"btn-abonnement\" ng-click=\"ctrl.ouvreSousMenu()\">Abonnements</md-button>\n      <div ng-if=\"ctrl.isOpen\" ng-repeat=\"menu in ctrl.menus\">\n        <md-button ng-click=\"ctrl.goTo(menu.path)\" ui-sref-active=\"active\" ng-class=\"{active:ctrl.isActive(menu.path)}\" class=\"niveau2\">{{menu.libelle}}</md-button>\n      </div>\n      <md-button ui-sref=\"app.admin.communication\">Communication</md-button>\n      <md-button ng-if=\"ctrl.displayModalMenu\" ui-sref=\"app.admin.gestionModales\">\n        Gestion des modales\n      </md-button>\n      <md-button class=\"btn-abonnement\" ng-click=\"ctrl.isOpenMenuTechniciens = !ctrl.isOpenMenuTechniciens\">Techniciens\n      </md-button>\n      <div ng-if=\"ctrl.isOpenMenuTechniciens\" ng-repeat=\"menu in ctrl.menuTechniciens\">\n        <md-button ui-sref=\"{{menu.path}}\" ui-sref-active=\"active\" class=\"niveau2\">{{menu.libelle}}</md-button>\n      </div>\n      <!--\n      <md-button ui-sref=\"app.admin.communication\">Autre</md-button>\n      -->\n    </div>\n\n    <ui-view flex layout=\"column\"></ui-view>\n  </div>\n\n  <div layout=\"row\" layout-align=\"space-between end\" class=\"footer-main\">\n    <div></div>\n    <div class=\"lien-footer\">\n      <a ui-sref=\"app.admin.mentionsLegales\" target=\"_blank\">Mentions légales</a>\n      <span class=\"separator\">/</span>\n      <a ui-sref=\"app.admin.partenaires\">Partenaires</a>\n    </div>\n    <div>\n      <p class=\"version\">{{ctrl.version}}</p>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/admin/mentionsLegales/mentionsLegales.html","<div layout=\"row\" ng-include=\"\'app/_common/partials/mentionsLegales/mentionsLegales.html\'\" flex></div>");
$templateCache.put("app/admin/multicheptels/multicheptels.html","<div flex layout=\"column\" class=\"cloture-abonnement\">\n  <div class=\"title-bar\" layout=\"row\">\n    <h2>Multicheptels</h2>\n  </div>\n  <md-content flex>\n    <form name=\"ctrl.authentForm\" ng-submit=\"ctrl.openListExploitations()\" novalidate flex layout=\"column\">\n      <div class=\"selection-form\" layout=\"row\" layout-align=\"center\">\n        <div>\n          <h4 class=\"codePays\">FR</h4>\n          <md-input-container>\n            <label>N° Exploitation</label>\n            <input name=\"numExploitation\" ng-model=\"ctrl.numExploitation\" ng-required=\"!ctrl.identifiant\">\n          </md-input-container>\n        </div>\n        <div class=\"choixInfo\">\n          ou\n        </div>\n        <md-input-container>\n          <label>Identifiant</label>\n          <input name=\"identifiant\" ng-model=\"ctrl.identifiant\" ng-required=\"!ctrl.numExploitation\">\n        </md-input-container>\n        <md-button type=\"submit\" class=\"md-raised md-primary btn-valider\" ng-disabled=\"ctrl.authentForm.$invalid\">Valider</md-button>\n      </div>\n    </form>\n    <div class=\"error-message\" layout=\"row\" layout-align=\"center\" ng-if=\"ctrl.exploitationInconnue\">Exploitation inconnue</div>\n\n    <div ng-if=\"ctrl.afficheListExploitations\">\n\n      <div class=\"content\" ng-if=\"ctrl.exploitation\">\n        <div class=\"recapitulatif\">\n          <div flex=\"50\">\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Identifiant\n              </div>\n              <div class=\"value\">\n                {{ctrl.infoIdentifiant}}\n              </div>\n            </div>\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                N° Exploitation\n              </div>\n              <div class=\"value\">\n                {{ctrl.infoNumExploitation}}\n              </div>\n            </div>\n            <div class=\"recap-item\" ng-if=\"!ctrl.numAgrin\">\n              <div class=\"label\">\n                N° Siren\n              </div>\n              <div class=\"value\">\n                {{ctrl.numSiren}}\n              </div>\n            </div>\n            <div class=\"recap-item\" ng-if=\"!ctrl.numSiren\">\n              <div class=\"label\">\n                N° Numagrin\n              </div>\n              <div class=\"value\">\n                {{ctrl.numAgrin}}\n              </div>\n            </div>\n          </div>\n          <div flex=\"50\">\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Profil\n              </div>\n              <div class=\"value\">\n                {{ctrl.profil}}\n              </div>\n            </div>\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Numéro du détenteur\n              </div>\n              <div class=\"value\">\n                {{ctrl.numDetenteur}}\n              </div>\n            </div>\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Raison Sociale\n              </div>\n              <div class=\"value\">\n                {{ctrl.raisonSociale}}\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div layout=\"row\" layout-align=\"end\">\n          <md-button type=\"button\" class=\"md-raised md-primary\" ng-click=\"ctrl.openMulticheptels()\">Ajouter cheptel</md-button>\n        </div>\n      </div>\n\n      <adv-toolbar class=\"title-toolbar\" layout=\"row\">\n        <div layout=\"row\" layout-align=\"start center\">\n          <h2>Rapprochements\n            <span class=\"compteur\">&nbsp;({{ctrl.listExploitations.length}})</span>\n          </h2>\n        </div>\n        <div flex=\"40\"></div>\n      </adv-toolbar>\n\n      <adv-list-item adv-header class=\"data-list-header\">\n        <div flex=\"30\" class=\"column\">\n          <span>N° Exploitation</span>\n        </div>\n        <div flex=\"30\" class=\"column\">\n          <span>Identifiant</span>\n        </div>\n        <div flex=\"30\" class=\"column\">\n          <span>Raison Sociale</span>\n        </div>\n        <div flex class=\"column\">\n        </div>\n      </adv-list-item>\n\n      <adv-list-item ng-if=\" ctrl.listExploitations.length === 0 \" class=\"empty-list\">\n        Aucune exploitation\n      </adv-list-item>\n\n\n      <adv-list class=\"data-list-body stripped\">\n        <adv-list-item ng-repeat=\"exploitation in ctrl.listExploitations\">\n          <div flex=\"30\">\n            {{exploitation.numExploitation}}\n          </div>\n          <div flex=\"30\">\n            {{exploitation.login}}\n          </div>\n          <div flex=\"30\">\n            {{exploitation.raisonsociale}}\n          </div>\n          <div flex>\n            <md-icon md-svg-src=\"assets/images/icones/ic_delete.svg\" ng-click=\"ctrl.suppressionExploitation(exploitation)\"></md-icon>\n          </div>\n\n        </adv-list-item>\n      </adv-list>\n    </div>\n  </md-content>\n</div>");
$templateCache.put("app/admin/partenaires/partenaires.html","<div flex layout=\"raw\">\n  <adv-menu menu=\"ctrl.menu\"></adv-menu>\n  <div flex layout=\"column\" class=\"partenaires\">\n    <div class=\"title-bar\">\n      <h2>Partenaires</h2>\n    </div>\n    <md-content flex layout-align=\"start center\">\n      <div ng-repeat=\"_ in ctrl.listePatenaires\" ng-if=\"$index % 4 === 0\">\n        <div class=\"partenaires-list\" layout=\"column\" layout-align=\"center center\">\n          <div layout=\"raw\" layout-align=\"center center\">\n            <div class=\"partenaires-item\" ng-repeat=\"i in [$index, $index + 1, $index + 2, $index + 3]\" ng-init=\"partenaire = ctrl.listePatenaires[i]\">\n              <div ng-if=\"partenaire != null\">\n                <div ng-if=\"partenaire.url != null\">\n                  <a href=\"{{partenaire.url}}\" target=\"_blank \" value=\"{{partenaire.libelle}} \">\n                    <img ng-src=\"{{partenaire.logo}} \" alt=\"{{partenaire.libelle}} \">\n                  </a>\n                </div>\n                <div ng-if=\"partenaire.url == null\">\n                  <img ng-src=\"{{partenaire.logo}} \" alt=\"{{partenaire.libelle}} \">\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </md-content>\n  </div>\n</div>");
$templateCache.put("app/auth/guideAbonnement/guideAbonnement.html","<md-dialog aria-label=\"guide-abonnement\" class=\"guide-abonnement\">\n  <md-dialog-content class=\"md-dialog-content\">\n    <div layout=\"row\">\n      <h2>Guide abonnement</h2>\n\n      <div flex></div>\n      <md-button ng-click=\"ctrl.cancel()\" class=\"md-icon-button\" aria-label=\"Close\">\n        <md-icon>close</md-icon>\n      </md-button>\n    </div>\n\n    <iframe width=\"840\" height=\"472.5\" src=\"https://www.youtube.com/embed/-Reol1uzP8Y?rel=0\" frameborder=\"0\" gesture=\"media\" allow=\"encrypted-media\" allowfullscreen></iframe>\n  </md-dialog-content>\n</md-dialog>");
$templateCache.put("app/eleveur/changeMdp/changeMdp.html","<div flex layout=\"raw\" class=\"change-mdp\">\n  <div flex layout=\"column\">\n    <div class=\"title-bar\" layout=\"row\">\n      <h2 flex=\"30\">Changement de mot de passe</h2>\n      <div flex=\"30\"></div>\n      <div flex=\"30\"></div>\n    </div>\n\n    <form name=\"ctrl.changeMdpForm\" ng-submit=\"ctrl.changeMdp()\" novalidate flex layout=\"column\">\n\n      <md-content flex>\n        <div layout-align=\"left\" class=\"change-mdp-content\">\n          <div class=\"changemdp-identifiant\">\n            <div class=\"label\">\n              Identifiant\n            </div>\n            <div class=\"value\">\n              {{ ctrl.estKeycloak ? ctrl.infosUtilisateur.mailLogin : ctrl.infosUtilisateur.login }}\n            </div>\n          </div>\n          <div layout=\"column\" class=\"form-mdp\">\n            <div>\n              <md-input-container ng-if=\"!ctrl.showPassword\">\n                <label>Mot de passe actuel</label>\n                <input type=\"password\" required name=\"mdpActuel\" ng-model=\"ctrl.infosUtilisateur.mdpActuel\">\n                <div ng-messages=\"ctrl.changeMdpForm.mdpActuel.$error\" role=\"alert\">\n                  <div ng-message=\"required\">Donnée obligatoire</div>\n                </div>\n              </md-input-container>\n              <md-input-container ng-if=\"ctrl.showPassword\">\n                <label>Mot de passe actuel</label>\n                <input required name=\"mdpActuel\" ng-model=\"ctrl.infosUtilisateur.mdpActuel\">\n                <div ng-messages=\"ctrl.changeMdpForm.mdpActuel.$error\" role=\"alert\">\n                  <div ng-message=\"required\">Donnée obligatoire</div>\n                </div>\n              </md-input-container>\n              <md-button ng-if=\"!ctrl.showPassword\" ng-click=\"ctrl.showpassword()\">\n                <md-icon md-svg-src=\"assets/images/icones/not_visibility.svg\" aria-label=\"visibility\"></md-icon>\n              </md-button>\n              <md-button ng-if=\"ctrl.showPassword\" ng-click=\"ctrl.showpassword()\">\n                <md-icon md-svg-src=\"assets/images/icones/visibility.svg\" aria-label=\"visibility\"></md-icon>\n              </md-button>\n            </div>\n\n            <div>\n              <md-input-container ng-if=\"!ctrl.showPassword\">\n                <label>Nouveau mot de passe</label>\n                <input required name=\"mdpNouveau\" type=\"password\" ng-model=\"ctrl.infosUtilisateur.mdpNouveau\" minlength=\"6\" maxlength=\"10\">\n                <div ng-messages=\"ctrl.changeMdpForm.mdpNouveau.$error\" role=\"alert\">\n                  <div ng-message=\"required\">Donnée obligatoire</div>\n                  <div ng-message=\"minlength\">Le nouveau mot de passe doit contenir au moins 6 caractères.</div>\n                </div>\n              </md-input-container>\n              <md-input-container ng-if=\"ctrl.showPassword\">\n                <label>Nouveau mot de passe</label>\n                <input required name=\"mdpNouveau\" ng-model=\"ctrl.infosUtilisateur.mdpNouveau\" minlength=\"6\" maxlength=\"10\">\n                <div ng-messages=\"ctrl.changeMdpForm.mdpNouveau.$error\" role=\"alert\">\n                  <div ng-message=\"required\">Donnée obligatoire</div>\n                  <div ng-message=\"minlength\">Le nouveau mot de passe doit contenir au moins 6 caractères.</div>\n                </div>\n              </md-input-container>\n            </div>\n\n            <div>\n              <i>Le nouveau mot de passe doit contenir entre 6 et 10 caractères</i>\n            </div>\n\n            <div ng-if=\"ctrl.infosUtilisateur.mdpNouveau\">\n              <md-input-container ng-if=\"!ctrl.showPassword\">\n                <label>Confirmation mot de passe</label>\n                <input required name=\"mdpConfirmNouveau\" type=\"password\" ng-model=\"ctrl.infosUtilisateur.mdpConfirmNouveau\" minlength=\"6\" maxlength=\"10\">\n                <div ng-messages=\"ctrl.changeMdpForm.mdpConfirmNouveau.$error\" role=\"alert\">\n                  <div ng-message=\"required\">Donnée obligatoire</div>\n                </div>\n              </md-input-container>\n              <md-input-container ng-if=\"ctrl.showPassword\">\n                <label>Confirmation mot de passe</label>\n                <input required name=\"mdpConfirmNouveau\" ng-model=\"ctrl.infosUtilisateur.mdpConfirmNouveau\" minlength=\"6\" maxlength=\"10\">\n                <div ng-messages=\"ctrl.changeMdpForm.mdpConfirmNouveau.$error\" role=\"alert\">\n                  <div ng-message=\"required\">Donnée obligatoire</div>\n                </div>\n              </md-input-container>\n            </div>\n          </div>\n        </div>\n      </md-content>\n\n\n      <div class=\"actions-bar\">\n        <md-button type=\"button\" class=\"md-raised md-sample\" ng-click=\"ctrl.goHome()\">Annuler</md-button>\n        <md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"ctrl.changeMdpForm.$invalid\">Valider</md-button>\n      </div>\n\n    </form>\n\n  </div>\n\n</div>");
$templateCache.put("app/eleveur/fonctionnalite/fonctionnalite.html","<div flex layout=\"row\" class=\"fonctionnalite\">\n\n  <md-content flex>\n    <iframe ng-src=\"{{ctrl.trustAsResourceUrl(ctrl.acces.url)}}\" scrolling=\"no\" adv-scale></iframe>\n  </md-content>\n</div>");
$templateCache.put("app/eleveur/lienApplication/lienApplication.html","<div flex layout=\"column\" class=\"eleveur\">\n    <md-toolbar id=\"lienApplicationToolBar\" class=\"header-bar\"> \n        <div class=\"md-toolbar-tools\">\n            <a ng-click=\"ctrl.goToHome()\">\n              <img src=\"assets/images/logo-plat.png\" class=\"logo\">\n            </a>\n            <div flex></div>\n        </div>\n    </md-toolbar>\n    <div flex layout=\"column\" id=\"divWeb\">\n        <div id=\"divTitleLienApplication\" class=\"title-bar\" layout=\"row\">\n            <h2 flex>Télécharger l\'application Pilot\'Elevage Mobile</h2>\n        </div>\n        <form name=\"ctrl.lienApplicationForm\" ng-submit=\"ctrl.sendSms()\" novalidate flex layout=\"column\">\n            <md-content flex>\n                <div id=\"divPrincipale\" layout=\"column\" layout-align=\"center\" class=\"divPrincipale\">\n                    <label class=\"margin\">Pour recevoir le lien de téléchargement de l\'application, merci de renseigner les informations suivantes : </label>\n                    <br>\n                       <div id=\"divLienApplication\" layout=\"column\" class=\"margin\">\n                            <md-input-container class=\"margin\">  \n                                <label>N° Tel. portable</label>\n                                <input class=\"input-width\" name=\"telephone\" ng-model=\"ctrl.numeroEleveur\" type=\"text\" ng-pattern=\"/^(06|07) [0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}$/\" ui-mask=\"?9?9 ?9?9 ?9?9 ?9?9 ?9?9\" ui-mask-placeholder=\"\" ui-mask-placeholder-char=\"space\" required>\n                                <div ng-messages=\"ctrl.lienApplicationForm.telephone.$error\" role=\"alert\">\n                                    <div ng-message=\"pattern\">Le N° de téléphone portable doit commencer par 06 ou 07.</div>\n                                  </div>\n                                  <div ng-messages=\"ctrl.lienApplicationForm.telephone.$error\" role=\"alert\">\n                                    <div ng-message=\"required\">Donnée obligatoire</div>\n                                  </div>\n                            </md-input-container>\n                            <br>\n                            <div layout=\"row\" id=\"divSystemeExploit\">\n                                <label class=\"margin\">Système d\'exploitation\n                                    <span class=\"required-asterisque\">*</span>\n                                  </label>\n                            <div layout-align=\"center\">\n                                <md-radio-group ng-model=\"ctrl.typeMobile\" required class=\"radio-inline margin\">\n                                    <md-radio-button ng-repeat=\"type in ctrl.listeTypeTel\" ng-value=\"type\" class=\"md-primary\">{{type.value}}</md-radio-button>\n                                </md-radio-group>\n                                <div ng-messages=\"ctrl.lienApplicationForm.typeMobile.$error\" role=\"alert\">\n                                    <div ng-message=\"required\">Donnée obligatoire</div>\n                                  </div>\n                            </div>\n                        </div>\n                    </div>                 \n                </div>\n            </md-content>\n            <div class=\"actions-bar\">\n                <md-button class=\"md-raised\" ng-click=\"ctrl.goToHome()\">Annuler</md-button>\n                <md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"ctrl.lienApplicationForm.$invalid\">Envoyer</md-button>\n            </div>\n        </form>\n    </div>\n</div>\n<!--<style>\n   /* @media screen and (max-device-width: 480px){\n        #divTitleLienApplication{margin-top: 10px;}\n        #mainMdToolBar{display: none;}\n        #divWeb{display: none;}\n    }\n\n    @media screen and (min-device-width: 481px){\n        #lienApplicationToolBar{display: none;}\n        #divMobile{display: none;}\n    }*/\n</style> -->");
$templateCache.put("app/eleveur/lienBgta/lienBgta.html","<div flex layout=\"raw\" class=\"bgta\">\n	<div flex layout=\"column\">\n		<div class=\"title-bar\" layout=\"row\">\n			<h2 flex>BGTA (Bilan G&eacute;n&eacute;tique du Troupeau Allaitant)</h2>\n			<!-- 			<div flex=\"30\"></div> -->\n			<!-- 			<div flex=\"30\"></div> -->\n		</div>\n\n		<md-content flex>\n			<div layout-align=\"left\" class=\"bgta-content\">\n				<div class=\"bgta-identifiant\">\n					<div class=\"label\">Veuillez s&eacute;lectionner une race :</div>\n				</div>\n				<md-radio-group ng-model=\"codeRace\"> \n					<md-radio-button ng-repeat=\"item in ctrl.items| orderBy: \'code\'\" value=\"{{item.code}}\" class=\"md-primary\">\n						{{item.libelle}} - {{item.code}}\n					</md-radio-button>\n				</md-radio-group>\n			</div>\n		</md-content>\n\n		<div class=\"actions-bar\">\n			<md-button ng-click=\"ctrl.goToHome()\" class=\"md-raised\">Annuler</md-button>\n			<md-button type=\"button\" class=\"md-raised md-primary\" ng-disabled=\"!codeRace\" ng-click=\"ctrl.goToBGTA(codeRace)\">Valider</md-button>\n		</div>\n	</div>\n</div>\n");
$templateCache.put("app/eleveur/lienCommandesIA/lienCommandesIA.html","<div flex layout=\"raw\" class=\"commandesIA\">\n	<div flex layout=\"column\">\n		<div class=\"title-bar\" layout=\"row\">\n			<h2 flex>Veuillez s&eacute;lectionner le Centre d’ins&eacute;mination de votre choix pour passer vos Commandes d’IA</h2>\n		</div>\n\n		<md-content flex class=\"parent\">\n			<div layout-align=\"center\" layout=\"column\" class=\"parent\">\n				<md-button ng-repeat=\"service in ctrl.services | orderBy : \'libelle\'\" type=\"button\" class=\"md-raised service\" ng-click=\"ctrl.goToCommandesIA(service.code)\">{{service.libelle}}</md-button>\n			</div>\n		</md-content>\n\n		<div class=\"actions-bar\">\n			<md-button ng-click=\"ctrl.goToHome()\" class=\"md-raised\">Annuler</md-button>\n		</div>\n	</div>\n</div>");
$templateCache.put("app/eleveur/main/main.html","<div flex layout=\"column\" class=\"eleveur\">\n  <md-toolbar id=\"mainMdToolBar\" class=\"header-bar\">\n    <div class=\"md-toolbar-tools\">\n      <a ng-click=\"ctrl.goToHome()\">\n        <img src=\"assets/images/logo-plat.png\" class=\"logo\">\n      </a>\n\n      <md-button class=\"production-link bov\" ng-class=\"{active: ctrl.onglet === \'bov\'}\" ng-model=\"bov\" type=\"button\" ng-if=\" ctrl.typeAbo == \'typeBovinEtOvCap\' \" ng-click=\"ctrl.changeTypeAbo(\'bov\')\">Bovin</md-button>\n      <md-button class=\"production-link woc\" ng-class=\"{active: ctrl.onglet === \'woc\'}\" ng-model=\"woc\" type=\"button\" ng-if=\" ctrl.typeAbo == \'typeBovinEtOvCap\' \" ng-click=\"ctrl.changeTypeAbo(\'ovcap\')\">Ovin / Caprin</md-button>\n\n      <div flex></div>\n\n      <div ng-click=\"ctrl.goToEspaceFacturation()\" class=\"menu-item\" ng-if=\"!ctrl.isHidden\">\n        <span class=\"span-menu\">Espace facturation Bovin</span>\n        <md-icon md-svg-src=\"assets/images/icones/euro.svg\" aria-label=\"euro\"></md-icon>\n      </div>\n\n      <div ng-click=\"ctrl.goToLienApplication()\" class=\"menu-item doc\" ng-if=\"!ctrl.isHidden && ctrl.typeAbo != \'typeOvCap\'\">\n        <span class=\"span-menu\">Télécharger l\'appli</span>\n        <img src=\"assets/images/menu/mobile.png\" aria-label=\"settings\" style=\"margin-left:5px; height: 24px\">\n      </div>\n\n      <div ng-click=\"ctrl.goToGed()\" class=\"menu-item doc\" ng-if=\"!ctrl.isHidden\">\n        <span class=\"span-menu\">Documents</span>\n        <md-icon md-svg-src=\"assets/images/icones/description.svg\" aria-label=\"settings\"></md-icon>\n      </div>\n\n      <div ng-click=\"ctrl.goToParametres()\" class=\"menu-item\" ng-if=\"!ctrl.isHidden\">\n        <span class=\"span-menu\">Paramètres</span>\n        <md-icon md-svg-src=\"assets/images/icones/settings.svg\" aria-label=\"settings\"></md-icon>\n      </div>\n\n      <div ng-click=\"ctrl.goToMail()\" class=\"menu-item\" ng-if=\"!ctrl.isHidden\">\n        <span class=\"span-menu\">Email</span>\n        <md-icon md-svg-src=\"assets/images/icones/email.svg\" aria-label=\"email\"></md-icon>\n      </div>\n      <md-menu-bar>\n        <md-menu>\n          <div ng-click=\"$mdMenu.open()\" class=\"menu-item\">\n            <span class=\"span-menu\">Assistance</span>\n            <md-icon md-svg-src=\"assets/images/icones/help.svg\" aria-label=\"help\"></md-icon>\n          </div>\n\n          <md-menu-content class=\"header-menu\">\n            <div flex layout=\"column\" class=\"div-item\" ng-click=\"$mdMenu.close()\">\n              <div flex layout=\"row\">\n                <div class=\"title-assistance\">Assistance Technique</div>\n              </div>\n              <div flex layout=\"row\">\n                <md-icon md-svg-src=\"assets/images/icones/phone_in_talk.svg\" aria-label=\"phone_in_talk\" class=\"icon-assistance\"></md-icon>\n                <div flex layout=\"column\" class=\"text-assistance\">\n                  {{ ctrl.exploitationActive.numeroAssistance | formatPhoneNumber }}\n                </div>\n              </div>\n            </div>\n            <md-menu-divider class=\"espace\"></md-menu-divider>\n            <!-- pas de menu item pour ça / d\'autant que ça casse la mise en page avec des contenus à géométrie variable-->\n            <div flex layout=\"column\" class=\"div-item\" ng-click=\"$mdMenu.close()\">\n              <div flex layout=\"row\">\n                <div class=\"title-assistance\">{{ ctrl.assistanceFacturation.TITRE}}</div>\n              </div>\n              <div flex layout=\"row\">\n                <md-icon md-svg-src=\"assets/images/icones/phone_in_talk.svg\" aria-label=\"phone_in_talk\" class=\"icon-assistance\"></md-icon>\n                <div flex layout=\"column\" class=\"text-assistance\">\n                  <div class=\"resserrer\">{{ ctrl.assistanceFacturation.TELEPHONE }}</div>\n                  <div class=\"resserrer\">{{ ctrl.assistanceFacturation.FREQUENCE }}</div>\n                </div>\n              </div>\n              <div flex layout=\"row\" class=\"espacer\">\n                <md-icon md-svg-src=\"assets/images/icones/arobase.svg\" aria-label=\"arobase\" class=\"icon-assistance\"></md-icon>\n                <div flex layout=\"column\" class=\"text-assistance\">\n                  {{ ctrl.assistanceFacturation.EMAIL }}\n                </div>\n              </div>\n            </div>\n          </md-menu-content>\n        </md-menu>\n      </md-menu-bar>\n      <md-menu-bar>\n        <md-menu>\n          <div ng-click=\"$mdMenu.open()\" class=\"menu-item account\">\n            <div flex layout=\"column\">\n              <div>\n                <span>{{ctrl.exploitationActive.raisonSociale}}</span>\n              </div>\n              <div>\n                <span class=\"num-exploitation\">FR{{ctrl.exploitationActive.numExploitation}}</span>\n              </div>\n            </div>\n\n            <md-icon class=\"md-icon\" md-svg-src=\"assets/images/icones/account_circle.svg\" aria-label=\"account_circle\"></md-icon>\n          </div>\n\n          <md-menu-content class=\"header-menu\">\n            <md-menu-item class=\"md-indent\" ng-if=\"ctrl.responsableAssocie || ctrl.isAssistance\">\n              <md-icon md-svg-src=\"assets/images/icones/account_circle.svg\" aria-label=\"person_outline\"></md-icon>\n              <md-button ng-click=\"ctrl.goToCompte()\">\n                Mon compte\n              </md-button>\n            </md-menu-item>\n            <md-menu-divider ng-if=\"ctrl.responsableAssocie || ctrl.isAssistance\"></md-menu-divider>\n\n            <md-menu-item class=\"md-indent\">\n              <md-icon md-svg-src=\"assets/images/icones/lock_open.svg\" aria-label=\"lock_open\"></md-icon>\n              <md-button ng-click=\"ctrl.goToChangeMdp()\">\n                Modifier mon mot de passe\n              </md-button>\n            </md-menu-item>\n            <md-menu-divider></md-menu-divider>\n\n            <md-menu-item ng-if=\"ctrl.isMultiExploitation()\" class=\"md-indent\">\n              <md-icon md-svg-src=\"assets/images/icones/autorenew.svg\" aria-label=\"autorenew\"></md-icon>\n              <md-button ng-click=\"ctrl.goToSelectionExploitation()\">\n                Changer de cheptel\n              </md-button>\n            </md-menu-item>\n            <md-menu-divider ng-if=\"ctrl.isMultiExploitation()\"></md-menu-divider>\n            <md-menu-item ng-if=\"ctrl.isMultiProfil()\" class=\"md-indent\">\n              <md-icon md-svg-src=\"assets/images/icones/autorenew.svg\" aria-label=\"autorenew\"></md-icon>\n              <md-button ng-click=\"ctrl.goToSelectionProfil()\">\n                Changer de profil\n              </md-button>\n            </md-menu-item>\n            <md-menu-divider ng-if=\"ctrl.isMultiProfil()\"></md-menu-divider>\n            <md-menu-item class=\"md-indent\">\n              <md-icon md-svg-src=\"assets/images/icones/exit_to_app.svg\" aria-label=\"exit_to_app\"></md-icon>\n              <md-button ng-click=\"ctrl.logout()\">\n                Se déconnecter\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n      </md-menu-bar>\n    </div>\n  </md-toolbar>\n\n  <ui-view flex layout=\"column\"></ui-view>\n\n  <div layout=\"row\" layout-align=\"space-between end\" class=\"footer-main\">\n    <div></div>\n    <div class=\"lien-footer\">\n      <a ng-click=\"ctrl.goToMentionLegales()\">Mentions légales</a>\n      <span class=\"separator\">/</span>\n      <a ng-click=\"ctrl.goToPolitiqueConfidentialite()\">Politique de confidentialité</a>\n      <span class=\"separator\">/</span>\n      <a ng-click=\"ctrl.goToPartenaire()\">Partenaires</a>\n    </div>\n    <div>\n      <p class=\"version\">{{ctrl.loginKc}}{{ctrl.version}}</p>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/footer/mentionsLegales/mentionsLegales.html","<md-toolbar class=\"header-bar\">\n  <div class=\"md-toolbar-tools\">\n    <a ng-click=\"ctrl.goToHome()\" flex layout=\"row\" layout-align=\"start center\">\n      <img src=\"assets/images/logo-plat.png\" class=\"logo\">\n    </a>\n  </div>\n</md-toolbar>\n<div layout=\"raw\" ng-include=\"\'app/_common/partials/mentionsLegales/mentionsLegales.html\'\" flex></div>\n\n<div layout=\"row\" layout-align=\"space-between center\" class=\"footer-main\">\n  <div class=\"\"></div>\n  <div class=\"\">\n    <a ui-sref=\"mentionsLegales\">Mentions légales</a>\n    <span class=\"separator\">/</span>\n    <a ui-sref=\"politiqueConfidentialite\">Politique de confidentialité</a>\n    <span class=\"separator\">/</span>\n    <a ui-sref=\"partenaires\">Partenaires</a>\n  </div>\n  <div class=\"\">\n    <adv-constant key=\"\'VERSION\'\" class=\"version\"></adv-constant>\n  </div>\n</div>");
$templateCache.put("app/footer/partenaires/partenaires.html","<md-toolbar class=\"header-bar\">\n  <div class=\"md-toolbar-tools\">\n    <a ng-click=\"ctrl.goToHome()\" flex layout=\"row\" layout-align=\"start center\">\n      <img src=\"assets/images/logo-plat.png\" class=\"logo\">\n    </a>\n  </div>\n</md-toolbar>\n<div flex layout=\"raw\">\n  <div flex layout=\"column\" class=\"partenaires\">\n    <div class=\"title-bar\">\n      <h2>Partenaires</h2>\n    </div>\n    <md-content flex layout-align=\"start center\">\n      <div ng-repeat=\"_ in ctrl.listePatenaires\" ng-if=\"$index % 4 === 0\">\n        <div class=\"partenaires-list\" layout=\"column\" layout-align=\"center center\">\n          <div layout-gt-sm=\"raw\" layout-align=\"center center\">\n            <div class=\"partenaires-item\" ng-repeat=\"i in [$index, $index + 1, $index + 2, $index + 3]\" ng-init=\"partenaire = ctrl.listePatenaires[i]\">\n              <div ng-if=\"partenaire != null\">\n                <div ng-if=\"partenaire.url != null\">\n                  <a href=\"{{partenaire.url}}\" target=\"_blank \" value=\"{{partenaire.libelle}} \">\n                    <img ng-src=\"{{partenaire.logo}} \" alt=\"{{partenaire.libelle}} \">\n                  </a>\n                </div>\n                <div ng-if=\"partenaire.url == null\">\n                  <img ng-src=\"{{partenaire.logo}} \" alt=\"{{partenaire.libelle}} \">\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </md-content>\n  </div>\n</div>\n<div layout=\"row\" layout-align=\"space-between center\" class=\"footer-main\">\n  <div class=\"\"></div>\n  <div class=\"\">\n    <a ui-sref=\"mentionsLegales\">Mentions légales</a>\n    <span class=\"separator\">/</span>\n    <a ui-sref=\"politiqueConfidentialite\">Politique de confidentialité</a>\n    <span class=\"separator\">/</span>\n    <a ui-sref=\"partenaires\">Partenaires</a>\n  </div>\n  <div class=\"\">\n    <adv-constant key=\"\'VERSION\'\" class=\"version\"></adv-constant>\n  </div>\n</div>");
$templateCache.put("app/footer/politiqueConfidentialite/politiqueConfidentialite.html","<md-toolbar class=\"header-bar\">\n    <div class=\"md-toolbar-tools\">\n      <a ng-click=\"ctrl.goToHome()\" flex layout=\"row\" layout-align=\"start center\">\n        <img src=\"assets/images/logo-plat.png\" alt=\"Logo et intitulé Pilot\'Elevage sur une ligne\" class=\"logo\">\n      </a>\n    </div>\n  </md-toolbar>\n  <div layout=\"raw\" ng-include=\"\'app/_common/partials/politiqueConfidentialite/politiqueConfidentialite.html\'\" flex></div>\n  \n  <div layout=\"row\" layout-align=\"space-between center\" class=\"footer-main\">\n    <div class=\"\"></div>\n    <div class=\"\">\n      <a ui-sref=\"mentionsLegales\">Mentions légales</a>\n      <span class=\"separator\">/</span>\n      <a ui-sref=\"politiqueConfidentialite\">Politique de confidentialité</a>\n      <span class=\"separator\">/</span>\n      <a ui-sref=\"partenaires\">Partenaires</a>\n    </div>\n    <div class=\"\">\n      <adv-constant key=\"\'VERSION\'\" class=\"version\"></adv-constant>\n    </div>\n  </div>");
$templateCache.put("app/nouvelAbonnement/autorisationsAcces/autorisationsAcces.html","\n <div layout=\"column\" ng-include=\"\'app/_common/partials/autorisationsAcces/autorisationsAcces.html\'\" flex></div>\n");
$templateCache.put("app/nouvelAbonnement/facturation/facturation.html","<div layout=\"column\" ng-include=\"\'app/_common/partials/facturation/facturation.html\'\" flex></div>");
$templateCache.put("app/nouvelAbonnement/informations/informations.html","<div flex layout=\"column\" class=\"informations-abonnement\">\n <form name=\"ctrl.authentForm\" ng-submit=\"ctrl.goToServices()\" novalidate flex layout=\"column\">\n    <md-content flex>\n      <div class=\"title-step-1\">\n        <span>Pour accéder aux détails de l\'Offre Pilot\'Elevage, merci de renseigner votre numéro d\'exploitation ainsi que votre n° de Siren (ou n° AGRIN), puis cliquez sur \"Suivant\" : </span>\n     \n      </div>\n      <div layout=\"row\" layout-align=\"center\">\n        <div layout=\"column\" class=\"informations-content\">\n          <div class=\"exploitation\">\n            <h4 class=\"codePays\">FR</h4>\n            <md-input-container>\n              <label>N° Exploitation</label>\n              <input required name=\"numExploitation\" ng-model=\"ctrl.nouvelAbonnement.numExploitation\" adv-numbers-only maxlength=\"8\" ng-pattern=\"/^[0-9]{8}$/\" ng-readonly=\"ctrl.hideSiren\" ng-change=\"ctrl.setNumeroAssistance()\">\n              <div ng-messages=\"ctrl.authentForm.numExploitation.$error\" role=\"alert\">\n                <div ng-message=\"required\">Donnée obligatoire</div>\n                <div ng-message=\"pattern\">Votre N° d\'exploitation doit contenir 8 caractères numériques.</div>\n              </div>\n            </md-input-container>\n          </div>\n\n          <div ng-hide=\"ctrl.hideSiren\">\n            <md-input-container>\n              <label ng-class=\"ctrl.hasNumagrin ? \'disabled\' : \'\' \">N° Siren</label>\n              <input ng-required=\"!ctrl.nouvelAbonnement.numagrin\" name=\"numSiren\" adv-numbers-only ng-class=\"ctrl.hasNumagrin ? \'disabled\' : \'\' \" ng-model=\"ctrl.nouvelAbonnement.numSiren\" maxlength=\"9\" ng-pattern=\"/^[0-9]{9}$/\" ng-disabled=\"ctrl.hasNumagrin\">\n              <div ng-messages=\"ctrl.authentForm.numSiren.$error\" role=\"alert\">\n                <div ng-message=\"required\">La saisie du N° Siren ou N° Numagrin est obligatoire. Si vous ne connaissez pas/plus votre N° Siren ou N° Numagrin,\n                  contactez votre service identification.</div>\n                <div ng-message=\"pattern\">Votre N° de Siren doit contenir 9 caractères numériques.</div>\n              </div>\n            </md-input-container>\n\n            <div>\n              <md-checkbox ng-model=\"ctrl.hasNumagrin\" aria-label=\"numagrin\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\" ng-change=\"ctrl.clearInput(ctrl.hasNumagrin)\"></md-checkbox>\n              <label>Je ne dispose pas d\'un N° SIREN, je souhaite renseigner un Numagrin</label>\n            </div>\n\n            <md-input-container ng-show=\"ctrl.hasNumagrin\">\n              <label>Numagrin</label>\n              <input ng-required=\"!ctrl.nouvelAbonnement.numSiren\" name=\"numagrin\" ng-model=\"ctrl.nouvelAbonnement.numagrin\" maxlength=\"9\" ng-pattern=\"/^[a-zA-Z]{1}[0-9]{8}$/\">\n              <div ng-messages=\"ctrl.authentForm.numagrin.$error\" role=\"alert\">\n                <div ng-message=\"required\">La saisie du N° Siren ou N° Numagrin est obligatoire. Si vous ne connaissez pas/plus votre N° Siren ou N° Numagrin,\n                  contactez votre service identification.</div>\n                <div ng-message=\"pattern\">Votre N° de Numagrin doit être composé d’une lettre suivie de 8 chiffres.</div>\n              </div>\n            </md-input-container>\n          </div>\n        </div>\n      </div>\n    </md-content>\n\n    <div class=\"actions-bar\">\n      <a href=\"assets/documents/savoirplus.pdf\" target=\"_blank\" class=\"light-link lien\">En savoir plus</a>\n      <md-button type=\"button\" ui-sref=\"auth\" class=\"md-raised md-sample\">Annuler</md-button>\n      <md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"ctrl.authentForm.$invalid\">Suivant</md-button>\n    </div>\n  </form>\n\n</div>");
$templateCache.put("app/nouvelAbonnement/main/main.html","<div flex layout=\"column\">\n  <md-toolbar class=\"header-bar\">\n    <div class=\"md-toolbar-tools\">\n      <a ui-sref=\"auth\" flex layout=\"row\" layout-align=\"start center\">\n        <img src=\"assets/images/logo-plat.png\" class=\"logo\">\n      </a>\n    </div>\n  </md-toolbar>\n\n  <div class=\"title-bar-responsive has-breadcrumbs\" layout-gt-sm=\"row\">\n    <h2 flex-gt-sm=\"30\">{{ctrl.getTitle()}}</h2>\n    <div flex-gt-sm=\"30\" layout-align=\"center center\" class=\"breadcrumbs breadcrumbs-responsive\">\n      <adv-breadcrumbs steps=\"ctrl.saisie.steps\"></adv-breadcrumbs>\n    </div>\n\n    <div flex-gt-sm=\"30\"></div>\n  </div>\n\n  <ui-view flex layout=\"column\"></ui-view>\n\n  <div layout=\"row\" layout-align=\"space-between end\" class=\"footer-main\">\n    <div></div>\n    <div class=\"lien-footer\">\n      <a ui-sref=\"mentionsLegales\" target=\"_blank\">Mentions légales</a>\n      <span class=\"separator\">/</span>\n      <a ui-sref=\"politiqueConfidentialite\" target=\"_blank\">Politique de confidentialité</a>\n      <span class=\"separator\">/</span>\n      <a ui-sref=\"partenaires\" target=\"_blank\">Partenaires</a>\n    </div>\n    <div>\n      <p class=\"version\">{{ctrl.version}}</p>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/nouvelAbonnement/offresPilotElevage/offresPilotElevage.html","<div flex layout=\"column\" class=\"offrePilotElevage\">\n  <form name=\"ctrl.authentForm\" ng-submit=\"ctrl.goToAutorisationsAcces()\" novalidate flex layout=\"column\">\n    <md-content flex>\n      <div class=\"content-div\">\n        <!--<embed src=\"assets/documents/details.pdf?#zoom=150&scrollbar=0&toolbar=0&navpanes=0\" type=\"application/pdf\" height=\"100%\" width=\"100%\"/>-->\n        <p><span style=\"color: #3fae2a; text-decoration: underline\"><b>Il existe 2 Formules Bovin et 1 formule Ovins/Caprins :</b></span> vous\n          trouverez le descriptif et le détail des fonctionnalités disponibles par formule ci-dessous.</p>\n        <p style=\"text-decoration: underline\"><b>Formules Bovin :</b></p>\n        <p>\n          <b>La formule ESSENTIEL BOVIN (8 € HT/mois à compter du 01/01/2025) :</b> permet de réaliser et consulter les enregistrements zootechniques (IPG, reproduction, sanitaire), de consulter le dossier animal de façon simple et rapide et les données de contrôles de performances, sur l’ordinateur comme sur l’application mobile.\n        </p>\n        <p>\n          <b>La formule PERFORMANCE BOVIN (17 € HT/mois à compter du 01/01/2025) :</b> dispose des fonctionnalités de la formule Essentiel et permet en plus d’accéder à toutes les alertes de pilotage du troupeau, à tous les tableaux de bord et bilans au plus près du besoin, sur l’ordinateur comme sur l’application mobile.\n        </p>\n        <img src=\"assets/images/offres.png\" class=\"img-offres\"><br>\n        <div style=\"border: solid 1px; padding: 10px\">\n          <h2>Une Option « Service FLORE Sortie Présumée» existe dans le cadre des formules BOVINS.</h2>\n          <p>\n            <b>FLORE Sortie Présumée est un robot conversationnel qui à l’aide de SMS permet de vous alerter en cas de\n              sortie présumée.</b> Il convient donc de posséder un\n            téléphone mobile pour recevoir les sms. Un seul téléphone par exploitation pourra recevoir ces alertes sms.\n          </p>\n          <p>\n            <b>Ce service est <span style=\"font-size: 20px; color: #3fae2a; text-decoration: underline\">inclus sans\n                surcoût</span> dans vos abonnements Pilot\'Elevage Essentiel et Performance bovins</b>\n            (hors coûts spécifiques d\'envoi de SMS depuis\n            votre smartphone).\n          </p>\n          <p>\n            Un SMS vous sera envoyé lorsqu’une notification d’abattage ou d’entrée d’un de vos bovins dans une autre\n            exploitation est enregistrée mais également lorsque\n            des bovins sont enlevés par l’équarrissage (et que vous ne les avez pas encore sortis de votre inventaire).\n            Pour précision : le robot Flore envoie l’alerte SMS si\n            vous n’avez pas notifié ces sorties au bout de 4 jours.\n          </p>\n          <p>\n            Le fait de répondre et de valider la sortie de l’animal via un sms adressé au service FLORE Sortie Présumée,\n            tient lieu de notification (en allant jusqu’au terme de\n            la conversation). Vous n’avez pas d’autres opérations à réaliser.\n          </p>\n          <p>\n            <b>Comment activer FLORE Sortie Présumée?</b><br>\n            Lors de son abonnement à l’offre PILOT’ELEVAGE, il convient de cocher « OUI » à la question «Confirmez-vous\n            l\'activation du service Flore inclus dans votre\n            abonnement (sans surcoût)?». L’activation est alors immédiate.\n          </p>\n          <p>\n            <b>Comment désactiver FLORE Sortie Présumée?</b><br>\n            Sur son portail PILOT’ELEVAGE, après authentification, il convient de cliquer sur « Mon compte » puis «\n            Services » et cocher « NON » à la question « Confirmezvous\n            l\'activation du service Flore inclus dans votre abonnement (sans surcoût)? ». La désactivation est alors\n            immédiate.\n          </p>\n        </div>\n        <p style=\"margin-top: 50px\">\n          <span style=\"text-decoration: underline\"><b>Formule Ovins/Caprins :</b></span> Elle rassemble les fonctions de recensement, de circulation et de commande de boucles. Les tarifs de cette formule dépendent du département dans lequel l’Abonné est établi. \n        </p>\n        <img src=\"assets/images/offre_caprin.png\" class=\"img-offres offre-caprin\">\n        <p>\n          <b>Pilot’Elevage informe ses utilisateurs qu’ils bénéficient d’un <u>délai de rétractation</u> de quatorze (14) jours francs à compter de la date de\n            souscription des Services. Le descriptif de l’application de ce doit ainsi que le formulaire de rétractation seront joints au mail que vous\n            recevrez suite à votre confirmation d’abonnement en ligne. \n            </b>\n        </p>\n        <p>\n          <span style=\"color: #3fae2a; text-decoration: underline\"><b>Assistance :</b></span> L’abonnement aux Services inclut un accès à une assistance par email ou téléphone (prix d’un appel normal en France\n          Métropolitaine). \n        </p>\n        <p>\n          <span style=\"color: #3fae2a; text-decoration: underline\"><b>Compatibilité :</b></span> La navigation sur le Site est optimisée avec les navigateurs Firefox et Chrome et compatible avec le navigateur Safari.\n          L\'affichage du Site est conçu pour les tablettes d\'une taille minimale de 10 pouces et pour les écrans dotés d\'une résolution minimale de\n          1280*800.\n          L\'application mobile Pilot\'Elevage Bovin est compatible avec les smartphones et tablettes équipés des systèmes d’exploitation en version :\n          iOS >= 10 et Android >= 6.1. \n        </p>\n        <p>L\'équipe Pilot\'Elevage</p>\n        <p>Mise à jour 15 novembre 2024</p>\n      </div>\n    </md-content>\n    <div class=\"actions-bar\">\n      <a href=\"assets/documents/cgsl.pdf\" target=\"_blank\" class=\"light-link lien\">Voir les détails</a>\n      <md-button type=\"button\" ui-sref=\"auth\" class=\"md-raised md-sample\">Annuler</md-button>\n      <md-button type=\"submit\" class=\"md-raised md-primary\">S\'abonner</md-button>\n    </div>\n  </form>\n</div>");
$templateCache.put("app/nouvelAbonnement/options/options.html","<div flex layout=\"column\" class=\"services-option\">\n    <form name=\"ctrl.servicesForm\" ng-submit=\"ctrl.goToFacturation()\" flex novalidate layout=\"column\">\n        <md-content flex>\n            <div style=\"display: flex; justify-content: center\">\n                <h3 class=\"colorh3\">{{ctrl.raisonSociale}} - FR {{ctrl.numeroExploitation}}</h3>\n              </div>\n            <div layout=\"row\" layout-align=\"center\" class=\"service\">\n                <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\">\n                    <div layout=\"column\" class=\"notification-border div-option\" ng-show=\"ctrl.bovin && ctrl.abonnementFlore\" ng-class=\"ctrl.showNotification === true ? \'notification-flore-active-create\' : \'notification-flore-unactive\'\">\n                        <h2 class=\"notification-title\">Service FLORE</h2>\n                        <div layout-gt-sm=\"row\">\n                            <div layout=\"row\">\n                                <div layout=\"column\">\n                                    <label>Souhaitez-vous activer le service Flore inclus dans votre</label>\n                                    <label>abonnement (sans surcoût)?</label>\n                                </div>\n                                <md-button class=\"md-icon-button\" ng-click=\"ctrl.showHelp()\">\n                                    <md-icon md-svg-src=\"assets/images/help.svg\" aria-label=\"help\" class=\"md-icon-help\">\n                                    </md-icon>\n                                </md-button>\n                            </div>\n                            <div layout=\"row\" class=\"notification-button-row\">\n                                <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.showingNotification()\" ng-class=\"ctrl.showNotification === true ? \'md-primary\' : \'md-sample\'\">\n                                    Oui\n                                </md-button>\n                                <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.hidingNotification()\" ng-class=\"ctrl.showNotification === false ? \'md-primary\' : \'md-sample\'\">\n                                    Non\n                                </md-button>\n                            </div>\n                        </div>\n                        <div layout=\"column\" ng-show=\"ctrl.showNotification === true\" class=\"notifiaction-margin-top\">\n                            <b>Choix du média pour recevoir l\'alerte sorties présumées : </b>\n                            <div layout=\"row\" class=\"notification-choix-media\">\n                                <md-radio-group ng-model=\"ctrl.flore.media\" class=\"md-radio-group-media\">\n                                    <md-radio-button value=\"sms\" flex=\"33\">SMS</md-radio-button>\n                                    <md-radio-button value=\"skype\" flex=\"33\" ng-show=\"ctrl.flore.media === \'mediaNonDispo\'\"> Skype</md-radio-button>\n                                    <md-radio-button value=\"facebook\" flex=\"33\" ng-show=\"ctrl.flore.media === \'mediaNonDispo\'\">Facebook Messenger\n                                    </md-radio-button>\n                                </md-radio-group>\n                            </div>\n                            <div layout=\"row\">\n                                <div layout=\"column\" flex=\"33\">\n                                    <md-input-container ng-show=\"ctrl.flore.media === \'sms\'\">\n                                        <label>N° Tel. portable</label>\n                                        <input class=\"input-width\" name=\"telephone\" ng-model=\"ctrl.flore.utilisateurTelephone.telMobile\" type=\"text\" ng-pattern=\"/^(06|07) [0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}$/\" ui-mask=\"?9?9 ?9?9 ?9?9 ?9?9 ?9?9\" ui-mask-placeholder=\"\" ui-mask-placeholder-char=\"space\" ng-required=\"ctrl.flore.media === \'sms\'\">\n                                        <div ng-messages=\"ctrl.servicesForm.telephone.$error\" role=\"alert\" class=\"input-width\">\n                                            <div ng-message=\"required\">La saisie de votre numéro de téléphone est\n                                                obligatoire.</div>\n                                            <div ng-message=\"pattern\">Le N° de téléphone portable doit commencer par 06\n                                                ou 07.</div>\n                                        </div>\n                                    </md-input-container>\n                                </div>\n                                <div ng-show=\"ctrl.flore.media === \'facebook\'\" class=\"infos-media-externe\">\n                                    <b ng-show=\"ctrl.parametres.FLORE_FACEBOOK_OPTION === \'enabled\'\">Contactez votre\n                                        service assistance pour recevoir vos alertes sorties présumées via Skype ou\n                                        Facebook Messenger</b>\n                                    <b ng-show=\"ctrl.parametres.FLORE_FACEBOOK_OPTION === \'disabled\'\">La communication\n                                        avec FLORE via Skype où Facebook Messenger sera possible prochainement.</b>\n                                </div>\n                                <div ng-show=\"ctrl.flore.media === \'skype\'\" class=\"infos-media-externe\">\n                                    <b ng-show=\"ctrl.parametres.FLORE_SKYPE_OPTION === \'enabled\'\">Contactez votre\n                                        service assistance pour recevoir vos alertes sorties présumées via Skype ou\n                                        Facebook Messenger</b>\n                                    <b ng-show=\"ctrl.parametres.FLORE_SKYPE_OPTION === \'disabled\'\">La communication avec\n                                        FLORE via Skype où Facebook Messenger sera possible prochainement.</b>\n                                </div>\n                            </div>\n                        </div>\n                        <div ng-show=\"ctrl.showNotification === true\" class=\"texte-juridique\">\n                            <p>Pilot’Elevage collecte le n° de téléphone mobile pour pouvoir activer le service d’alerte SMS, pour plus d’informations consultez la Politique de Confidentialité de Pilot’Elevage.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div layout=\"row\" layout-align=\"center\" class=\"service\" ng-repeat=\"option in ctrl.options\">\n                <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\" ng-show=\"option.nom == \'dataHUB\' && option.allowed\">\n                    <div layout=\"column\" class=\"notification-border div-option\" class=\"notification-flore-unactive\">\n                        <h2 class=\"option-title\">{{option.libelle}}</h2>\n                        <div layout-gt-sm=\"row\">\n                            <div layout=\"column\">\n                                <div layout=\"row\">\n                                    <label>Pour découvrir l\'option {{option.nom}} 360°, cliquez </label>&nbsp;\n                                    <a ng-click=\"ctrl.showOptionHelp(option)\" style=\"text-decoration: underline; color: black\"> ici</a>\n                                </div>\n                                <div layout=\"row\" style=\"justify-content: center\">\n                                    <label>Souhaitez-vous être recontacté pour activer l\'option {{option.nom}} ? </label>\n                                </div>\n                            </div>\n                            <div layout=\"row\" class=\"notification-button-row\">\n                                <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.datahubOuiButton(option, true)\" ng-class=\"option.isSelected === true ? \'md-primary\' : \'md-sample\'\">\n                                    {{option.boutonValidation}}\n                                </md-button>\n                                <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.datahubNonButton(option)\" ng-class=\"option.isSelected === false ? \'md-primary\' : \'md-sample\'\">\n                                    {{option.boutonAnnulation}}\n                                </md-button>\n                            </div>\n                        </div>\n                        <ng-include ng-show=\"option.isSelected === true\" src=\"\'app/_common/partials/options/optionTemplates/datahub.html\'\">\n                        </ng-include>\n                    </div>\n                </div>\n                <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\" ng-show=\"option.allowed && option.nom != \'dataHUB\'\">\n                    <div layout=\"column\" class=\"notification-border div-option\" class=\"notification-flore-unactive\">\n                        <h2 class=\"option-title\">{{option.libelle}}</h2>\n                        <div layout-gt-sm=\"row\">\n                            <div layout=\"row\">\n                                <div layout=\"column\" style=\"justify-content: center\">\n                                    <ng-bind-html ng-if=\"option.description\" ng-bind-html=\"option.description\"></ng-bind-html>\n                                    <label ng-if=\"!option.description\">Confirmez-vous l\'activation du service {{option.nom}} ?</label>\n                                </div>\n                                <md-button class=\"md-icon-button\" ng-click=\"ctrl.showOptionHelp(option)\" ng-show=\"option.titrePopup && option.contenuPopup\">\n                                    <md-icon md-svg-src=\"assets/images/help.svg\" aria-label=\"help\" class=\"md-icon-help\">\n                                    </md-icon>\n                                </md-button>\n                            </div>\n                            <div layout=\"row\" class=\"notification-button-row\">\n                                <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.optionOuiButtonClic(option)\" ng-class=\"option.isSelected === true ? \'md-primary\' : \'md-sample\'\">\n                                    {{option.boutonValidation}}\n                                </md-button>\n                                <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.optionNonButtonClic(option)\" ng-class=\"option.isSelected === false ? \'md-primary\' : \'md-sample\'\">\n                                    {{option.boutonAnnulation}}\n                                </md-button>\n                            </div>\n                        </div>\n                        <ng-include ng-show=\"option.templateHtml && option.isSelected === true\" src=\"option.templateHtml\"></ng-include>\n                        <a ng-href=\"{{\'assets/documents/\'+option.nomPdfPolitiqueConfidentialite}}\" ng-show=\"option.nomPdfPolitiqueConfidentialite\" target=\"_blank\" class=\"light-link\">Politique de confidentialite</a>\n                    </div>\n                </div>\n                <div id=\"bottom-{{option.idAbonnement}}\"></div>\n            </div>\n        </md-content>\n\n        <div class=\"actions-bar service-actions-bar\">\n            <md-button type=\"button\" ui-sref=\"auth\" class=\"md-raised md-sample\">Annuler</md-button>\n            <md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"ctrl.disabled\">Suivant</md-button>\n        </div>\n    </form>\n</div>");
$templateCache.put("app/nouvelAbonnement/services/services.html","<div flex layout=\"column\" class=\"services-compte\">\n  <form name=\"ctrl.servicesForm\" ng-submit=\"ctrl.goToFacturation()\" flex novalidate layout=\"column\">\n    <md-content flex>\n      <div layout=\"row\" layout-align=\"center\">\n        <div flex=\"20\"></div>\n        <div>\n          <h3 class=\"colorh3\">{{ctrl.raisonSociale}} - FR {{ctrl.numeroExploitation}}</h3>\n        </div>\n        <div flex=\"20\"></div>\n      </div>\n      <div layout=\"row\" layout-align=\"center\" class=\"service\">\n        <div flex=\"20\"></div>\n        <div>\n          <md-card ng-if=\"ctrl.abonnementsBovin\" layout=\"column\" class=\"md-whiteframe-2dp card-content\">\n            <div>\n              <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\">\n                <h2>Formule bovin</h2>\n                <md-radio-group ng-model=\"ctrl.bovin\" ng-if=\"ctrl.abonnementsBovin\" class=\"md-radio-group-nouvel-abo\">\n                  <md-radio-button ng-repeat=\"niveau in ctrl.abonnementsBovin | orderBy : \'-niveauAbonnement.code\'\" ng-value=\"niveau\" class=\"radio-button-service\">\n                    <md-card type=\"button\" class=\"service-card {{niveau.niveauAbonnement.code==\'2\' ? \'niveau-basique\' : \'niveau-expert\'}} md-whiteframe-6dp\" ng-class=\"{active: (ctrl.bovin === niveau)}\">\n                      <md-card-title>\n                        <img src=\"assets/images/logo-plat.png\" class=\"logo-card\">\n                      </md-card-title>\n\n                      <md-card-content>\n                        <div flex>\n                          <p class=\"titre\">{{niveau.niveauAbonnement.libelle}}</p>\n                          <p class=\"libelle\">{{niveau.sloganAbonnement}}</p>\n                        </div>\n\n                        <md-icon md-svg-src=\"assets/images/icones/devices.svg\" class=\"devices\" aria-label=\"devices\"></md-icon>\n                      </md-card-content>\n\n                      <div class=\"contrat\">\n                        <p class=\"tarif\" ng-if=\"ctrl.reduction\">{{ctrl.reductionTxt}}</p>\n                        <p class=\"tarif\">\n                          <span ng-if=\"ctrl.reduction\"> Puis </span>{{niveau.prix.toFixed(2)}} € HT / {{niveau.periodicite.libelle}}</p>\n                          <p class=\"duree\">Engagement à l\'année civile, renouvellement par tacite reconduction*</p>\n                      </div>\n                    </md-card>\n                  </md-radio-button>\n                  <md-radio-button ng-value=\"0\">\n                    <md-card type=\"button\" ng-class=\"{active: (ctrl.bovin === 0)}\" class=\"service-card cloture md-whiteframe-6dp\">\n                      <md-card-content>\n                        <i class=\"material-icons\">block</i>\n                      </md-card-content>\n\n                      <div class=\"contrat\">\n                        <p class=\"tarif\">\n                          Ne pas souscrire\n                        </p>\n                      </div>\n                    </md-card>\n                  </md-radio-button>\n                </md-radio-group>\n              </div>\n            </div>\n          </md-card>\n          <md-card ng-if=\"ctrl.abonnementsOvCap\" layout=\"column\" class=\"md-whiteframe-2dp card-content\">\n            <div>\n\n              <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\">\n                <h2>Formule ovin / caprin</h2>\n                <md-radio-group ng-model=\"ctrl.ovin\" ng-if=\"ctrl.abonnementsOvCap\" class=\"md-radio-group-nouvel-abo\">\n\n                  <md-radio-button ng-repeat=\"niveau in ctrl.abonnementsOvCap | orderBy : \'-niveauAbonnement.code\'\" ng-value=\"niveau\" class=\"radio-button-service\">\n                    <md-card type=\"button\" class=\"service-card ovin md-whiteframe-6dp\" ng-class=\"{active: (ctrl.ovin === niveau)}\">\n                      <md-card-title>\n                        <img src=\"assets/images/logo-plat.png\" class=\"logo-card\">\n                      </md-card-title>\n\n                      <md-card-content>\n                        <div flex>\n                          <p class=\"titre\">{{niveau.niveauAbonnement.libelle}}</p>\n                          <p class=\"libelle\">{{niveau.sloganAbonnement}}</p>\n                        </div>\n\n                        <md-icon md-svg-src=\"assets/images/icones/devices.svg\" class=\"devices\" aria-label=\"devices\"></md-icon>\n                      </md-card-content>\n\n                      <div class=\"contrat\">\n\n                        <p class=\"tarif\">\n                          {{niveau.prix.toFixed(2)}} € HT / {{niveau.periodicite.libelle}}</p>\n                          <p class=\"duree\">Engagement à l\'année civile, renouvellement par tacite reconduction*</p>\n                      </div>\n                    </md-card>\n                  </md-radio-button>\n\n                  <md-radio-button ng-value=\"0\">\n                    <md-card type=\"button\" ng-class=\"{active: (ctrl.ovin === 0)}\" class=\"service-card cloture md-whiteframe-6dp\">\n                      <md-card-content>\n                        <i class=\"material-icons\">block</i>\n                      </md-card-content>\n\n                      <div class=\"contrat\">\n                        <p class=\"tarif\">\n                          Ne pas souscrire\n                        </p>\n                      </div>\n                    </md-card>\n                  </md-radio-button>\n\n                </md-radio-group>\n\n              </div>\n            </div>\n          </md-card>\n        </div>\n        <div flex=\"20\"></div>\n      </div>\n    </md-content>\n\n    <div class=\"actions-bar service-actions-bar\">\n      <div class=\"cgsl spacer\"><label>*Consultez les <a href=\"assets/documents/cgsl.pdf\" target=\"_blank\" class=\"light-link cgsl\">Conditions générales de Souscription en ligne</a> de Pilot\'Elevage</label></div>\n      <a href=\"assets/documents/details.pdf\" target=\"_blank\" class=\"light-link details\">Voir les détails</a>\n      <md-button type=\"button\" ui-sref=\"auth\" class=\"md-raised md-sample\">Annuler</md-button>\n      <md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"ctrl.disabled\">Suivant</md-button>\n    </div>\n  </form>\n</div>");
$templateCache.put("app/nouvelAbonnement/validation/validation.html","<div flex layout=\"column\" class=\"validation\">\n\n  <md-content flex>\n    <div layout=\"row\">\n      <div layout=\"column\" class=\"validation-content\">\n\n        <p class=\"abonnement\">Merci d\'avoir choisi Pilot\'Elevage !</p>\n\n        <p>\n          Suite à la confirmation de votre abonnement à l\'offre {{ctrl.description}}, chaque personne autorisée à accéder à votre compte Pilot’Elevage avec le droit « saisie autorisée » va recevoir  \n          un mail avec les instructions pour se connecter au portail WEB, ainsi qu’un SMS avec le lien de téléchargement de l’application Pilot’Elevage Mobile (sans surcoût).\n        </p>\n\n        <p>Une question ? Contactez le service assistance de votre département.</p>\n\n        <div class=\"cgv\">\n          <md-checkbox ng-model=\"acceptCGV\" aria-label=\"acceptCGV\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\"></md-checkbox>\n          En tant que responsable de l\'exploitation, j\'atteste avoir lu et j\'accepte les \n          <a href=\"assets/documents/cgsl.pdf\" ng-show=\"!ctrl.aboFloreActive\" target=\"_blank\" class=\"light-link\">conditions générales de souscription en ligne Pilot\'Elevage</a><!-- (sans flore) -->\n          <a href=\"assets/documents/cgsl.pdf\" ng-show=\"ctrl.aboFloreActive\" target=\"_blank\" class=\"light-link\">conditions générales de souscription en ligne Pilot\'Elevage</a><!-- (avec flore) -->\n        </div>\n\n      </div>\n    </div>\n  </md-content>\n\n  <div class=\"actions-bar\">\n    <md-button type=\"button\" ui-sref=\"auth\" class=\"md-raised md-sample\">Annuler</md-button>\n    <md-button type=\"submit\" class=\"md-raised md-primary\" ng-click=\"ctrl.confirmAbonnement()\" ng-disabled=\"!acceptCGV\">Je m\'abonne</md-button>\n  </div>\n\n</div>");
$templateCache.put("app/selectionCheptel/assistance/assistance.html","<div flex layout=\"column\" class=\"selection-cheptel-assistance\">\n  <div class=\"title-bar\" layout=\"row\">\n    <h2>Sélectionnez un cheptel</h2>\n  </div>\n\n  <div layout=\"column\" layout-align=\"start center\" layout-padding class=\"selection-departement\">\n    <md-input-container>\n      <label>Département</label>\n      <md-select ng-model=\"ctrl.selectedDepartement\" required>\n        <md-option ng-repeat=\"departement in ctrl.departements | orderBy: \'code\'\" value=\"{{departement.code}}\">\n          {{departement.code}} - {{departement.libelle}}\n        </md-option>\n      </md-select>\n    </md-input-container>\n  </div>\n\n  <md-content flex>\n    <div ng-if=\"ctrl.showCheptels\">\n      <div class=\"header-container\">\n        <adv-toolbar class=\"title-toolbar details-abo\" layout=\"row\">\n          <div flex layout=\"row\" layout-align=\"center\">\n            <div flex layout=\"row\" layout-align=\"start center\">\n              <h2>Sélectionnez un cheptel</h2>\n            </div>\n            <div flex layout=\"row\" layout-align=\"end center\">\n              <adv-input-search class=\"input-search\" ng-model=\"ctrl.filter\"></adv-input-search>\n            </div>\n          </div>\n        </adv-toolbar>\n        <adv-list-item adv-header class=\"data-list-header\">\n          <div flex=\"50\" class=\"column\">\n            <span>N° Exploitation</span>\n          </div>\n          <div flex=\"50\" class=\"column\">\n            <span>Raison Sociale</span>\n          </div>\n        </adv-list-item>\n      </div>\n    \n      <adv-list-item ng-if=\"ctrl.cheptelsFiltre.length === 0\" class=\"empty-list\">\n        Aucun cheptel ne correspond à votre filtre\n      </adv-list-item>\n    \n      <adv-list class=\"data-list-body stripped\">\n        <adv-list-item ng-repeat=\"exploitation in ctrl.cheptelsFiltre | orderBy: \'numExploitation\'\" ng-click=\"ctrl.selectionCheptel(exploitation)\">\n          <div flex=\"50\">\n            {{exploitation.numExploitation}}\n          </div>\n          <div flex=\"50\">\n            {{exploitation.raisonSociale}}\n          </div>\n        </adv-list-item>\n      </adv-list>\n    </div>\n  </md-content>\n</div>");
$templateCache.put("app/selectionCheptel/main/main.html","<div flex layout=\"column\">\n  <md-toolbar class=\"header-bar\">\n    <div class=\"md-toolbar-tools\">\n      <div flex layout=\"row\" layout-align=\"start center\">\n        <img src=\"assets/images/logo-plat.png\" class=\"logo\">\n\n        <h2 ng-if=\"ctrl.isAssistance\">Assistance</h2>\n        <h2 ng-if=\"!ctrl.isAssistance\">Technicien</h2>\n      </div>\n\n      <div flex></div>\n\n      <md-menu-bar>\n        <md-menu>\n          <div ng-click=\"$mdMenu.open()\" class=\"menu-item account\">\n            <span>\n              <adv-profil key=\"\'login\'\"></adv-profil>\n            </span>\n            <md-icon md-svg-src=\"assets/images/icones/account_circle.svg\" aria-label=\"account_circle\"></md-icon>\n          </div>\n\n          <md-menu-content class=\"header-menu\">\n            <md-menu-item ng-if=\"ctrl.isMultiProfil()\" class=\"md-indent\">\n              <md-icon md-svg-src=\"assets/images/icones/autorenew.svg\" aria-label=\"autorenew\"></md-icon>\n              <md-button ng-click=\"ctrl.goToSelectionProfil()\">\n                Changer de profil\n              </md-button>\n            </md-menu-item>\n            <md-menu-divider ng-if=\"ctrl.isMultiProfil()\"></md-menu-divider>\n            <md-menu-item class=\"md-indent\">\n              <md-icon md-svg-src=\"assets/images/icones/exit_to_app.svg\" aria-label=\"exit_to_app\"></md-icon>\n              <md-button ng-click=\"ctrl.logout()\">\n                Se déconnecter\n              </md-button>\n            </md-menu-item>\n          </md-menu-content>\n        </md-menu>\n      </md-menu-bar>\n    </div>\n  </md-toolbar>\n\n  <ui-view flex layout=\"column\"></ui-view>\n\n  <div layout=\"row\" layout-align=\"space-between end\" class=\"footer-main\">\n    <div></div>\n    <div>\n      <p class=\"version\">{{ctrl.version}}</p>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/selectionCheptel/technicien/technicien.html","<md-content class=\"selection-cheptel-technicien\">\n  <div flex layout=\"column\">\n    <div class=\"header-container\">\n      <adv-toolbar class=\"title-toolbar details-abo\" layout=\"row\">\n        <div flex layout=\"row\" layout-align=\"center\">\n          <div flex layout=\"row\" layout-align=\"start center\">\n            <h2>Sélectionnez un cheptel</h2>\n          </div>\n          <div flex layout=\"row\" layout-align=\"end center\">\n            <adv-input-search class=\"input-search\" ng-model=\"ctrl.filter\"></adv-input-search>\n          </div>\n        </div>\n      </adv-toolbar>\n      <adv-list-item adv-header class=\"data-list-header\">\n        <div flex=\"50\" class=\"column\">\n          <span>N° Exploitation</span>\n        </div>\n        <div flex=\"50\" class=\"column\">\n          <span>Raison Sociale</span>\n        </div>\n      </adv-list-item>\n    </div>\n\n    <adv-list-item ng-if=\"ctrl.noCheptel\" class=\"empty-list\">\n      Aucun cheptel n\'est associé à votre compte technicien. Vous ne pouvez pas poursuivre votre navigation.\n    </adv-list-item>\n    <adv-list-item ng-if=\"ctrl.cheptelsFiltre.length === 0 && !ctrl.noCheptel\" class=\"empty-list\">\n      Aucun cheptel ne correspond à votre filtre\n    </adv-list-item>\n\n    <adv-list class=\"data-list-body stripped\">\n      <adv-list-item ng-repeat=\"exploitation in ctrl.cheptelsFiltre | orderBy: \'numExploitation\'\" ng-click=\"ctrl.selectionCheptel(exploitation)\">\n        <div flex=\"50\">\n          {{exploitation.numExploitation}}\n        </div>\n        <div flex=\"50\">\n          {{exploitation.raisonSociale}}\n        </div>\n      </adv-list-item>\n    </adv-list>\n  </div>\n</md-content>");
$templateCache.put("app/_common/directives/breadcrumbs/breadcrumbs.html","<div class=\"breadcrumbs\">\n  <div ng-click=\"ctrl.goToStep(step)\" ng-repeat=\"step in ctrl.steps track by $index\" class=\"step\" ng-class=\"{selected: ctrl.isStepActive(step), disabled: (!$first && ctrl.isStepDisabled(step)) }\">\n    <div class=\"position\">{{$index+1}}</div>\n    <div class=\"label\">{{step.libelle}}</div>\n  </div>\n</div>\n");
$templateCache.put("app/_common/directives/souffleur/souffleur.html","<div class=\"souffleur\">\n  <ng-transclude></ng-transclude>\n  <md-icon ng-click=\"ctrl.clear()\">clear</md-icon>\n</div>\n");
$templateCache.put("app/_common/partials/autorisationsAcces/autorisationsAcces.html","<div ng-if=\"ctrl.state.name===\'app.admin.gestionAssocies\'\" class=\"title-bar\" layout=\"row\">\n  <h2>Gestion des autorisations d\'accès</h2>\n</div>\n<div ng-if=\"ctrl.state.name===\'app.admin.gestionAssocies\' \" class=\"autorisations-acces-admin\">\n  <form name=\"ctrl.searchForm\" ng-submit=\"ctrl.validerRecherche()\" novalidate flex layout=\"column\">\n    <div class=\"selection-form\" layout-gt-md=\"row\" layout-align=\"center center\">\n      <h4 class=\"codePays\">FR</h4>\n      <md-input-container class=\"searchInputContainer\">\n        <label>N° Exploitation</label>\n        <input name=\"numExploitation\" ng-model=\"ctrl.numExploitation\" ng-required=\"!ctrl.identifiant\">\n      </md-input-container>\n      <div class=\"choixInfo\">\n        ou\n      </div>\n      <md-input-container class=\"searchInputContainer\">\n        <label>Email</label>\n        <input name=\"identifiant\" ng-model=\"ctrl.identifiant\" ng-required=\"!ctrl.numExploitation\" type=\"email\" ng-pattern=\"/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$/\">\n      </md-input-container>\n      <md-button type=\"submit\" class=\"md-raised md-primary btn-valider\" ng-disabled=\"ctrl.searchForm.$invalid\">\n        Valider</md-button>\n    </div>\n  </form>\n</div>\n<div class=\"compte-autorisations-acces\">\n  <div id=\"div-form\"></div>\n  <div ng-if=\"ctrl.state.name!==\'app.admin.gestionAssocies\'\">\n    <p>La saisie des coordonnées de chaque responsable/associé ou tiers (exemple : salarié) autorisé à accéder au compte\n      Pilot’Elevage\n      de l’exploitation est essentielle pour une authentification personnelle sécurisée.</p>\n    <p>Veuillez ajouter ci dessous les informations de sécurité obligatoires pour chaque personne autorisée à utiliser\n      l\'abonnement Pilot\'Elevage de l\'exploitation\n      <span ng-if=\"ctrl.state.name ===\'abonnement.autorisations\'\">(vous pourrez modifier cette liste une fois votre\n        abonnement créé, depuis l\'espace \"Mon compte\") :</span>\n    </p>\n    <p class=\"juridique\">Pilot’Elevage collecte les données personnelles ci dessous afin d’ouvrir les accès personnels sécurisés et d’envoyer le lien de téléchargement de l’application mobile. Pour plus d’informations, consultez la politique de confidentialité de Pilot’Elevage.</p>\n  </div>\n\n  <form name=\"ctrl.associeForm\" novalidate class=\"form\">\n    <div class=\"div-form\" layout-gt-sm=\"row\">\n      <md-input-container ng-if=\"ctrl.state.name===\'app.admin.gestionAssocies\'\" layout=\"column\">\n        <div layout=\"row\">\n          <label>Exploitation : </label>\n          <input ng-class=\"ctrl.state.name===\'app.admin.gestionAssocies\'?\'admin-width-100\':\'min-width\'\" required name=\"numExploitation\" ng-model=\"ctrl.personne.numExploitation\" ng-disabled=\'ctrl.recherchePar===\"NUMEXPLOIT\"\'>\n        </div>\n        <div ng-messages=\"ctrl.associeForm.numExploitation.$error\" role=\"alert\" ng-show=\"ctrl.associeForm.numExploitation.$touched\">\n          <div ng-message=\"required\">Donnée obligatoire</div>\n        </div>\n      </md-input-container>\n      <md-input-container layout=\"column\">\n        <div layout=\"row\">\n          <label ng-if=\"ctrl.state.name!==\'app.admin.gestionAssocies\'\">Nom de famille : </label>\n          <label ng-if=\"ctrl.state.name==\'app.admin.gestionAssocies\'\">Nom : </label>\n          <input class=\"min-width\" aria-label=\"nom\" required name=\"nom\" ng-model=\"ctrl.personne.nom\" focus-me=\"ctrl.state.name !== \'app.admin.gestionAssocies\'\" ng-disabled=\"ctrl.isTechnicien\" ng-change=\"ctrl.personne.nom = (ctrl.personne.nom | uppercase)\">\n        </div>\n        <div ng-messages=\"ctrl.associeForm.nom.$error\" role=\"alert\" ng-show=\"ctrl.associeForm.nom.$touched\">\n          <div ng-message=\"required\">Donnée obligatoire</div>\n        </div>\n      </md-input-container>\n      <md-input-container layout=\"column\">\n        <div layout=\"row\">\n          <label>Prénom : </label>\n          <input class=\"min-width\" required name=\"prenom\" ng-model=\"ctrl.personne.prenom\" ng-disabled=\"ctrl.isTechnicien\" ng-change=\"ctrl.personne.prenom = (ctrl.personne.prenom | uppercase)\">\n        </div>\n        <div ng-messages=\"ctrl.associeForm.prenom.$error\" role=\"alert\" ng-show=\"ctrl.associeForm.prenom.$touched\">\n          <div ng-message=\"required\">Donnée obligatoire</div>\n        </div>\n      </md-input-container>\n      <md-input-container layout=\"column\">\n        <div layout=\"row\">\n          <label>Email : </label>\n          <input class=\"min-width\" required name=\"email\" ng-model=\"ctrl.personne.email\" ng-model-options=\"{ allowInvalid: true }\" ng-pattern=\"/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$/\" type=\"email\" ng-disabled=\'ctrl.recherchePar===\"IDENTIFIANT\" || ctrl.isTechnicien\' ng-change=\"ctrl.personne.email = (ctrl.personne.email | lowercase)\">\n        </div>\n        <div ng-messages=\"ctrl.associeForm.email.$error\" role=\"alert\" ng-show=\"ctrl.associeForm.email.$touched\">\n          <div ng-message=\"required\">Donnée obligatoire</div>\n          <div ng-message=\"pattern\">Donnée invalide</div>\n        </div>\n      </md-input-container>\n      <md-input-container layout=\"column\" ng-if=\"ctrl.afficherConfirmationEmail()\">\n        <div layout=\"row\">\n          <label>Confirmation email : </label>\n          <input class=\"min-width\" required name=\"confirmationEmail\" ng-model=\"ctrl.personne.confirmationEmail\" ng-model-options=\"{ allowInvalid: true }\" type=\"email\" ng-pattern=\"/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$/\" match=\"ctrl.personne.email\" onpaste=\"return false\" ondrop=\"return false\" ng-change=\"ctrl.personne.confirmationEmail = (ctrl.personne.confirmationEmail | lowercase)\">\n        </div>\n        <div ng-messages=\"ctrl.associeForm.confirmationEmail.$error\" role=\"alert\" ng-show=\"ctrl.associeForm.confirmationEmail.$touched\">\n          <div ng-message=\"required\">Donnée obligatoire</div>\n          <div ng-message=\"pattern\">Donnée invalide</div>\n          <div ng-message=\"mismatch\">Vos adresses mails ne sont pas identiques, veuillez les rectifier</div>\n\n        </div>\n      </md-input-container>\n      <md-input-container layout=\"column\">\n        <div layout=\"row\">\n          <label>Tel mobile : </label>\n          <input ng-class=\"ctrl.state.name===\'app.admin.gestionAssocies\'?\'admin-width-100\':\'min-width\'\" name=\"telMobile\" ng-model=\"ctrl.personne.telMobile\" type=\"text\" ng-pattern=\"/^(06|07) [0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}$/\" ui-mask=\"?9?9 ?9?9 ?9?9 ?9?9 ?9?9\" ng-disabled=\"ctrl.isTechnicien\" ui-mask-placeholder=\"\" ui-mask-placeholder-char=\"space\">\n        </div>\n        <div ng-messages=\"ctrl.associeForm.telMobile.$error\" role=\"alert\" ng-show=\"ctrl.associeForm.telMobile.$touched\">\n          <div ng-message=\"pattern\">Le N° de téléphone portable doit commencer par 06 ou 07.</div>\n        </div>\n      </md-input-container>\n      <md-input-container layout=\"column\">\n        <div layout=\"row\">\n          <label>Type tel : </label>\n          <md-select ng-model=\"ctrl.personne.typeTelMobile\" ng-required=\"ctrl.personne.telMobile\" ng-disabled=\"!ctrl.personne.telMobile || ctrl.isTechnicien\" ng-class=\"ctrl.state.name===\'app.admin.gestionAssocies\'?\'admin-width-100\':\'min-width\'\">\n            <md-option ng-repeat=\"typeTelMobile in ctrl.typesTel\" value=\"{{typeTelMobile}}\">\n              {{typeTelMobile}}\n            </md-option>\n          </md-select>\n        </div>\n        <div ng-messages=\"ctrl.associeForm.typeTelMobile.$error\" role=\"alert\" ng-show=\"ctrl.associeForm.typeTelMobile.$touched\">\n          <div ng-message=\"required\">Donnée obligatoire</div>\n        </div>\n      </md-input-container>\n      <md-input-container layout=\"column\">\n        <div layout=\"row\">\n          <label>Profil : </label>\n          <md-select ng-model=\"ctrl.personne.profil\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-disabled=\"ctrl.isTechnicien\" ng-change=\"ctrl.changeProfile()\" required ng-class=\"ctrl.state.name===\'app.admin.gestionAssocies\'?\'admin-width-175\':\'min-width\'\">\n            <md-option ng-repeat=\"profil in ctrl.profils\" ng-value=\"profil\">\n              {{profil.libelle}}\n            </md-option>\n          </md-select>\n        </div>\n        <div ng-messages=\"ctrl.associeForm.profil.$error\" role=\"alert\" ng-show=\"ctrl.associeForm.profil.$touched\">\n          <div ng-message=\"required\">Donnée obligatoire</div>\n        </div>\n      </md-input-container>\n      <md-input-container layout=\"column\">\n        <div layout=\"row\">\n          <label>Droit : </label>\n          <md-select ng-model=\"ctrl.personne.niveauDroit\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-class=\"ctrl.state.name===\'app.admin.gestionAssocies\'?\'admin-width-135\':\'min-width\'\" required ng-disabled=\"ctrl.isProfilResponsableAssocie\">\n            <!-- <md-option value=\"\"></md-option> -->\n            <md-option ng-repeat=\"niveauDroit in ctrl.droits\" ng-value=\"niveauDroit\" id=\"{{niveauDroit.id}}\" ng-disabled=\"{{ niveauDroit.id ==\'2\' }}\">\n              {{niveauDroit.libelle}}\n            </md-option>\n          </md-select>\n        </div>\n        <div ng-messages=\"ctrl.associeForm.niveauDroit.$error\" role=\"alert\" ng-show=\"ctrl.associeForm.niveauDroit.$touched\">\n          <div ng-message=\"required\">Donnée obligatoire</div>\n        </div>\n      </md-input-container>\n\n      <md-button type=\"submit\" class=\"md-raised md-primary margin-bottom\" ng-if=\"ctrl.modeCreation\" ng-click=\"ctrl.ajouterAutorisationAcces()\" ng-disabled=\"ctrl.associeForm.$invalid || ctrl.isTechnicien\">Ajouter</md-button>\n      <md-button type=\"submit\" class=\"md-raised md-sample margin-bottom\" ng-show=\"!ctrl.modeCreation\" ng-disabled=\"ctrl.associeForm.$invalid\" ng-click=\"ctrl.modifierPersonne()\">Modifier</md-button>\n      <md-button type=\"button\" class=\"md-raised md-sample margin-bottom\" ng-show=\"!ctrl.modeCreation\" ng-click=\"ctrl.annulerModification()\">Annuler</md-button>\n    </div>\n  </form>\n  <u>Liste des Responsables/Associés ou Tiers autorisés pour votre abonnement:</u>\n  <div class=\"notification-border\">\n    <table class=\"table\">\n      <thead>\n        <tr>\n          <th ng-if=\"ctrl.state.name===\'app.admin.gestionAssocies\'\">Exploitation*</th>\n          <th>Nom*</th>\n          <th>Prenom*</th>\n          <th>Email*</th>\n          <th>Tel Mobile</th>\n          <th>Type Tel*</th>\n          <th>Profil*</th>\n          <th>Droit*</th>\n          <th>Modifier</th>\n          <th>Supprimer</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-show=\"ctrl.listAssocies.length === 0\">\n          <td colspan=\"100%\" style=\"text-align: center\">Aucune donnée disponible</td>\n        </tr>\n        <tr ng-repeat=\"associe in ctrl.listAssocies\" ng-class=\"$odd ? \'odd\' : \'even\'\" ng-show=\"ctrl.listAssocies.length > 0\">\n          <td ng-if=\"ctrl.state.name===\'app.admin.gestionAssocies\'\" data-label=\"Exploitation\">\n            {{associe.numExploitation}}\n          </td>\n          <td data-label=\"Nom\">{{ associe.nom }}</td>\n          <td data-label=\"Prenom\">{{ associe.prenom }}</td>\n          <td data-label=\"Email\">{{ associe.email }}</td>\n          <td data-label=\"Tel Mobile\">{{ associe.telMobile }}</td>\n          <td data-label=\"Type Tel\">{{ associe.typeTelMobile }}</td>\n          <td data-label=\"Profil\">{{ associe.profil.libelle }}</td>\n          <td data-label=\"Droit\">{{ associe.niveauDroit.libelle }}</td>\n          <td data-label=\"Modifier\">\n            <md-button ng-click=\"ctrl.editerPersonne(associe, $index)\" aria-label=\"Modifier\" ng-disabled=\"ctrl.isTechnicien\">\n              <md-tooltip>Modifier</md-tooltip>\n              <md-icon class=\"editButton\" md-svg-src=\"assets/images/icones/ic_edit.svg\"></md-icon>\n            </md-button>\n          </td>\n          <td data-label=\"Supprimer\">\n            <md-button ng-click=\"$event.stopPropagation(); ctrl.supprimerPersonne(associe, $index)\" aria-label=\"Supprimer\" ng-disabled=\"ctrl.isTechnicien\">\n              <md-tooltip>Supprimer</md-tooltip>\n              <md-icon md-svg-src=\"assets/images/icones/ic_delete.svg\"></md-icon>\n            </md-button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n<div class=\"actions-bar\" ng-if=\"ctrl.state.name !==\'abonnement.autorisations\' && ctrl.state.name!==\'app.admin.gestionAssocies\'\">\n  <md-button class=\"md-raised md-primary\" ng-disabled=\"ctrl.disableEnregistrer || ctrl.isTechnicien\" ng-click=\"ctrl.enregistrerModifications()\">Enregistrer les modifications</md-button>\n</div>\n\n<div class=\"actions-bar\" ng-if=\"ctrl.state.name ===\'app.admin.gestionAssocies\'\">\n  <md-button class=\"md-raised md-primary\" ng-click=\"ctrl.enregistrerModificationsAdmin()\" ng-disabled=\"ctrl.listAssocies.length===0\">Enregistrer les\n    modifications\n  </md-button>\n</div>\n<div class=\"actions-bar\" ng-if=\"ctrl.state.name ===\'abonnement.autorisations\'\">\n  <md-button type=\"button\" ui-sref=\"auth\" class=\"md-raised md-sample\">Annuler</md-button>\n  <md-button ng-click=\"ctrl.goToAbonnementService()\" class=\"md-raised md-primary\">Je m\'abonne</md-button>\n</div>");
$templateCache.put("app/_common/partials/facturation/facturation.html","<div flex layout=\"column\" class=\"facturation\">\n\n  <!-- alignement de l\'ensemble des rubriques -->\n  <md-content flex>\n    <div style=\"display: flex; justify-content: center\" ng-if=\"ctrl.state.name === \'abonnement.facturation\'\">\n      <h3 class=\"colorh3\">{{ctrl.raisonSociale}} - FR {{ctrl.numeroExploitation}}</h3>\n    </div>\n\n    <form name=\"ctrl.contactForm\" novalidate flex layout=\"column\">\n      <!-- Accès portail facturation (éleveur/Mon Compte uniquement) -->\n      <div layout=\"row\" layout-align=\"center\" class=\"service\" ng-if=\"ctrl.state.name === \'app.eleveur.compte.compte\'\">\n        <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\">\n          <div layout=\"column\" class=\"notification-border div-option\"> <!-- liseret -->\n\n            <div layout=\"row\">\n              <h2 class=\"h2-custom\">Accéder au portail facturation</h2>\n            </div>\n\n            <div layout=\"row\">\n\n              <div layout=\"column\">\n                <label class=\"label-default\"><b>Accessible seulement pour le Reponsable/associé facturation de votre\n                    exploitation:</b></label>\n                <label class=\"label-default\">(modifiable dans l\'onglet \'Autorisation d\'accès\')</label>\n              </div>\n\n              <div ng-if=\"ctrl.state.name === \'app.eleveur.compte.compte\'\" layout=\"column\" class=\"notification-button-row\">\n                <md-button ng-click=\"ctrl.goToGestionFactures()\" class=\"md-raised md-primary btn-change-mdp md-button md-ink-ripple\" ng-disabled=\"ctrl.isTechnicien\">\n                  Gérer mes factures en ligne\n                </md-button>\n              </div>\n\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- Modalité de réglement - uniquement à la souscription -->\n      <div layout=\"row\" layout-align=\"center\" class=\"service\" ng-if=\"ctrl.state.name === \'abonnement.facturation\'\">\n        <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\">\n          <div layout=\"column\" class=\"notification-border div-option\"> <!-- liseret -->\n            <h2 class=\"h2-custom\">Modalité de règlement : Mandat de prélévement automatique SEPA</h2>\n            <label class=\"label-default\">Le règlement de l\'abonnement est  à effectuer obligatoirement par prélèvement automatique. Vous bénéficiez ainsi d\'une <b>réduction de {{ctrl.tarifPrelevementAuto}} euros HT/an</b> sur votre abonnement</label>\n            <label class=\"label-default\" style=\"font-size: 11px\">(proratisé au nombre de mois d\'abonnement).</label>\n            <md-input-container>\n              <label>IBAN</label>\n              <input name=\"iban\" ng-model=\"ctrl.iban\" iban-validator type=\"text\" autocomplete=\"off\" ng-required=\"!ctrl.pdfPrelevementDownloaded\" ng-change=\"ctrl.onIbanChange()\">\n              <div ng-messages=\"ctrl.contactForm.iban.$error\" role=\"alert\">\n                <div ng-message=\"ibanValid\">Le format de l\'IBAN est incorrect</div>\n                <div ng-message=\"required\">Donnée obligatoire</div>\n              </div>\n            </md-input-container>\n            <div flex layout=\"row\" class=\"div-iban\">\n              <div>\n                <md-input-container>\n                  <label>Téléphone mobile</label>\n                  <input name=\"prelevementMobile\" ng-model=\"ctrl.prelevementMobile\" type=\"text\" ng-pattern=\"/^(06|07)[0-9]{2}[0-9]{2}[0-9]{2}[0-9]{2}$/\" autocomplete=\"off\" ng-required=\"!ctrl.pdfPrelevementDownloaded\" ng-minlength=\"10\" ng-maxlength=\"10\" style=\"width: 150px\">\n                  <div ng-messages=\"ctrl.contactForm.prelevementMobile.$error\" role=\"alert\">\n                    <div ng-message=\"minlength\">Le format du téléphone est incorrect.</div>\n                    <div ng-message=\"maxlength\">Le format du téléphone est incorrect.</div>\n                    <div ng-message=\"pattern\">Le N° de téléphone portable doit commencer par 06 ou 07</div>\n                    <div ng-message=\"required\">Donnée obligatoire</div>\n                  </div>\n                </md-input-container>\n                <md-button class=\"md-raised md-primary\" type=\"button\" ng-click=\"ctrl.sendSms()\" ng-disabled=\"!ctrl.iban || ctrl.contactForm.iban.$invalid || ctrl.contactForm.prelevementMobile.$invalid\">Envoi de SMS</md-button>    \n              </div>\n              <md-input-container>\n                <label>Code de vérification</label>\n                <input name=\"codeVerification\" ng-model=\"ctrl.codeVerification\" aria-label=\"Code de vérification\" type=\"text\" autocomplete=\"off\" ng-disabled=\"!ctrl.iban || !ctrl.prelevementMobile || ctrl.contactForm.prelevementMobile.$invalid || ctrl.contactForm.iban.$invalid || !ctrl.codeVerificationEnabled\" ng-pattern=\"/^\\d{6}$/\" maxlength=\"6\" ng-required=\"!ctrl.pdfPrelevementDownloaded\">\n                <div ng-messages=\"ctrl.contactForm.codeVerification.$error\" role=\"alert\">\n                  <div ng-message=\"pattern\">Le code doit contenir exactement 6 chiffres</div>\n                  <div ng-message=\"required\">Donnée obligatoire</div>\n                </div>\n              </md-input-container>\n\n              <div ng-if=\"ctrl.afficherPasCodeRecuButton\" style=\"align-content: center\">\n                <md-button class=\"pas-code-recu-button md-raised\" type=\"button\" ng-click=\"ctrl.pasCodeRecuOnClick()\">\n                  Problème d’enregistrement du mandat\n                </md-button>    \n              </div>\n\n            </div>\n\n            <label class=\"label-default\">En renseignant ce mandat, vous autorisez la SAS Pilot\'Elevage à envoyer des instructions à votre banque pour débiter votre compte conformément aux instructions de la SAS Pilot’Elevage. Dans le cadre de vos droits, vous avez droit à un remboursement par votre banque selon les conditions générales de votre contrat banque. Vos droits sont expliqués dans une déclaration que vous pouvez obtenir auprès de votre banque. Le remboursement doit être demandé dans un délai de 8 semaines à compter de la date à laquelle votre compte a été débité. \n            </label>\n          </div>\n        </div>\n      </div>\n\n      <!-- Option réception facture papier (éleveur/Mon Compte uniquement) -->\n      <div layout=\"row\" layout-align=\"center\" class=\"service\" ng-if=\"ctrl.state.name === \'app.eleveur.compte.compte\' || ctrl.state.name === \'abonnement.facturation\'\">\n        <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\">\n          <div layout=\"column\" class=\"notification-border div-option\"> <!-- liseret -->\n\n            <div layout=\"row\">\n              <h2 class=\"h2-custom\">Recevoir ma facture Bovin Pilot’Elevage par voie postale</h2>\n            </div>\n\n            <div layout=\"row\">\n              <div layout=\"column\">\n                <label class=\"label-default\"><b>Souhaitez-vous activer le service \'Recevoir ma facture Bovin par voie postale\' pour {{ ctrl.tarifOptionFacturePapier }}€ HT/{{ ctrl.periodiciteOptionFacturePapier }} ?</b></label>\n                <label class=\"label-default\">(engagement à l\'année civile, renouvellement par tacite reconduction)</label>\n              </div>\n              <div layout=\"column\" layout-align=\"center\">\n                <md-button class=\"md-icon-button\" ng-click=\"ctrl.showDescriptionFacturePapier()\">\n                  <md-icon md-svg-src=\"assets/images/help.svg\" aria-label=\"help\" class=\"md-icon-help\">\n                  </md-icon>\n                </md-button>\n              </div>\n              <!-- gestion espacement -->\n              <div flex layout=\"column\"></div>\n              <div layout=\"column\" layout-align=\"center\">\n                <div layout=\"row\" class=\"notification-button-row\">\n                  <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-disabled=\"ctrl.isTechnicien\" ng-click=\"ctrl.activerOptionFacturePapier(option, true)\" ng-class=\"ctrl.hasOptionFacturePapier === true ? \'md-primary\' : \'md-sample\'\">\n                    Oui\n                  </md-button>\n                  <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-disabled=\"ctrl.isTechnicien\" ng-click=\"ctrl.annulerOptionFacturePapier(option)\" ng-class=\"ctrl.hasOptionFacturePapier === false ? \'md-primary\' : \'md-sample\'\">\n                    Non\n                  </md-button>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- Adresse postale -->\n      <div layout=\"row\" layout-align=\"center\" class=\"service\" ng-if=\"ctrl.state.name === \'app.eleveur.compte.compte\'\">\n        <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\">\n\n          <div layout=\"column\" class=\"notification-border div-option\"> <!-- liseret -->\n\n            <div layout=\"row\">\n              <div layout=\"column\">\n                <h2 class=\"h2-custom\">Adresse postale figurant sur la facture</h2>\n                <label class=\"label-default\" ng-if=\"ctrl.state.name !== \'app.admin.gestionAbonnement.detail\'\">(modifiable par l\'assistance via une demande mail)</label>\n              </div>\n\n              <div layout=\"column\" ng-if=\"ctrl.state.name !== \'app.admin.gestionAbonnement.detail\'\" class=\"notification-button-row\">\n                <div class=\"label-default\">\n                  <p>{{ctrl.detenteur.adresse.adress}}</p>\n                  <p>{{ctrl.detenteur.adresse.complementAdresse}}</p>\n                  <p>{{ctrl.detenteur.adresse.codePostal}} {{ctrl.detenteur.adresse.ville}}</p>\n                  <p></p>\n                </div>\n              </div> <!-- column adresse -->\n\n              <!-- affichage ADMIN-->\n              <div layout=\"column\" layout-align=\"center\" class=\"div-adresse\" ng-if=\"ctrl.state.name === \'app.admin.gestionAbonnement.detail\'\" flex>\n                <md-input-container class=\"adresse\">\n                  <label class=\"md-required\"> Adresse postale :</label>\n                  <input name=\"adresse\" aria-label=\"adresse\" ng-model=\"ctrl.detenteur.adresse.adress\" type=\"text\" autocomplete=\"off\">\n                </md-input-container>\n                <md-input-container class=\"adresse\">\n                  <input name=\"complementAdresse\" aria-label=\"complementAdresse\" ng-model=\"ctrl.detenteur.adresse.complementAdresse\" type=\"text\" autocomplete=\"off\">\n                </md-input-container>\n                <div layout=\"row\" class=\"footer-margin\">\n                  <md-input-container class=\"adresse\">\n                    <input id=\"codePostal\" name=\"codePostal\" aria-label=\"codePostal\" ng-model=\"ctrl.detenteur.adresse.codePostal\" type=\"text\" required ng-pattern=\"/^(\\d{5}(-\\d{4})?|[A-Z]\\d[A-Z] *\\d[A-Z]\\d)$/\" autocomplete=\"off\">\n                    <div ng-messages=\"ctrl.contactForm.codePostal.$error\" role=\"alert\">\n                      <div ng-message=\"required\">Donnée obligatoire</div>\n                      <div ng-message=\"pattern\">Donnée invalide</div>\n                    </div>\n                  </md-input-container>\n                  <md-input-container class=\"adresse\">\n                    <input id=\"ville\" name=\"ville\" aria-label=\"ville\" ng-model=\"ctrl.detenteur.adresse.ville\" type=\"text\" required>\n                    <div ng-messages=\"ctrl.contactForm.ville.$error\" role=\"alert\" autocomplete=\"off\">\n                      <div ng-message=\"required\">Donnée obligatoire</div>\n                    </div>\n                  </md-input-container>\n                </div>\n              </div>\n\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- Réception complémentaire de la facture -->\n      <div layout=\"row\" layout-align=\"center\" class=\"service\">\n        <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\">\n\n          <div layout=\"column\" class=\"notification-border div-option\"> <!-- liseret -->\n            <h2 class=\"h2-custom\">Réception complémentaire de la facture</h2>\n            <label class=\"label-default\">(peut être différent du mail du responsable/associé facturation, permet d\'envoyer\n              la facture à une autre\n              personne: comptable, associé...)</label>\n\n            <div flex layout=\"row\">\n              <md-input-container flex>\n                <label>Indiquez l’email</label>\n                <input name=\"email\" ng-disabled=\"ctrl.isTechnicien\" aria-label=\"email\" ng-model=\"ctrl.contact.email\" type=\"email\" autocomplete=\"off\" ng-pattern=\"/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$/\" ng-model-options=\"{ allowInvalid: true }\">\n                <div ng-messages=\"ctrl.contactForm.email.$error\" role=\"alert\">\n                  <div ng-message=\"pattern\">Donnée invalide</div>\n                </div>\n              </md-input-container>\n\n              <md-input-container flex>\n                <label>Indiquez le n° téléphone</label>\n                <input name=\"telMobile\" ng-disabled=\"ctrl.isTechnicien\" ng-model=\"ctrl.contact.telMobile\" type=\"text\" ng-pattern=\"/^(06|07) [0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}$/\" ui-mask=\"?9?9 ?9?9 ?9?9 ?9?9 ?9?9\" ui-mask-placeholder=\"\" ui-mask-placeholder-char=\"space\" autocomplete=\"off\">\n                <div ng-messages=\"ctrl.contactForm.telMobile.$error\" role=\"alert\">\n                  <div ng-message=\"pattern\">Le N° de téléphone portable doit commencer par 06 ou 07.</div>\n                </div>\n              </md-input-container>\n            </div>\n\n            <div flex layout=\"row\">\n              <md-input-container flex>\n                <label>Indiquez le nom</label>\n                <input name=\"nom\" ng-disabled=\"ctrl.isTechnicien\" aria-label=\"nom\" ng-model=\"ctrl.contact.nom\" type=\"text\" autocomplete=\"off\">\n              </md-input-container>\n              <md-input-container flex>\n                <label>Indiquez le prénom</label>\n                <input name=\"prenom\" ng-disabled=\"ctrl.isTechnicien\" aria-label=\"prenom\" ng-model=\"ctrl.contact.prenom\" type=\"text\" autocomplete=\"off\">\n              </md-input-container>\n\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"texte-juridique texte\" ng-if=\"ctrl.state.name !== \'app.admin.gestionAbonnement.detail\'\">\n        <p>Pilot’Elevage collecte ces données personnelles afin de pouvoir gérer la facturation et le recouvrement des\n          services souscrits. Pour plus d’informations, consultez la politique de confidentialité de Pilot’Elevage.</p>\n      </div>\n\n    </form>\n\n  </md-content>\n</div>\n\n<!-- Eleveur > Mon Compte -->\n<div class=\"actions-bar\" ng-if=\"ctrl.state.name === \'app.eleveur.compte.compte\'\">\n  <md-button type=\"button\" ng-click=\"ctrl.annuler()\" class=\"md-raised md-sample\">Annuler</md-button>\n  <md-button class=\"md-raised md-primary\" ng-disabled=\"ctrl.contactForm.$invalid || ctrl.isTechnicien\" ng-click=\"ctrl.enregistrerModifications(false)\">Modifier</md-button>\n</div>\n\n<!-- Admin > Gestion abonnement > Détail -->\n<div class=\"actions-bar\" ng-if=\"ctrl.state.name === \'app.admin.gestionAbonnement.detail\'\">\n  <md-button type=\"button\" ui-sref=\"app.admin.gestionAbonnement.selection\" class=\"md-raised md-primary\">Retour</md-button>\n  <md-button class=\"md-raised md-primary\" ng-click=\"ctrl.enregistrerModifications(true)\" ng-disabled=\"ctrl.contactForm.$invalid\">Modifier</md-button>\n</div>\n\n<!-- Abonnement > Facturation -->\n<div class=\"actions-bar\" ng-if=\"ctrl.state.name === \'abonnement.facturation\'\">\n  <md-button type=\"button\" ui-sref=\"auth\" class=\"md-raised md-sample\">Annuler</md-button>\n  <md-button ng-click=\"ctrl.goToValidation()\" class=\"md-raised md-primary\" ng-disabled=\"ctrl.contactForm.$invalid && !ctrl.pdfPrelevementDownloaded\">\n    Je m\'abonne\n  </md-button>\n</div>");
$templateCache.put("app/_common/partials/mentionsLegales/mentionsLegales.html","<div flex layout=\"column\">\n    <div class=\"title-bar\">\n      <h2>Mentions légales</h2>\n    </div>\n    <md-content flex>\n      <div class=\"mentionsLegales\">\n        <p class=\"title\">Mentions légales</p>\n        <p class=\"subtitle\"><u>Adresse internet du site</u></p>\n        <div class=\"paragraphe\">\n          <p>L\'adresse internet du site concerné par ces mentions légales est <a href=\"https://www.pilotelevage.fr/auth\" target=\"_blank\">www.pilotelevage.fr</a> (ci-après, le « Site »).</p>\n        </div>\n\n        <p class=\"subtitle\"><u>Éditeur</u></p>\n        <div class=\"paragraphe\">\n          <p>PILOT\'ELEVAGE</p>\n          <p>Société par actions simplifiée au capital de 52 930 euros</p>\n          <p><u>Siège social :</u> 6 rue des Roquemonts 14000 CAEN</p>\n          <p>Immatriculée au Registre du commerce sous le numéro 842 581 332</p>\n          <p><u>N° TVA :</u> FR 56842581332</p>\n          <p><u>Email :</u> contact@pilotelevage.fr</p>\n          <p>Ci-après dénommée « PILOT\'ELEVAGE»</p>\n        </div>\n\n        <p class=\"subtitle\"><u>Directeur de la publication</u></p>\n        <div class=\"paragraphe\">\n          <p><u>Nom :</u> Delphine DESCAMPS</p>\n          <p><u>Adresse :</u> 6 rue des Rocquemonts - 14053 CAEN Cedex 4</p>\n          <p><u>Email :</u> contact@pilotelevage.fr</p>\n        </div>\n        <p class=\"subtitle\"><u>Hébergeur</u></p>\n        <div class=\"paragraphe\">\n          <p><u>Nom :</u> Adventiel</p>\n          <p><u>Adresse :</u> 7 Boulevard Nominoë, 35740 Pacé</p>\n          <p><u>Tél. :</u> 02 99 60 10 11</p>\n        </div>\n\n        <p class=\"subtitle\"><u>Contenu du site – Propriété intellectuelle</u></p>\n        <p>L\'ensemble du contenu du Site, y compris les illustrations, photographies, vidéo, images, textes, marques, noms de\n          domaine et autres fichiers apparaissant sur le Site, ou de toute documentation publicitaire est la propriété de\n          PILOT\'ELEVAGE ou est utilisé avec l\'autorisation des titulaires des droits en cause.</p>\n        <p>La reproduction et/ou représentation intégrale ou partielle du Site, ou de tout élément qui le compose, est interdite, sauf\n          autorisation expresse et préalable de PILOT\'ELEVAGE.</p>\n        <p>PILOT\'ELEVAGE n\'autorise pas la création de liens hypertextes sauf accord exprès et préalable.</p>\n\n\n        <p class=\"subtitle\"><u>Limitations de responsabilité</u></p>\n        <p>L\'internaute reconnaît être informé des caractéristiques intrinsèques de l\'Internet et notamment des difficultés pouvant\n          survenir à certaines heures de la journée pour accéder au Site (mauvaises liaisons, nœuds de communication saturés...)\n          pour des raisons totalement indépendantes de la volonté de PILOT\'ELEVAGE, qui ne pourra donc être tenu pour\n          responsable des incidents limitant l\'accès au Site.</p>\n        <p>En conséquence, PILOT\'ELEVAGE ne saurait être responsable des dommages, temporaires ou permanents, causés au\n          système informatique de l\'internaute ni des pertes ou dommages éventuels qui seraient subis notamment suite à l\'accès ou\n          la navigation sur son Site, sauf faute de sa part.</p>\n\n        <p class=\"subtitle\"><u>Données personnelles</u></p>\n\n        <p>Dans le cadre de l\'exploitation du Site, PILOT\'ELEVAGE est amené à collecter des données personnelles des internautes.</p> \n        <p>Les données personnelles collectées par PILOT\'ELEVAGE à cette occasion sont traitées dans le respect des dispositions\n          prévues par la législation française et européenne applicable à la protection des données personnelles.</p>\n        <p>Dans un souci de transparence, il est primordial pour PILOT\'ELEVAGE que l\'internaute soit informé des pratiques de\n          traitement et de protection de ses données personnelles. Ce dernier est invité, dans cette optique, à lire attentivement la\n            <a href=\"/politiqueConfidentialite\" target=\"_blank\">Politique de confidentialité de PILOT\'ELEVAGE</a>.</p>\n\n        <p class=\"subtitle\"><u>Cookies et traceurs</u></p>\n\n        <p>PILOT\' ELEVAGE utilise des cookies nécessaires au bon fonctionnement et à la fourniture des services du Site et afin de\n          réaliser des mesures d\'audience. Pour en savoir plus sur ces finalités et les cookies utilisés sur le Site, l\'internaute est invité\n          à consulter la <a href=\"/politiqueConfidentialite\" target=\"_blank\">Politique de confidentialité de PILOT\'ELEVAGE</a>.</p>\n\n        <p>Mise à jour 1 décembre 2022</p>\n      </div>\n    </md-content>\n  </div>");
$templateCache.put("app/_common/partials/options/options.html","<div flex layout=\"column\" class=\"services-option\">\n    <md-content flex>\n        <div layout=\"row\" layout-align=\"center\" class=\"service\">\n            <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\">\n                <div layout=\"column\" class=\"notification-border div-option\" ng-show=\"ctrl.bovinSelected && ctrl.abonnementFlore\" ng-class=\"ctrl.showNotification === true ? \'notification-flore-active-update\' : \'notification-flore-unactive\'\">\n                    <h2 class=\"notification-title\">Service FLORE</h2>\n                    <form name=\"ctrl.notificationForm\" ng-submit=\"ctrl.goToFacturation()\" flex novalidate layout=\"column\">\n                        <div layout-gt-sm=\"row\">\n                            <div layout=\"row\">\n                                <div layout-gt-sm=\"column\">\n                                    <label>Souhaitez-vous activer le service Flore inclus dans votre</label>\n                                    <label>abonnement (sans surcoût)?</label>\n                                </div>\n                                <md-button class=\"md-icon-button\" ng-click=\"ctrl.showHelp()\" ng-disabled=\"ctrl.disableAbonnement\">\n                                    <md-icon md-svg-src=\"assets/images/help.svg\" aria-label=\"help\" class=\"md-icon-help\">\n                                    </md-icon>\n                                </md-button>\n                            </div>\n                            <div layout=\"row\" class=\"notification-button-row\">\n                                <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.notificationOuiButton()\" ng-class=\"ctrl.showNotification === true ? \'md-primary\' : \'md-sample\'\" ng-disabled=\"ctrl.disableAbonnement\">\n                                    Oui\n                                </md-button>\n                                <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.notificationNonButton()\" ng-disabled=\"ctrl.disableAbonnement\" ng-class=\"ctrl.showNotification === false ? \'md-primary\' : \'md-sample\'\">\n                                    Non\n                                </md-button>\n                            </div>\n                        </div>\n                        <div layout=\"column\" ng-show=\"ctrl.showNotification === true\" class=\"notifiaction-margin-top\">\n                            <label>Choix du média pour recevoir l\'alerte sorties présumées : </label>\n                            <div layout=\"row\" class=\"notification-choix-media\">\n                                <md-radio-group ng-model=\"ctrl.aboFloreActif.preference\" class=\"md-radio-group-media\">\n                                    <md-radio-button ng-disabled=\"ctrl.disableAbonnement\" value=\"sms\" flex=\"33\">SMS\n                                    </md-radio-button>\n                                    <md-radio-button ng-disabled=\"ctrl.disableAbonnement\" ng-show=\"ctrl.aboFloreActif.preference === \'mediaNonDispo\'\" value=\"skype\" flex=\"33\">Skype</md-radio-button>\n                                    <md-radio-button ng-disabled=\"ctrl.disableAbonnement\" ng-show=\"ctrl.aboFloreActif.preference === \'mediaNonDispo\'\" value=\"facebook\" flex=\"33\">Facebook Messenger</md-radio-button>\n                                </md-radio-group>\n                            </div>\n                            <div layout=\"row\">\n                                <div layout=\"column\" flex=\"33\">\n                                    <md-input-container ng-show=\"ctrl.aboFloreActif.preference === \'sms\'\">\n                                        <label>N° Tel. portable</label>\n                                        <input ng-disabled=\"ctrl.disableAbonnement\" class=\"input-width\" name=\"telephone\" ng-model=\"ctrl.aboFloreActif.telephoneSms\" type=\"text\" ng-pattern=\"/^(06|07) [0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}$/\" ui-mask=\"?9?9 ?9?9 ?9?9 ?9?9 ?9?9\" ui-mask-placeholder=\"\" ui-mask-placeholder-char=\"space\" ng-required=\"ctrl.aboFloreActif.preference === \'sms\'\">\n                                        <div ng-messages=\"ctrl.notificationForm.telephone.$error\" role=\"alert\" class=\"input-width\">\n                                            <div ng-message=\"required\">La saisie de votre numéro de téléphone est\n                                                obligatoire.</div>\n                                            <div ng-message=\"pattern\">Le N° de téléphone portable doit commencer par 06\n                                                ou 07.</div>\n                                        </div>\n                                    </md-input-container>\n                                </div>\n                                <div ng-show=\"ctrl.aboFloreActif.preference === \'facebook\'\" class=\"infos-media-externe\">\n                                    <b ng-show=\"ctrl.parametres.FLORE_FACEBOOK_OPTION === \'enabled\'\">Contactez votre\n                                        service assistance pour recevoir vos alertes sorties présumées via Skype ou\n                                        Facebook Messenger</b>\n                                    <b ng-show=\"ctrl.parametres.FLORE_FACEBOOK_OPTION === \'disabled\'\">La communication\n                                        avec FLORE via Skype où Facebook Messenger sera possible prochainement.</b>\n                                </div>\n                                <div ng-show=\"ctrl.aboFloreActif.preference === \'skype\'\" class=\"infos-media-externe\">\n                                    <b ng-show=\"ctrl.parametres.FLORE_SKYPE_OPTION === \'enabled\'\">Contactez votre\n                                        service assistance pour recevoir vos alertes sorties présumées via Skype ou\n                                        Facebook Messenger</b>\n                                    <b ng-show=\"ctrl.parametres.FLORE_SKYPE_OPTION === \'disabled\'\">La communication avec\n                                        FLORE via Skype où Facebook Messenger sera possible prochainement.</b>\n                                </div>\n                            </div>\n                            <div ng-show=\"ctrl.showNotification === true\" class=\"texte-juridique\">\n                                <p>Pilot’Elevage collecte le n° de téléphone mobile pour pouvoir activer le service d’alerte SMS, pour plus d’informations consultez la Politique de Confidentialité de Pilot’Elevage.</p>\n                            </div>\n                            <div layout=\"row\" layout-align=\"end center\">\n                                <md-button type=\"submit\" ng-click=\"ctrl.enregistrerNotif()\" class=\"md-raised md-primary\" ng-disabled=\"ctrl.disableAbonnement || ctrl.disableEnregistrerFlore\">Enregistrer\n                                </md-button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n        <div layout=\"row\" layout-align=\"center\" class=\"service\" ng-repeat=\"option in ctrl.options\">\n            <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\" ng-if=\"option.nom == \'dataHUB\' && option.allowed\">\n                <div layout=\"column\" class=\"notification-border div-option\" class=\"notification-flore-unactive\">\n                    <h2 class=\"option-title\">{{option.libelle}}</h2>\n                    <div layout-gt-sm=\"row\">\n                        <div layout=\"column\">\n                            <div layout=\"row\">\n                                <label>Pour découvrir l\'option {{option.nom}} 360°, cliquez </label>&nbsp;\n                                <a ng-click=\"ctrl.showOptionHelp(option)\" style=\"text-decoration: underline; color: black\"> ici</a>\n                            </div>\n                            <div layout=\"row\" style=\"justify-content: center\">\n                                <label>Souhaitez-vous être recontacté pour activer l\'option {{option.nom}} ? </label>\n                            </div>\n                        </div>\n                        <div layout=\"row\" class=\"notification-button-row\">\n                            <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.datahubButton(option, true)\" ng-class=\"option.isSelected === true || (option.idEleveurAbonnementExploitation && option.isSelected !== false) ? \'md-primary\' : \'md-sample\'\">\n                                {{option.boutonValidation}}\n                            </md-button>\n                            <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.optionDataHubNonButtonClic(option)\" ng-class=\"(option.isSelected === false || option.isSelected === undefined) && option.estSaisie ? \'md-primary\' : \'md-sample\'\">\n                                {{option.boutonAnnulation}}\n                            </md-button>\n                        </div>\n                    </div>\n                    <ng-include ng-show=\"option.isSelected === true\" src=\"\'app/_common/partials/options/optionTemplates/datahub.html\'\">\n                    </ng-include>\n                </div>\n            </div>\n            <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\" ng-if=\"option.allowed && option.nom != \'dataHUB\'\">\n                <div layout=\"column\" class=\"notification-border div-option\" class=\"notification-flore-unactive\">\n                    <h2 class=\"option-title\">{{option.libelle}}</h2>\n                    <div layout-gt-sm=\"row\">\n                        <div layout=\"row\">\n                            <div layout=\"column\" style=\"justify-content: center\">\n                                <ng-bind-html ng-if=\"option.description\" ng-bind-html=\"option.description\"></ng-bind-html>\n                                <label ng-if=\"!option.description\">Confirmez-vous l\'activation du service {{option.nom}} ?</label>\n                            </div>\n                            <md-button class=\"md-icon-button\" ng-click=\"ctrl.showOptionHelp(option)\" ng-show=\"option.titrePopup && option.contenuPopup\">\n                                <md-icon md-svg-src=\"assets/images/help.svg\" aria-label=\"help\" class=\"md-icon-help\">\n                                </md-icon>\n                            </md-button>\n                        </div>\n                        <div layout=\"row\" class=\"notification-button-row\">\n                            <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.optionOuiButtonClic(option)\" ng-class=\"option.isSelected === true || (option.idEleveurAbonnementExploitation && option.isSelected !== false) ? \'md-primary\' : \'md-sample\'\">\n                                {{option.boutonValidation}}\n                            </md-button>\n                            <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.optionNonButtonClic(option)\" ng-class=\"(option.isSelected === false || option.isSelected === undefined) && option.estSaisie ? \'md-primary\' : \'md-sample\'\">\n                                {{option.boutonAnnulation}}\n                            </md-button>\n                        </div>\n                    </div>\n                    <ng-include ng-show=\"option.templateHtml && option.isSelected === true\" src=\"option.templateHtml\">\n                    </ng-include>\n                    <a ng-href=\"{{\'assets/documents/\'+option.nomPdfPolitiqueConfidentialite}}\" ng-show=\"option.nomPdfPolitiqueConfidentialite\" target=\"_blank\" class=\"light-link\">Politique de confidentialite</a>\n                </div>\n            </div>\n            <div id=\"bottom-{{option.idAbonnement}}\"></div>\n        </div>\n\n    </md-content>\n\n    <div class=\"actions-bar\">\n        <a href=\"assets/documents/details.pdf\" target=\"_blank\" class=\"light-link details\">Voir toutes les offres</a>\n        <md-button type=\"button\" class=\"md-raised md-sample\" ng-click=\"ctrl.annuleModificationsService()\">Retour\n        </md-button>\n    </div>\n    \n</div>");
$templateCache.put("app/_common/partials/politiqueConfidentialite/politiqueConfidentialite.html","<div flex layout=\"column\">\n    <div class=\"title-bar\">\n        <h2>Politique de confidentialité</h2>\n    </div>\n    <md-content flex>\n        <div class=\"politiqueConfidentialite\">\n            <p>Chez <strong>PILOT’ELEVAGE</strong> la protection des données personnelles de nos clients,\n                internautes,\n                utilisateurs et partenaires est un élément primordial. Nous nous engageons ainsi à respecter la loi\n                n°\n                78-17 du 6 janvier 1978 relative à l\'informatique, aux fichiers et aux libertés, modifiée par le\n                Règlement européen 2016/679 du 27 avril 2016 relatif à la protection des données personnelles.</p>\n            <p>Afin de vous une offrir une information transparente et la plus complète possible sur notre\n                utilisation\n                de vos données personnelles, nous avons élaboré la présente politique de protection des données.</p>\n            <p>PILOT’ELEVAGE, société par actions simplifiées, immatriculée au RCS, n°842 581 332, située au 6 rue\n                des\n                Roquemonts 14000 CAEN, est responsable du traitement des données personnelles des clients et\n                utilisateurs du site internet <a href=\"/auth\" target=\"_blank\">www.pilotelevage.fr</a> (le « Site »).</p>\n            <p>PILOT’ ELEVAGE fournit à ses abonnés une solution de pilotage numérique de leur élevage bovin, ou\n                ovin/caprin, disponible sur les différents supports (ordinateur, smartphone, tablette). L’offre de\n                PILOT’ELEVAGE permet de gérer l\'identification, la reproduction, la santé, les performances lait et\n                viande des troupeaux des abonnés.</p>\n            <p>Nous sommes ainsi amenés à collecter et traiter vos données personnelles aux fins de répondre aux\n                obligations contractuelles nous incombant lorsque vous vous abonnez à notre service ou créez un\n                compte\n                chez PILOT’ELEVAGE. Il est également dans notre intérêt légitime de collectez vos données afin de\n                répondre à vos questions et demandes concernant nos services et d’assurer le bon fonctionnement de\n                notre\n                Site, mesurer sa fréquentation et connaitre la pertinence de son contenu et son attractivité.</p>\n\n            <p class=\"subtitle\"><u>Qu’est ce qu’une donnée personnelle ?</u></p>\n            <p>Les données personnelles sont des informations qui permettent de vous identifier, que ce soit directement\n                ou indirectement. Il peut notamment s’agir de votre nom, votre prénom, de votre numéro de téléphone, de\n                votre adresse postale ou de votre adresse électronique.</p>\n\n            <p class=\"subtitle\"><u>Quelles sont nos pratiques en matière de données personnelles ?</u></p>\n            <p>Nous collectons vos données personnelles de manière loyale, licite, transparente. Vos données\n                personnelles, ainsi collectées, sont proportionnées aux finalités de notre traitement. Elles nous\n                permettent de vous fournir un service sur mesure afin que vous pilotiez votre élevage à distance et\n                gériez votre abonnement.</p>\n            <p>Nous assurons également la protection de vos données personnelles en mettant en place des mesures\n                strictes de sécurité, conformes à la réglementation applicable en la matière.</p>\n\n            <p class=\"subtitle\"><u>Pourquoi collectons-nous vos données personnelles ?</u></p>\n            <p>Nous collectons et traitons différentes catégories de données personnelles afin d’assurer au mieux la\n                gestion de notre service ainsi que les relations contractuelles et commerciales avec nos utilisateurs et\n                partenaires.</p>\n            <p>Le traitement de vos données personnelles a notamment pour finalités :</p>\n            <ul class=\"circle\">\n                <li>la création d’un compte PILOT’ELEVAGE ;</li>\n                <li>la souscription à un abonnement PILOT’ELEVAGE ;</li>\n                <li>l’activation de l’ensemble des fonctionnalités incluses dans l’Offre souscrite ;</li>\n                <li>le traitement de vos demandes ;</li>\n                <li>le suivi des clients ;</li>\n                <li>la gestion et le bon fonctionnement du site pilotelevage.fr et la réalisation de mesures d’audience\n                </li>\n                <li>la gestion des factures, de la comptabilité.</li>\n            </ul>\n\n            <p class=\"subtitle\"><u>Qui peut accéder à vos données personnelles ?</u></p>\n            <p>Vos données personnelles sont transmises, au sein de nos services, aux seules personnes habilitées par\n                leurs fonctions à les traiter. Vos données sont également transmises à nos partenaires et sous-traitants\n                comme la plateforme Hubixeo permettant l’utilisation et la gestion du service Flore, Adventiel pour\n                l’hébergement de nos données et Odoo pour la gestion de la facturation. Si vous souhaitez souscrire à\n                certaines options proposées par le service PILOT’ELEVAGE, vos données pourront également être\n                transférées à certains de nos prestataires intervenant dans la fourniture des prestations additionnelles\n                auxquelles vous avez souscrit.</p>\n            <p>De plus, nous veillons attentivement à ce que l’ensemble de nos prestataires et sous-traitants mettent en\n                place les mesures de sécurité et de confidentialité appropriées pour garantir la protection de vos\n                données personnelles.</p>\n            <p>En dehors de ces cas, PILOT’ELEVAGE ne partagera pas vos données personnelles avec des tiers sauf si la\n                loi l’exige.</p>\n\n            <p class=\"subtitle\"><u>Quelles catégories de données personnelles collectons-nous ?</u></p>\n            <p>Afin de répondre aux finalités des traitements précités, nous collectons notamment :</p>\n            <ul class=\"circle\">\n                <li>vos nom et prénom ;</li>\n                <li>votre adresse postale ;</li>\n                <li>votre adresse électronique ;</li>\n                <li>votre numéro de téléphone.</li>\n            </ul>\n            <p>Vos données personnelles ne feront pas l’objet d’une utilisation autre que celle nécessaire à la\n                fourniture des services web et mobile PILOT’ELEVAGE, conformément aux finalités précédemment citées.\n                PILOT’ELEVAGE n’utilisera pas vos données pour poursuivre d’autre finalités sans vous en avoir\n                préalablement informé et, le cas échéant, solliciter votre consentement.</p>\n\n            <p class=\"subtitle\"><u>Pendant quelle durée vos données personnelles sont-elles conservées ?</u></p>\n            <p>Conformément à la réglementation relative à la protection des données personnelles, nous conservons vos\n                données personnelles pour la durée nécessaire à la réalisation des finalités du traitement pour\n                lesquelles elles sont collectées.\n            </p><p>\n            </p><p>Les durées de conservation de vos données sont précisées ci-dessous, par finalité de traitement. Au terme\n                de ces durées, nous procédons soit à la suppression, soit à l’anonymisation de vos données.</p>\n\n            <p>o Les données du compte abonné\n            </p><p>Les données collectées à partir de la création de votre compte abonné sont conservées jusqu’à la\n                suppression du dit compte. Toutefois dans les cas où nous constaterions que votre compte a été inactif\n                pendant 2 ans, nous pourrions procéder à sa suppression, après vous en avoir préalablement informé et\n                sauf opposition de votre part.\n                <br>Ainsi, la durée de conservation maximale de vos données dans nos dossiers relatifs à la gestion de\n                nos relations commerciales équivaut à la durée de notre relation.\n            </p>\n\n            <p>o La souscription à un abonnement PILOT’ELEVAGE, l’activation de l’ensemble des fonctionnalités incluses\n                et le suivi client</p>\n            <p>Les données collectées pour le besoin des finalités précitées sont conservées pendant la durée de notre\n                relation contractuelle.</p>\n\n            <p>o Les données relatives à vos demandes de contact</p>\n            <p>Nous conservons les données traitées afin de répondre à votre demande de contact pendant trois ans à\n                compter de notre dernier contact.\n                <br>A l’issue de cette période, ces données seront conservées sous forme d’archivage intermédiaire pour\n                prévenir tout éventuel contentieux pour une durée limitée aux durées de prescription fixées en matière\n                civile et commerciale.\n            </p>\n\n            <p>o La gestion et le bon fonctionnement du Site et la réalisation de mesures d’audience</p>\n            <p>Les données issues des cookies utilisés sur le Site afin d’assurer le bon fonctionnement de ce dernier et\n                de réaliser des mesures d’audience sont conservées pour une durée n’excédant pas 25 mois.</p>\n\n            <p>o La gestion des factures, de la comptabilité.</p>\n            <p>Les données collectées pour le besoin des finalités précitées sont conservées pendant la durée conforme\n                aux obligations légales ou aux délais prévus par la loi.</p>\n\n            <p class=\"subtitle\"></p>\n            <p>Au-delà de ces périodes, nous pouvons conserver vos données sous forme d’archivage intermédiaire pour\n                établir la preuve d’un droit ou d’un contrat, ou pour assurer le respect d’une obligation légale.\n                L’archivage sera opéré conformément aux recommandations de la CNIL : les données archivées feront\n                l’objet d’une sélection et d’une conservation distincte de la base de données active et limitée dans le\n                temps, notamment en fonction des prescriptions du Code Civil et du Code de Commerce.</p>\n\n            <p class=\"subtitle\"><u>Vos données sont-elles transférées en dehors de l’Union européenne ?</u></p>\n            <p>En principe, l’ensemble de vos données personnelles sont traitées et conservées sur le territoire de\n                l’Union européenne.</p>\n            <p>Toutefois, dans le cadre de la gestion de la facturation, vos données sont transmises à notre prestataire\n                Odoo qui pourrait être amené à réaliser des sauvegardes de vos données personnelles au sein de ses\n                serveurs situés au Canada. Le pays destinataire de ces données étant toutefois reconnu comme adéquat par\n                l’Union européenne pour les transferts réalisés dans le cadre d’activités commerciales, ce transfert ne\n                nécessite pas la mise en place de mesures d’encadrement spécifiques complémentaires. Nous vous assurons\n                en tout état de cause être particulièrement attentifs à la sécurité de vos données personnelles et au\n                fait que chaque transfert de vos données, au sein ou en dehors de l’Union européenne, bénéficie d’un\n                niveau de protection suffisant et approprié.</p>\n\n            <p class=\"subtitle\"><u>Quels sont les droits dont vous disposez à l’égard de vos données personnelles ?</u>\n            </p>\n            <p>Conformément à la réglementation applicable, vous disposez des droits d’accès, de rectification et\n                d’effacement de vos données personnelles. Vous pouvez également exercer votre droit à la portabilité\n                afin d’obtenir vos données personnelles dans un format structuré, utilisable et lisible par une machine,\n                afin que ces dernières soient transmissibles à un tiers, si votre demande est éligible.</p>\n            <p>Vous bénéficiez, en outre, du droit de demander la limitation du traitement de vos données personnelles\n                ainsi que du droit de vous opposer à leurs traitements en raison de circonstances propres à votre\n                situation personnelle.</p>\n            <p>Vous disposez également du droit de définir des directives générales ou particulières quant au sort post\n                mortem de vos données personnelles. Les directives particulières peuvent être enregistrées auprès de\n                notre référent interne à la protection des données personnelles. Les directives générales peuvent être\n                enregistrées auprès d’un tiers de confiance numérique certifié par la CNIL. Vous avez la possibilité de\n                modifier ou supprimer ces directives à tout moment.</p>\n\n            <p class=\"subtitle\"><u>Qui pouvez-vous contacter sur les sujets relatifs à la protection de vos données\n                    ?</u></p>\n            <p>Vous pouvez nous contacter directement ou exercer les droits visés au précédent paragraphe via l’adresse\n                email suivante : contact@pilotelevage.fr</p>\n            <p>Vos demandes seront examinées dans les meilleurs délais.</p>\n            <p>Dans l’hypothèse où vous estimeriez que vos droits ne sont pas respectés au regard de la protection de\n                vos données ou qu’une action relative aux conditions du traitement de vos données personnelles serait\n                incompatible avec les dispositions de la présente politique ou de la réglementation applicable, vous\n                pourrez directement formuler une réclamation auprès de la <a href=\"https://www.cnil.fr\" target=\"_blank\" rel=\"noopener\">CNIL</a>.</p>\n\n            <p class=\"subtitle\"><u>Informations complémentaires concernant les cookies utilisés sur le site <a href=\"/auth\" target=\"_blank\">www.pilotelevage.fr</a></u></p>\n            <p>Nous pouvons collecter des données relatives à votre navigation sur les pages du Site par l’intermédiaire\n                de cookies.</p>\n            <p>Pour vote information, un cookie est un petit fichier informatique qui peut être déposé et lu sur votre\n                terminal par un site web sur lequel vous vous connectez. Les cookies peuvent avoir différentes finalités\n                et leur utilisation est, par principe, soumise à votre consentement préalable, sauf lorsque ces derniers\n                sont strictement nécessaires à la fourniture d’un service de communication en ligne demandé par\n                l’internaute ou lorsqu’ils ont pour seule finalité de permettre ou faciliter la communication par voie\n                électronique.</p>\n            <p>Les cookies utilisés sur le Site ont pour finalité d’assurer un fonctionnement optimal de nos services :\n                ils sont destinés à permettre votre authentification auprès du Site et à faciliter votre navigation. En\n                cela, et conformément aux préconisations de la CNIL, l’utilisation de ces cookies ne nécessite pas le\n                consentement préalable de l’internaute en ce qu’ils sont strictement nécessaires à la fourniture d’un\n                service de communication en ligne demandé par l’internaute et qu’ils ont pour seule finalité de\n                permettre ou faciliter la communication par voie électronique.</p>\n            <p>Des cookies peuvent également être déposés sur votre terminal afin de mesurer l’audience du Site. Ces\n                cookies de mesure d’audience rentrent dans le périmètre défini par la CNIL des cookies bénéficiant de\n                l’exemption du consentement, en ce que leur utilisation est notamment strictement limitée au suivi et à\n                la mesure de l’audience du Site, sans recoupement de données ou transmission de données à des tiers et\n                qu’ils ne produisent que des données statistiques anonymes. Le dépôt de ces derniers ne nécessite donc\n                pas votre consentement préalable.</p>\n\n            <p class=\"subtitle\"><u>Mises à jour de la présente Politique</u></p>\n            <p>PILOT’ ELEVAGE se réserve le droit de modifier la présente Politique de protection des données à tout\n                moment en tenant compte des dispositions en vigueur en matière de protection des données personnelles.\n            </p>\n\n            <p>Mise à jour 1 décembre 2022</p>\n        </div>\n</md-content></div>\n\n");
$templateCache.put("app/admin/gestionAbonnement/detail/detail.html","<div flex layout=\"column\" class=\"detail-abonnement\">\n  <adv-toolbar class=\"title-toolbar\">\n    <h2>Détails</h2>\n    <div class=\"item\" ng-repeat=\"onglet in ctrl.onglets\" ng-class=\"{active: ctrl.onglet === onglet.libelle}\">\n      <button type=\"button\" class=\"adv-button\" ng-click=\"ctrl.onglet=onglet.libelle\">{{onglet.libelle}}</button>\n    </div>\n  </adv-toolbar>\n  <div flex layout=\"column\" ng-switch=\"ctrl.onglet\">\n    <div flex layout=\"column\" ng-switch-when=\"informations\">\n      <div layout=\"column\" ng-include=\"\'app/admin/gestionAbonnement/detail/templates/informations.html\'\" flex></div>\n    </div>\n    <div flex layout=\"column\" ng-switch-when=\"services\">\n      <div layout=\"column\" ng-include=\"\'app/admin/gestionAbonnement/detail/templates/services.html\'\" flex></div>\n    </div>\n    <div flex layout=\"column\" ng-switch-when=\"facturation\">\n      <div layout=\"column\" ng-include=\"\'app/_common/partials/facturation/facturation.html\'\" ng-controller=\"FacturationController as ctrl\" flex></div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/admin/gestionAbonnement/main/main.html","<div flex layout=\"column\" class=\"gestionAbonnement\">\n  <div class=\"title-bar\" layout=\"row\">\n    <h2 flex=\"30\">Gestion des abonnements</h2>\n\n    <div flex=\"30\"></div>\n\n    <div flex=\"30\"></div>\n  </div>\n\n  <ui-view flex layout=\"column\"></ui-view>\n</div>");
$templateCache.put("app/admin/gestionAbonnement/selection/menu.html","<div layout=\"row\" layout-align=\"start center\">\n  <h2>Abonnements<span class=\"compteur\">&nbsp;({{ctrl.abonnementsAffiches.length}})</span></h2>\n\n  <div class=\"item\" ng-class=\"ctrl.listActifs == true ? \'active\' : \'\'\">\n    <button type=\"button\" ng-click=\"ctrl.afficheListActifs()\" ng-model=\"actifs\" class=\"adv-button\">Actifs</button>\n  </div>\n  <div class=\"item\" ng-class=\"ctrl.listTous == true ? \'active\' : \'\'\">\n    <button type=\"button\" ng-click=\"ctrl.afficheListTous()\" class=\"adv-button\">Tous</button>\n  </div>\n</div>\n");
$templateCache.put("app/admin/gestionAbonnement/selection/selection.html","<div flex layout=\"column\" class=\"selection-abonnement\">\n  <md-content flex>\n    <form name=\"ctrl.authentForm\" ng-submit=\"ctrl.openListAbonnements()\" novalidate layout=\"column\">\n      <div class=\"selection-form\" layout=\"row\" layout-align=\"center\">\n        <div>\n          <h4 class=\"codePays\">FR</h4>\n          <md-input-container>\n            <label>N° Exploitation</label>\n            <input name=\"numExploitation\" ng-model=\"ctrl.numExploitation\">\n          </md-input-container>\n        </div>\n        <div class=\"choixInfo\">\n          ou\n        </div>\n        <md-input-container>\n          <label>Identifiant</label>\n          <input name=\"identifiant\" ng-model=\"ctrl.identifiant\">\n        </md-input-container>\n        <md-button type=\"submit\" class=\"md-raised md-primary btn-valider\" ng-disabled=\"ctrl.authentForm.$invalid\">\n          Valider</md-button>\n      </div>\n    </form>\n\n    <div ng-if=\"ctrl.afficheListAbonnements\">\n\n      <adv-toolbar class=\"title-toolbar\" layout=\"row\">\n        <div flex layout=\"row\" layout-align=\"center\">\n          <div flex layout=\"row\" layout-align=\"start center\">\n            <ng-include src=\"\'app/admin/gestionAbonnement/selection/menu.html\'\"></ng-include>\n          </div>\n          <div flex layout=\"row\" layout-align=\"end center\">\n            <adv-input-search class=\"input-search\" ng-model=\"ctrl.filter.search.value\"></adv-input-search>\n            <adv-souffleur-button show-souffleur=\"ctrl.showSouffleur\" filter=\"ctrl.filter\"></adv-souffleur-button>\n\n            <a ng-click=\"ctrl.export()\" aria-label=\"exportExcel\" class=\"md-icon-button\">\n              <md-icon md-svg-src=\"assets/images/icones/excel.svg\"></md-icon>\n            </a>\n          </div>\n        </div>\n\n      </adv-toolbar>\n      <md-subheader>\n        <adv-list-item adv-header adv-order=\"ctrl.order\" class=\"data-list-header\">\n          <div flex=\"10\" class=\"column\">\n            <div>\n              <span adv-column adv-order-by=\"numExploitation\">Exploitation</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.numExploitation\">\n                  <input ng-model=\"ctrl.filter.souffleurs.numExploitation.value\" placeholder=\"Rechercher\" class=\"souffleur-input\">\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"10\" class=\"column\">\n            <div>\n              <span adv-column adv-order-by=\"identifiant\">Identifiant OpenAM</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.identifiant\">\n                  <input ng-model=\"ctrl.filter.souffleurs.identifiant.value\" placeholder=\"Rechercher\" class=\"souffleur-input\">\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"10\" class=\"column\">\n            <div>\n              <span adv-column adv-order-by=\"typeAbonnement.code\">Type</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.typeAbonnement\" type=\"\'multiple\'\">\n                  <md-select md-selected-text=\"ctrl.getSelectedText(ctrl.filter.souffleurs.typeAbonnement.value)\" ng-model=\"ctrl.filter.souffleurs.typeAbonnement.value\" multiple=\"true\" aria-label=\"typeAbonnement\" class=\"souffleur-input\">\n                    <md-option ng-value=\"typeAbonnement\" ng-repeat=\"typeAbonnement in ctrl.types track by typeAbonnement.code\">{{typeAbonnement.libelle}}\n                    </md-option>\n                  </md-select>\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"10\" class=\"column\">\n            <div>\n              <span adv-column adv-order-by=\"niveau.code\">Niveau</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.niveau\" type=\"\'multiple\'\">\n                  <md-select md-selected-text=\"ctrl.getSelectedText(ctrl.filter.souffleurs.niveau.value)\" ng-model=\"ctrl.filter.souffleurs.niveau.value\" multiple=\"true\" aria-label=\"niveau\" class=\"souffleur-input\">\n                    <md-option ng-value=\"niveau\" ng-repeat=\"niveau in ctrl.niveaux track by niveau.code\">\n                      {{niveau.libelle}}</md-option>\n                  </md-select>\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"10\" class=\"column\">\n            <div>\n              <span adv-column adv-order-by=\"dateDebut\">Date début</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.dateDebut\" type=\"\'date\'\">\n                  <md-datepicker filter-date-picker ng-model=\"ctrl.filter.souffleurs.dateDebut.value\" md-placeholder=\"Entrer date\" md-hide-icons=\"calendar\" class=\"souffleur-input\"></md-datepicker>\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"10\" class=\"column\" ng-hide=\"ctrl.listActifs\">\n            <div>\n              <span adv-column adv-order-by=\"dateFin\">Date fin</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.dateFin\" type=\"\'date\'\">\n                  <md-datepicker filter-date-picker ng-model=\"ctrl.filter.souffleurs.dateFin.value\" md-placeholder=\"Entrer date\" md-hide-icons=\"calendar\" class=\"souffleur-input\"></md-datepicker>\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"10\" class=\"column\">\n            <div>\n              <span adv-column adv-order-by=\"dateFinDifferee\">Date fin différée</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" class=\"derniere-connexion\" ng-model=\"ctrl.filter.souffleurs.dateFinDifferee\" type=\"\'date\'\">\n                  <md-datepicker filter-date-picker ng-model=\"ctrl.filter.souffleurs.dateFinDifferee.value\" md-placeholder=\"Entrer date\" md-hide-icons=\"calendar\" class=\"souffleur-input\"></md-datepicker>\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"20\" class=\"column\">\n            <div>\n              <span adv-column adv-order-by=\"email\">Mail</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.email\">\n                  <input ng-model=\"ctrl.filter.souffleurs.email.value\" placeholder=\"Rechercher\" class=\"souffleur-input\">\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"10\" class=\"column\">\n            <div>\n              <span adv-column adv-order-by=\"nombreAutorisationsAcces\">Nb d’autorisations d’accès</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.nombreAutorisationsAcces\">\n                  <input ng-model=\"ctrl.filter.souffleurs.nombreAutorisationsAcces.value\" placeholder=\"Rechercher\" class=\"souffleur-input\">\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n        </adv-list-item>\n      </md-subheader>\n\n      <adv-list-item ng-if=\" ctrl.abonnementsAffiches.length === 0 \" class=\"empty-list\">\n        Aucun abonnement\n      </adv-list-item>\n\n      <adv-list class=\"data-list-body stripped\">\n        <adv-list-item ng-repeat=\"abonnement in ctrl.abonnementsAffiches | advOrderBy:ctrl.order | advStartFrom: ctrl.currentPage*ctrl.pageSize | limitTo:ctrl.pageSize\" ng-click=\"ctrl.goToDetails(abonnement)\">\n          <div flex=\"10\">\n            {{abonnement.numExploitation}}\n          </div>\n          <div flex=\"10\">\n            {{abonnement.identifiant}}\n          </div>\n          <div flex=\"10\">\n            {{abonnement.typeAbonnement ? abonnement.typeAbonnement.libelle : \'-\'}}\n          </div>\n          <div flex=\"10\">\n            {{abonnement.niveau ? abonnement.niveau.libelle : \'-\'}}\n          </div>\n          <div flex=\"10\">\n            {{abonnement.dateDebut | date: \'dd/MM/yyyy\'}}\n          </div>\n          <div flex=\"10\" ng-hide=\"ctrl.listActifs\">\n            {{abonnement.dateFin | date: \'dd/MM/yyyy\'}}\n          </div>\n          <div flex=\"10\">\n            {{abonnement.dateFinDifferee | date: \'dd/MM/yyyy\'}}\n          </div>\n          <div flex=\"20\" style=\"overflow: hidden\" ng-attr-title=\"{{abonnement.email}}\">\n            {{abonnement.email}}\n          </div>\n          <div flex=\"10\">\n            {{abonnement.nombreAutorisationsAcces}}\n          </div>\n        </adv-list-item>\n      </adv-list>\n      <div style=\"display: flex;justify-content: center;align-items: center\" ng-if=\"ctrl.abonnementsAffiches.length > ctrl.pageSize\">\n        <button ng-disabled=\"ctrl.currentPage == 0\" ng-click=\"ctrl.currentPage=ctrl.currentPage-1\" class=\"md-raised md-primary md-button md-ink-ripple\">\n          Précédent\n        </button>\n        {{ctrl.currentPage+1}} / {{ctrl.numberOfPages()}}\n        <button ng-disabled=\"ctrl.currentPage >= ctrl.abonnementsAffiches.length/ctrl.pageSize - 1\" ng-click=\"ctrl.currentPage=ctrl.currentPage+1\" class=\"md-raised md-primary md-button md-ink-ripple\">\n          Suivant\n        </button>\n        <md-input-container>\n            <md-select ng-model=\"ctrl.pageSize\" style=\"width: 50px\" aria-label=\"lignes\">\n              <md-option value=\"10\">10</md-option>\n              <md-option value=\"25\">25</md-option>\n              <md-option value=\"50\">50</md-option>\n              <md-option value=\"100\">100</md-option>\n              <md-option value=\"150\">150</md-option>\n              <md-option value=\"200\">200</md-option>\n              <md-option value=\"250\">250</md-option>\n              <md-option value=\"300\">300</md-option>\n            </md-select>\n        </md-input-container>\n      </div>\n    </div>\n  </md-content>\n</div>");
$templateCache.put("app/admin/gestionModales/creerModale/creerModale.html","<div flex layout=\"column\" class=\"creer-modale\">\n\n  <div class=\"title-bar\" layout=\"row\">\n    <h2 ng-if=\"ctrl.mode === \'creation\'\">Gestion des modales - Création</h2>\n    <h2 ng-if=\"ctrl.mode === \'duplication\'\">Gestion des modales - Duplication</h2>\n    <h2 ng-if=\"ctrl.mode === \'edition\'\">Gestion des modales - Édition</h2>\n  </div>\n\n  <form name=\"ctrl.modaleForm\" novalidate flex layout=\"column\" class=\"form-creation\">\n\n    <md-content flex>\n\n      <!-- div form début -->\n      <div style=\"margin-left: 35px\">\n\n        <!-- DESTINATAIRES début -->\n        <div>\n\n          <div class=\"titre2-uppercase\">DESTINATAIRES</div>\n\n          <div>\n            <div class=\"titre3-bold\">\n              Profils *\n            </div>\n            <div class=\"flex-row\">\n              <div ng-repeat=\"profil in ctrl.profilsDisponibles\" class=\"space-right\">\n                <md-checkbox ng-model=\"profil.checked\" ng-change=\"ctrl.toggleProfil(profil)\">\n                  {{ profil.label }}\n                </md-checkbox>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"flex-column\">\n            <div class=\"titre3-bold\">\n              Liste cheptels\n            </div>\n            <div class=\"flex-row\">\n              <md-radio-group ng-model=\"ctrl.exploitationsOption\" ng-change=\"ctrl.onExploitationsChange()\">\n                <md-radio-button value=\"all\">Tous les cheptels</md-radio-button>\n                <md-radio-button value=\"defined\">Liste de cheptels définis</md-radio-button>\n              </md-radio-group>\n            </div>\n            <div ng-if=\"ctrl.exploitationsOption === \'defined\'\">\n              <md-button class=\"md-raised md-primary\" ng-click=\"ctrl.triggerFileInput()\">\n                + Importer la liste des cheptels\n              </md-button>\n              <!-- Affichage du nom du fichier sélectionné -->\n              <span ng-if=\"!ctrl.nomFichier\" style=\"margin-left: 15px\">\n                Aucun fichier choisi\n              </span>\n              <span ng-if=\"ctrl.nomFichier\" style=\"margin-left: 15px\">\n                {{ ctrl.nomFichier }} contenant {{ ctrl.modale.exploitations.length }} cheptels\n              </span>\n              <input type=\"file\" id=\"fileInput\" accept=\".csv\" style=\"display: none\" onchange=\"angular.element(this).scope().ctrl.importerExploitations(event)\">\n            </div>\n\n          </div>\n\n        </div>\n        <!-- DESTINATAIRES fin -->\n\n        <!-- MESSAGE début -->\n        <div>\n\n          <div class=\"titre2-uppercase\">MESSAGE</div>\n\n          <!-- Affichage début -->\n          <div>\n            <div class=\"titre3-bold\">\n              Affichage\n            </div>\n\n            <div class=\"flex-row\">\n              <div class=\"space-right\">\n                <md-input-container>\n                  <label>Date et heure de début</label>\n                  <input type=\"datetime-local\" ng-model=\"ctrl.dateDebut\" required>\n                </md-input-container>\n              </div>\n              <div class=\"space-right\">\n                  <md-input-container>\n                    <label>Date et heure de fin</label>\n                    <input type=\"datetime-local\" ng-model=\"ctrl.dateFin\" required ng-attr-min=\"{{ ctrl.dateDebut }}\">\n                  </md-input-container>\n              </div>\n              <div class=\"space-right\">\n                <md-input-container>\n                  <label>Priorité d\'affichage</label>\n                  <input name=\"priorite\" type=\"number\" ng-model=\"ctrl.modale.modale.priorite\" required>\n                </md-input-container>\n              </div>\n            </div>\n\n            <div class=\"flex-row\">\n              <md-input-container class=\"space-right\">\n                <label>Titre</label>\n                <textarea name=\"titre\" ng-model=\"ctrl.modale.modale.titre\" required class=\"input_titre\" style=\"resize: auto\">\n                </textarea>\n                <div ng-messages=\"ctrl.modaleForm.titre.$error\">\n                  <div ng-message=\"required\">Obligatoire.</div>\n                </div>\n              </md-input-container>\n              <md-input-container>\n                <label>Code</label>\n                <input name=\"code\" ng-model=\"ctrl.modale.modale.code\" maxlength=\"70\" required class=\"input_titre\" ng-disabled=\"ctrl.mode === \'edition\'\">\n                <div ng-messages=\"ctrl.modaleForm.code.$error\">\n                  <div ng-message=\"required\">Obligatoire.</div>\n                </div>\n              </md-input-container>\n            </div>\n\n            <div>\n              <md-input-container class=\"no-floating-label\">\n                <label>Texte</label>\n                <textarea name=\"contenu\" ui-tinymce=\"{width: 700, height: 250, menubar: false, toolbar: \'undo redo | bold italic underline\',\n                  valid_elements: \'p,b,strong,i,em,u,a[href|target],ul,ol,li,br\',\n                  extended_valid_elements: \'u\',\n                  forced_root_block: \'p\',\n                  formats: {\n                    underline: { inline: \'u\', remove: \'all\' }\n                  }}\" ng-model=\"ctrl.modale.modale.contenu\" required></textarea>\n                <div ng-messages=\"ctrl.modaleForm.contenu.$error\">\n                  <div ng-message=\"required\">Obligatoire.</div>\n                </div>\n              </md-input-container>\n            </div>\n\n          </div>\n          <!-- Affichage fin -->\n\n          <!-- Boutons début -->\n          <div>\n\n            <div class=\"flex-row\">\n\n              <!-- Bouton 1 début -->\n              <div style=\"margin-right: 100px\">\n\n                <div class=\"titre3-bold\">\n                  Boutons\n                </div>\n\n                <div class=\"flex-row\" style=\"align-items: center\">\n                  <div class=\"space-right\">\n                    Bouton 1 *\n                  </div>\n                  <div>\n                    <md-input-container>\n                      <label>Titre</label>\n                      <input name=\"boutonValiderLibelle\" ng-model=\"ctrl.modale.modale.boutonValider.libelle\" maxlength=\"70\" required class=\"input_titre\">\n                      <div ng-messages=\"ctrl.modaleForm.boutonValiderLibelle.$error\">\n                        <div ng-message=\"required\">Obligatoire.</div>\n                      </div>\n                    </md-input-container>\n                  </div>\n                </div>\n\n                <div class=\"flex-row\">\n                  <div class=\"space-right\">\n                    Action\n                  </div>\n                  <div>\n                    <md-radio-group ng-model=\"ctrl.actionBoutonValider\" ng-change=\"ctrl.updateButtonAction(ctrl.modale.modale.boutonValider)\" class=\"flex-row\">\n                      <md-radio-button value=\"open\" class=\"space-right\">Ouvre une page</md-radio-button>\n                      <md-radio-button value=\"close\">Ferme la modale</md-radio-button>\n                    </md-radio-group>\n                  </div>\n                </div>\n\n                <div ng-if=\"ctrl.actionBoutonValider === \'open\'\">\n                  <md-input-container>\n                      <label>URL</label>\n                      <input type=\"text\" ng-model=\"ctrl.modale.modale.boutonValider.urlRedirection\" required>\n                  </md-input-container>\n                  <div class=\"flex-row\" style=\"align-items: center\">\n                    <div class=\"space-right\">\n                      Ouvrir dans un nouvel onglet\n                    </div>\n                    <div layout=\"row\">\n                      <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.modale.modale.boutonValider.ouvrirOnglet = true\" ng-class=\"ctrl.modale.modale.boutonValider.ouvrirOnglet === true ? \'md-primary\' : \'md-sample\'\">\n                        Oui\n                      </md-button>\n                      <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.modale.modale.boutonValider.ouvrirOnglet = false\" ng-class=\"ctrl.modale.modale.boutonValider.ouvrirOnglet === false ? \'md-primary\' : \'md-sample\'\">\n                        Non\n                      </md-button>\n                    </div>\n                  </div>\n              </div>\n\n              </div>\n              <!-- Bouton 1 fin -->\n\n              <!-- Bouton 2 début -->\n              <div style=\"margin-top: 20px\">\n\n                <div>\n                  <md-checkbox ng-model=\"ctrl.afficherBoutonFermer\" ng-change=\"ctrl.toggleAfficherBoutonFermer()\">\n                    Afficher bouton 2\n                  </md-checkbox>\n                </div>\n\n                <div ng-if=\"ctrl.afficherBoutonFermer\" style=\"margin-top: -20px\">\n\n                  <div class=\"flex-row\" style=\"align-items: center\">\n                    <div class=\"space-right\">\n                      Bouton 2 *\n                    </div>\n                    <div>\n                      <md-input-container>\n                        <label>Titre</label>\n                        <input name=\"boutonFermerLibelle\" ng-model=\"ctrl.modale.modale.boutonFermer.libelle\" maxlength=\"70\" required class=\"input_titre\">\n                        <div ng-messages=\"ctrl.modaleForm.boutonFermerLibelle.$error\">\n                          <div ng-message=\"required\">Obligatoire.</div>\n                        </div>\n                      </md-input-container>\n                    </div>\n                  </div>\n\n                  <div class=\"flex-row\">\n                    <div class=\"space-right\">\n                      Action\n                    </div>\n                    <div>\n                      <md-radio-group ng-model=\"ctrl.actionBoutonFermer\" ng-change=\"ctrl.updateButtonAction(ctrl.modale.modale.boutonFermer)\" class=\"flex-row\">\n                        <md-radio-button value=\"open\" class=\"space-right\">Ouvre une page</md-radio-button>\n                        <md-radio-button value=\"close\">Ferme la modale</md-radio-button>\n                      </md-radio-group>\n                    </div>\n                  </div>\n\n                  <div ng-if=\"ctrl.actionBoutonFermer === \'open\'\">\n                    <md-input-container>\n                        <label>URL</label>\n                        <input type=\"text\" ng-model=\"ctrl.modale.modale.boutonFermer.urlRedirection\" required>\n                    </md-input-container>\n                    <div class=\"flex-row\" style=\"align-items: center\">\n                      <div class=\"space-right\">\n                        Ouvrir dans un nouvel onglet\n                      </div>\n                      <div layout=\"row\">\n                        <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.modale.modale.boutonFermer.ouvrirOnglet = true\" ng-class=\"ctrl.modale.modale.boutonFermer.ouvrirOnglet === true ? \'md-primary\' : \'md-sample\'\">\n                          Oui\n                        </md-button>\n                        <md-button type=\"button\" class=\"md-raised button-abonnement\" ng-click=\"ctrl.modale.modale.boutonFermer.ouvrirOnglet = false\" ng-class=\"ctrl.modale.modale.boutonFermer.ouvrirOnglet === false ? \'md-primary\' : \'md-sample\'\">\n                          Non\n                        </md-button>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n\n              </div>\n              <!-- Bouton 2 fin -->\n\n            </div>\n\n          </div>\n          <!-- Boutons fin -->\n\n        </div>\n        <!-- MESSAGE fin -->\n\n      </div>\n      <!-- div form fin -->\n\n      <div class=\"actions-bar\" style=\"margin-top: 40px\">\n        <md-button ng-click=\"ctrl.retour()\" class=\"md-raised\">\n          Retour\n        </md-button>\n        <md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"!ctrl.isFormValid()\" ng-click=\"ctrl.publier()\">\n          Publier\n        </md-button>\n      </div>\n\n    </md-content>\n\n  </form>\n\n</div>");
$templateCache.put("app/admin/gestionModales/modalesList/modalesList.html","<div flex layout=\"column\" class=\"communication\">\n\n  <div class=\"title-bar\" layout=\"row\">\n    <h2>Gestion des modales - Liste</h2>\n  </div>\n\n  <div flex layout=\"column\" class=\"selection-abonnement\">\n    <md-content flex>\n      <div>\n\n        <adv-toolbar class=\"title-toolbar\" layout=\"row\">\n          <div flex layout=\"row\" layout-align=\"center\">\n            <div flex layout=\"row\" layout-align=\"start center\">\n              <h2>Modales\n                <span class=\"compteur\">&nbsp;({{ctrl.modalesListAffichees.length}} /\n                  {{ctrl.allModalesList.length}})</span>\n              </h2>\n            </div>\n            <div flex layout=\"row\" layout-align=\"end center\">\n              <md-button class=\"md-raised md-primary btn-valider\" ui-sref=\"app.admin.gestionModalesCreate({ mode: \'creation\' })\" style=\"margin-bottom: 20px\">\n                Créer une nouvelle modale\n              </md-button>\n            </div>\n            <div flex layout=\"row\" layout-align=\"end center\">\n              <adv-input-search class=\"input-search\" ng-model=\"ctrl.filter.search.value\"></adv-input-search>\n              <adv-souffleur-button show-souffleur=\"ctrl.showSouffleur\" filter=\"ctrl.filter\"></adv-souffleur-button>\n            </div>\n          </div>\n\n        </adv-toolbar>\n\n        <!-- header début -->\n        <md-subheader>\n          <adv-list-item adv-header adv-order=\"ctrl.order\" class=\"data-list-header\">\n            <div flex=\"10\" class=\"column\">\n              <div>\n                <!-- adv-order-by=\"code\" -->\n                <span adv-column adv-order-by=\"code\">Code</span>\n                <div>\n                  <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.code\">\n                    <input ng-model=\"ctrl.filter.souffleurs.code.value\" placeholder=\"Rechercher\" class=\"souffleur-input\">\n                  </adv-souffleur>\n                </div>\n              </div>\n            </div>\n            <div flex class=\"column\">\n              <div>\n                <span adv-column adv-order-by=\"titre\">Titre</span>\n                <div>\n                  <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.titre\">\n                    <input ng-model=\"ctrl.filter.souffleurs.titre.value\" placeholder=\"Rechercher\" class=\"souffleur-input\">\n                  </adv-souffleur>\n                </div>\n              </div>\n            </div>\n            <div flex=\"15\" class=\"column\">\n              <div>\n                <span adv-column adv-order-by=\"dateCreation\">Date de création</span>\n                <div>\n                  <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.dateCreation\" type=\"\'date\'\">\n                    <md-datepicker filter-date-picker ng-model=\"ctrl.filter.souffleurs.dateCreation.value\" md-placeholder=\"Entrer date\" md-hide-icons=\"calendar\" class=\"souffleur-input\"></md-datepicker>\n                  </adv-souffleur>\n                </div>\n              </div>\n            </div>\n            <div flex=\"15\" class=\"column\">\n              <div>\n                <span adv-column adv-order-by=\"debutAffichage\">Début d\'affichage</span>\n                <div>\n                  <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.debutAffichage\" type=\"\'date\'\">\n                    <md-datepicker filter-date-picker ng-model=\"ctrl.filter.souffleurs.debutAffichage.value\" md-placeholder=\"Entrer date\" md-hide-icons=\"calendar\" class=\"souffleur-input\"></md-datepicker>\n                  </adv-souffleur>\n                </div>\n              </div>\n            </div>\n            <div flex=\"15\" class=\"column\">\n              <div>\n                <span adv-column adv-order-by=\"finAffichage\">Fin d\'affichage</span>\n                <div>\n                  <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.finAffichage\" type=\"\'date\'\">\n                    <md-datepicker filter-date-picker ng-model=\"ctrl.filter.souffleurs.finAffichage.value\" md-placeholder=\"Entrer date\" md-hide-icons=\"calendar\" class=\"souffleur-input\"></md-datepicker>\n                  </adv-souffleur>\n                </div>\n              </div>\n            </div>\n            <div flex=\"10\" class=\"column\">\n            </div>\n          </adv-list-item>\n        </md-subheader>\n        <!-- header fin -->\n\n        <adv-list-item ng-if=\"ctrl.modalesListAffichees.length === 0 \" class=\"empty-list\">\n          Aucune modale\n        </adv-list-item>\n\n        <!-- rows début -->\n        <adv-list class=\"data-list-body stripped\">\n          <adv-list-item ng-repeat=\"modale in ctrl.modalesListAffichees | advOrderBy:ctrl.order | advStartFrom: ctrl.currentPage*ctrl.pageSize | limitTo:ctrl.pageSize\">\n            <div flex=\"10\">\n              {{ modale.code }}\n            </div>\n            <div flex>\n              {{ modale.titre }}\n            </div>\n            <div flex=\"15\">\n              {{ modale.dateCreation | date: \'dd/MM/yyyy HH:mm\'}}\n            </div>\n            <div flex=\"15\">\n              {{ modale.periodes[0].debut | date: \'dd/MM/yyyy HH:mm\'}}\n            </div>\n            <div flex=\"15\">\n              {{ modale.periodes[0].fin | date: \'dd/MM/yyyy HH:mm\'}}\n            </div>\n            <div flex=\"10\">\n              <md-icon md-svg-src=\"assets/images/icones/eye.svg\" ng-click=\"ctrl.editer(modale)\"></md-icon>\n              <md-icon md-svg-src=\"assets/images/icones/copy.svg\" ng-click=\"ctrl.dupliquer(modale)\"></md-icon>\n              <md-icon md-svg-src=\"assets/images/icones/ic_delete.svg\" ng-click=\"ctrl.supprimer(modale)\"></md-icon>\n            </div>\n\n          </adv-list-item>\n        </adv-list>\n        <!-- rows fin -->\n\n        <!-- footer tableau début -->\n        <div style=\"display: flex;justify-content: center;align-items: center\">\n          <button ng-disabled=\"ctrl.currentPage == 0\" ng-click=\"ctrl.currentPage=ctrl.currentPage-1\" class=\"md-raised md-primary md-button md-ink-ripple\">\n            Précédent\n          </button>\n          {{ctrl.currentPage+1}} / {{ctrl.numberOfPages()}}\n          <button ng-disabled=\"ctrl.currentPage >= ctrl.modalesListAffichees.length/ctrl.pageSize - 1\" ng-click=\"ctrl.currentPage=ctrl.currentPage+1\" class=\"md-raised md-primary md-button md-ink-ripple\">\n            Suivant\n          </button>\n          <md-input-container>\n            <md-select ng-model=\"ctrl.pageSize\" style=\"width: 50px\" aria-label=\"lignes\">\n              <md-option value=\"10\">10</md-option>\n              <md-option value=\"25\">25</md-option>\n              <md-option value=\"50\">50</md-option>\n            </md-select>\n          </md-input-container>\n        </div>\n        <!-- footer tableau début -->\n\n      </div>\n    </md-content>\n  </div>\n\n</div>");
$templateCache.put("app/admin/techniciens/affectation/affectation.html","<div flex layout=\"column\" class=\"admin-techniciens\">\n  <div class=\"title-bar\" layout=\"row\">\n    <h2>Affectation de cheptels</h2>\n  </div>\n    <div layout=\"row\" layout-align=\"end center\">\n      <md-button type=\"button\" class=\"md-raised md-primary btn-valider\" ui-sref=\"app.admin.techniciens.gestion\">Retour à la liste des techniciens</md-button>\n    </div>\n    <div layout=\"row\" layout-align=\"center center\">\n      <div layout=\"row\" layout-align=\"start center\">\n        <h3>Identifiant :&nbsp;</h3>\n        <span>{{ctrl.technicien.login}}</span>\n      </div>\n      <div style=\"width: 50px\"></div>\n      <div layout=\"row\" layout-align=\"start center\">\n        <h3>Email :&nbsp;</h3>\n        <span>{{ctrl.technicien.mail}}</span>\n      </div>\n    </div>\n    \n  <md-content flex>\n    <div flex class=\"listes-affectation-cheptels\" layout=\"row\">\n      <div flex layout=\"column\">\n        <form name=\"ctrl.affectationForm\" ng-submit=\"ctrl.ajoutCheptel(ctrl.saisieExploitation)\" novalidate layout=\"row\" layout-align=\"center start\" class=\"form-recherche-exploitation\">\n          <md-input-container>\n            <label>N° Exploitation</label>\n            <input name=\"numExploitation\" ng-model=\"ctrl.saisieExploitation\" ng-required=\"true\" autocomplete=\"off\">\n          </md-input-container>\n          <md-button type=\"submit\" class=\"md-raised md-primary btn-valider\" ng-disabled=\"ctrl.affectationForm.$invalid\">Ajouter</md-button>\n        </form>\n        <div class=\"error-message\" layout=\"row\" layout-align=\"center\" ng-if=\"ctrl.exploitationInconnue\">Exploitation inconnue</div>\n        <div class=\"error-message\" layout=\"row\" layout-align=\"center\" ng-if=\"ctrl.dejaAffecte\">Exploitation déjà affectée</div>\n      </div>\n      <div style=\"width: 25px\"></div>\n      <div flex layout=\"row\" layout-align=\"center start\">\n        <div flex>\n          <adv-toolbar class=\"title-toolbar details-abo cheptels-affectes-header\" layout=\"row\">\n            <div flex layout=\"row\" layout-align=\"center\">\n              <div flex layout=\"row\" layout-align=\"start center\">\n                <h2>Cheptels affectés ({{ ctrl.cheptelsAffectes.length }})</h2>\n              </div>\n              <div flex layout=\"row\" layout-align=\"end center\">\n                <adv-input-search class=\"input-search\" ng-model=\"ctrl.filterAffectes\"></adv-input-search>\n              </div>\n            </div>\n          </adv-toolbar>\n          <adv-list-item adv-header class=\"data-list-header cheptels-affectes-header header2\">\n            <div flex=\"45\" class=\"column\">\n              <span>N° Exploitation</span>\n            </div>\n            <div flex=\"45\" class=\"column\">\n              <span>Raison Sociale</span>\n            </div>\n            <div flex class=\"column\">\n            </div>\n          </adv-list-item>\n    \n          <adv-list class=\"data-list-body stripped\">\n            <adv-list-item ng-repeat=\"exploitation in ctrl.cheptelsAffectes\" ng-click=\"ctrl.supprimeCheptel(exploitation)\" ng-class=\"{\'disabled\':!ctrl.isOfCurrentDepartement(exploitation)}\">\n              <div flex=\"45\">\n                {{exploitation.numExploitation}}\n              </div>\n              <div flex=\"45\">\n                {{exploitation.raisonSociale}}\n              </div>\n              <div flex>\n                <md-icon md-svg-src=\"assets/images/icones/ic_delete.svg\"></md-icon>\n              </div>\n            </adv-list-item>\n          </adv-list>\n        </div>\n      </div>\n    </div>\n  </md-content>\n</div>");
$templateCache.put("app/admin/techniciens/creation/creation.html","<div flex layout=\"column\">\n  <div class=\"title-bar\" layout=\"row\">\n    <h2>Nouveau technicien</h2>\n  </div>\n  <md-content flex>\n    <form name=\"ctrl.rechercheForm\" ng-submit=\"ctrl.rechercheTechnicien()\" novalidate flex layout=\"column\">\n      <div class=\"selection-form\" layout=\"row\" layout-align=\"center\">\n        <div>\n          <md-input-container>\n            <label>Identifiant</label>\n            <input name=\"identifiant\" ng-model=\"ctrl.identifiant\" ng-required=\"true\">\n          </md-input-container>\n          <md-button type=\"submit\" class=\"md-raised md-primary btn-valider\" ng-disabled=\"ctrl.rechercheForm.$invalid\">Rechercher</md-button>\n        </div>\n      </div>\n    </form>\n\n    <form name=\"ctrl.detailsForm\" ng-submit=\"ctrl.ajoutTechnicien()\" ng-if=\"ctrl.afficheFormDetails\" novalidate flex layout=\"column\">\n      <div class=\"selection-form\" layout=\"row\" layout-align=\"center\">\n        <div>\n        <md-input-container>\n          <label>Email</label>\n          <input name=\"email\" ng-model=\"ctrl.saisieTechnicien.mail\" ng-required=\"true\">\n        </md-input-container>\n\n        <md-input-container>\n          <label>N° Tel. portable</label>\n          <input name=\"telMobile\" ng-model=\"ctrl.saisieTechnicien.telMobile\">\n        </md-input-container>\n        <md-button type=\"submit\" class=\"md-raised md-primary btn-valider\" ng-disabled=\"ctrl.detailsForm.$invalid\">Enregistrer</md-button>\n      </div>\n    </div></form>\n  </md-content>\n</div>");
$templateCache.put("app/admin/techniciens/gestion/gestion.html","<div flex layout=\"column\" class=\"admin-techniciens\">\n  <div class=\"title-bar\" layout=\"row\">\n    <h2>Techniciens</h2>\n  </div>\n  <form name=\"ctrl.searchTechniciensForm\" novalidate layout=\"column\" class=\"selection-form\">\n    <div layout=\"row\" layout-align=\"center center\">\n      <div>\n        <md-input-container>\n          <label>Identifiant</label>\n          <input name=\"identifiant\" ng-model=\"ctrl.searchIdentifiant\">\n        </md-input-container>\n      </div>\n      <div class=\"choixInfo\">\n        ou\n      </div>\n      <md-input-container>\n        <label>Email</label>\n        <input name=\"email\" ng-model=\"ctrl.searchEmail\">\n      </md-input-container>\n    </div>\n  </form>\n\n  <md-content flex>\n    <div ng-if=\"ctrl.afficheListeTechniciens\">\n      <adv-list-item adv-header class=\"data-list-header header-liste-tech\">\n        <div flex=\"45\" class=\"column\">\n          <span>Identifiant</span>\n        </div>\n        <div flex=\"45\" class=\"column\">\n          <span>Email</span>\n        </div>\n        <div flex=\"10\" class=\"column\">\n        </div>\n      </adv-list-item>\n\n      <adv-list-item ng-if=\" ctrl.listeTechniciensFiltree.length === 0 \" class=\"empty-list\">\n        Aucun technicien ne correspond avec votre filtre.\n      </adv-list-item>\n\n      <adv-list class=\"data-list-body stripped\">\n        <adv-list-item ng-repeat=\"technicien in ctrl.listeTechniciensFiltree\" ng-click=\"ctrl.goToAffectations(technicien)\" class=\"item-liste-techniciens\">\n          <div flex=\"45\">\n            {{technicien.login}}\n          </div>\n          <div flex=\"45\">\n            {{technicien.mail}}\n          </div>\n          <div flex=\"10\">\n            <md-icon md-svg-src=\"assets/images/icones/ic_delete.svg\" ng-click=\"$event.stopPropagation(); ctrl.suppressionTechnicien(technicien)\"></md-icon>\n          </div>\n        </adv-list-item>\n      </adv-list>\n    </div>\n  </md-content>\n</div>");
$templateCache.put("app/auth/_common/popupLoginSynel/popupLoginSynel.html","<md-dialog>\n    <md-toolbar class=\"md-toolbar-tools\">\n      <h2>Abonnement Pilot\'Elevage</h2>\n    </md-toolbar>\n  \n    <form name=\"fromSynel\" ng-submit=\"fromSynel.$valid && ctrl.confirm(loginSynel)\">\n      <md-dialog-content class=\"md-dialog-content\">\n        <p>Pour continuer, veuillez saisir votre identifiant SYNel</p>\n        <md-input-container>\n          <input name=\"loginSynel\" ng-model=\"loginSynel\" required placeholder=\"login\">\n        </md-input-container>\n      </md-dialog-content>\n    \n      <md-dialog-actions>\n        <md-button ng-click=\"ctrl.cancel()\" class=\"md-raised\">Annuler</md-button>\n        <md-button type=\"submit\" class=\"md-raised md-primary\">Confirmer</md-button>\n      </md-dialog-actions>\n    </form>\n  </md-dialog>");
$templateCache.put("app/eleveur/bovin/home/home.html","<div flex layout=\"column\" class=\"home\">\n  <md-content flex>\n    <div layout=\"column\" layout-align=\"start center\">\n      <div layout=\"row\" layout-align=\"center\">\n        <div layout=\"column\">\n          <div layout=\"row\">\n            <adv-favoris></adv-favoris>\n            <adv-dossier-animal></adv-dossier-animal>\n          </div>\n          <adv-alerte></adv-alerte>\n        </div>\n        \n        <!-- <adv-actualites></adv-actualites> -->\n      </div>\n    </div>\n  </md-content>\n</div>");
$templateCache.put("app/eleveur/bovin/main/main.html","<!-- max-height pour firefox - cf. #31154 -->\n<div class=\"bovin {{ctrl.getOrientation()}}\" style=\"max-height: 100%\">\n  <adv-menu menu=\"ctrl.menu\" orientation=\"ctrl.getOrientation()\" type=\"\'bov\'\"></adv-menu>\n  <ui-view flex layout=\"column\" class=\"main-view\"></ui-view>\n</div>");
$templateCache.put("app/eleveur/compte/compte/compte.html","<div flex layout=\"column\" class=\"compte-abonnement\">\n  <adv-toolbar class=\"title-toolbar\">\n    <div class=\"item\" ng-repeat=\"onglet in ctrl.onglets\" ng-class=\"{active: ctrl.onglet === onglet.libelle}\">\n      <button type=\"button\" class=\"adv-button\" ng-click=\"ctrl.changeOnglet(onglet.libelle)\">{{onglet.libelle}}</button>\n    </div>\n  </adv-toolbar>\n  <div flex layout=\"column\" ng-switch=\"ctrl.onglet\">\n    <div flex layout=\"column\" ng-switch-when=\"services\">\n      <div layout=\"column\" ng-include=\"\'app/eleveur/compte/compte/templates/services.html\'\" flex></div>\n    </div>\n    <div flex layout=\"column\" ng-switch-when=\"options\">\n      <div layout=\"column\" ng-include=\"\'app/_common/partials/options/options.html\'\" flex></div>\n    </div>\n    <div flex layout=\"column\" ng-switch-when=\"informations\">\n      <div layout=\"column\" ng-include=\"\'app/eleveur/compte/compte/templates/informations.html\'\" flex></div>\n    </div>\n    <div flex layout=\"column\" ng-switch-when=\"autorisations d\'accès\">\n      <div layout=\"column\" ng-include=\"\'app/_common/partials/autorisationsAcces/autorisationsAcces.html\'\" ng-controller=\"AutorisationsAccesController as ctrl\" flex></div>\n    </div>\n    <div flex layout=\"column\" ng-switch-when=\"facturation\">\n      <div layout=\"column\" ng-include=\"\'app/_common/partials/facturation/facturation.html\'\" ng-controller=\"FacturationController as ctrl\" flex></div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/eleveur/compte/main/main.html","<div flex layout=\"raw\" class=\"compte\">\n  <div flex layout=\"column\">\n    <div class=\"title-bar\" layout=\"raw\">\n      <h2 flex-gt-sm=\"30\">Mon compte</h2>\n      <div flex-gt-sm=\"30\"></div>\n      <div flex-gt-sm=\"30\"></div>\n    </div>\n\n    <ui-view flex layout=\"column\"></ui-view>\n  </div>\n</div>");
$templateCache.put("app/eleveur/woc/home/home.html","<div flex layout=\"column\" class=\"home\">\n  <md-content flex>\n    <div layout=\"column\" layout-align=\"start center\">\n      <div layout=\"row\" layout-align=\"center\">\n        <div layout=\"column\">\n          <div layout=\"row\">\n          </div>\n          <adv-alerte></adv-alerte>\n        </div>\n        <!-- <adv-actualites></adv-actualites> -->\n      </div>\n    </div>\n  </md-content>\n</div>");
$templateCache.put("app/eleveur/woc/main/main.html","<div flex layout=\"column\">\n  <adv-menu menu=\"ctrl.menu\" orientation=\"\'horizontal\'\" type=\"\'woc\'\"></adv-menu>\n  <ui-view flex layout=\"column\"></ui-view>\n</div>");
$templateCache.put("app/nouvelAbonnement/informations/dejaAbonne/dejaAbonne.html","<md-dialog aria-label=\"deja-abonne\">\n\n  <md-dialog-content>\n    <div class=\"md-dialog-content\">\n      <p>\n        Il existe déjà un abonnement actif à Pilot\'Elevage pour votre exploitation. Veuillez-vous connecter avec votre identifiant\n        : {{ctrl.login}}. Si vous avez perdu votre mot de passe associé, vous pouvez en demander un nouveau en cliquant sur\n        <a class=\"light-link\" ng-click=\"ctrl.goToPerteMdp()\">Mot de passe oublié ?</a> sur le site Pilot\'Elevage.\n      </p>\n    </div>\n\n  </md-dialog-content>\n\n  <md-dialog-actions layout=\"row\">\n    <md-button class=\"md-raised md-primary\" ng-click=\"ctrl.close()\">\n      Ok\n    </md-button>\n  </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/partials/options/optionTemplates/datahub.html","<div layout=\"column\" class=\"notifiaction-margin-top\">\n    <form name=\"ctrl.datahubForm\" novalidate flex layout=\"column\">\n        <div layout=\"column\">\n            <div layout=\"column\" flex=\"33\" ng-repeat=\"donnee in option.optionDonneesComplementaires\">\n                <div ng-if=\"donnee.libelle == \'N° de téléphone à contacter\'\">\n                    <md-input-container>\n                        <label>{{donnee.libelle}} : </label>\n                        <input class=\"input-width\" ng-model=\"donnee.valeur\" type=\"text\" name=\"telephone\" ng-pattern=\"/^(06|07) [0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}$/\" ui-mask=\"?9?9 ?9?9 ?9?9 ?9?9 ?9?9\" ui-mask-placeholder=\"\" ui-mask-placeholder-char=\"space\" required>\n                        <div ng-messages=\"ctrl.datahubForm.telephone.$error\" role=\"alert\" class=\"input-width\">\n                        <div ng-message=\"required\">La saisie de votre numéro de téléphone est\n                            obligatoire.</div>\n                        <div ng-message=\"pattern\">Le N° de téléphone portable doit commencer par 06\n                            ou 07.</div>\n                    </div>\n                    </md-input-container>\n                </div>\n                <div ng-if=\"donnee.libelle == \'Type de matériel\'\">\n                    <md-input-container layout=\"column\">\n                        <div layout=\"row\">\n                          <label>{{donnee.libelle}} : </label>\n                          <md-select ng-model=\"donnee.valeur\" required>\n                            <md-option value=\"Robot\">Robot</md-option>\n                            <md-option value=\"SalleDeTraite\">Salle de traite</md-option>\n                            <md-option value=\"DAC\">DAC</md-option>\n                            <md-option value=\"Autre\">Autre</md-option>\n                          </md-select>\n                        </div>\n                    </md-input-container>\n                </div>\n                <div ng-if=\"donnee.libelle == \'Marque\'\">\n                    <md-input-container layout=\"column\">\n                        <div layout=\"row\">\n                          <label>{{donnee.libelle}} : </label>\n                          <md-select ng-model=\"donnee.valeur\" required>\n                            <md-option value=\"AFIMILK\">AFIMILK</md-option>\n                            <md-option value=\"BOUMATIC\">BOUMATIC</md-option>\n                            <md-option value=\"DELAVAL\">DELAVAL</md-option>\n                            <md-option value=\"GEA\">GEA</md-option>\n                            <md-option value=\"LELY\">LELY</md-option>\n                            <md-option value=\"PACKO-FULLWOOD\">PACKO-FULLWOOD</md-option>\n                            <md-option value=\"SAC\">SAC</md-option>\n                            <md-option value=\"Autre\">Autre</md-option>\n                          </md-select>\n                        </div>\n                    </md-input-container>\n                </div>\n            </div>\n            <div class=\"texte-juridique\">\n                <p>Pilot’Elevage collecte le n° de téléphone pour permettre à un technicien de vous recontacter et rendre possible l’activation de cette option, pour plus d’informations consultez la Politique de Confidentialité de Pilot’Elevage.</p>\n            </div>\n        </div>\n        <div layout=\"row\" layout-align=\"end center\" ng-show=\"ctrl.monCompte\">\n            <md-button type=\"submit\" ng-click=\"ctrl.enregistrerOptionDatahub(option)\" class=\"md-raised md-primary\" ng-disabled=\"!ctrl.formDataHubValid\">Confirmer la demande\n            </md-button>\n        </div>\n    </form>\n</div>");
$templateCache.put("app/_common/partials/options/optionTemplates/test.html","<div layout=\"column\" class=\"notifiaction-margin-top\">\n    <form name=\"ctrl.templateForm\" novalidate flex layout=\"column\">\n        <div layout=\"column\">\n            <div layout=\"column\" flex=\"33\" ng-repeat=\"donnee in option.optionDonneesComplementaires\">\n                <md-input-container>\n                    <label>{{donnee.libelle}}</label>\n                    <input class=\"input-width\" ng-model=\"donnee.valeur\" type=\"text\" required>\n                </md-input-container>\n            </div>\n            <div layout=\"row\" layout-align=\"end center\" ng-show=\"ctrl.monCompte\">\n                <md-button type=\"submit\" ng-click=\"ctrl.enregistrerOption(option)\" class=\"md-raised md-primary\" ng-disabled=\"ctrl.templateForm.$invalid\">Enregistrer\n                </md-button>\n            </div>\n        </div>\n    </form>\n</div>");
$templateCache.put("app/admin/clotureAbonnement/_common/resiliation/resiliation.html","<md-dialog aria-label=\"resiliation\" class=\"resiliation\">\n  <md-toolbar>\n    <div class=\"md-toolbar-tools\">\n      <h2 ng-if=\"ctrl.abonnement\">Résilier l\'abonnement : {{ctrl.abonnement.typeAbonnement}}\n        {{ctrl.abonnement.niveauAbonnement}}</h2>\n      <h2 ng-if=\"!ctrl.abonnement\">Clotûrer le compte</h2>\n\n      <div flex></div>\n      <md-button class=\"md-icon-button\" ng-click=\"ctrl.cancel()\">\n        <md-icon md-svg-src=\"assets/images/icones/close.svg\" aria-label=\"close\"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-dialog-content flex class=\"md-dialog-content\" style=\"padding-bottom: 0; padding-top: 20px\">\n    <div class=\"md-dialog-content-body\" layout=\"row\">\n      <md-calendar class=\"fixed-calendar\" ng-model=\"ctrl.dateCloture\" md-date-locale=\"locale\"></md-calendar>\n      <div layout=\"column\" class=\"raison\">\n\n        <md-radio-group ng-model=\"ctrl.raisonChoix\">\n          <md-radio-button ng-repeat=\"raison in ctrl.raisonsResiliations\" value=\"{{raison.libelle}}\">\n            {{raison.libelle}}</md-radio-button>\n          <md-radio-button value=\"AUTRE\">Autre raison </md-radio-button>\n        </md-radio-group>\n        <md-input-container ng-if=\"ctrl.raisonChoix===\'AUTRE\'\" style=\"margin: 0\">\n          <textarea name=\"raison\" ng-model=\"ctrl.commentaireLibre\" maxlength=\"400\"></textarea>\n        </md-input-container>\n       \n        <div layout=\"row\" ng-show=\"ctrl.error\" class=\"error_width\">\n          <md-icon md-svg-src=\"assets/images/icones/ic_error.svg\" class=\"icone\"></md-icon>\n          <p>{{ctrl.error}}</p>\n        </div>\n      </div>\n    </div>\n  </md-dialog-content>\n\n  <md-dialog-actions>\n    <div layout=\"column\" style=\"align-items: flex-end\">\n      <div layout=\"row\" ng-show=\"ctrl.dernierAbonnement\">\n        <md-icon md-svg-src=\"assets/images/icones/ic_warning.svg\" aria-label=\"warning\" class=\"icone\" style=\"margin: 0\"></md-icon>\n        <p class=\"dernier-abo\" style=\"margin: 0\">Il s\'agit du dernier abonnement actif du compte. La résiliation va clôturer le compte.\n        </p>\n      </div>\n      <div layout=\"row\">\n        <md-button ng-click=\"ctrl.cancel()\" class=\"md-raised\">Annuler</md-button>\n        <md-button ng-click=\"ctrl.confirm()\" class=\"md-raised md-primary\" ng-if=\"!ctrl.dernierAbonnement\" ng-disabled=\"ctrl.error\">Confirmer</md-button>\n        <md-button ng-click=\"ctrl.confirmCloture()\" class=\"md-raised md-primary\" ng-if=\"ctrl.dernierAbonnement\" ng-disabled=\"ctrl.error\">Confirmer et clôturer le compte</md-button>\n      </div>\n     \n    </div>\n   \n  </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/admin/gestionAbonnement/detail/templates/informations.html","<div flex layout=\"column\" class=\"informations-details\">\n  <form name=\"ctrl.contactForm\" ng-submit=\"ctrl.gotoSelection()\" novalidate flex layout=\"column\" class=\"form-informations\" ng-if=\"ctrl.infosAbonnement.identifiant\">\n    <md-content flex>\n      <div layout=\"row\" flex class=\"content-infos\" layout-align=\"center start\">\n        <div layout=\"row\" flex=\"50\" layout-align=\"center start\">\n          \n          <div flex=\"90\" layout=\"column\" layout-align=\"start start\">\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Identifiant OpenAM\n                </div>\n              <div class=\"value\">\n                {{ctrl.infosAbonnement.identifiant}}\n              </div>\n            </div>\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Profil\n              </div>\n              <div class=\"value\">\n                {{ctrl.infosAbonnement.profil}}\n              </div>\n            </div>\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                N° Exploitation\n              </div>\n              <div class=\"value\">\n                {{ctrl.infosAbonnement.numExploitation}}\n              </div>\n            </div>\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                N° détenteur\n              </div>\n              <div class=\"value\">\n                {{ctrl.infosAbonnement.numDetenteur}}\n              </div>\n            </div>\n            <div class=\"recap-item\" ng-if=\"ctrl.infosAbonnement.numSiren\">\n                <div class=\"label\">\n                  N° Siren\n                </div>\n                <div class=\"value\">\n                  {{ctrl.infosAbonnement.numSiren}}\n                </div>\n              </div>\n              <div class=\"recap-item\" ng-if=\"ctrl.infosAbonnement.numagrin\">\n                <div class=\"label\">\n                  N° Numagrin\n                </div>\n                <div class=\"value\">\n                  {{ctrl.infosAbonnement.numagrin}}\n                </div>\n              </div>\n          </div>\n        </div>\n        <div layout=\"column\" flex=\"50\" layout-align=\"center start\">\n          <md-input-container class=\"header-margin\">\n            <label>Raison sociale</label>\n            <input name=\"raisonSociale\" aria-label=\"raisonSociale\" ng-model=\"ctrl.infosAbonnement.raisonSociale\" type=\"text\" autocomplete=\"off\" required>\n            <div ng-messages=\"ctrl.contactForm.raisonSociale.$error\" role=\"alert\">\n              <div ng-message=\"required\">Donnée obligatoire</div>\n            </div>\n          </md-input-container>\n          <md-input-container ng-show=\"ctrl.infosAbonnement.raisonSociale !== ctrl.origineRaisonSociale\">\n            <label>Confirmation Raison sociale</label>\n            <input name=\"confirmRaisonSociale\" aria-label=\"confirmRaisonSociale\" ng-paste=\"$event.preventDefault()\" ng-copy=\"$event.preventDefault()\" autocomplete=\"off\" ng-model=\"ctrl.confirmRaisonSociale\" type=\"text\" ng-required=\"ctrl.infosAbonnement.raisonSociale !== ctrl.origineRaisonSociale\">\n            <div ng-messages=\"ctrl.contactForm.confirmRaisonSociale.$error\" role=\"alert\">\n              <div ng-message=\"required\">Donnée obligatoire</div>\n            </div>\n          </md-input-container>\n          <br>\n          <md-input-container class=\"adresse\">\n            <label class=\"md-required\">Adresse</label>\n            <input name=\"adresse\" aria-label=\"adresse\" ng-model=\"ctrl.infosAbonnement.adresse.adress\" type=\"text\" autocomplete=\"off\">\n          </md-input-container>\n          <md-input-container class=\"adresse\">\n            <input name=\"complementAdresse\" aria-label=\"complementAdresse\" ng-model=\"ctrl.infosAbonnement.adresse.complementAdresse\" type=\"text\" autocomplete=\"off\">\n          </md-input-container>\n          <div layout=\"row\" class=\"footer-margin\">\n            <md-input-container class=\"adresse\">\n              <input id=\"codePostal\" name=\"codePostal\" aria-label=\"codePostal\" ng-model=\"ctrl.infosAbonnement.adresse.codePostal\" type=\"text\" required ng-pattern=\"/^(\\d{5}(-\\d{4})?|[A-Z]\\d[A-Z] *\\d[A-Z]\\d)$/\" autocomplete=\"off\">\n              <div ng-messages=\"ctrl.contactForm.codePostal.$error\" role=\"alert\">\n                <div ng-message=\"required\">Donnée obligatoire</div>\n                <div ng-message=\"pattern\">Donnée invalide</div>\n              </div>\n            </md-input-container>\n            <md-input-container class=\"adresse\">\n              <input id=\"ville\" name=\"ville\" aria-label=\"ville\" ng-model=\"ctrl.infosAbonnement.adresse.ville\" type=\"text\" required>\n              <div ng-messages=\"ctrl.contactForm.ville.$error\" role=\"alert\" autocomplete=\"off\">\n                <div ng-message=\"required\">Donnée obligatoire</div>\n              </div>\n            </md-input-container>\n          </div>\n        \n          <div layout=\"column\" flex=\"50\" ng-show=\"ctrl.adressUpdated()\" class=\"footer-margin\">\n            <md-input-container class=\"adresse\">\n              <label class=\"md-required\">Confirmation adresse</label>\n              <input name=\"confirmAdresse\" aria-label=\"confirmAdresse\" ng-model=\"ctrl.confirmAdresse\" type=\"text\" ng-paste=\"$event.preventDefault()\" ng-copy=\"$event.preventDefault()\" autocomplete=\"off\">\n            </md-input-container>\n            <md-input-container class=\"adresse\">\n              <input name=\"confirmComplementAdresse\" aria-label=\"confirmComplementAdresse\" ng-model=\"ctrl.confirmComplementAdresse\" type=\"text\" ng-paste=\"$event.preventDefault()\" ng-copy=\"$event.preventDefault()\" autocomplete=\"off\">\n            </md-input-container>\n            <div layout=\"row\">\n              <md-input-container class=\"adresse\">\n                <input id=\"confirmCodePostal\" name=\"confirmCodePostal\" aria-label=\"confirmCodePostal\" ng-model=\"ctrl.confirmCodePostal\" type=\"text\" ng-required=\"ctrl.confirmAdressRequired()\" ng-pattern=\"/^(\\d{5}(-\\d{4})?|[A-Z]\\d[A-Z] *\\d[A-Z]\\d)$/\" ng-paste=\"$event.preventDefault()\" ng-copy=\"$event.preventDefault()\" autocomplete=\"off\">\n                <div ng-messages=\"ctrl.contactForm.confirmCodePostal.$error\" role=\"alert\">\n                  <div ng-message=\"required\">Donnée obligatoire</div>                  \n                  <div ng-message=\"pattern\">Donnée invalide</div>\n                </div>\n              </md-input-container>\n              <md-input-container class=\"adresse\">\n                <input id=\"confirmVille\" name=\"confirmVille\" aria-label=\"confirmVille\" ng-model=\"ctrl.confirmVille\" type=\"text\" ng-required=\"ctrl.confirmAdressRequired()\" ng-paste=\"$event.preventDefault()\" ng-copy=\"$event.preventDefault()\" autocomplete=\"off\">\n                <div ng-messages=\"ctrl.contactForm.confirmVille.$error\" role=\"alert\">\n                  <div ng-message=\"required\">Donnée obligatoire</div>\n                </div>\n              </md-input-container>\n            </div>\n          </div>\n        </div>\n        <div layout=\"column\" flex=\"50\" layout-align=\"center start\">\n          <md-input-container class=\"header-margin\" ng-if=\"!ctrl.infosAbonnement.autorisationsAccesExist\">\n            <label>Email</label>\n            <input name=\"email\" aria-label=\"email\" ng-model=\"ctrl.contact.mail\" type=\"email\" autocomplete=\"off\" ng-pattern=\"/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$/\" required>\n            <div ng-messages=\"ctrl.contactForm.email.$error\" role=\"alert\">\n              <div ng-message=\"pattern\">Donnée invalide</div>\n            </div>\n          </md-input-container>\n\n          <md-input-container ng-show=\"ctrl.contact.mail !== ctrl.origineContact.mail\" ng-if=\"!ctrl.infosAbonnement.autorisationsAccesExist\">\n            <label>Confirmation Email</label>\n            <input name=\"confirmMail\" aria-label=\"confirmMail\" ng-paste=\"$event.preventDefault()\" ng-copy=\"$event.preventDefault()\" autocomplete=\"off\" ng-model=\"ctrl.confirmMail\" type=\"email\" ng-pattern=\"/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$/\" ng-required=\"ctrl.contact.mail !== ctrl.origineContact.mail\">\n            <div ng-messages=\"ctrl.contactForm.confirmMail.$error\" role=\"alert\">\n              <div ng-message=\"required\">Donnée obligatoire</div>\n              <div ng-message=\"pattern\">Donnée invalide</div>\n            </div>\n          </md-input-container>\n\n          <md-input-container ng-if=\"!ctrl.infosAbonnement.autorisationsAccesExist\">\n            <label>N° Tel. portable</label>\n            <input name=\"telMobile\" ng-model=\"ctrl.contact.telMobile\" type=\"text\" ng-pattern=\"/^(06|07) [0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}$/\" ui-mask=\"?9?9 ?9?9 ?9?9 ?9?9 ?9?9\" ui-mask-placeholder=\"\" ui-mask-placeholder-char=\"space\" autocomplete=\"off\">\n            <div ng-messages=\"ctrl.contactForm.telMobile.$error\" role=\"alert\">\n              <div ng-message=\"pattern\">Le N° de téléphone portable doit commencer par 06 ou 07.</div>\n            </div>\n          </md-input-container>\n          <div ng-if=\"ctrl.infosAbonnement.autorisationsAccesExist\">\n            Email et n° de Tel Portable visibles dans le\n              module “Gestion des autorisations d’accès”</div>\n          <md-input-container>\n            <label>N° Tel. fixe</label>\n            <input name=\"telFixe\" ng-model=\"ctrl.contact.telFixe\" type=\"text\" ng-pattern=\"/^[0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}$/\" ui-mask=\"?9?9 ?9?9 ?9?9 ?9?9 ?9?9\" ui-mask-placeholder=\"\" ui-mask-placeholder-char=\"space\" autocomplete=\"off\">\n            <div ng-messages=\"ctrl.contactForm.telFixe.$error\" role=\"alert\">\n              <div ng-message=\"pattern\">Donnée invalide</div>\n            </div>\n          </md-input-container>\n        </div>\n      \n      </div>\n    </md-content>\n    <div class=\"actions-bar\">\n      <md-button type=\"button\" ui-sref=\"app.admin.gestionAbonnement.selection\" class=\"md-raised md-primary\">Retour</md-button>\n      <md-button type=\"submit\" class=\"md-raised md-primary\">Valider</md-button>\n    </div>\n  </form>\n</div>");
$templateCache.put("app/admin/gestionAbonnement/detail/templates/services.html","<div flex layout=\"column\" class=\"selection-abonnement\">\n  <md-content flex>\n    <div>\n      <adv-toolbar class=\"title-toolbar details-abo\" layout=\"row\">\n        <div flex layout=\"row\" layout-align=\"center\">\n          <div flex layout=\"row\" layout-align=\"start center\">\n            <h2>Abonnements et exploitations autorisées\n              <span class=\"compteur\">&nbsp;({{ctrl.listAbonnementsAffiches.length}})</span>\n            </h2>\n          </div>\n          <div flex layout=\"row\" layout-align=\"end center\">\n            <adv-input-search class=\"input-search\" ng-model=\"ctrl.filter.search.value\"></adv-input-search>\n            <adv-souffleur-button show-souffleur=\"ctrl.showSouffleur\" filter=\"ctrl.filter\"></adv-souffleur-button>\n\n            <a ng-click=\"ctrl.exportToExcel()\" aria-label=\"exportExcel\" class=\"md-icon-button\">\n              <md-icon md-svg-src=\"assets/images/icones/excel.svg\"></md-icon>\n            </a>\n          </div>\n        </div>\n      </adv-toolbar>\n      <md-subheader>\n        <adv-list-item adv-header adv-order=\"ctrl.order\" class=\"data-list-header\">\n          <div flex=\"10\" class=\"colunm\">\n            <div>\n              <span adv-column adv-order-by=\"numExploitation\">Exploitation</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.numExploitation\">\n                  <input ng-model=\"ctrl.filter.souffleurs.numExploitation.value\" placeholder=\"Rechercher\" class=\"souffleur-input\">\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"20\" class=\"column\">\n            <div>\n              <span adv-column adv-order-by=\"numDetenteur\">Détenteur</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.numDetenteur\">\n                  <input ng-model=\"ctrl.filter.souffleurs.numDetenteur.value\" placeholder=\"Rechercher\" class=\"souffleur-input\">\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"15\" class=\"column\">\n            <div>\n              <span adv-column adv-order-by=\"typeAbonnement.code\">Type</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.typeAbonnement\" type=\"\'multiple\'\">\n                  <md-select md-selected-text=\"ctrl.getSelectedText(ctrl.filter.souffleurs.typeAbonnement.value)\" ng-model=\"ctrl.filter.souffleurs.typeAbonnement.value\" multiple=\"true\" aria-label=\"typeAbonnement\" placeholder=\"Définir\" class=\"souffleur-input\">\n                    <md-option ng-value=\"typeAbonnement\" ng-repeat=\"typeAbonnement in ctrl.types track by typeAbonnement.code\">{{typeAbonnement.libelle}}</md-option>\n                  </md-select>\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"10\" class=\"column\" ng-hide=\"ctrl.listActifs\">\n            <div>\n              <span adv-column adv-order-by=\"niveau.code\">Niveau</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.niveau\" type=\"\'multiple\'\">\n                  <md-select md-selected-text=\"ctrl.getSelectedText(ctrl.filter.souffleurs.niveau.value)\" ng-model=\"ctrl.filter.souffleurs.niveau.value\" multiple=\"true\" aria-label=\"niveau\" placeholder=\"Définir\" class=\"souffleur-input\">\n                    <md-option ng-value=\"niveau\" ng-repeat=\"niveau in ctrl.niveaux track by niveau.code\">{{niveau.libelle}}</md-option>\n                  </md-select>\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"15\" class=\"column\">\n            <div>\n              <span adv-column adv-order-by=\"dateDebut\">Début</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.dateDebut\" type=\"\'date\'\">\n                  <md-datepicker filter-date-picker ng-model=\"ctrl.filter.souffleurs.dateDebut.value\" md-placeholder=\"Entrer date\" md-hide-icons=\"calendar\" class=\"souffleur-input\"></md-datepicker>\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"15\" class=\"column\">\n            <div>\n              <span adv-column adv-order-by=\"dateFin\">Fin</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.dateFin\" type=\"\'date\'\">\n                  <md-datepicker filter-date-picker ng-model=\"ctrl.filter.souffleurs.dateFin.value\" md-placeholder=\"Entrer date\" md-hide-icons=\"calendar\" class=\"souffleur-input\"></md-datepicker>\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n          <div flex=\"15\" class=\"column\">\n            <div>\n              <span adv-column adv-order-by=\"dateFinDifferee\">Date fin différée</span>\n              <div>\n                <adv-souffleur ng-if=\"ctrl.showSouffleur\" ng-model=\"ctrl.filter.souffleurs.dateFinDifferee\" type=\"\'date\'\">\n                  <md-datepicker filter-date-picker ng-model=\"ctrl.filter.souffleurs.dateFinDifferee.value\" md-placeholder=\"Entrer date\" md-hide-icons=\"calendar\" class=\"souffleur-input\"></md-datepicker>\n                </adv-souffleur>\n              </div>\n            </div>\n          </div>\n        </adv-list-item>\n      </md-subheader>\n\n      <adv-list-item ng-if=\" ctrl.listAbonnementsAffiches.length === 0 \" class=\"empty-list\">\n        Aucun abonnement\n      </adv-list-item>\n\n      <adv-list class=\"data-list-body stripped\">\n        <adv-list-item ng-repeat=\"abonnement in ctrl.listAbonnementsAffiches| advOrderBy:ctrl.order\">\n          <div flex=\"10\">\n            {{abonnement.numExploitation}}\n          </div>\n          <div flex=\"20\">\n            {{abonnement.raisonSociale}} - {{abonnement.numDetenteur}}\n          </div>\n          <div flex=\"15\">\n            {{abonnement.typeAbonnement ? abonnement.typeAbonnement.libelle : \'-\'}}\n          </div>\n          <div flex=\"10\">\n            {{abonnement.niveau ? abonnement.niveau.libelle : \'-\'}}\n          </div>\n          <div flex=\"15\">\n            {{abonnement.dateDebut | date: \'dd/MM/yyyy\'}}\n          </div>\n          <div flex=\"15\">\n            {{abonnement.dateFin | date: \'dd/MM/yyyy\'}}\n          </div>\n          <div flex=\"15\">\n            {{abonnement.dateFinDifferee | date: \'dd/MM/yyyy\'}}\n          </div>\n        </adv-list-item>\n      </adv-list>\n    </div>\n  </md-content>\n  <div class=\"actions-bar\">\n    <md-button type=\"button\" ui-sref=\"app.admin.gestionAbonnement.selection\" class=\"md-raised md-primary\">Retour</md-button>\n  </div>\n</div>");
$templateCache.put("app/admin/multicheptels/_common/selectionExploitation/selectionExploitation.html","<md-dialog aria-label=\"multicheptels\" flex layout=\"column\" class=\"selection-exploitation\">\n  <md-toolbar>\n    <div class=\"md-toolbar-tools\">\n      <h2 ng-if=\"!ctrl.afficheInfosExploitation\">Sélection du cheptel à ajouter</h2>\n      <h2 ng-if=\"ctrl.afficheInfosExploitation\">Confirmation du cheptel à ajouter</h2>\n      <div flex></div>\n      <md-button class=\"md-icon-button\" ng-click=\"ctrl.close()\">\n        <md-icon md-svg-src=\"assets/images/icones/close.svg\" aria-label=\"close\"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content flex class=\"md-dialog-content\">\n    <div class=\"md-dialog-content-body\" layout=\"row\" ng-if=\"!ctrl.afficheInfosExploitation\">\n      <form name=\"ctrl.authentForm\" ng-submit=\"ctrl.openListAbonnements()\" novalidate flex layout=\"column\">\n        <div class=\"selection-form\" layout=\"row\" layout-align=\"center\">\n          <div>\n            <h4 class=\"codePays\">FR</h4>\n            <md-input-container>\n              <label>N° Exploitation</label>\n              <input name=\"numExploitation\" ng-model=\"ctrl.numExploitation\" ng-required=\"!ctrl.identifiant\">\n            </md-input-container>\n          </div>\n          <div class=\"choixInfo\">\n            ou\n          </div>\n          <md-input-container>\n            <label>Identifiant</label>\n            <input name=\"identifiant\" ng-model=\"ctrl.identifiant\" ng-required=\"!ctrl.numExploitation\">\n          </md-input-container>\n          <md-button type=\"submit\" class=\"md-raised md-primary btn-valider\" ng-disabled=\"ctrl.authentForm.$invalid\">Valider</md-button>\n          <md-button ng-click=\"ctrl.close()\" class=\"md-raised btn-annuler\">Annuler</md-button>\n        </div>\n      </form>\n    </div>\n    <div class=\"error-message\" layout=\"row\" layout-align=\"center\" ng-if=\"ctrl.exploitationInconnue\">Exploitation inconnue</div>\n    <div ng-if=\"ctrl.afficheInfosExploitation\">\n\n      <div>\n        <div class=\"recapitulatif\">\n          <div flex=\"50\">\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Identifiant\n              </div>\n              <div class=\"value\">\n                {{ctrl.exploitation.infoIdentifiant}}\n              </div>\n            </div>\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                N° Exploitation\n              </div>\n              <div class=\"value\">\n                {{ctrl.exploitation.infoNumExploitation}}\n              </div>\n            </div>\n            <div class=\"recap-item\" ng-if=\"!ctrl.exploitation.numAgrin\">\n              <div class=\"label\">\n                N° Siren\n              </div>\n              <div class=\"value\">\n                {{ctrl.exploitation.numSiren}}\n              </div>\n            </div>\n            <div class=\"recap-item\" ng-if=\"!ctrl.exploitation.numSiren\">\n              <div class=\"label\">\n                N° Numagrin\n              </div>\n              <div class=\"value\">\n                {{ctrl.exploitation.numagrin}}\n              </div>\n            </div>\n          </div>\n          <div flex=\"50\">\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Profil\n              </div>\n              <div class=\"value\">\n                {{ctrl.exploitation.profil}}\n              </div>\n            </div>\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Numéro du détenteur\n              </div>\n              <div class=\"value\">\n                {{ctrl.exploitation.numDetenteur}}\n              </div>\n            </div>\n            <div class=\"recap-item\">\n              <div class=\"label\">\n                Raison Sociale\n              </div>\n              <div class=\"value\">\n                {{ctrl.exploitation.raisonSociale}}\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </md-dialog-content>\n  <md-dialog-actions ng-if=\"ctrl.afficheInfosExploitation\">\n    <md-button ng-click=\"ctrl.cancel()\" class=\"md-raised\">Annuler</md-button>\n    <md-button type=\"button\" class=\"md-raised md-primary\" ng-click=\"ctrl.rapprocherCheptel()\">Confirmer</md-button>\n  </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/accesFacturationNonDisponible.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>Accès à l\'espace facturation Bovin non disponible</h2>\n        <div class=\"md-dialog-content-body\">\n            <div>\n                <p>Vous ne disposez pas des droits nécessaires pour accéder à l\'espace facturation Bovin.</p>\n\n                <p>Veuillez-vous authentifier avec l\'adresse mail du Responsable/Associé Facturation de cet élevage ({{ctrl.emailResponsableFacturation}}) pour y accéder.</p>\n            </div>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"ctrl.fermer()\" class=\"md-raised md-sample\">Fermer</md-button>\n        <md-button ng-if=\"ctrl.showBoutonAutorisationAcces\" ng-click=\"ctrl.voirAutorisationsAcces()\" class=\"md-raised md-primary\">Voir les autorisations d\'accès</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/aideIncitationCreationCompteKc.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>Changement du système d\'authentification à Pilot\'Elevage</h2>\n        <div class=\"md-dialog-content-body\">\n            <div>\n                <p style=\"text-indent: 4em\">Pour plus de sécurité, nous devons changer de système d\'authentification.  \n                    Dans le cadre de ce changement technique, nous souhaitons vous offrir l\'opportunité de créer des comptes personnels. \n                    Ainsi chaque responsable de l\'exploitation pourra bénéficier de son accès personnel et sécurisé au portail Pilot\'Elevage \n                    de votre exploitation.</p>\n                <p>L\'abonnement restera bien sûr à l\'exploitation, aucun frais ne sera demandé pour la mise en place des comptes personnels sécurisés.</p>\n                <p style=\"text-indent: 4em\">Dans le cadre de la mise en place de ces comptes personnels, vos identifiants et mots de passe \n                    vont devoir changer. L\'identifiant sera pour chaque utilisateur: son <b>adresse mail personnelle</b>. \n                    Il va donc être capital de bien renseigner cette information. Si vous cliquez sur « Suivant» et que nous \n                    vous avons bien identifié comme responsable de l\'exploitation, alors vous recevrez un mail avec lien vous permettant \n                    de créer votre nouveau mot de passe personnel et sécurisé.</p>\n                <p style=\"text-indent: 4em\">Ces modifications de fonctionnement vont nous permettre de vous offrir une autre nouveauté : \n                    la gestion des accès à votre compte Pilot\'Elevage par des tiers extérieurs (salariés, stagiaires, conseiller..). \n                    Vous pourrez gérer vous-même les autorisations que vous déciderez de donner à ces différentes personnes.</p>\n                <p>En cas de difficultés, vos équipes habituelles d\'assistance Pilot\'Elevage vous accompagnent : n\'hésitez pas à les contacter.</p><p>\n                </p><p>L\'équipe Pilot\'Elevage</p>\n            </div>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\">OK</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/alert.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2 ng-bind-html=\"ctrl.options.title\"></h2>\n        <div class=\"md-dialog-content-body\">\n            <div ng-bind-html=\"ctrl.options.template\"></div>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\">{{ctrl.options.okText}}</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/alerteCompteKcExistant.html","");
$templateCache.put("app/_common/services/modal/templates/annulerModifierCommandeAuto.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <div class=\"md-dialog-content-body\">\n            <div>\n                <p>Vous souhaitez annuler ou modifier votre commande de boucles de naissance : merci de nous indiquer la raison :</p>\n                <md-radio-group ng-model=\"ctrl.commandeAuto.raisonModif\" ng-change=\"ctrl.resetSaisie()\">\n                    <div style=\"display: flex\" ng-repeat=\"raison in ctrl.raisons\">\n                        <md-radio-button ng-value=\"raison\">{{raison.libelle}}</md-radio-button>\n                        <span ng-if=\"raison.saisieComplementaire\">&nbsp;:&nbsp;</span>\n                        <md-input-container style=\"margin: 0\" ng-if=\"raison.saisieComplementaire && raison.typeSaisie === \'varchar\'\">\n                            <input aria-label=\"saisie\" type=\"text\" style=\"height: 18px; padding-bottom: 2px\" ng-model=\"ctrl.commandeAuto.saisieRaison\" ng-disabled=\"ctrl.commandeAuto.raisonModif !== raison\">\n                        </md-input-container>\n                        <md-input-container style=\"margin: 0\" ng-if=\"raison.saisieComplementaire && raison.typeSaisie === \'number\'\">\n                            <input aria-label=\"quantite\" style=\"width: 100px; padding-bottom: 2px; height:18px\" type=\"number\" ng-model=\"ctrl.commandeAuto.saisieQuantite\" ng-disabled=\"ctrl.commandeAuto.raisonModif !== raison\">\n                        </md-input-container>\n                </div></md-radio-group>\n               \n            </div>\n        </div>\n        \n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\" ng-disabled=\"!ctrl.commandeAuto.raisonModif.libelle || \n        (ctrl.commandeAuto.raisonModif.saisieComplementaire && ctrl.commandeAuto.raisonModif.typeSaisie === \'varchar\' && !ctrl.commandeAuto.saisieRaison) ||\n        (ctrl.commandeAuto.raisonModif.saisieComplementaire && ctrl.commandeAuto.raisonModif.typeSaisie === \'number\' && !ctrl.commandeAuto.saisieQuantite)\">Ok</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/choixExport.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>Choix de l\'export : </h2>\n        <div class=\"md-dialog-content-body\">\n            <md-radio-group ng-model=\"ctrl.choix\">\n                <div style=\"display: flex\" ng-repeat=\"choix in ctrl.listChoix\">\n                    <md-radio-button ng-value=\"choix\">{{choix}}</md-radio-button>\n                   \n            </div></md-radio-group>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"ctrl.cancel()\" class=\"md-raised md-sample\">Annuler</md-button>\n        <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\" ng-disabled=\"!ctrl.choix\">Confirmer</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/commandeAuto.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>Renouvellement du stock de boucles de naissance</h2>\n        <div class=\"md-dialog-content-body\">\n            <div>\n                <p>Votre stock de boucles de naissance est bas.</p>\n                <p>Nous proposons de vous recommander {{ctrl.quantite}} boucles({{ctrl.typeBoucle}}).</p>\n            </div>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"ctrl.cancel()\" class=\"md-raised md-sample\">Annuler / Modifier</md-button>\n        <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\">Valider</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/confirm.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2 ng-bind-html=\"ctrl.options.title\"></h2>\n        <div class=\"md-dialog-content-body\">\n            <div ng-bind-html=\"ctrl.options.template\"></div>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"ctrl.cancel()\" class=\"md-raised md-primary\">{{ctrl.options.cancelText}}</md-button>\n        <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\">{{ctrl.options.okText}}</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/confirmAbonnementFlore.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n      <h2>Demande de confirmation</h2>\n      <div class=\"md-dialog-content-body\">\n        <div>\n            <md-checkbox ng-model=\"acceptCGV\" aria-label=\"acceptCGV\" tabindex=\"0\" type=\"checkbox\" role=\"checkbox\"></md-checkbox>\n            Je souhaite m’abonner au Service Flore (sans surcoût), j’ai lu et j’accepte \n            <a href=\"assets/documents/cgu.pdf\" target=\"_blank\" class=\"light-link\">La politique de Confidentialité de Flore.</a>\n        </div>\n       </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n      <md-button ng-click=\"ctrl.cancel()\" class=\"md-raised md-primary\">NON</md-button>\n      <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\" ng-disabled=\"!acceptCGV\">OUI</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/confirmAnnulerModifierCommandeAuto.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>Demande de confirmation</h2>\n        <div class=\"md-dialog-content-body\">\n            <div>\n                <p>Vous allez modifier ou annuler votre commande de boucles. Voulez-vous continuer ? </p>\n            </div>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"ctrl.cancel()\" class=\"md-raised md-sample\">Non</md-button>\n        <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\">Oui</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/facturePapierInfos.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>Recevoir ma facture Bovin Pilot’Elevage par voie postale</h2>\n        <div class=\"md-dialog-content-body\">\n            <div>\n                <p>Vous disposez d’un accès à l’espace facturation en ligne (inclus dans votre abonnement) qui vous permet de gérer vos factures (suivi des règlements, téléchargement et impression des factures).</p>\n                <p>Si vous souhaitez recevoir vos factures Bovin par voie postale, il vous faut souscrire au service ‘Recevoir mes factures Bovin par voie postale’ pour un surcoût d’abonnement de {{ ctrl.tarif }}€ HT/{{ ctrl.periodicite }}.</p>\n            </div>\n        </div>\n      </md-dialog-content>\n      <md-dialog-actions>\n        <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\">OK</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/floreInfos.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>Service FLORE : gestion des sorties présumées</h2>\n        <div class=\"md-dialog-content-body\">\n            <div>\n                <p><b>FLORE est un robot conversationnel</b> qui à l\'aide de SMS, Facebook Messenger ou Skype, <b>permet de vous alerter</b> en cas de sortie présumée.</p>\n                <p>Ce service est <b>inclus sans surcoût</b> dans vos abonnements Pilot\'Elevage Essentiel et Performance bovins.</p>\n                <p style=\"text-align: justify\">Un message automatique vous sera envoyé dès lors qu’une notification d’abattage ou d’entrée d’un de vos bovins dans une autre exploitation est enregistrée. L’envoi de ce message se déclenche au 4ème jour qui suit la date de la sortie présumée. <b>Le fait de répondre et de valider la sortie de l\'animal via FLORE, tient lieu de notification</b> (en allant jusqu\'au terme de la conversation). Vous n\'avez pas d\'autres opérations à réaliser.</p>\n                <p>Des questions ? Contactez votre service assistance.</p><p>\n                </p><p>L\'équipe Pilot\'Elevage</p>\n            </div>\n        </div>\n      </md-dialog-content>\n      <md-dialog-actions>\n        <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\">OK</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/incitationCreationCompteKc.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <div class=\"md-dialog-content-body\">\n            <div layout=\"row\">\n                <p><b>Le processus de connexion a changé.</b></p>\n            </div>\n            <p>Désormais vous devez vous connecter avec votre adresse email qui devient votre identifiant (<span ng-click=\"ctrl.afficherAide()\"><u>lire les explications</u></span>).</p>\n            <p>Il vous reste <b>{{ctrl.nbJours}} jours</b> pour le faire.</p>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions style=\"padding-left:5px; padding-right: 5px; justify-content: center\">\n        <md-button style=\"margin-left: 5px;margin-right: 5px; max-width: 120px\" ng-click=\"ctrl.ok()\" class=\"md-raised md-primary incitation-button\">Ok, je fais la mise à jour</md-button>\n    </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("app/_common/services/modal/templates/information.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>{{ctrl.informationModale.titre}}</h2>\n        <div class=\"md-dialog-content-body\">\n            <ng-bind-html ng-bind-html=\"ctrl.informationModale.contenu\">\n            </ng-bind-html>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <!-- affichage conditionnel... peut-être un ou deux boutons...-->\n        <!-- sur le papier, le même comportement peut être appliqué au 2 : fermeture ou redirection + signaler modale vue -->\n        <md-button ng-if=\"ctrl.informationModale.boutonValider\" ng-click=\"ctrl.valider(ctrl.informationModale.boutonValider)\" class=\"md-raised md-primary\">{{ctrl.informationModale.boutonValider.libelle}}</md-button>\n        <md-button ng-if=\"ctrl.informationModale.boutonFermer\" ng-click=\"ctrl.valider(ctrl.informationModale.boutonFermer)\" class=\"md-raised md-primary\">{{ctrl.informationModale.boutonFermer.libelle}}</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/obligationUseKeycloak.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>Le processus d’authentification a changé</h2>\n        <div class=\"md-dialog-content-body\">\n            \n            <p>La connexion via votre ancien identifiant n’est plus possible, nous vous invitons à vous connecter avec l’identifiant personnel <b>{{ctrl.identifiantKc}}</b> que vous avez créé il y a quelques jours.</p>\n            <p>En cas de difficulté, votre assistance Pilot’Elevage vous accompagne : n’hésitez pas à nous contacter.</p>\n            <p>L’équipe Pilot’Elevage</p>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <a ng-click=\"ctrl.ok()\" class=\"link-popin lien\" style=\"position: fixed; left: 20px\"><span><u>Ce n\'est pas mon adresse mail</u></span></a>\n        <a class=\"md-raised md-primary md-button md-ink-ripple incitation-button\" style=\"display: flex; justify-content: center\" ng-href=\"{{ctrl.urlMireKc}}\"><span>Ok</span></a>\n    </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("app/_common/services/modal/templates/optionInfos.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\" ng-class=\"{width850: ctrl.options.nom === \'dataHUB\'}\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>{{ctrl.options.title}}</h2>\n        <div class=\"md-dialog-content-body\">\n            <ng-bind-html ng-bind-html=\"ctrl.options.body\">\n            </ng-bind-html>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\">OK</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/saisieIBAN.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>SAISIE IBAN</h2>\n        <div class=\"md-dialog-content-body\">\n            <div>\n                <p>Si vous ne parvenez pas à renseigner votre IBAN ou si vous ne recevez pas de SMS lors de l’enregistrement de votre mandat, veuillez imprimer l’autorisation de prélèvement automatique ci-joint et le retourner complété par mail à <b style=\"color: #0055BC; font-size: 15px; text-decoration: underline\">facturation@pilotelevage.fr</b></p>\n            </div>\n        </div>\n      </md-dialog-content>\n      <md-dialog-actions>\n        <md-button class=\"red-button md-raised\" type=\"button\" ng-click=\"ctrl.download()\">\n          Télécharger l\'autorisation de mandat de prélèvement automatique SEPA\n        </md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/suspensionAccesAutre.html","<div class=\"modal-suspension\">\n    <md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog custom-width\">\n        <md-dialog-content class=\"md-dialog-content padding-0\">\n            <div class=\"title-color\">\n                <img alt=\"logo\" src=\"assets/images/logo-plat.png\" class=\"logo img\">\n                <h3 class=\"title\"><u>SUSPENSION DE VOS ACCES</u></h3>\n            </div>\n            <div class=\"md-dialog-content-body content\">\n                <p>\n                    Nous constatons avec regret qu’une facture liée à cet abonnement Pilot’Elevage est toujours en attente de règlement. \n                    En l’absence de règlement, et conformément à nos conditions générales de souscription en ligne, nous sommes contraints de suspendre les accès à cet élevage jusqu’à régularisation du paiement.\n                </p>\n                <p>\n                    Le responsable/associé Facturation de cet élevage ({{ctrl.emailResponsable}}) dispose des droits d’accès à l’espace de facturation. \n                    Pour régulariser la situation, veuillez-vous authentifier avec cette adresse mail à Pilot’Elevage.\n                </p>\n                <p>\n                    Nous vous encourageons à régulariser cette situation au plus vite pour accéder de nouveau à vos services. Pour cela, afin de bénéficier d’une levée de suspension rapide, nous vous conseillons de régler via prélèvement automatique en renseignant votre RIB via le portail facturation. Tout autre moyen de paiement (virement ou chèque, en indiquant la référence de la facture), nécessite un délai de traitement plus long et donc un délai de levée de la suspension d’au minimum 7 jours.\n                </p>\n                <p>\n                    Nous vous rappelons qu’en tant que détenteur vous êtes responsable des délais de notification de mouvements de vos animaux.\n                </p>\n                <p>\n                    Si vous rencontrez la moindre difficulté, n\'hésitez pas à contacter nos équipes :\n                </p>\n                <ul>\n                    <li>par mail, à tout moment à l\'adresse suivante : facturation@pilotelevage.fr</li>\n                    <li>par téléphone au 02.61.12.02.32 les lundi, mardi, jeudi et vendredi de 9h à 12h.</li>\n                </ul>\n            </div>\n        </md-dialog-content>\n        <md-dialog-actions>\n            <md-button ng-if=\"ctrl.isMultiCheptel\" ng-click=\"ctrl.changerDeCheptel()\" class=\"md-raised md-primary btn-changer-cheptel\">Changer de cheptel</md-button>\n            <md-button ng-click=\"ctrl.fermer()\" class=\"md-raised md-primary\">Fermer</md-button>\n        </md-dialog-actions>\n    </md-dialog>\n</div>");
$templateCache.put("app/_common/services/modal/templates/suspensionAccesReponsable.html","<div class=\"modal-suspension\">\n    <md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog custom-width\">\n        <md-dialog-content class=\"md-dialog-content padding-0\">\n            <div class=\"title-color\">\n                <img alt=\"logo\" src=\"assets/images/logo-plat.png\" class=\"logo img\">\n                <h3 class=\"title\"><u>SUSPENSION DE VOS ACCES</u></h3>\n            </div>\n            <div class=\"md-dialog-content-body content\">\n                <p>\n                    Après plusieurs relances, nous constatons avec regret, qu’une facture liée à votre abonnement Pilot’Elevage est toujours en attente de règlement. En l’absence de paiement de votre part, et conformément à nos conditions générales de souscription en ligne, nous sommes contraints de suspendre vos accès jusqu’à l’enregistrement du paiement.\n                </p>\n                <p>\n                    Nous vous encourageons à régulariser cette situation au plus vite pour accéder de nouveau à vos services. Pour cela, afin de bénéficier d’une levée de suspension rapide, nous vous conseillons de régler via prélèvement automatique en renseignant votre RIB via le portail facturation. Tout autre moyen de paiement (virement ou chèque, en indiquant la référence de la facture), nécessite un délai de traitement plus long et donc un délai de levée de la suspension d’au minimum 7 jours.\n                </p>\n                <p>\n                    Nous vous rappelons qu’en tant que détenteur vous êtes responsable des délais de notification de mouvements de vos animaux.\n                </p>\n                <p>\n                    Si vous rencontrez la moindre difficulté, n\'hésitez pas à contacter nos équipes :\n                </p>\n                <ul>\n                    <li>par mail, à tout moment à l\'adresse suivante : facturation@pilotelevage.fr</li>\n                    <li>par téléphone au 02.61.12.02.32 les lundi, mardi, jeudi et vendredi de 9h à 12h.</li>\n                </ul>\n            </div>\n        </md-dialog-content>\n        <md-dialog-actions>\n            <md-button ng-if=\"ctrl.isMultiCheptel\" ng-click=\"ctrl.changerDeCheptel()\" class=\"md-raised md-primary btn-changer-cheptel\">Changer de cheptel</md-button>\n            <md-button ng-click=\"ctrl.gererMesFactures()\" class=\"md-raised md-primary\">Gérer ma facture</md-button>\n        </md-dialog-actions>\n    </md-dialog>\n</div>");
$templateCache.put("app/_common/services/modal/templates/validationCompteKcExistant.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>Vérification de l\'identité</h2>\n        <div class=\"md-dialog-content-body\">\n            <div>\n                <p>Votre identité est bien vérifiée et vous avez déjà procédé à la création de vos nouveaux identifiants et mots de passe Pilot\'Elevage.</p>\n                <p>Vous allez être redirigé vers  la page de connexion Pilot\'Elevage afin de les saisir et ainsi pouvoir accéder à votre portail.</p>\n                <p>En cas de difficultés, contacter votre assistance Pilot\'Elevage habituelle.</p><p>\n                </p><p>L\'équipe Pilot\'Elevage</p>\n            </div>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <a class=\"md-raised md-primary md-button md-ink-ripple\" ng-href=\"{{ctrl.urlMireKc}}\">Ok</a>\n        <!-- <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\">Ok</md-button> -->\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/validationCompteKcKo.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>Vérification de l\'identité</h2>\n        <div class=\"md-dialog-content-body\">\n            <div>\n                <p>Votre e-mail n’est pas reconnu dans les autorisations d’accès, votre identité n’a pas pu être vérifiée.</p>\n                <p>En cliquant sur \'OK\', vous serez dirigé dans <b>l\'onglet \"Autorisations d’accès\"</b> de votre compte Pilot\'Elevage où vous pouvez \n                <b>renseigner votre identité avec votre adresse mail.</b>\n                    Ainsi, lors de votre prochaine connexion, vous pourrez créer <b>votre nouveau compte d\'accès en utilisant le nom et \n                    l\'adresse mail renseignés ce jour</b> pour basculer sur le nouveau système d\'authentification.</p>\n                <p>En cas de difficulté, votre assistance Pilot\'Elevage vous accompagne : n\'hésitez pas à nous contacter.</p>\n                <p>L\'équipe Pilot\'Elevage</p>\n            </div>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\">Ok</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/validationNouveauCompteKc.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>Vérification de l\'identité</h2>\n        <div class=\"md-dialog-content-body\">\n            <div>\n                <p>Votre identité a bien été vérifiée.</p>\n                <p>Vous allez recevoir un mail sécurisé (sur l\'adresse indiquée précédemment) vous permettant de créer votre nouveau mot de passe personnel.</p>\n                <p>Avec ce nouveau mot de passe vous pourrez ensuite vous connecter à votre compte Pilot\'Elevage.</p>\n                <p>En cas de difficultés, contacter votre assistance Pilot\'Elevage habituelle.</p><p>\n                </p><p>Pensez à vérifier dans les spams/publicités.</p>\n                <p>L\'équipe Pilot\'Elevage</p>\n            </div>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\">Ok</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/_common/services/modal/templates/validerCommandeAuto.html","<md-dialog aria-label=\"confirm-dialog\" class=\"confirm-dialog\">\n    <md-dialog-content class=\"md-dialog-content\">\n        <h2>Demande de confirmation</h2>\n        <div class=\"md-dialog-content-body\">\n            <div>\n                <p>Vous allez valider votre commande de boucles. Voulez-vous continuer ? </p>\n            </div>\n        </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n        <md-button ng-click=\"ctrl.cancel()\" class=\"md-raised md-sample\">Non</md-button>\n        <md-button ng-click=\"ctrl.ok()\" class=\"md-raised md-primary\">Oui</md-button>\n    </md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/eleveur/_common/directives/actualites/actualites.html","<md-card class=\"actualites\">\n  <md-card-header>\n    <h3 flex>Actualités</h3>\n    <md-icon md-svg-src=\"assets/images/icones/vache.svg\" aria-label=\"Actualités\"></md-icon>\n  </md-card-header>\n\n  <div flex layout=\"column\">\n    <div ng-show=\"actualitesCtrl.loading\" flex layout=\"row\" layout-align=\"center center\">\n      <md-progress-circular md-diameter=\"20\"></md-progress-circular>\n    </div>\n\n    <div ng-show=\"actualitesCtrl.error\" flex layout=\"column\" layout-align=\"center center\">\n      Erreur pendant le chargement des actualités\n\n      <md-button ng-click=\"actualitesCtrl.load()\" class=\"md-raised\">Réessayer</md-button>\n    </div>\n\n    <div ng-repeat=\"actualite in actualitesCtrl.actualites\" flex=\"50\" layout=\"column\" class=\"actualite-item\">\n      <h4 ng-click=\"actualitesCtrl.showActualite(actualite)\">{{actualite.titre}} {{actualite.titre}}</h4>\n      <div flex layout=\"row\">\n        <img ng-src=\"{{actualite.imageUrl}}\" ng-click=\"actualitesCtrl.showActualite(actualite)\">\n        <p class=\"description\" ng-clamp=\"5\">{{actualite.description}}</p>\n      </div>\n    </div>\n  </div>\n</md-card>");
$templateCache.put("app/eleveur/_common/directives/alerte/alerte.html","<md-card ng-hide=\"alerteCtrl.alerte === null\" layout=\"column\" class=\"alerte {{alerteCtrl.alerte.niveauAlerte | lowercase}}\">\n  <div ng-show=\"alerteCtrl.loading\" flex layout=\"row\" layout-align=\"center center\">\n    <md-progress-circular md-diameter=\"20\"></md-progress-circular>\n  </div>\n\n  <div ng-show=\"alerteCtrl.error\" flex layout=\"column\" layout-align=\"center center\">\n    <div>Erreur pendant le chargement de la communication</div>\n\n    <md-button ng-click=\"alerteCtrl.load()\" class=\"md-raised\">Réessayer</md-button>\n  </div>\n\n\n  <div ng-if=\"alerteCtrl.alerte\" flex layout=\"row\" layout-align=\"start center\">\n    <md-icon ng-if=\"alerteCtrl.alerte.niveauAlerte === \'Faible\'\" md-svg-src=\"assets/images/icones/add_alert.svg\" aria-label=\"add_alert\"></md-icon>\n    <md-icon ng-if=\"alerteCtrl.alerte.niveauAlerte === \'Moyen\'\" md-svg-src=\"assets/images/icones/error.svg\" aria-label=\"error\"></md-icon>\n    <md-icon ng-if=\"alerteCtrl.alerte.niveauAlerte === \'Haut\'\" md-svg-src=\"assets/images/icones/error.svg\" aria-label=\"error\"></md-icon>\n\n    <div flex layout=\"column\" layout-align=\"center\" class=\"description\">\n      <h3>{{alerteCtrl.alerte.titre}}</h3>\n      <p ng-bind-html=\"alerteCtrl.trustAsHtml(alerteCtrl.alerte.message)\"></p>\n    </div>\n  </div>\n</md-card>");
$templateCache.put("app/eleveur/_common/directives/menu/menu.html","<div id=\"divMenu\" class=\"menu {{ctrl.orientation}}\">\n  <div ng-if=\"ctrl.type!==\'woc\'\" class=\"head-menu head-color-menu-{{ctrl.type}}\">\n    <div ng-repeat=\"item in ctrl.menu | orderBy : \'ordre\'\" ng-click=\"ctrl.selectItem(item)\" class=\"menu-item\">\n      <md-icon md-svg-src=\"assets/images/menu/{{item.code | lowercase}}.svg\" aria-label=\"{{item.libelle}}\"></md-icon>\n      <span class=\"libelle\">{{item.libelle}}</span>\n\n      <div ng-show=\"item.code === ctrl.selectedItem.code\" class=\"underline\"></div>\n    </div>\n  </div>\n  <div ng-if=\"ctrl.type===\'woc\'\" class=\"head-menu head-color-menu-{{ctrl.type}}\">\n    <div ng-repeat=\"item in ctrl.menu | orderBy : \'ordre\'\" ng-click=\"ctrl.selectItemWoc(item)\" class=\"menu-item\">\n      <md-icon md-svg-src=\"assets/images/menu/{{item.code | lowercase}}.svg\" aria-label=\"{{item.libelle}}\"></md-icon>\n      <span class=\"libelle\">{{item.libelle}}</span>\n\n      <div ng-show=\"item.code === ctrl.selectedItem.code\" class=\"underline\"></div>\n    </div>\n  </div>\n\n  <div ng-show=\"ctrl.selectedItem\" class=\"sub-menu\">\n    <div ng-repeat=\"category in ctrl.selectedItem.items | orderBy : \'ordre\'\" class=\"sub-menu-group\">\n      <h3 ng-if=\"!category.acces\">{{category.libelle}}</h3>\n      \n      <md-button ng-if=\"category.acces\" ng-click=\"ctrl.goToFonctionnalite(category)\" class=\"niveau2\">\n        <h3>{{category.libelle}}</h3>\n      </md-button>\n      <div layout=\"row\">\n        <div layout=\"column\" ng-if=\"category.items\" ng-repeat=\"i in ctrl.generateColArray(category.items) track by $index\">\n          <md-button ng-repeat=\"entry in ctrl.getLinksInCol(category.items, $index)\" ng-click=\"ctrl.goToFonctionnalite(entry)\" class=\"break-long-menu\">&gt; {{entry.libelle}}</md-button>\n        </div>\n      </div>\n    </div>\n\n    <md-icon ng-click=\"ctrl.closeSubMenu()\" class=\"close-icon\"> keyboard_arrow_up </md-icon>\n  </div>\n</div>");
$templateCache.put("app/eleveur/compte/compte/templates/confirmClotureAbonnement.html","<md-dialog aria-label=\"raison\" class=\"confirm-cloture-abonnement\">\n  <md-dialog-content>\n    <md-content flex layout=\"column\">\n      <div class=\"content\">\n        Afin de mieux satisfaire nos utilisateurs, nous vous serions reconnaissants de nous indiquer la raison de votre\n        choix :\n      </div>\n      <div layout=\"column\" class=\"raison\">\n\n        <md-radio-group ng-model=\"ctrl.raisonChoix\">\n          <md-radio-button ng-repeat=\"raison in ctrl.raisonsResiliations\" value=\"{{raison.libelle}}\">\n            {{raison.libelle}}</md-radio-button>\n          <md-radio-button value=\"AUTRE\">Autre raison </md-radio-button>\n        </md-radio-group>\n        <md-input-container ng-if=\"ctrl.raisonChoix===\'AUTRE\'\">\n          <textarea name=\"raison\" ng-model=\"ctrl.commentaireLibre\" maxlength=\"400\" cols=\"50\" style=\"width: 382px\"></textarea>\n        </md-input-container>\n\n    </div></md-content>\n  </md-dialog-content>\n\n  <md-dialog-actions layout=\"row\">\n    <md-button class=\"md-raised md-primary\" ng-click=\"ctrl.close()\">\n      Ok\n    </md-button>\n  </md-dialog-actions>\n\n</md-dialog>");
$templateCache.put("app/eleveur/compte/compte/templates/demandeModificationAbonnement.html","<md-dialog flex aria-label=\"raison\" class=\"modal-demande-modification-abonnement\">\n    <md-dialog-content>\n        <md-content flex layout=\"column\" class=\"content\">\n            <h2>\n                Demande de modification\n            </h2>\n            <p>\n                Vous souhaitez modifier votre abonnement à l\'offre Pilot’Elevage.\n            </p>\n            <p ng-if=\"ctrl.raisonsResiliations\">\n                <b>Si votre demande est liée à un CHANGEMENT DE DETENTEUR ou à une CESSATION D\'ACTIVITE, merci d’annuler cette demande et de CONTACTER DIRECTEMENT LE SERVICE ASSISTANCE de votre département.</b>\n            </p>\n            <p>\n                Votre abonnement au service Pilot’Elevage comporte un engagement à l\'année civile.\n            </p>\n            <p ng-if=\"ctrl.raisonsResiliations\">\n                Afin de prendre en compte votre demande, merci d\'en indiquer la raison :\n            </p>\n            <div layout=\"column\" ng-if=\"ctrl.raisonsResiliations\">\n                <md-radio-group ng-model=\"ctrl.raisonChoix\">\n                    <!-- exclure changement de détention et cessation d\'activités -->\n                    <md-radio-button ng-repeat=\"raison in ctrl.raisonsResiliations\" value=\"{{raison.libelle}}\">\n                        {{raison.libelle}}</md-radio-button>\n                    <md-radio-button value=\"AUTRE\">Autre raison </md-radio-button>\n                </md-radio-group>\n                <md-input-container ng-if=\"ctrl.raisonChoix===\'AUTRE\'\">\n                    <textarea name=\"raison\" ng-model=\"ctrl.commentaireLibre\" maxlength=\"400\" cols=\"50\" style=\"width: 382px\"></textarea>\n                </md-input-container>\n            </div>\n            <p>\n                Votre demande de modification va être prise en compte et sera effective à compter du 01 janvier de l’année prochaine. Jusqu’à cette date, vous continuerez à bénéficier des services actuels pour lesquels vous êtes engagés.\n            </p>\n            <p>\n                Sachez que vous pouvez annuler votre demande à tout moment.\n            </p>\n        </md-content>\n    </md-dialog-content>\n\n    <md-dialog-actions layout=\"row\">\n        <md-button class=\"md-raised\" ng-click=\"ctrl.annulerDemande()\">\n            Annuler la demande\n        </md-button>\n        <md-button class=\"md-raised\" ng-click=\"ctrl.confirmerDemande()\">\n            Confirmer la demande\n        </md-button>\n    </md-dialog-actions>\n\n</md-dialog>");
$templateCache.put("app/eleveur/compte/compte/templates/informations.html","<!-- v1.0 -->\n<div flex layout=\"column\" class=\"compte-informations\">\n  <form name=\"ctrl.contactForm\" ng-submit=\"ctrl.validerModificationInformations()\" novalidate flex layout=\"column\">\n    <md-content flex>\n      <div layout-gt-sm=\"row\" layout-align=\"center\" class=\"infos-global\">\n        <div layout=\"column\" class=\"informations-content\">\n          <div class=\"recap-item\">\n            <div class=\"label\">\n              Identifiant\n            </div>\n            <div class=\"value\">\n              {{ctrl.login}}\n            </div>\n          </div>\n          <div class=\"recap-item\">\n            <div class=\"label\">\n              Raison sociale\n            </div>\n            <div class=\"value\">\n              {{ctrl.exploitationActive.raisonSociale}}\n            </div>\n          </div>\n          <div class=\"recap-item\">\n            <div class=\"label\">\n              Numéro exploitation\n            </div>\n            <div class=\"value\">\n              FR{{ctrl.exploitationActive.numExploitation}}\n            </div>\n          </div>\n          <div class=\"recap-item\">\n            <div class=\"label\">\n              Adresse\n            </div>\n            <div class=\"value\">\n              {{ctrl.exploitationActive.adresse.adress}}\n            </div>\n          </div>\n          <div class=\"recap-item\">\n            <div class=\"label\">\n\n            </div>\n            <div class=\"value\">\n              {{ctrl.exploitationActive.adresse.complementAdresse}}\n            </div>\n          </div>\n          <div class=\"recap-item\">\n            <div class=\"label\">\n\n            </div>\n            <div class=\"value\">\n              {{ctrl.exploitationActive.adresse.codePostal}} {{ctrl.exploitationActive.adresse.ville}}\n            </div>\n          </div>\n          <div class=\"recap-item\">\n            <div class=\"label\">\n              Numéro détenteur\n            </div>\n            <div class=\"value\">\n              {{ctrl.exploitationActive.numDetenteur}}\n            </div>\n          </div>\n        </div>\n        <div layout=\"column\">\n          <md-button class=\"md-raised md-primary btn-change-mdp\" ui-sref=\"app.eleveur.changeMdp\">Modifier mon mot de passe</md-button>\n        </div>\n      </div>\n    </md-content>\n\n    <div class=\"actions-bar\">\n      <md-button type=\"button\" ng-click=\"ctrl.annuleModificationsInformations()\" class=\"md-raised md-sample\">Annuler</md-button>\n      <md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"ctrl.isEqual\">Valider</md-button>\n    </div>\n  </form>\n</div>");
$templateCache.put("app/eleveur/compte/compte/templates/modificationsEnCours.html","<div>\n    <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\">\n        <div layout=\"row\">\n            <h2>Demande de modification en cours :</h2>\n        </div>\n        <!-- liste modifications en cours -->\n        <p ng-repeat=\"modification in ctrl.modificationsEnCours\">\n            <span class=\"modification bold\">{{ modification.description }}</span><b> enregistrée</b><br>\n            <b>Effective au </b><span class=\"modification bold\">{{ modification.dateEffective | date: \'dd/MM/yy\' }}</span>\n        </p>\n        <!-- annulation des modifications en cours -->\n        <div layout=\"row\">\n            <div flex></div>\n            <md-button type=\"button\" class=\"md-raised md-sample btn-annuler\" ng-click=\"ctrl.annulerModificationsEnCours()\">Annuler les modifications</md-button>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/eleveur/compte/compte/templates/services.html","<div flex layout=\"column\" class=\"services-compte\">\n  <md-content flex>\n    <div layout=\"row\" layout-align=\"center\">\n      <div flex=\"20\"></div>\n      <div>\n        <!-- bloc des modifications d\'abonnements en cours -->\n        <md-card ng-if=\"ctrl.modificationsEnCours.length !== 0\" layout=\"column\" ng-include=\"\'app/eleveur/compte/compte/templates/modificationsEnCours.html\'\" class=\"md-whiteframe-2dp card-content\"></md-card>\n\n        <md-card ng-if=\"ctrl.abonnementsBovin\" layout=\"column\" class=\"md-whiteframe-2dp card-content\">\n          <div>\n\n            <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\">\n              <h2>Formule bovin\n                <span ng-if=\"ctrl.aboBovActif\">(depuis le {{ctrl.aboBovActif.dateDebutGestion | date: \'dd/MM/yy\' }})</span>\n              </h2>\n              <md-radio-group ng-model=\"ctrl.bovin\" ng-if=\"ctrl.abonnementsBovin\" class=\"md-radio-group-nouvel-abo\">\n\n                <md-radio-button ng-repeat=\"niveau in ctrl.abonnementsBovin | orderBy : \'-niveauAbonnement.code\'\" ng-value=\"niveau\" class=\"radio-button-service\" ng-click=\"!ctrl.disableAbonnement && ctrl.modificationBovin(niveau)\" ng-disabled=\"ctrl.disableAbonnement\">\n                  <md-card type=\"button\" class=\"service-card {{niveau.niveauAbonnement.code==\'2\' ? \'niveau-basique\' : \'niveau-expert\'}} md-whiteframe-6dp\" ng-class=\"{active: (ctrl.bovin === niveau)}\" ng-click=\"ctrl.modificationBovin()\">\n                    <md-card-title>\n                      <img src=\"assets/images/logo-plat.png\" class=\"logo-card\">\n                    </md-card-title>\n\n                    <md-card-content>\n                      <div flex>\n                        <p class=\"titre\">{{niveau.niveauAbonnement.libelle}}</p>\n                        <p class=\"libelle\">{{niveau.sloganAbonnement}}</p>\n                      </div>\n\n                      <md-icon md-svg-src=\"assets/images/icones/devices.svg\" class=\"devices\" aria-label=\"devices\"></md-icon>\n                    </md-card-content>\n\n                    <div class=\"contrat\">\n                      <p class=\"tarif\" ng-if=\"ctrl.reduction\">{{ctrl.reductionTxt}}</p>\n                      <p class=\"tarif\">\n                        <span ng-if=\"ctrl.reduction\"> Puis </span>{{ niveau.prix.toFixed(2) }} € HT / {{niveau.periodicite.libelle}}</p>\n                      <p class=\"duree\">Engagement à l\'année civile, renouvellement par tacite reconduction*</p>\n                    </div>\n                  </md-card>\n                </md-radio-button>\n\n                <md-radio-button ng-value=\"0\" ng-click=\"!ctrl.disableAbonnement && ctrl.resiliationBovin()\" ng-disabled=\"ctrl.disableAbonnement\">\n                  <md-card type=\"button\" ng-class=\"{active: (ctrl.bovin === 0)}\" class=\"service-card cloture md-whiteframe-6dp\" ng-click=\"ctrl.resiliationBovin()\">\n                    <md-card-content>\n                      <i class=\"material-icons\">block</i>\n                    </md-card-content>\n\n                    <div class=\"contrat\">\n                      <p class=\"tarif\">\n                        Pas d\'abonnement\n                      </p>\n                    </div>\n                  </md-card>\n                </md-radio-button>\n\n              </md-radio-group>\n       \n            </div>\n          </div>\n        </md-card>\n        \n        <md-card ng-if=\"ctrl.abonnementsOvCap\" layout=\"column\" class=\"md-whiteframe-2dp card-content\">\n          <div>\n            <div flex layout=\"column\" layout-align=\"center\" class=\"description-abo\">\n              <h2>Formule ovin / caprin\n                <span ng-if=\"ctrl.aboOvActif\">(depuis le {{ctrl.aboOvActif.dateDebutGestion | date: \'dd/MM/yy\' }})</span>\n              </h2>\n              <md-radio-group ng-model=\"ctrl.ovin\" ng-if=\"ctrl.abonnementsOvCap\" class=\"md-radio-group-nouvel-abo\">\n\n                <md-radio-button ng-repeat=\"niveau in ctrl.abonnementsOvCap | orderBy : \'-niveauAbonnement.code\'\" ng-value=\"niveau\" class=\"radio-button-service\" ng-click=\"!ctrl.disableAbonnement && ctrl.modificationOvin(niveau)\" ng-disabled=\"ctrl.disableAbonnement\">\n                  <md-card type=\"button\" class=\"service-card ovin md-whiteframe-6dp\" ng-class=\"{active: (ctrl.ovin === niveau)}\" ng-click=\"ctrl.modificationOvin()\">\n                    <md-card-title>\n                      <img src=\"assets/images/logo-plat.png\" class=\"logo-card\"> \n                    </md-card-title>\n\n                    <md-card-content>\n                      <div flex>\n                        <p class=\"titre\">{{niveau.niveauAbonnement.libelle}}</p>\n                        <p class=\"libelle\">{{niveau.sloganAbonnement}}</p>\n                      </div>\n\n                      <md-icon md-svg-src=\"assets/images/icones/devices.svg\" class=\"devices\" aria-label=\"devices\"></md-icon>\n                    </md-card-content>\n\n                    <div class=\"contrat\">\n\n                      <p class=\"tarif\">\n                        {{niveau.prix.toFixed(2)}} € HT / {{niveau.periodicite.libelle}}</p>\n                      <p class=\"duree\">Engagement à l\'année civile, renouvellement par tacite reconduction*</p>\n                    </div>\n                  </md-card>\n                </md-radio-button>\n\n                <md-radio-button ng-value=\"0\" ng-click=\"!ctrl.disableAbonnement && ctrl.resiliationOvin()\" ng-disabled=\"ctrl.disableAbonnement\" checked=\"checked\">\n                  <md-card type=\"button\" ng-class=\"{active: (ctrl.ovin === 0)}\" class=\"service-card cloture md-whiteframe-6dp\" ng-click=\"ctrl.resiliationOvin()\">\n                    <md-card-content>\n                      <i class=\"material-icons\">block</i>\n                    </md-card-content>\n\n                    <div class=\"contrat\">\n                      <p class=\"tarif\">\n                        Pas d\'abonnement\n                      </p>\n                    </div>\n                  </md-card>\n                </md-radio-button>\n              </md-radio-group>\n            </div>\n          </div>\n        </md-card>\n\n      </div>\n      <div flex=\"20\"></div>\n    </div>\n  </md-content>\n\n\n  <div class=\"actions-bar\">\n    <md-button type=\"button\" class=\"md-raised md-sample cloturer\" ng-click=\"!ctrl.disableAbonnement && ctrl.clotureCompte()\" ng-disabled=\"ctrl.disableAbonnement\">Clôturer mon compte</md-button>\n    <div flex></div>\n    <div class=\"cgsl spacer\"><label>*Consultez les <a href=\"assets/documents/cgsl.pdf\" target=\"_blank\" class=\"light-link cgsl\">Conditions générales de Souscription en ligne</a> de Pilot\'Elevage</label></div>\n    <a href=\"assets/documents/details.pdf\" target=\"_blank\" class=\"light-link details\">Voir toutes les offres</a>\n    <md-button type=\"button\" class=\"md-raised md-sample\" ng-click=\"ctrl.annuleModificationsService()\">Retour</md-button>\n  </div>\n</div>");
$templateCache.put("app/eleveur/_common/services/commandeAuto/annulationCommande/annulationCommande.html","<md-dialog aria-label=\"confirm-dialog\" class=\"annulation-commande\">\n  <form name=\"ctrl.annulationCommandeForm\" ng-submit=\"ctrl.onSubmit()\">\n    <md-dialog-content class=\"md-dialog-content\">\n      <h2>Demande d\'annulation</h2>\n      <div class=\"md-dialog-content-body\">\n        <div class=\"recap-item\">\n          <div class=\"label\">Objet</div>\n          <div class=\"value\">Demande d\'annulation de la commande automatique N° {{ctrl.commandeAuto.noBonCommande}} du {{ctrl.commandeAuto.dateCommande\n            | date : \'dd/MM/yy\'}} pour l\'exploitation FR {{ctrl.numeroExploitation}}.</div>\n        </div>\n\n        <md-input-container class=\"md-block\">\n          <input type=\"text\" ng-model=\"ctrl.remarques\" md-autofocus placeholder=\"Remarques éventuelles à stipuler concernant cette demande d\'annulation\">\n        </md-input-container>\n      </div>\n    </md-dialog-content>\n    <md-dialog-actions>\n      <md-button type=\"button\" ng-click=\"ctrl.cancel()\" class=\"md-raised md-primary\">Annuler</md-button>\n      <md-button type=\"submit\" class=\"md-raised md-primary\">OK</md-button>\n    </md-dialog-actions>\n  </form>\n</md-dialog>");
$templateCache.put("app/eleveur/_common/services/exploitation/selectionExploitation/selectionExploitation.html","<md-dialog aria-label=\"Changer de cheptel\" class=\"selection-exploitation large-dialog\">\n  <form name=\"ctrl.authentForm\" ng-submit=\"ctrl.onSubmitAuthent()\" novalidate>\n    <md-toolbar>\n      <div class=\"md-toolbar-tools\">\n        <h2>Changer de cheptel</h2>\n\n        <div flex></div>\n        <md-button class=\"md-icon-button\" ng-click=\"ctrl.cancel()\">\n          <md-icon md-svg-src=\"assets/images/icones/close.svg\" aria-label=\"close\"></md-icon>\n        </md-button>\n      </div>\n    </md-toolbar>\n\n    <md-dialog-content class=\"md-dialog-content\" ng-if=\"!ctrl.estKeyCloak\">\n      <div>\n        <div layout=\"row\">\n          <md-card flex=\"50\" ng-click=\"ctrl.toggleForm(exploitation)\" ng-repeat=\"exploitation in ctrl.exploitations\" ng-if=\"!ctrl.openFormAuth && $index < 2\" ng-model=\"exploitation\" class=\"md-whiteframe-2dp menu-item account\" ng-click=\"ctrl.selectionCheptel(exploitation)\">\n            <span class=\"multi\">{{exploitation.raisonsociale}}</span>\n            <span>{{exploitation.numExploitation}}</span>\n          </md-card>\n        </div>\n        <div layout=\"row\">\n          <md-card flex=\"50\" ng-click=\"ctrl.toggleForm(exploitation)\" ng-repeat=\"exploitation in ctrl.exploitations\" ng-if=\"!ctrl.openFormAuth && 1 < $index && $index < 4\" ng-model=\"exploitation\" class=\"md-whiteframe-2dp menu-item account\">\n            <span class=\"multi\">{{exploitation.raisonsociale}}</span>\n            <span>{{exploitation.numExploitation}}</span>\n          </md-card>\n        </div>\n        <div layout=\"row\">\n          <md-card flex=\"50\" ng-click=\"ctrl.toggleForm(exploitation)\" ng-repeat=\"exploitation in ctrl.exploitations\" ng-if=\"!ctrl.openFormAuth && 3 < $index && $index < 6\" ng-model=\"exploitation\" class=\"md-whiteframe-2dp menu-item account\">\n            <span class=\"multi\">{{exploitation.raisonsociale}}</span>\n            <span>{{exploitation.numExploitation}}</span>\n          </md-card>\n        </div>\n        <div ng-if=\"ctrl.openFormAuth\">\n          <md-card ng-click=\"ctrl.toggleForm(exploitation)\" ng-model=\"exploitation\" class=\"md-whiteframe-2dp menu-item account\">\n            <span>{{ctrl.exploitation.raisonsociale}}</span>\n            <span>{{ctrl.exploitation.numExploitation}}</span>\n          </md-card>\n          <div layout=\"row\">\n\n            <md-input-container>\n              <label>Identifiant</label>\n              <input required name=\"identifiant\" ng-model=\"ctrl.exploitation.login\" readonly=\"readonly\">\n              <div ng-messages=\"ctrl.authentForm.identifiant.$error\" role=\"alert\" ng-show=\"ctrl.authentForm.$submitted\">\n                <div ng-message=\"required\">Donnée obligatoire</div>\n              </div>\n            </md-input-container>\n          </div>\n          <div layout=\"row\">\n            <md-input-container>\n              <label>Mot de passe</label>\n              <input required type=\"password\" name=\"password\" ng-model=\"ctrl.exploitation.password\">\n              <div ng-messages=\"ctrl.authentForm.password.$error\" role=\"alert \" ng-show=\"ctrl.authentForm.$submitted\">\n                <div ng-message=\"required\">Donnée obligatoire</div>\n              </div>\n            </md-input-container>\n          </div>\n          <div ng-if=\"ctrl.authentError\" class=\"error-message\">{{ctrl.authentError}}</div>\n        </div>\n      </div>\n    </md-dialog-content>\n    <md-dialog-content class=\"md-dialog-content\" ng-if=\"ctrl.estKeyCloak\">\n      <div layout=\"column\">\n        <md-card flex=\"50\" ng-click=\"ctrl.selectionCheptel(exploitation)\" ng-repeat=\"exploitation in ctrl.exploitations\" ng-model=\"exploitation\" class=\"md-whiteframe-2dp menu-item account\">\n          <span class=\"multi\">{{exploitation.raisonsociale}}</span>\n          <span>{{exploitation.numExploitation}}</span>\n        </md-card>\n      </div>\n    </md-dialog-content>\n\n    <md-dialog-actions ng-if=\"!ctrl.openFormAuth\">\n      <md-button ng-click=\"ctrl.close()\" class=\"md-raised md-primary\">Fermer</md-button>\n    </md-dialog-actions>\n    <md-dialog-actions ng-if=\"ctrl.openFormAuth\">\n      <md-button ng-click=\"ctrl.cancel()\" class=\"md-raised\">Annuler</md-button>\n      <md-button type=\"submit\" class=\"md-raised md-primary\">Connexion</md-button>\n    </md-dialog-actions>\n  </form>\n</md-dialog>");
$templateCache.put("app/eleveur/bovin/_common/directives/dossierAnimal/dossierAnimal.html","<md-card class=\"dossierAnimal\">\n  <md-card-header>\n    <h3 flex>Dossier animal</h3>\n    <md-icon md-svg-src=\"assets/images/icones/animal.svg\" aria-label=\"Dossier animal\"></md-icon>\n  </md-card-header>\n\n  <div ng-show=\"dossierAnimalCtrl.loadingFonctionnalite\" flex layout=\"row\" layout-align=\"center center\">\n    <md-progress-circular md-diameter=\"20\"></md-progress-circular>\n  </div>\n\n  <div ng-show=\"dossierAnimalCtrl.errorFonctionnalite\" flex layout=\"column\" layout-align=\"center center\">\n    <div>Erreur pendant le chargement de la fonctionnalité</div>\n\n    <md-button ng-click=\"dossierAnimalCtrl.loadFonctionnalite()\" class=\"md-raised\">Réessayer</md-button>\n  </div>\n\n  <div ng-show=\"dossierAnimalCtrl.errorSearching\" flex layout=\"column\" layout-align=\"center center\">\n    <div>Erreur pendant le chargement des animaux</div>\n\n    <md-button ng-click=\"dossierAnimalCtrl.getInventaire()\" class=\"md-raised\">Réessayer</md-button>\n  </div>\n\n  <form name=\"dossierAnimalCtrl.searchAnimalForm\" ng-if=\"dossierAnimalCtrl.fonctionnalite && !dossierAnimalCtrl.errorSearching\" ng-submit=\"dossierAnimalCtrl.onSubmit()\" flex layout=\"column\" novalidate>\n    <md-card-content flex layout=\"column\">\n      <div class=\"autocomplete-container\">\n        <md-autocomplete md-input-name=\"animal\" md-selected-item=\"dossierAnimalCtrl.animal\" md-search-text=\"dossierAnimalCtrl.searchText\" md-items=\"animal in dossierAnimalCtrl.searchAnimal(dossierAnimalCtrl.searchText)\" md-item-text=\"animal.identifiantFavori + \' - \' + animal.numeroNational\" md-min-length=\"0\" md-delay=\"500\" md-no-cache=\"true\" ng-disabled=\"dossierAnimalCtrl.searching\" md-require-match=\"true\" required placeholder=\"Identifiant favori ou numéro national\" md-floating-label=\"Identifiant favori ou numéro national\">\n          <md-item-template>\n            <span md-highlight-text=\"dossierAnimalCtrl.searchText\" md-highlight-flags=\"g\">{{animal.identifiantFavori}} - {{animal.numeroNational}}</span>\n          </md-item-template>\n          <md-not-found>\n            Animal inconnu\n          </md-not-found>\n        </md-autocomplete>\n\n        <md-progress-circular ng-show=\"dossierAnimalCtrl.searching\" md-diameter=\"20\"></md-progress-circular>\n      </div>\n      <div ng-messages=\"dossierAnimalCtrl.searchAnimalForm.animal.$error\" ng-show=\"dossierAnimalCtrl.searchAnimalForm.$submitted\">\n        <div ng-message=\"required\">Obligatoire</div>\n        <div ng-message=\"md-require-match\">Obligatoire</div>\n      </div>\n\n      <md-radio-group ng-model=\"dossierAnimalCtrl.sortis\" layout=\"row\" layout-align=\"space-between center\">\n        <md-radio-button ng-value=\"false\">Présents</md-radio-button>\n        <md-radio-button ng-value=\"true\">\n          Présents et sortis depuis\n          <adv-parametre key=\"\'dossierAnimalSortisMois\'\" default=\"12\"></adv-parametre> mois\n        </md-radio-button>\n      </md-radio-group>\n    </md-card-content>\n\n    <md-button type=\"submit\" class=\"md-raised\">Ouvrir dossier</md-button>\n  </form>\n</md-card>\n");
$templateCache.put("app/eleveur/bovin/_common/directives/favoris/favoris.html","<md-card class=\"favoris\">\n  <md-card-header>\n    <h3 flex>Mes Favoris</h3>\n    <md-icon md-svg-src=\"assets/images/icones/star.svg\" aria-label=\"star\"></md-icon>\n  </md-card-header>\n\n  <div ng-show=\"favorisCtrl.loading\" flex layout=\"row\" layout-align=\"center center\">\n    <md-progress-circular md-diameter=\"20\"></md-progress-circular>\n  </div>\n\n  <div ng-show=\"favorisCtrl.error\" flex layout=\"column\" layout-align=\"center center\">\n    <div>Erreur pendant le chargement des favoris</div>\n\n    <md-button ng-click=\"favorisCtrl.load()\" class=\"md-raised\">Réessayer</md-button>\n  </div>\n\n  <div ng-if=\"favorisCtrl.favoris\" flex layout=\"column\">\n    <md-card-content flex layout=\"column\">\n      <md-button ng-repeat=\"favori in favorisCtrl.favoris | orderBy : \'libelleFavoris\'\" ng-click=\"favorisCtrl.goToFavori(favori)\" class=\"favori\">&gt; {{favori.libelleFavoris}}</md-button>\n    </md-card-content>\n\n    <md-button ng-click=\"favorisCtrl.editFavoris()\" class=\"md-raised edit\">Modifier</md-button>\n  </div>\n</md-card>\n");
$templateCache.put("app/eleveur/bovin/_common/directives/favoris/services/editFavoris/editFavoris.html","<md-dialog aria-label=\"Edition des favoris\" class=\"large-dialog\">\n  <md-toolbar>\n    <div class=\"md-toolbar-tools\">\n      <h2>Edition des favoris</h2>\n\n      <div flex></div>\n      <md-button class=\"md-icon-button\" ng-click=\"ctrl.cancel()\">\n        <md-icon md-svg-src=\"assets/images/icones/close.svg \" aria-label=\"close\"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n\n  <md-content flex>\n    <div flex layout=\"column\">\n      <md-checkbox ng-repeat=\"service in ctrl.services | orderBy : \'libelleFavoris\'\" ng-model=\"service.isFavori\" aria-label=\"{{service.libelleFavoris}}\">\n        {{service.libelleFavoris}}\n      </md-checkbox>\n    </div>\n  </md-content>\n\n  <md-dialog-actions>\n    <md-button ng-click=\"ctrl.cancel()\" class=\"md-raised md-primary\">Annuler</md-button>\n    <md-button ng-click=\"ctrl.save()\" class=\"md-raised md-primary\">Valider</md-button>\n  </md-dialog-actions>\n</md-dialog>");}]);
(function () {
  angular
    .module('app')
    .config(routesConfig);

  /** @ngInject */
  function routesConfig($locationProvider, $stateProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);

    $urlRouterProvider.otherwise('/eleveur/home');
  }
})();

/* eslint-disable */
/*
 * Copyright 2016 Red Hat, Inc. and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
    if ( typeof exports === 'object' ) {
        if ( typeof module === 'object' ) {
            module.exports = factory( require("js-sha256"), require("base64-js") );    
        } else {
            exports["keycloak"] = factory( require("js-sha256"), require("base64-js") );    
        }
    } else {
        /**
        * [js-sha256]{@link https://github.com/emn178/js-sha256}
        *
        * @version 0.9.0
        * @author Chen, Yi-Cyuan [emn178@gmail.com]
        * @copyright Chen, Yi-Cyuan 2014-2017
        * @license MIT
        */
        !function () { "use strict"; function t(t, i) { i ? (d[0] = d[16] = d[1] = d[2] = d[3] = d[4] = d[5] = d[6] = d[7] = d[8] = d[9] = d[10] = d[11] = d[12] = d[13] = d[14] = d[15] = 0, this.blocks = d) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], t ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = t } function i(i, r, s) { var e, n = typeof i; if ("string" === n) { var o, a = [], u = i.length, c = 0; for (e = 0; e < u; ++e)(o = i.charCodeAt(e)) < 128 ? a[c++] = o : o < 2048 ? (a[c++] = 192 | o >> 6, a[c++] = 128 | 63 & o) : o < 55296 || o >= 57344 ? (a[c++] = 224 | o >> 12, a[c++] = 128 | o >> 6 & 63, a[c++] = 128 | 63 & o) : (o = 65536 + ((1023 & o) << 10 | 1023 & i.charCodeAt(++e)), a[c++] = 240 | o >> 18, a[c++] = 128 | o >> 12 & 63, a[c++] = 128 | o >> 6 & 63, a[c++] = 128 | 63 & o); i = a } else { if ("object" !== n) throw new Error(h); if (null === i) throw new Error(h); if (f && i.constructor === ArrayBuffer) i = new Uint8Array(i); else if (!(Array.isArray(i) || f && ArrayBuffer.isView(i))) throw new Error(h) } i.length > 64 && (i = new t(r, !0).update(i).array()); var y = [], p = []; for (e = 0; e < 64; ++e) { var l = i[e] || 0; y[e] = 92 ^ l, p[e] = 54 ^ l } t.call(this, r, s), this.update(p), this.oKeyPad = y, this.inner = !0, this.sharedMemory = s } var h = "input is invalid type", r = "object" == typeof window, s = r ? window : {}; s.JS_SHA256_NO_WINDOW && (r = !1); var e = !r && "object" == typeof self, n = !s.JS_SHA256_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node; n ? s = global : e && (s = self); var o = !s.JS_SHA256_NO_COMMON_JS && "object" == typeof module && module.exports, a = "function" == typeof define && define.amd, f = !s.JS_SHA256_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer, u = "0123456789abcdef".split(""), c = [-2147483648, 8388608, 32768, 128], y = [24, 16, 8, 0], p = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298], l = ["hex", "array", "digest", "arrayBuffer"], d = []; !s.JS_SHA256_NO_NODE_JS && Array.isArray || (Array.isArray = function (t) { return "[object Array]" === Object.prototype.toString.call(t) }), !f || !s.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (t) { return "object" == typeof t && t.buffer && t.buffer.constructor === ArrayBuffer }); var A = function (i, h) { return function (r) { return new t(h, !0).update(r)[i]() } }, w = function (i) { var h = A("hex", i); n && (h = b(h, i)), h.create = function () { return new t(i) }, h.update = function (t) { return h.create().update(t) }; for (var r = 0; r < l.length; ++r) { var s = l[r]; h[s] = A(s, i) } return h }, b = function (t, i) { var r = eval("require('crypto')"), s = eval("require('buffer').Buffer"), e = i ? "sha224" : "sha256", n = function (i) { if ("string" == typeof i) return r.createHash(e).update(i, "utf8").digest("hex"); if (null === i || void 0 === i) throw new Error(h); return i.constructor === ArrayBuffer && (i = new Uint8Array(i)), Array.isArray(i) || ArrayBuffer.isView(i) || i.constructor === s ? r.createHash(e).update(new s(i)).digest("hex") : t(i) }; return n }, v = function (t, h) { return function (r, s) { return new i(r, h, !0).update(s)[t]() } }, _ = function (t) { var h = v("hex", t); h.create = function (h) { return new i(h, t) }, h.update = function (t, i) { return h.create(t).update(i) }; for (var r = 0; r < l.length; ++r) { var s = l[r]; h[s] = v(s, t) } return h }; t.prototype.update = function (t) { if (!this.finalized) { var i, r = typeof t; if ("string" !== r) { if ("object" !== r) throw new Error(h); if (null === t) throw new Error(h); if (f && t.constructor === ArrayBuffer) t = new Uint8Array(t); else if (!(Array.isArray(t) || f && ArrayBuffer.isView(t))) throw new Error(h); i = !0 } for (var s, e, n = 0, o = t.length, a = this.blocks; n < o;) { if (this.hashed && (this.hashed = !1, a[0] = this.block, a[16] = a[1] = a[2] = a[3] = a[4] = a[5] = a[6] = a[7] = a[8] = a[9] = a[10] = a[11] = a[12] = a[13] = a[14] = a[15] = 0), i) for (e = this.start; n < o && e < 64; ++n)a[e >> 2] |= t[n] << y[3 & e++]; else for (e = this.start; n < o && e < 64; ++n)(s = t.charCodeAt(n)) < 128 ? a[e >> 2] |= s << y[3 & e++] : s < 2048 ? (a[e >> 2] |= (192 | s >> 6) << y[3 & e++], a[e >> 2] |= (128 | 63 & s) << y[3 & e++]) : s < 55296 || s >= 57344 ? (a[e >> 2] |= (224 | s >> 12) << y[3 & e++], a[e >> 2] |= (128 | s >> 6 & 63) << y[3 & e++], a[e >> 2] |= (128 | 63 & s) << y[3 & e++]) : (s = 65536 + ((1023 & s) << 10 | 1023 & t.charCodeAt(++n)), a[e >> 2] |= (240 | s >> 18) << y[3 & e++], a[e >> 2] |= (128 | s >> 12 & 63) << y[3 & e++], a[e >> 2] |= (128 | s >> 6 & 63) << y[3 & e++], a[e >> 2] |= (128 | 63 & s) << y[3 & e++]); this.lastByteIndex = e, this.bytes += e - this.start, e >= 64 ? (this.block = a[16], this.start = e - 64, this.hash(), this.hashed = !0) : this.start = e } return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this } }, t.prototype.finalize = function () { if (!this.finalized) { this.finalized = !0; var t = this.blocks, i = this.lastByteIndex; t[16] = this.block, t[i >> 2] |= c[3 & i], this.block = t[16], i >= 56 && (this.hashed || this.hash(), t[0] = this.block, t[16] = t[1] = t[2] = t[3] = t[4] = t[5] = t[6] = t[7] = t[8] = t[9] = t[10] = t[11] = t[12] = t[13] = t[14] = t[15] = 0), t[14] = this.hBytes << 3 | this.bytes >>> 29, t[15] = this.bytes << 3, this.hash() } }, t.prototype.hash = function () { var t, i, h, r, s, e, n, o, a, f = this.h0, u = this.h1, c = this.h2, y = this.h3, l = this.h4, d = this.h5, A = this.h6, w = this.h7, b = this.blocks; for (t = 16; t < 64; ++t)i = ((s = b[t - 15]) >>> 7 | s << 25) ^ (s >>> 18 | s << 14) ^ s >>> 3, h = ((s = b[t - 2]) >>> 17 | s << 15) ^ (s >>> 19 | s << 13) ^ s >>> 10, b[t] = b[t - 16] + i + b[t - 7] + h << 0; for (a = u & c, t = 0; t < 64; t += 4)this.first ? (this.is224 ? (e = 300032, w = (s = b[0] - 1413257819) - 150054599 << 0, y = s + 24177077 << 0) : (e = 704751109, w = (s = b[0] - 210244248) - 1521486534 << 0, y = s + 143694565 << 0), this.first = !1) : (i = (f >>> 2 | f << 30) ^ (f >>> 13 | f << 19) ^ (f >>> 22 | f << 10), r = (e = f & u) ^ f & c ^ a, w = y + (s = w + (h = (l >>> 6 | l << 26) ^ (l >>> 11 | l << 21) ^ (l >>> 25 | l << 7)) + (l & d ^ ~l & A) + p[t] + b[t]) << 0, y = s + (i + r) << 0), i = (y >>> 2 | y << 30) ^ (y >>> 13 | y << 19) ^ (y >>> 22 | y << 10), r = (n = y & f) ^ y & u ^ e, A = c + (s = A + (h = (w >>> 6 | w << 26) ^ (w >>> 11 | w << 21) ^ (w >>> 25 | w << 7)) + (w & l ^ ~w & d) + p[t + 1] + b[t + 1]) << 0, i = ((c = s + (i + r) << 0) >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10), r = (o = c & y) ^ c & f ^ n, d = u + (s = d + (h = (A >>> 6 | A << 26) ^ (A >>> 11 | A << 21) ^ (A >>> 25 | A << 7)) + (A & w ^ ~A & l) + p[t + 2] + b[t + 2]) << 0, i = ((u = s + (i + r) << 0) >>> 2 | u << 30) ^ (u >>> 13 | u << 19) ^ (u >>> 22 | u << 10), r = (a = u & c) ^ u & y ^ o, l = f + (s = l + (h = (d >>> 6 | d << 26) ^ (d >>> 11 | d << 21) ^ (d >>> 25 | d << 7)) + (d & A ^ ~d & w) + p[t + 3] + b[t + 3]) << 0, f = s + (i + r) << 0; this.h0 = this.h0 + f << 0, this.h1 = this.h1 + u << 0, this.h2 = this.h2 + c << 0, this.h3 = this.h3 + y << 0, this.h4 = this.h4 + l << 0, this.h5 = this.h5 + d << 0, this.h6 = this.h6 + A << 0, this.h7 = this.h7 + w << 0 }, t.prototype.hex = function () { this.finalize(); var t = this.h0, i = this.h1, h = this.h2, r = this.h3, s = this.h4, e = this.h5, n = this.h6, o = this.h7, a = u[t >> 28 & 15] + u[t >> 24 & 15] + u[t >> 20 & 15] + u[t >> 16 & 15] + u[t >> 12 & 15] + u[t >> 8 & 15] + u[t >> 4 & 15] + u[15 & t] + u[i >> 28 & 15] + u[i >> 24 & 15] + u[i >> 20 & 15] + u[i >> 16 & 15] + u[i >> 12 & 15] + u[i >> 8 & 15] + u[i >> 4 & 15] + u[15 & i] + u[h >> 28 & 15] + u[h >> 24 & 15] + u[h >> 20 & 15] + u[h >> 16 & 15] + u[h >> 12 & 15] + u[h >> 8 & 15] + u[h >> 4 & 15] + u[15 & h] + u[r >> 28 & 15] + u[r >> 24 & 15] + u[r >> 20 & 15] + u[r >> 16 & 15] + u[r >> 12 & 15] + u[r >> 8 & 15] + u[r >> 4 & 15] + u[15 & r] + u[s >> 28 & 15] + u[s >> 24 & 15] + u[s >> 20 & 15] + u[s >> 16 & 15] + u[s >> 12 & 15] + u[s >> 8 & 15] + u[s >> 4 & 15] + u[15 & s] + u[e >> 28 & 15] + u[e >> 24 & 15] + u[e >> 20 & 15] + u[e >> 16 & 15] + u[e >> 12 & 15] + u[e >> 8 & 15] + u[e >> 4 & 15] + u[15 & e] + u[n >> 28 & 15] + u[n >> 24 & 15] + u[n >> 20 & 15] + u[n >> 16 & 15] + u[n >> 12 & 15] + u[n >> 8 & 15] + u[n >> 4 & 15] + u[15 & n]; return this.is224 || (a += u[o >> 28 & 15] + u[o >> 24 & 15] + u[o >> 20 & 15] + u[o >> 16 & 15] + u[o >> 12 & 15] + u[o >> 8 & 15] + u[o >> 4 & 15] + u[15 & o]), a }, t.prototype.toString = t.prototype.hex, t.prototype.digest = function () { this.finalize(); var t = this.h0, i = this.h1, h = this.h2, r = this.h3, s = this.h4, e = this.h5, n = this.h6, o = this.h7, a = [t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, 255 & t, i >> 24 & 255, i >> 16 & 255, i >> 8 & 255, 255 & i, h >> 24 & 255, h >> 16 & 255, h >> 8 & 255, 255 & h, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, 255 & r, s >> 24 & 255, s >> 16 & 255, s >> 8 & 255, 255 & s, e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e, n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, 255 & n]; return this.is224 || a.push(o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, 255 & o), a }, t.prototype.array = t.prototype.digest, t.prototype.arrayBuffer = function () { this.finalize(); var t = new ArrayBuffer(this.is224 ? 28 : 32), i = new DataView(t); return i.setUint32(0, this.h0), i.setUint32(4, this.h1), i.setUint32(8, this.h2), i.setUint32(12, this.h3), i.setUint32(16, this.h4), i.setUint32(20, this.h5), i.setUint32(24, this.h6), this.is224 || i.setUint32(28, this.h7), t }, i.prototype = new t, i.prototype.finalize = function () { if (t.prototype.finalize.call(this), this.inner) { this.inner = !1; var i = this.array(); t.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(i), t.prototype.finalize.call(this) } }; var B = w(); B.sha256 = B, B.sha224 = w(!0), B.sha256.hmac = _(), B.sha224.hmac = _(!0), o ? module.exports = B : (s.sha256 = B.sha256, s.sha224 = B.sha224, a && define(function () { return B })) }();

        /**
         * [base64-js]{@link https://github.com/beatgammit/base64-js}
         *
         * @version v1.3.0 
         * @author Kirill, Fomichev
         * @copyright Kirill, Fomichev 2014
         * @license MIT
         */
        (function (r) { if (typeof exports === "object" && typeof module !== "undefined") { module.exports = r() } else if (typeof define === "function" && define.amd) { define([], r) } else { var e; if (typeof window !== "undefined") { e = window } else if (typeof global !== "undefined") { e = global } else if (typeof self !== "undefined") { e = self } else { e = this } e.base64js = r() } })(function () { var r, e, n; return function () { function r(e, n, t) { function o(f, i) { if (!n[f]) { if (!e[f]) { var u = "function" == typeof require && require; if (!i && u) return u(f, !0); if (a) return a(f, !0); var v = new Error("Cannot find module '" + f + "'"); throw v.code = "MODULE_NOT_FOUND", v } var d = n[f] = { exports: {} }; e[f][0].call(d.exports, function (r) { var n = e[f][1][r]; return o(n || r) }, d, d.exports, r, e, n, t) } return n[f].exports } for (var a = "function" == typeof require && require, f = 0; f < t.length; f++)o(t[f]); return o } return r }()({ "/": [function (r, e, n) { "use strict"; n.byteLength = d; n.toByteArray = h; n.fromByteArray = p; var t = []; var o = []; var a = typeof Uint8Array !== "undefined" ? Uint8Array : Array; var f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"; for (var i = 0, u = f.length; i < u; ++i) { t[i] = f[i]; o[f.charCodeAt(i)] = i } o["-".charCodeAt(0)] = 62; o["_".charCodeAt(0)] = 63; function v(r) { var e = r.length; if (e % 4 > 0) { throw new Error("Invalid string. Length must be a multiple of 4") } var n = r.indexOf("="); if (n === -1) n = e; var t = n === e ? 0 : 4 - n % 4; return [n, t] } function d(r) { var e = v(r); var n = e[0]; var t = e[1]; return (n + t) * 3 / 4 - t } function c(r, e, n) { return (e + n) * 3 / 4 - n } function h(r) { var e; var n = v(r); var t = n[0]; var f = n[1]; var i = new a(c(r, t, f)); var u = 0; var d = f > 0 ? t - 4 : t; for (var h = 0; h < d; h += 4) { e = o[r.charCodeAt(h)] << 18 | o[r.charCodeAt(h + 1)] << 12 | o[r.charCodeAt(h + 2)] << 6 | o[r.charCodeAt(h + 3)]; i[u++] = e >> 16 & 255; i[u++] = e >> 8 & 255; i[u++] = e & 255 } if (f === 2) { e = o[r.charCodeAt(h)] << 2 | o[r.charCodeAt(h + 1)] >> 4; i[u++] = e & 255 } if (f === 1) { e = o[r.charCodeAt(h)] << 10 | o[r.charCodeAt(h + 1)] << 4 | o[r.charCodeAt(h + 2)] >> 2; i[u++] = e >> 8 & 255; i[u++] = e & 255 } return i } function s(r) { return t[r >> 18 & 63] + t[r >> 12 & 63] + t[r >> 6 & 63] + t[r & 63] } function l(r, e, n) { var t; var o = []; for (var a = e; a < n; a += 3) { t = (r[a] << 16 & 16711680) + (r[a + 1] << 8 & 65280) + (r[a + 2] & 255); o.push(s(t)) } return o.join("") } function p(r) { var e; var n = r.length; var o = n % 3; var a = []; var f = 16383; for (var i = 0, u = n - o; i < u; i += f) { a.push(l(r, i, i + f > u ? u : i + f)) } if (o === 1) { e = r[n - 1]; a.push(t[e >> 2] + t[e << 4 & 63] + "==") } else if (o === 2) { e = (r[n - 2] << 8) + r[n - 1]; a.push(t[e >> 10] + t[e >> 4 & 63] + t[e << 2 & 63] + "=") } return a.join("") } }, {}] }, {}, [])("/") });

        /**
         * [promise-polyfill]{@link https://github.com/taylorhakes/promise-polyfill}
         *
         * @version v8.1.3 
         * @author Hakes, Taylor
         * @copyright Hakes, Taylor 2014
         * @license MIT
         */
        !function(e,n){"object"==typeof exports&&"undefined"!=typeof module?n():"function"==typeof define&&define.amd?define(n):n()}(0,function(){"use strict";function e(e){var n=this.constructor;return this.then(function(t){return n.resolve(e()).then(function(){return t})},function(t){return n.resolve(e()).then(function(){return n.reject(t)})})}function n(e){return!(!e||"undefined"==typeof e.length)}function t(){}function o(e){if(!(this instanceof o))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=undefined,this._deferreds=[],c(e,this)}function r(e,n){for(;3===e._state;)e=e._value;0!==e._state?(e._handled=!0,o._immediateFn(function(){var t=1===e._state?n.onFulfilled:n.onRejected;if(null!==t){var o;try{o=t(e._value)}catch(r){return void f(n.promise,r)}i(n.promise,o)}else(1===e._state?i:f)(n.promise,e._value)})):e._deferreds.push(n)}function i(e,n){try{if(n===e)throw new TypeError("A promise cannot be resolved with itself.");if(n&&("object"==typeof n||"function"==typeof n)){var t=n.then;if(n instanceof o)return e._state=3,e._value=n,void u(e);if("function"==typeof t)return void c(function(e,n){return function(){e.apply(n,arguments)}}(t,n),e)}e._state=1,e._value=n,u(e)}catch(r){f(e,r)}}function f(e,n){e._state=2,e._value=n,u(e)}function u(e){2===e._state&&0===e._deferreds.length&&o._immediateFn(function(){e._handled||o._unhandledRejectionFn(e._value)});for(var n=0,t=e._deferreds.length;t>n;n++)r(e,e._deferreds[n]);e._deferreds=null}function c(e,n){var t=!1;try{e(function(e){t||(t=!0,i(n,e))},function(e){t||(t=!0,f(n,e))})}catch(o){if(t)return;t=!0,f(n,o)}}var a=setTimeout;o.prototype["catch"]=function(e){return this.then(null,e)},o.prototype.then=function(e,n){var o=new this.constructor(t);return r(this,new function(e,n,t){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof n?n:null,this.promise=t}(e,n,o)),o},o.prototype["finally"]=e,o.all=function(e){return new o(function(t,o){function r(e,n){try{if(n&&("object"==typeof n||"function"==typeof n)){var u=n.then;if("function"==typeof u)return void u.call(n,function(n){r(e,n)},o)}i[e]=n,0==--f&&t(i)}catch(c){o(c)}}if(!n(e))return o(new TypeError("Promise.all accepts an array"));var i=Array.prototype.slice.call(e);if(0===i.length)return t([]);for(var f=i.length,u=0;i.length>u;u++)r(u,i[u])})},o.resolve=function(e){return e&&"object"==typeof e&&e.constructor===o?e:new o(function(n){n(e)})},o.reject=function(e){return new o(function(n,t){t(e)})},o.race=function(e){return new o(function(t,r){if(!n(e))return r(new TypeError("Promise.race accepts an array"));for(var i=0,f=e.length;f>i;i++)o.resolve(e[i]).then(t,r)})},o._immediateFn="function"==typeof setImmediate&&function(e){setImmediate(e)}||function(e){a(e,0)},o._unhandledRejectionFn=function(e){void 0!==console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)};var l=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if("undefined"!=typeof global)return global;throw Error("unable to locate global object")}();"Promise"in l?l.Promise.prototype["finally"]||(l.Promise.prototype["finally"]=e):l.Promise=o});

        var Keycloak = factory( root["sha256"], root["base64js"] );
        root["Keycloak"] = Keycloak;

        if ( typeof define === "function" && define.amd ) { 
            define( "keycloak", [], function () { return Keycloak; } );
        }
    }
})(window, function (sha256_imported, base64js_imported) {
    if (typeof Promise === 'undefined') {
        throw Error('Keycloak requires an environment that supports Promises. Make sure that you include the appropriate polyfill.');
    }

    var loggedPromiseDeprecation = false;

    function logPromiseDeprecation() {
        if (!loggedPromiseDeprecation) {
            loggedPromiseDeprecation = true;
            console.warn('[KEYCLOAK] Usage of legacy style promise methods such as `.error()` and `.success()` has been deprecated and support will be removed in future versions. Use standard style promise methods such as `.then() and `.catch()` instead.');
        }
    }

    function toKeycloakPromise(promise) {
        promise.__proto__ = KeycloakPromise.prototype;
        return promise;
    }

    function KeycloakPromise(executor) {
        return toKeycloakPromise(new Promise(executor));
    }

    KeycloakPromise.prototype = Object.create(Promise.prototype);
    KeycloakPromise.prototype.constructor = KeycloakPromise;

    KeycloakPromise.prototype.success = function(callback) {
        logPromiseDeprecation();

        var promise = this.then(function handleSuccess(value) {
            callback(value);
        });
        
        return toKeycloakPromise(promise);
    };

    KeycloakPromise.prototype.error = function(callback) {
        logPromiseDeprecation();

        var promise = this.catch(function handleError(error) {
            callback(error);
        });

        return toKeycloakPromise(promise);
    };

    function Keycloak (config) {
        if (!(this instanceof Keycloak)) {
            return new Keycloak(config);
        }

        var kc = this;
        var adapter;
        var refreshQueue = [];
        var callbackStorage;

        var loginIframe = {
            enable: true,
            callbackList: [],
            interval: 5
        };

        var scripts = document.getElementsByTagName('script');
        for (var i = 0; i < scripts.length; i++) {
            if ((scripts[i].src.indexOf('keycloak.js') !== -1 || scripts[i].src.indexOf('keycloak.min.js') !== -1) && scripts[i].src.indexOf('version=') !== -1) {
                kc.iframeVersion = scripts[i].src.substring(scripts[i].src.indexOf('version=') + 8).split('&')[0];
            }
        }

        var useNonce = true;
        var logInfo = createLogger(console.info);
        var logWarn = createLogger(console.warn);
        
        kc.init = function (initOptions) {
            kc.authenticated = false;

            callbackStorage = createCallbackStorage();
            var adapters = ['default', 'cordova', 'cordova-native'];

            if (initOptions && adapters.indexOf(initOptions.adapter) > -1) {
                adapter = loadAdapter(initOptions.adapter);
            } else if (initOptions && typeof initOptions.adapter === "object") {
                adapter = initOptions.adapter;
            } else {
                if (window.Cordova || window.cordova) {
                    adapter = loadAdapter('cordova');
                } else {
                    adapter = loadAdapter();
                }
            }

            if (initOptions) {
                if (typeof initOptions.useNonce !== 'undefined') {
                    useNonce = initOptions.useNonce;
                }

                if (typeof initOptions.checkLoginIframe !== 'undefined') {
                    loginIframe.enable = initOptions.checkLoginIframe;
                }

                if (initOptions.checkLoginIframeInterval) {
                    loginIframe.interval = initOptions.checkLoginIframeInterval;
                }

                if (initOptions.onLoad === 'login-required') {
                    kc.loginRequired = true;
                }

                if (initOptions.responseMode) {
                    if (initOptions.responseMode === 'query' || initOptions.responseMode === 'fragment') {
                        kc.responseMode = initOptions.responseMode;
                    } else {
                        throw 'Invalid value for responseMode';
                    }
                }

                if (initOptions.flow) {
                    switch (initOptions.flow) {
                        case 'standard':
                            kc.responseType = 'code';
                            break;
                        case 'implicit':
                            kc.responseType = 'id_token token';
                            break;
                        case 'hybrid':
                            kc.responseType = 'code id_token token';
                            break;
                        default:
                            throw 'Invalid value for flow';
                    }
                    kc.flow = initOptions.flow;
                }

                if (initOptions.timeSkew != null) {
                    kc.timeSkew = initOptions.timeSkew;
                }

                if(initOptions.redirectUri) {
                    kc.redirectUri = initOptions.redirectUri;
                }

                if (initOptions.silentCheckSsoRedirectUri) {
                    kc.silentCheckSsoRedirectUri = initOptions.silentCheckSsoRedirectUri;
                }

                if (initOptions.pkceMethod) {
                    if (initOptions.pkceMethod !== "S256") {
                        throw 'Invalid value for pkceMethod';
                    }
                    kc.pkceMethod = initOptions.pkceMethod;
                }

                if (typeof initOptions.enableLogging === 'boolean') {
                    kc.enableLogging = initOptions.enableLogging;
                } else {
                    kc.enableLogging = false;
                }
            }

            if (!kc.responseMode) {
                kc.responseMode = 'fragment';
            }
            if (!kc.responseType) {
                kc.responseType = 'code';
                kc.flow = 'standard';
            }

            var promise = createPromise();

            var initPromise = createPromise();
            initPromise.promise.then(function() {
                kc.onReady && kc.onReady(kc.authenticated);
                promise.setSuccess(kc.authenticated);
            }).catch(function(errorData) {
                promise.setError(errorData);
            });

            var configPromise = loadConfig(config);

            function onLoad() {
                var doLogin = function(prompt) {
                    if (!prompt) {
                        options.prompt = 'none';
                    }

                    kc.login(options).then(function () {
                        initPromise.setSuccess();
                    }).catch(function () {
                        initPromise.setError();
                    });
                }

                var checkSsoSilently = function() {
                    var ifrm = document.createElement("iframe");
                    var src = kc.createLoginUrl({prompt: 'none', redirectUri: kc.silentCheckSsoRedirectUri});
                    ifrm.setAttribute("src", src);
                    ifrm.setAttribute("title", "keycloak-silent-check-sso");
                    ifrm.style.display = "none";
                    document.body.appendChild(ifrm);

                    var messageCallback = function(event) {
                        if (event.origin !== window.location.origin || ifrm.contentWindow !== event.source) {
                            return;
                        }

                        var oauth = parseCallback(event.data);
                        processCallback(oauth, initPromise);

                        document.body.removeChild(ifrm);
                        window.removeEventListener("message", messageCallback);
                    };

                    window.addEventListener("message", messageCallback);
                };

                var options = {};
                switch (initOptions.onLoad) {
                    case 'check-sso':
                        if (loginIframe.enable) {
                            setupCheckLoginIframe().then(function() {
                                checkLoginIframe().then(function (unchanged) {
                                    if (!unchanged) {
                                        kc.silentCheckSsoRedirectUri ? checkSsoSilently() : doLogin(false);
                                    } else {
                                        initPromise.setSuccess();
                                    }
                                }).catch(function () {
                                    initPromise.setError();
                                });
                            });
                        } else {
                            kc.silentCheckSsoRedirectUri ? checkSsoSilently() : doLogin(false);
                        }
                        break;
                    case 'login-required':
                        doLogin(true);
                        break;
                    default:
                        throw 'Invalid value for onLoad';
                }
            }

            function processInit() {
                var callback = parseCallback(window.location.href);

                if (callback) {
                    window.history.replaceState(window.history.state, null, callback.newUrl);
                }

                if (callback && callback.valid) {
                    return setupCheckLoginIframe().then(function() {
                        processCallback(callback, initPromise);
                    }).catch(function (e) {
                        initPromise.setError();
                    });
                } else if (initOptions) {
                    if (initOptions.token && initOptions.refreshToken) {
                        setToken(initOptions.token, initOptions.refreshToken, initOptions.idToken);

                        if (loginIframe.enable) {
                            setupCheckLoginIframe().then(function() {
                                checkLoginIframe().then(function (unchanged) {
                                    if (unchanged) {
                                        kc.onAuthSuccess && kc.onAuthSuccess();
                                        initPromise.setSuccess();
                                        scheduleCheckIframe();
                                    } else {
                                        initPromise.setSuccess();
                                    }
                                }).catch(function () {
                                    initPromise.setError();
                                });
                            });
                        } else {
                            kc.updateToken(-1).then(function() {
                                kc.onAuthSuccess && kc.onAuthSuccess();
                                initPromise.setSuccess();
                            }).catch(function() {
                                kc.onAuthError && kc.onAuthError();
                                if (initOptions.onLoad) {
                                    onLoad();
                                } else {
                                    initPromise.setError();
                                }
                            });
                        }
                    } else if (initOptions.onLoad) {
                        onLoad();
                    } else {
                        initPromise.setSuccess();
                    }
                } else {
                    initPromise.setSuccess();
                }
            }

            configPromise.then(processInit);
            configPromise.catch(function() {
                promise.setError();
            });

            return promise.promise;
        }

        kc.login = function (options) {
            return adapter.login(options);
        }

        function generateRandomData(len) {
            // use web crypto APIs if possible
            var array = null;
            var crypto = window.crypto || window.msCrypto;
            if (crypto && crypto.getRandomValues && window.Uint8Array) {
                array = new Uint8Array(len);
                crypto.getRandomValues(array);
                return array;
            }

            // fallback to Math random
            array = new Array(len);
            for (var j = 0; j < array.length; j++) {
                array[j] = Math.floor(256 * Math.random());
            }
            return array;
        }

        function generateCodeVerifier(len) {
            return generateRandomString(len, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789');
        }

        function generateRandomString(len, alphabet){
            var randomData = generateRandomData(len);
            var chars = new Array(len);
            for (var i = 0; i < len; i++) {
                chars[i] = alphabet.charCodeAt(randomData[i] % alphabet.length);
            }
            return String.fromCharCode.apply(null, chars);
        }

        function generatePkceChallenge(pkceMethod, codeVerifier) {
            switch (pkceMethod) {
                // The use of the "plain" method is considered insecure and therefore not supported.
                case "S256":
                    // hash codeVerifier, then encode as url-safe base64 without padding
                    var hashBytes = new Uint8Array(sha256_imported.arrayBuffer(codeVerifier));
                    var encodedHash = base64js_imported.fromByteArray(hashBytes)
                        .replace(/\+/g, '-')
                        .replace(/\//g, '_')
                        .replace(/\=/g, '');
                    return encodedHash;
                default:
                    throw 'Invalid value for pkceMethod';
            }
        }

        kc.createLoginUrl = function(options) {
            var state = createUUID();
            var nonce = createUUID();

            var redirectUri = adapter.redirectUri(options);

            var callbackState = {
                state: state,
                nonce: nonce,
                redirectUri: encodeURIComponent(redirectUri)
            };

            if (options && options.prompt) {
                callbackState.prompt = options.prompt;
            }

            var baseUrl;
            if (options && options.action == 'register') {
                baseUrl = kc.endpoints.register();
            } else {
                baseUrl = kc.endpoints.authorize();
            }

            var scope;
            if (options && options.scope) {
                if (options.scope.indexOf("openid") != -1) {
                    scope = options.scope;
                } else {
                    scope = "openid " + options.scope;
                }
            } else {
                scope = "openid";
            }

            var url = baseUrl
                + '?client_id=' + encodeURIComponent(kc.clientId)
                + '&redirect_uri=' + encodeURIComponent(redirectUri)
                + '&state=' + encodeURIComponent(state)
                + '&response_mode=' + encodeURIComponent(kc.responseMode)
                + '&response_type=' + encodeURIComponent(kc.responseType)
                + '&scope=' + encodeURIComponent(scope);
            if (useNonce) {
                url = url + '&nonce=' + encodeURIComponent(nonce);
            }

            if (options && options.prompt) {
                url += '&prompt=' + encodeURIComponent(options.prompt);
            }

            if (options && options.maxAge) {
                url += '&max_age=' + encodeURIComponent(options.maxAge);
            }

            if (options && options.loginHint) {
                url += '&login_hint=' + encodeURIComponent(options.loginHint);
            }

            if (options && options.idpHint) {
                url += '&kc_idp_hint=' + encodeURIComponent(options.idpHint);
            }

            if (options && options.action && options.action != 'register') {
                url += '&kc_action=' + encodeURIComponent(options.action);
            }

            if (options && options.locale) {
                url += '&ui_locales=' + encodeURIComponent(options.locale);
            }

            if (kc.pkceMethod) {
                var codeVerifier = generateCodeVerifier(96);
                callbackState.pkceCodeVerifier = codeVerifier;
                var pkceChallenge = generatePkceChallenge(kc.pkceMethod, codeVerifier);
                url += '&code_challenge=' + pkceChallenge;
                url += '&code_challenge_method=' + kc.pkceMethod;
            }

            callbackStorage.add(callbackState);

            return url;
        }

        kc.logout = function(options) {
            return adapter.logout(options);
        }

        kc.createLogoutUrl = function(options) {
            var url = kc.endpoints.logout()
                + '?redirect_uri=' + encodeURIComponent(adapter.redirectUri(options, false));

            return url;
        }

        kc.register = function (options) {
            return adapter.register(options);
        }

        kc.createRegisterUrl = function(options) {
            if (!options) {
                options = {};
            }
            options.action = 'register';
            return kc.createLoginUrl(options);
        }

        kc.createAccountUrl = function(options) {
            var realm = getRealmUrl();
            var url = undefined;
            if (typeof realm !== 'undefined') {
                url = realm
                + '/account'
                + '?referrer=' + encodeURIComponent(kc.clientId)
                + '&referrer_uri=' + encodeURIComponent(adapter.redirectUri(options));
            }
            return url;
        }

        kc.accountManagement = function() {
            return adapter.accountManagement();
        }

        kc.hasRealmRole = function (role) {
            var access = kc.realmAccess;
            return !!access && access.roles.indexOf(role) >= 0;
        }

        kc.hasResourceRole = function(role, resource) {
            if (!kc.resourceAccess) {
                return false;
            }

            var access = kc.resourceAccess[resource || kc.clientId];
            return !!access && access.roles.indexOf(role) >= 0;
        }

        kc.loadUserProfile = function() {
            var url = getRealmUrl() + '/account';
            var req = new XMLHttpRequest();
            req.open('GET', url, true);
            req.setRequestHeader('Accept', 'application/json');
            req.setRequestHeader('Authorization', 'bearer ' + kc.token);

            var promise = createPromise();

            req.onreadystatechange = function () {
                if (req.readyState == 4) {
                    if (req.status == 200) {
                        kc.profile = JSON.parse(req.responseText);
                        promise.setSuccess(kc.profile);
                    } else {
                        promise.setError();
                    }
                }
            }

            req.send();

            return promise.promise;
        }

        kc.loadUserInfo = function() {
            var url = kc.endpoints.userinfo();
            var req = new XMLHttpRequest();
            req.open('GET', url, true);
            req.setRequestHeader('Accept', 'application/json');
            req.setRequestHeader('Authorization', 'bearer ' + kc.token);

            var promise = createPromise();

            req.onreadystatechange = function () {
                if (req.readyState == 4) {
                    if (req.status == 200) {
                        kc.userInfo = JSON.parse(req.responseText);
                        promise.setSuccess(kc.userInfo);
                    } else {
                        promise.setError();
                    }
                }
            }

            req.send();

            return promise.promise;
        }

        kc.isTokenExpired = function(minValidity) {
            if (!kc.tokenParsed || (!kc.refreshToken && kc.flow != 'implicit' )) {
                throw 'Not authenticated';
            }

            if (kc.timeSkew == null) {
                logInfo('[KEYCLOAK] Unable to determine if token is expired as timeskew is not set');
                return true;
            }

            var expiresIn = kc.tokenParsed['exp'] - Math.ceil(new Date().getTime() / 1000) + kc.timeSkew;
            if (minValidity) {
                if (isNaN(minValidity)) {
                    throw 'Invalid minValidity';
                }
                expiresIn -= minValidity;
            }
            return expiresIn < 0;
        }

        kc.updateToken = function(minValidity) {
            var promise = createPromise();

            if (!kc.refreshToken) {
                promise.setError();
                return promise.promise;
            }

            minValidity = minValidity || 5;

            var exec = function() {
                var refreshToken = false;
                if (minValidity == -1) {
                    refreshToken = true;
                    logInfo('[KEYCLOAK] Refreshing token: forced refresh');
                } else if (!kc.tokenParsed || kc.isTokenExpired(minValidity)) {
                    refreshToken = true;
                    logInfo('[KEYCLOAK] Refreshing token: token expired');
                }

                if (!refreshToken) {
                    promise.setSuccess(false);
                } else {
                    var params = 'grant_type=refresh_token&' + 'refresh_token=' + kc.refreshToken;
                    var url = kc.endpoints.token();

                    refreshQueue.push(promise);

                    if (refreshQueue.length == 1) {
                        var req = new XMLHttpRequest();
                        req.open('POST', url, true);
                        req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                        req.withCredentials = true;

                        params += '&client_id=' + encodeURIComponent(kc.clientId);

                        var timeLocal = new Date().getTime();

                        req.onreadystatechange = function () {
                            if (req.readyState == 4) {
                                if (req.status == 200) {
                                    logInfo('[KEYCLOAK] Token refreshed');

                                    timeLocal = (timeLocal + new Date().getTime()) / 2;

                                    var tokenResponse = JSON.parse(req.responseText);

                                    setToken(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], timeLocal);

                                    kc.onAuthRefreshSuccess && kc.onAuthRefreshSuccess();
                                    for (var p = refreshQueue.pop(); p != null; p = refreshQueue.pop()) {
                                        p.setSuccess(true);
                                    }
                                } else {
                                    logWarn('[KEYCLOAK] Failed to refresh token');

                                    if (req.status == 400) {
                                        kc.clearToken();
                                    }

                                    kc.onAuthRefreshError && kc.onAuthRefreshError();
                                    for (var p = refreshQueue.pop(); p != null; p = refreshQueue.pop()) {
                                        p.setError(true);
                                    }
                                }
                            }
                        };

                        req.send(params);
                    }
                }
            }

            if (loginIframe.enable) {
                var iframePromise = checkLoginIframe();
                iframePromise.then(function() {
                    exec();
                }).catch(function() {
                    promise.setError();
                });
            } else {
                exec();
            }

            return promise.promise;
        }

        kc.clearToken = function() {
            if (kc.token) {
                setToken(null, null, null);
                kc.onAuthLogout && kc.onAuthLogout();
                if (kc.loginRequired) {
                    kc.login();
                }
            }
        }

        function getRealmUrl() {
            if (typeof kc.authServerUrl !== 'undefined') {
                if (kc.authServerUrl.charAt(kc.authServerUrl.length - 1) == '/') {
                    return kc.authServerUrl + 'realms/' + encodeURIComponent(kc.realm);
                } else {
                    return kc.authServerUrl + '/realms/' + encodeURIComponent(kc.realm);
                }
            } else {
            	return undefined;
            }
        }

        function getOrigin() {
            if (!window.location.origin) {
                return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
            } else {
                return window.location.origin;
            }
        }

        function processCallback(oauth, promise) {
            var code = oauth.code;
            var error = oauth.error;
            var prompt = oauth.prompt;

            var timeLocal = new Date().getTime();

            if (oauth['kc_action_status']) {
                kc.onActionUpdate && kc.onActionUpdate(oauth['kc_action_status']);
            }

            if (error) {
                if (prompt != 'none') {
                    var errorData = { error: error, error_description: oauth.error_description };
                    kc.onAuthError && kc.onAuthError(errorData);
                    promise && promise.setError(errorData);
                } else {
                    promise && promise.setSuccess();
                }
                return;
            } else if ((kc.flow != 'standard') && (oauth.access_token || oauth.id_token)) {
                authSuccess(oauth.access_token, null, oauth.id_token, true);
            }

            if ((kc.flow != 'implicit') && code) {
                var params = 'code=' + code + '&grant_type=authorization_code';
                var url = kc.endpoints.token();

                var req = new XMLHttpRequest();
                req.open('POST', url, true);
                req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                params += '&client_id=' + encodeURIComponent(kc.clientId);
                params += '&redirect_uri=' + oauth.redirectUri;

                if (oauth.pkceCodeVerifier) {
                    params += '&code_verifier=' + oauth.pkceCodeVerifier;
                }

                req.withCredentials = true;

                req.onreadystatechange = function() {
                    if (req.readyState == 4) {
                        if (req.status == 200) {

                            var tokenResponse = JSON.parse(req.responseText);
                            authSuccess(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], kc.flow === 'standard');
                            scheduleCheckIframe();
                        } else {
                            kc.onAuthError && kc.onAuthError();
                            promise && promise.setError();
                        }
                    }
                };

                req.send(params);
            }

            function authSuccess(accessToken, refreshToken, idToken, fulfillPromise) {
                timeLocal = (timeLocal + new Date().getTime()) / 2;

                setToken(accessToken, refreshToken, idToken, timeLocal);

                if (useNonce && ((kc.tokenParsed && kc.tokenParsed.nonce != oauth.storedNonce) ||
                    (kc.refreshTokenParsed && kc.refreshTokenParsed.nonce != oauth.storedNonce) ||
                    (kc.idTokenParsed && kc.idTokenParsed.nonce != oauth.storedNonce))) {

                    logInfo('[KEYCLOAK] Invalid nonce, clearing token');
                    kc.clearToken();
                    promise && promise.setError();
                } else {
                    if (fulfillPromise) {
                        kc.onAuthSuccess && kc.onAuthSuccess();
                        promise && promise.setSuccess();
                    }
                }
            }

        }

        function loadConfig(url) {
            var promise = createPromise();
            var configUrl;

            if (!config) {
                configUrl = 'keycloak.json';
            } else if (typeof config === 'string') {
                configUrl = config;
            }

            function setupOidcEndoints(oidcConfiguration) {
                if (! oidcConfiguration) {
                    kc.endpoints = {
                        authorize: function() {
                            return getRealmUrl() + '/protocol/openid-connect/auth';
                        },
                        token: function() {
                            return getRealmUrl() + '/protocol/openid-connect/token';
                        },
                        logout: function() {
                            return getRealmUrl() + '/protocol/openid-connect/logout';
                        },
                        checkSessionIframe: function() {
                            var src = getRealmUrl() + '/protocol/openid-connect/login-status-iframe.html';
                            if (kc.iframeVersion) {
                              src = src + '?version=' + kc.iframeVersion;
                            }
                            return src;
                        },
                        register: function() {
                            return getRealmUrl() + '/protocol/openid-connect/registrations';
                        },
                        userinfo: function() {
                            return getRealmUrl() + '/protocol/openid-connect/userinfo';
                        }
                    };
                } else {
                    kc.endpoints = {
                        authorize: function() {
                            return oidcConfiguration.authorization_endpoint;
                        },
                        token: function() {
                            return oidcConfiguration.token_endpoint;
                        },
                        logout: function() {
                            if (!oidcConfiguration.end_session_endpoint) {
                                throw "Not supported by the OIDC server";
                            }
                            return oidcConfiguration.end_session_endpoint;
                        },
                        checkSessionIframe: function() {
                            if (!oidcConfiguration.check_session_iframe) {
                                throw "Not supported by the OIDC server";
                            }
                            return oidcConfiguration.check_session_iframe;
                        },
                        register: function() {
                            throw 'Redirection to "Register user" page not supported in standard OIDC mode';
                        },
                        userinfo: function() {
                            if (!oidcConfiguration.userinfo_endpoint) {
                                throw "Not supported by the OIDC server";
                            }
                            return oidcConfiguration.userinfo_endpoint;
                        }
                    }
                }
            }

            if (configUrl) {
                var req = new XMLHttpRequest();
                req.open('GET', configUrl, true);
                req.setRequestHeader('Accept', 'application/json');

                req.onreadystatechange = function () {
                    if (req.readyState == 4) {
                        if (req.status == 200 || fileLoaded(req)) {
                            var config = JSON.parse(req.responseText);

                            kc.authServerUrl = config['auth-server-url'];
                            kc.realm = config['realm'];
                            kc.clientId = config['resource'];
                            setupOidcEndoints(null);
                            promise.setSuccess();
                        } else {
                            promise.setError();
                        }
                    }
                };

                req.send();
            } else {
                if (!config.clientId) {
                    throw 'clientId missing';
                }

                kc.clientId = config.clientId;

                var oidcProvider = config['oidcProvider'];
                if (!oidcProvider) {
                    if (!config['url']) {
                        var scripts = document.getElementsByTagName('script');
                        for (var i = 0; i < scripts.length; i++) {
                            if (scripts[i].src.match(/.*keycloak\.js/)) {
                                config.url = scripts[i].src.substr(0, scripts[i].src.indexOf('/js/keycloak.js'));
                                break;
                            }
                        }
                    }
                    if (!config.realm) {
                        throw 'realm missing';
                    }

                    kc.authServerUrl = config.url;
                    kc.realm = config.realm;
                    setupOidcEndoints(null);
                    promise.setSuccess();
                } else {
                    if (typeof oidcProvider === 'string') {
                        var oidcProviderConfigUrl;
                        if (oidcProvider.charAt(oidcProvider.length - 1) == '/') {
                            oidcProviderConfigUrl = oidcProvider + '.well-known/openid-configuration';
                        } else {
                            oidcProviderConfigUrl = oidcProvider + '/.well-known/openid-configuration';
                        }
                        var req = new XMLHttpRequest();
                        req.open('GET', oidcProviderConfigUrl, true);
                        req.setRequestHeader('Accept', 'application/json');

                        req.onreadystatechange = function () {
                            if (req.readyState == 4) {
                                if (req.status == 200 || fileLoaded(req)) {
                                    var oidcProviderConfig = JSON.parse(req.responseText);
                                    setupOidcEndoints(oidcProviderConfig);
                                    promise.setSuccess();
                                } else {
                                    promise.setError();
                                }
                            }
                        };

                        req.send();
                    } else {
                        setupOidcEndoints(oidcProvider);
                        promise.setSuccess();
                    }
                }
            }

            return promise.promise;
        }

        function fileLoaded(xhr) {
            return xhr.status == 0 && xhr.responseText && xhr.responseURL.startsWith('file:');
        }

        function setToken(token, refreshToken, idToken, timeLocal) {
            if (kc.tokenTimeoutHandle) {
                clearTimeout(kc.tokenTimeoutHandle);
                kc.tokenTimeoutHandle = null;
            }

            if (refreshToken) {
                kc.refreshToken = refreshToken;
                kc.refreshTokenParsed = decodeToken(refreshToken);
            } else {
                delete kc.refreshToken;
                delete kc.refreshTokenParsed;
            }

            if (idToken) {
                kc.idToken = idToken;
                kc.idTokenParsed = decodeToken(idToken);
            } else {
                delete kc.idToken;
                delete kc.idTokenParsed;
            }

            if (token) {
                kc.token = token;
                kc.tokenParsed = decodeToken(token);
                kc.sessionId = kc.tokenParsed.session_state;
                kc.authenticated = true;
                kc.subject = kc.tokenParsed.sub;
                kc.realmAccess = kc.tokenParsed.realm_access;
                kc.resourceAccess = kc.tokenParsed.resource_access;

                if (timeLocal) {
                    kc.timeSkew = Math.floor(timeLocal / 1000) - kc.tokenParsed.iat;
                }

                if (kc.timeSkew != null) {
                    logInfo('[KEYCLOAK] Estimated time difference between browser and server is ' + kc.timeSkew + ' seconds');

                    if (kc.onTokenExpired) {
                        var expiresIn = (kc.tokenParsed['exp'] - (new Date().getTime() / 1000) + kc.timeSkew) * 1000;
                        logInfo('[KEYCLOAK] Token expires in ' + Math.round(expiresIn / 1000) + ' s');
                        if (expiresIn <= 0) {
                            kc.onTokenExpired();
                        } else {
                            kc.tokenTimeoutHandle = setTimeout(kc.onTokenExpired, expiresIn);
                        }
                    }
                }
            } else {
                delete kc.token;
                delete kc.tokenParsed;
                delete kc.subject;
                delete kc.realmAccess;
                delete kc.resourceAccess;

                kc.authenticated = false;
            }
        }

        function decodeToken(str) {
            str = str.split('.')[1];

            str = str.replace('/-/g', '+');
            str = str.replace('/_/g', '/');
            switch (str.length % 4)
            {
                case 0:
                    break;
                case 2:
                    str += '==';
                    break;
                case 3:
                    str += '=';
                    break;
                default:
                    throw 'Invalid token';
            }

            str = (str + '===').slice(0, str.length + (str.length % 4));
            str = str.replace(/-/g, '+').replace(/_/g, '/');

            str = decodeURIComponent(escape(atob(str)));

            str = JSON.parse(str);
            return str;
        }

        function createUUID() {
            var hexDigits = '0123456789abcdef';
            var s = generateRandomString(36, hexDigits).split("");
            s[14] = '4';
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
            s[8] = s[13] = s[18] = s[23] = '-';
            var uuid = s.join('');
            return uuid;
        }

        function parseCallback(url) {
            var oauth = parseCallbackUrl(url);
            if (!oauth) {
                return;
            }

            var oauthState = callbackStorage.get(oauth.state);

            if (oauthState) {
                oauth.valid = true;
                oauth.redirectUri = oauthState.redirectUri;
                oauth.storedNonce = oauthState.nonce;
                oauth.prompt = oauthState.prompt;
                oauth.pkceCodeVerifier = oauthState.pkceCodeVerifier;
            }

            return oauth;
        }

        function parseCallbackUrl(url) {
            var supportedParams;
            switch (kc.flow) {
                case 'standard':
                    supportedParams = ['code', 'state', 'session_state', 'kc_action_status'];
                    break;
                case 'implicit':
                    supportedParams = ['access_token', 'token_type', 'id_token', 'state', 'session_state', 'expires_in', 'kc_action_status'];
                    break;
                case 'hybrid':
                    supportedParams = ['access_token', 'id_token', 'code', 'state', 'session_state', 'kc_action_status'];
                    break;
            }

            supportedParams.push('error');
            supportedParams.push('error_description');
            supportedParams.push('error_uri');

            var queryIndex = url.indexOf('?');
            var fragmentIndex = url.indexOf('#');

            var newUrl;
            var parsed;

            if (kc.responseMode === 'query' && queryIndex !== -1) {
                newUrl = url.substring(0, queryIndex);
                parsed = parseCallbackParams(url.substring(queryIndex + 1, fragmentIndex !== -1 ? fragmentIndex : url.length), supportedParams);
                if (parsed.paramsString !== '') {
                    newUrl += '?' + parsed.paramsString;
                }
                if (fragmentIndex !== -1) {
                    newUrl += url.substring(fragmentIndex);
                }
            } else if (kc.responseMode === 'fragment' && fragmentIndex !== -1) {
                newUrl = url.substring(0, fragmentIndex);
                parsed = parseCallbackParams(url.substring(fragmentIndex + 1), supportedParams);
                if (parsed.paramsString !== '') {
                    newUrl += '#' + parsed.paramsString;
                }
            }

            if (parsed && parsed.oauthParams) {
                if (kc.flow === 'standard' || kc.flow === 'hybrid') {
                    if ((parsed.oauthParams.code || parsed.oauthParams.error) && parsed.oauthParams.state) {
                        parsed.oauthParams.newUrl = newUrl;
                        return parsed.oauthParams;
                    }
                } else if (kc.flow === 'implicit') {
                    if ((parsed.oauthParams.access_token || parsed.oauthParams.error) && parsed.oauthParams.state) {
                        parsed.oauthParams.newUrl = newUrl;
                        return parsed.oauthParams;
                    }
                }
            }
        }

        function parseCallbackParams(paramsString, supportedParams) {
            var p = paramsString.split('&');
            var result = {
                paramsString: '',
                oauthParams: {}
            }
            for (var i = 0; i < p.length; i++) {
                var split = p[i].indexOf("=");
                var key = p[i].slice(0, split);
                if (supportedParams.indexOf(key) !== -1) {
                    result.oauthParams[key] = p[i].slice(split + 1);
                } else {
                    if (result.paramsString !== '') {
                        result.paramsString += '&';
                    }
                    result.paramsString += p[i];
                }
            }
            return result;
        }

        function createPromise() {
            // Need to create a native Promise which also preserves the
            // interface of the custom promise type previously used by the API
            var p = {
                setSuccess: function(result) {
                    p.resolve(result);
                },

                setError: function(result) {
                    p.reject(result);
                }
            };
            p.promise = new KeycloakPromise(function(resolve, reject) {
                p.resolve = resolve;
                p.reject = reject;
            });
            return p;
        }


        function setupCheckLoginIframe() {
            var promise = createPromise();

            if (!loginIframe.enable) {
                promise.setSuccess();
                return promise.promise;
            }

            if (loginIframe.iframe) {
                promise.setSuccess();
                return promise.promise;
            }

            var iframe = document.createElement('iframe');
            loginIframe.iframe = iframe;

            iframe.onload = function() {
                var authUrl = kc.endpoints.authorize();
                if (authUrl.charAt(0) === '/') {
                    loginIframe.iframeOrigin = getOrigin();
                } else {
                    loginIframe.iframeOrigin = authUrl.substring(0, authUrl.indexOf('/', 8));
                }
                promise.setSuccess();
            }

            var src = kc.endpoints.checkSessionIframe();
            iframe.setAttribute('src', src );
            iframe.setAttribute('title', 'keycloak-session-iframe' );
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            var messageCallback = function(event) {
                if ((event.origin !== loginIframe.iframeOrigin) || (loginIframe.iframe.contentWindow !== event.source)) {
                    return;
                }

                if (!(event.data == 'unchanged' || event.data == 'changed' || event.data == 'error')) {
                    return;
                }


                if (event.data != 'unchanged') {
                    kc.clearToken();
                }

                var callbacks = loginIframe.callbackList.splice(0, loginIframe.callbackList.length);

                for (var i = callbacks.length - 1; i >= 0; --i) {
                    var promise = callbacks[i];
                    if (event.data == 'error') {
                        promise.setError();
                    } else {
                        promise.setSuccess(event.data == 'unchanged');
                    }
                }
            };

            window.addEventListener('message', messageCallback, false);

            return promise.promise;
        }

        function scheduleCheckIframe() {
            if (loginIframe.enable) {
                if (kc.token) {
                    setTimeout(function() {
                        checkLoginIframe().then(function(unchanged) {
                            if (unchanged) {
                                scheduleCheckIframe();
                            }
                        });
                    }, loginIframe.interval * 1000);
                }
            }
        }

        function checkLoginIframe() {
            var promise = createPromise();

            if (loginIframe.iframe && loginIframe.iframeOrigin ) {
                var msg = kc.clientId + ' ' + (kc.sessionId ? kc.sessionId : '');
                loginIframe.callbackList.push(promise);
                var origin = loginIframe.iframeOrigin;
                if (loginIframe.callbackList.length == 1) {
                    loginIframe.iframe.contentWindow.postMessage(msg, origin);
                }
            } else {
                promise.setSuccess();
            }

            return promise.promise;
        }

        function loadAdapter(type) {
            if (!type || type == 'default') {
                return {
                    login: function(options) {
                        window.location.replace(kc.createLoginUrl(options));
                        return createPromise().promise;
                    },

                    logout: function(options) {
                        window.location.replace(kc.createLogoutUrl(options));
                        return createPromise().promise;
                    },

                    register: function(options) {
                        window.location.replace(kc.createRegisterUrl(options));
                        return createPromise().promise;
                    },

                    accountManagement : function() {
                        var accountUrl = kc.createAccountUrl();
                        if (typeof accountUrl !== 'undefined') {
                            window.location.href = accountUrl;
                        } else {
                            throw "Not supported by the OIDC server";
                        }
                        return createPromise().promise;
                    },

                    redirectUri: function(options, encodeHash) {
                        if (arguments.length == 1) {
                            encodeHash = true;
                        }

                        if (options && options.redirectUri) {
                            return options.redirectUri;
                        } else if (kc.redirectUri) {
                            return kc.redirectUri;
                        } else {
                            return location.href;
                        }
                    }
                };
            }

            if (type == 'cordova') {
                loginIframe.enable = false;
                var cordovaOpenWindowWrapper = function(loginUrl, target, options) {
                    if (window.cordova && window.cordova.InAppBrowser) {
                        // Use inappbrowser for IOS and Android if available
                        return window.cordova.InAppBrowser.open(loginUrl, target, options);
                    } else {
                        return window.open(loginUrl, target, options);
                    }
                };

                var shallowCloneCordovaOptions = function (userOptions) {
                    if (userOptions && userOptions.cordovaOptions) {
                        return Object.keys(userOptions.cordovaOptions).reduce(function (options, optionName) {
                            options[optionName] = userOptions.cordovaOptions[optionName];
                            return options;
                        }, {});
                    } else {
                        return {};
                    }
                };

                var formatCordovaOptions = function (cordovaOptions) {
                    return Object.keys(cordovaOptions).reduce(function (options, optionName) {
                        options.push(optionName+"="+cordovaOptions[optionName]);
                        return options;
                    }, []).join(",");
                };

                var createCordovaOptions = function (userOptions) {
                    var cordovaOptions = shallowCloneCordovaOptions(userOptions);
                    cordovaOptions.location = 'no';
                    if (userOptions && userOptions.prompt == 'none') {
                        cordovaOptions.hidden = 'yes';
                    }
                    return formatCordovaOptions(cordovaOptions);
                };

                return {
                    login: function(options) {
                        var promise = createPromise();

                        var cordovaOptions = createCordovaOptions(options);
                        var loginUrl = kc.createLoginUrl(options);
                        var ref = cordovaOpenWindowWrapper(loginUrl, '_blank', cordovaOptions);
                        var completed = false;

                        var closed = false;
                        var closeBrowser = function() {
                            closed = true;
                            ref.close();
                        };

                        ref.addEventListener('loadstart', function(event) {
                            if (event.url.indexOf('http://localhost') == 0) {
                                var callback = parseCallback(event.url);
                                processCallback(callback, promise);
                                closeBrowser();
                                completed = true;
                            }
                        });

                        ref.addEventListener('loaderror', function(event) {
                            if (!completed) {
                                if (event.url.indexOf('http://localhost') == 0) {
                                    var callback = parseCallback(event.url);
                                    processCallback(callback, promise);
                                    closeBrowser();
                                    completed = true;
                                } else {
                                    promise.setError();
                                    closeBrowser();
                                }
                            }
                        });

                        ref.addEventListener('exit', function(event) {
                            if (!closed) {
                                promise.setError({
                                    reason: "closed_by_user"
                                });
                            }
                        });

                        return promise.promise;
                    },

                    logout: function(options) {
                        var promise = createPromise();

                        var logoutUrl = kc.createLogoutUrl(options);
                        var ref = cordovaOpenWindowWrapper(logoutUrl, '_blank', 'location=no,hidden=yes');

                        var error;

                        ref.addEventListener('loadstart', function(event) {
                            if (event.url.indexOf('http://localhost') == 0) {
                                ref.close();
                            }
                        });

                        ref.addEventListener('loaderror', function(event) {
                            if (event.url.indexOf('http://localhost') == 0) {
                                ref.close();
                            } else {
                                error = true;
                                ref.close();
                            }
                        });

                        ref.addEventListener('exit', function(event) {
                            if (error) {
                                promise.setError();
                            } else {
                                kc.clearToken();
                                promise.setSuccess();
                            }
                        });

                        return promise.promise;
                    },

                    register : function(options) {
                        var promise = createPromise();
                        var registerUrl = kc.createRegisterUrl();
                        var cordovaOptions = createCordovaOptions(options);
                        var ref = cordovaOpenWindowWrapper(registerUrl, '_blank', cordovaOptions);
                        ref.addEventListener('loadstart', function(event) {
                            if (event.url.indexOf('http://localhost') == 0) {
                                ref.close();
                                var oauth = parseCallback(event.url);
                                processCallback(oauth, promise);
                            }
                        });
                        return promise.promise;
                    },

                    accountManagement : function() {
                        var accountUrl = kc.createAccountUrl();
                        if (typeof accountUrl !== 'undefined') {
                            var ref = cordovaOpenWindowWrapper(accountUrl, '_blank', 'location=no');
                            ref.addEventListener('loadstart', function(event) {
                                if (event.url.indexOf('http://localhost') == 0) {
                                    ref.close();
                                }
                            });
                        } else {
                            throw "Not supported by the OIDC server";
                        }
                    },

                    redirectUri: function(options) {
                        return 'http://localhost';
                    }
                }
            }

            if (type == 'cordova-native') {
                loginIframe.enable = false;

                return {
                    login: function(options) {
                        var promise = createPromise();
                        var loginUrl = kc.createLoginUrl(options);

                        universalLinks.subscribe('keycloak', function(event) {
                            universalLinks.unsubscribe('keycloak');
                            window.cordova.plugins.browsertab.close();
                            var oauth = parseCallback(event.url);
                            processCallback(oauth, promise);
                        });

                        window.cordova.plugins.browsertab.openUrl(loginUrl);
                        return promise.promise;
                    },

                    logout: function(options) {
                        var promise = createPromise();
                        var logoutUrl = kc.createLogoutUrl(options);

                        universalLinks.subscribe('keycloak', function(event) {
                            universalLinks.unsubscribe('keycloak');
                            window.cordova.plugins.browsertab.close();
                            kc.clearToken();
                            promise.setSuccess();
                        });

                        window.cordova.plugins.browsertab.openUrl(logoutUrl);
                        return promise.promise;
                    },

                    register : function(options) {
                        var promise = createPromise();
                        var registerUrl = kc.createRegisterUrl(options);
                        universalLinks.subscribe('keycloak' , function(event) {
                            universalLinks.unsubscribe('keycloak');
                            window.cordova.plugins.browsertab.close();
                            var oauth = parseCallback(event.url);
                            processCallback(oauth, promise);
                        });
                        window.cordova.plugins.browsertab.openUrl(registerUrl);
                        return promise.promise;

                    },

                    accountManagement : function() {
                        var accountUrl = kc.createAccountUrl();
                        if (typeof accountUrl !== 'undefined') {
                            window.cordova.plugins.browsertab.openUrl(accountUrl);
                        } else {
                            throw "Not supported by the OIDC server";
                        }
                    },

                    redirectUri: function(options) {
                        if (options && options.redirectUri) {
                            return options.redirectUri;
                        } else if (kc.redirectUri) {
                            return kc.redirectUri;
                        } else {
                            return "http://localhost";
                        }
                    }
                }
            }

            throw 'invalid adapter type: ' + type;
        }

        var LocalStorage = function() {
            if (!(this instanceof LocalStorage)) {
                return new LocalStorage();
            }

            localStorage.setItem('kc-test', 'test');
            localStorage.removeItem('kc-test');

            var cs = this;

            function clearExpired() {
                var time = new Date().getTime();
                for (var i = 0; i < localStorage.length; i++)  {
                    var key = localStorage.key(i);
                    if (key && key.indexOf('kc-callback-') == 0) {
                        var value = localStorage.getItem(key);
                        if (value) {
                            try {
                                var expires = JSON.parse(value).expires;
                                if (!expires || expires < time) {
                                    localStorage.removeItem(key);
                                }
                            } catch (err) {
                                localStorage.removeItem(key);
                            }
                        }
                    }
                }
            }

            cs.get = function(state) {
                if (!state) {
                    return;
                }

                var key = 'kc-callback-' + state;
                var value = localStorage.getItem(key);
                if (value) {
                    localStorage.removeItem(key);
                    value = JSON.parse(value);
                }

                clearExpired();
                return value;
            };

            cs.add = function(state) {
                clearExpired();

                var key = 'kc-callback-' + state.state;
                state.expires = new Date().getTime() + (60 * 60 * 1000);
                localStorage.setItem(key, JSON.stringify(state));
            };
        };

        var CookieStorage = function() {
            if (!(this instanceof CookieStorage)) {
                return new CookieStorage();
            }

            var cs = this;

            cs.get = function(state) {
                if (!state) {
                    return;
                }

                var value = getCookie('kc-callback-' + state);
                setCookie('kc-callback-' + state, '', cookieExpiration(-100));
                if (value) {
                    return JSON.parse(value);
                }
            };

            cs.add = function(state) {
                setCookie('kc-callback-' + state.state, JSON.stringify(state), cookieExpiration(60));
            };

            cs.removeItem = function(key) {
                setCookie(key, '', cookieExpiration(-100));
            };

            var cookieExpiration = function (minutes) {
                var exp = new Date();
                exp.setTime(exp.getTime() + (minutes*60*1000));
                return exp;
            };

            var getCookie = function (key) {
                var name = key + '=';
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return '';
            };

            var setCookie = function (key, value, expirationDate) {
                var cookie = key + '=' + value + '; '
                    + 'expires=' + expirationDate.toUTCString() + '; ';
                document.cookie = cookie;
            }
        };

        function createCallbackStorage() {
            try {
                return new LocalStorage();
            } catch (err) {
            }

            return new CookieStorage();
        }

        function createLogger(fn) {
            return function() {
                if (kc.enableLogging) {
                    fn.apply(console, Array.prototype.slice.call(arguments));
                }
            };
        }
    }

    return Keycloak;
})